import { getImgUrl } from "../Utility/Utility";

// start live shows
export const ShowsPostsData = [
  {
    id: 1,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Tom Jones \n Tel Aviv ",
    smltitle:
      "The one and only Tom Jones returns to Tel Aviv for one live performance",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											28.06.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.tomjones.com/">
												www.tomjones.com
											</a>
										</p>
									</div>
								</div>
							</div>
						<div class="img-wrapper">
							<img src=${getImgUrl() + "/Concerts/1/1.jpg"} class="img-responsive" />
						</div>

						<p>
							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
						</p>

						<p>
							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
						</p>
						<p>
							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
						</p>

						<p>
							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
						</p>
						`,
      };
    },
  },

  {
    id: 2,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "Britney Spears \n  Live in Concert",
    smltitle:
      "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											03.07.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.britneyspears.com">
												www.britneyspears.com
											</a>
										</p>
									</div>
								</div>
							</div>
						<div class="img-wrapper">
							<img src=${getImgUrl() + "/Concerts/2/1.jpg"} class="img-responsive" />
						</div>

						<p>
							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
						</p>

						<p>
							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
						</p>
						<p>
							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
						</p>

						<p>
							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
						</p>

						<p>
							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
						</p>
						`,
      };
    },
  },

  {
    id: 3,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Tears for Fears",
    smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											05.07.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.tearsforfears.com">
												www.tearsforfears.com
											</a>
										</p>
									</div>
								</div>
							</div>


						<p>
							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
						</p>

						<p>
							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
						</p>
						<p>
							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
						</p>
						<p>
						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
						</p>

						`,
      };
    },
  },

  {
    id: 4,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: ' Guns N\' Roses  "Not in this Lifetime"',
    smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											15.07.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.gunsnroses.com">
											www.gunsnroses.com
											</a>
										</p>
									</div>
								</div>
							</div>


							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/4/1.jpg"} class="img-responsive" />
							</div>
							<p>
								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
							</p>

							<p>
								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
							</p>
							<p>
								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
							</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/4/2.jpg"} class="img-responsive" />
							</div>

							<h3>
							"Not in this Lifetime"
							</h3>
							<p>
							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
							</p>
							<p>
								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
							</p>
							<p>
								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
							</p>
						`,
      };
    },
  },

  {
    id: 5,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: " RADIOHEAD  \n Tel Aviv",
    smltitle:
      "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											19.07.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.radiohead.com">
											www.radiohead.com
											</a>
										</p>
									</div>
								</div>
							</div>


							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/5/1.jpeg"} class="img-responsive" />
							</div>
							<p>
								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
							</p>

							<p>
								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
							</p>

							<p>
								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
							</p>

							<p>
								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
							</p>
							<p>
							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
							</p>
						`,
      };
    },
  },

  {
    id: 6,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "The Pixies",
    smltitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv outskirts
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											25-26.07.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.pixiesmusic.com">
											www.pixiesmusic.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<p>
								The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!
							</p>

							<p>
								The famous rock band was founded in 1986 in Boston and released its first EP "Come on Pilgrim" in 1987. A year later, when their first album "Surfer Rose" came out, they became a unique voice in the American Rock. 2 years later, they released their second album "Doolittle" that is considered one of the best rock albums of all times. Their third album "Bossanova" came out in 1990 and included unforgettable songs such as "Hang Wire", "Stormy Weather", and "All Over the World".
							</p>
							<p>
							A year later they released their fourth album "Trompe le Monde" that featured songs such as "Planet of Sound", "Distance Equals Rate Times Time" and many more. They fell apart in 1993 but went back to performing together in 2004. After a decade of touring the world, they released their fifth album "Indie Cindy" which included songs like "Another Toe in The Ocean", "Blue Eyed Hexe", and "Jaime Bravo". To this date they released six albums, the last one, "Head Carrier" came out last year. Their biggest hits include "Hey", "Where Is My Mind", "Monkey Gone to Heaven" and "Here Comes Your Man".
							</p>
							<p>
								The band that is known to influence artists such as PJ Harvey and Kurt Kobain will perform this summer in Tel Aviv, giving only 7000 lucky fans the opportunity to see them live and after the rave reviews of their 2014 performance, it’s shaping up to be an unmissable night!
							</p>
						`,
      };
    },
  },

  {
    id: 7,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Regina Spektor – Back in Israel",
    smltitle: "Regina Spektor – Back in Israel",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv outskirts
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											19.08.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.reginaspektor.com">
											www.reginaspektor.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<p>
								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
							</p>

							<p>
								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
							</p>
							<p>
								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
							</p>
							<p>
								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
							</p>

							<p>
								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
							</p>
							<p>
								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
							</p>
						`,
      };
    },
  },

  {
    id: 8,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Nick Cave & The Bad Seeds",
    smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv outskirts
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											19-20.11.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.nick-cave.com">
											www.nick-cave.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<p>
								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
							</p>

							<p>
								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
							</p>

							<p>
							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
							</p>
							<p>
								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
							</p>
							<p>
								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
							</p>
							<p>
								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
							</p>

							<p>
								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
							</p>
						`,
      };
    },
  },

  {
    id: 9,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Justin Bieber",
    smltitle:
      "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv outskirts
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											03.05.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.justinbiebermusic.com">
											www.justinbiebermusic.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/9/1.png"} class="img-responsive" />
							</div>
							<p>
								The artist with the most followers on Twitter 90,149,014
								The artist with the most watched official music channel online 13,518,849,954
								The artist with the most mentions on Youtube music channel
							</p>

							<p>
							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
							</p>
							<p>
								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
							</p>

							<p>
								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
							</p>

							<p>
								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
							</p>
							<p>
								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
							</p>
							<p>
								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
							</p>

							<p>
								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
							</p>

							<p>
								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
							</p>

							<p>
								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
							</p>
						`,
      };
    },
  },

  {
    id: 10,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: 'AEROSMITH \n "AERO-VEDERCI BABY" ',
    smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv outskirts
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											28.06.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.aerosmith.com">
											www.aerosmith.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/10/1.png"} class="img-responsive" />
							</div>
							<p>
								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
							</p>
							<p>
								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
							</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/10/2.jpg"} class="img-responsive" />
							</div>

							<p>
								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
							</p>

							<p>
								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
							</p>

							<p>
							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
							</p>

						`,
      };
    },
  },

  {
    id: 11,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Frankie Valli & The Four Seasons  ",
    smltitle: " An American Legend in the heart of Tel Aviv ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv outskirts
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											4.007.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.frankievallifourseasons.com/">
											www.frankievallifourseasons.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/11/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
							</p>
							<p>
								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
							</p>

							<p>
								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
							</p>

							<p>
								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
							</p>



						`,
      };
    },
  },

  {
    id: 12,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "Unite With Tomorrowland",
    smltitle:
      "The world’s number one leading EDM festival is coming to Tel Aviv! ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv outskirts
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											29.07.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
											www.tomorrowland.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/12/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
							</p>
							<p>
								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
							</p>

							<p>
								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
							</p>

							<p>
								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
							</p>



						`,
      };
    },
  },

  {
    id: 13,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "The Chainsmokers",
    smltitle:
      "The world’s number one leading EDM festival is coming to Tel Aviv! ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											NEAR Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											3.08.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.thechainsmokers.com/">
											www.thechainsmokers.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/13/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
							</p>
							<p>
								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
							</p>

							<p>
								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
							</p>





						`,
      };
    },
  },

  {
    id: 14,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "The Dire Straits Experience",
    smltitle: "Get a shiver in the dark in Tel Aviv",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											14.09.17
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.direstraitsexperience.com/">
											www.direstraitsexperience.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/14/1.jpg"} class="img-responsive" />
							</div>
							<p>
								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
							</p>
							<p>
								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
							</p>

							<p>
								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
							</p>

							<p>
							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
							</p>

							<p>
							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
							</p>

							<p>
							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
							</p>



						`,
      };
    },
  },

  {
    id: 15,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Alan Parsons",
    smltitle: "The man that said no to Pink Floyd, live in TA",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											11.11.17
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.alanparsonsmusic.com/">
											 www.alanparsonsmusic.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/15/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
							</p>
							<p>
								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
							</p>

							<p>
								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
							</p>

							<p>
							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
							</p>


							<p>
							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
							</p>

							<p>
							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
							</p>

						`,
      };
    },
  },

  {
    id: 16,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Bryan Adams",
    smltitle: "Bryan Adams to warm our winter with 3 shows",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv & Jerusalem
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											4+5+6.12.17
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.bryanadams.co.il/">
											 www.bryanadams.co.il
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/16/1.jpg"} class="img-responsive" />
							</div>
							<p>
								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
							</p>
							<p>
								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
							</p>

							<p>
								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
							</p>

							<p>
							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
							</p>


							<p>
							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
							</p>

							<p>
							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
							</p>

							<p>
							   Make sure you don’t miss this time-defying legend.
							</p>

						`,
      };
    },
  },

  {
    id: 17,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Chris Rock",
    smltitle: "Coming to Tel Aviv to rock your world ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											8+9.01.18
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.chrisrock.com/">
											 www.chrisrock.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/17/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
							</p>
							<p>
								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
							</p>

							<p>
								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
							</p>

							<p>
							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
                              Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).

							</p>


							<p>
							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
							</p>

							<p>
							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
							</p>

							<p>
							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
							</p>

							<p>
							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
							</p>

						`,
      };
    },
  },

  {
    id: 18,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Patricia Kaas",
    smltitle: "The great French singer returns to the white city once again",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											28.09.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.patriciakaas.net/">
											  www.patriciakaas.net
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/18/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
							</p>
							<p>
								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
							</p>

							<p>
								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
							</p>

							<p>

                                   Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.

							</p>

						`,
      };
    },
  },

  {
    id: 19,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Blue Man Group",
    smltitle:
      "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											 7-23.08.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.blueman.com/">
											  www.blueman.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/19/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
							</p>
							<p>
								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
							</p>

							<p>
								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
							</p>

							<p>

                                 Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!

							</p>

						`,
      };
    },
  },

  {
    id: 20,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "Sean Paul",
    smltitle:
      "The international mega star is coming to make our summer sizzle!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv Outskirts
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											22.08.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.allseanpaul.com/">
											  www.allseanpaul.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/20/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
							</p>
							<p>
								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
							</p>
							<p>
							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
							</p>

							<p>
							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
							</p>
							<p>
							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
							</p>

							<p>

                                  His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.

							</p>

							<p>
                                Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
							</p>

							<p>
                               Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
							</p>

							<p>
                               Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
							</p>

							<p>
                               His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
							</p>

						`,
      };
    },
  },

  {
    id: 21,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "The Pretenders",
    smltitle:
      "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											23.09.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.thepretenders.com/">
											  www.thepretenders.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/21/1.jpg"} class="img-responsive" />
							</div>
							<p>
								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
							</p>
							<p>
								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
							</p>

							<p>
								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
							</p>

							<p>

                                  The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!

							</p>

						`,
      };
    },
  },

  {
    id: 22,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "Cliff Richard",
    smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											10.10.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.cliffrichard.org/">
											  www.cliffrichard.org
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/22/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
							</p>
							<p>
								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
							</p>

							<p>
								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
							</p>

							<p>

                                 Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.

							</p>

							<p>
							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
							</p>

							<p>
							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
							</p>

							<p>
							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel-Aviv!
							</p>

						`,
      };
    },
  },

  {
    id: 23,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "DGTL Festival",
    smltitle:
      "An awesome digital celebration in the one of the world’s Digital Capitals",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											05.10.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
											  www.tlv-digital.nl
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/23/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
							</p>
							<p>
								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
							</p>

							<p>
								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
							</p>

							<p>

                               The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.

							</p>

							<p>
							   The festival will include three stages featuring excellent music at any given moment.
							</p>

							<p>
							   The fantastic international line up is set to include:
							</p>

							<p>
							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
							</p>

							<p>
							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
							</p>

						`,
      };
    },
  },

  {
    id: 24,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Richard Clayderman",
    smltitle:
      "The famous pianist returns to perform in Israel with all his unforgettable hits!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											17.11.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.clayderman.co.uk/">
											  www.clayderman.co.uk
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/24/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
							</p>
							<p>
								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
							</p>

							<p>
								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
							</p>

							<p>

                               His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!

							</p>



						`,
      };
    },
  },

  {
    id: 25,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "Smokie",
    smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv + Jerusalim
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											28+31.10.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//smokie.co.uk/Band">
											  www.smokie.co.uk
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/25/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
							</p>
							<p>
								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
							</p>

							<p>
								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
							</p>

							<p>

                              Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."

							</p>

							<p>
							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
							</p>

							<p>
							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
							</p>

							<p>

							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
							</p>



						`,
      };
    },
  },

  {
    id: 26,
    bgImage: "/posts/bank/15/1.jpg",
    mobBgImage: "/posts/bank/15/M.jpg",
    title: "Foreigner",
    smltitle: "The 80's are back to rock Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											02.12.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.foreigneronline.com/">
											  www.foreigneronline.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/26/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
							</p>
							<p>
								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
							</p>

							<p>
								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
							</p>

							<p>

                              The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".

							</p>

							<p>
							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
							</p>

						`,
      };
    },
  },

  {
    id: 27,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Carcass",
    smltitle:
      "The British metal legends are coming <br>to rock the city that never sleeps!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											09.12.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
											  facebook.com/OfficialCarcass
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/27/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
							</p>
							<p>
								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
							</p>

							<p>
								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
							</p>

							<p>

                              In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.

							</p>
							<p>
							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
							</p>

						`,
      };
    },
  },

  {
    id: 28,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "Kygo",
    smltitle:
      "The Norwegian house phenomena for the first time ever in Tal Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											02.12.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.kygomusic.com/">
											  www.kygomusic.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/28/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
							</p>
							<p>
								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
							</p>

							<p>
								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
							</p>

							<p>

                              His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.

							</p>
							<p>
							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
							</p>

						`,
      };
    },
  },

  {
    id: 29,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "Led Zeppelin 2",
    smltitle: "Don’t Miss the Zeps in Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											 Tel Aviv, Haifa and Be'er Sheva
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											07-10.01.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//zep2.com/">
											  www.zep2.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/29/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
							</p>
							<p>
								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
							</p>

							<p>
								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
							</p>

							<p>

                             Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.

							</p>


						`,
      };
    },
  },

  {
    id: 30,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Oh Wonder",
    smltitle: "Live in Tel Aviv for the first time ever!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											 Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											16.12.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//ohwondermusic.com/">
											  www.ohwondermusic.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/30/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
							</p>
							<p>
								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
							</p>

							<p>
								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
							</p>




						`,
      };
    },
  },

  {
    id: 31,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Ott & The All Seeing I",
    smltitle: "Electro explosion in the city that never sleeps",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											 Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											15.12.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//ottsonic.com/">
											  www.ottsonic.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/31/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
							</p>
							<p>
								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
							</p>

							<p>
								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
							</p>

							<p>
							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
							</p>

							 <p>
							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
							 </p>

						`,
      };
    },
  },

  {
    id: 32,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Take That",
    smltitle: "Take That – Taking Tel Aviv By Storm!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											 Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											27.11.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//takethat.com/">
											  www.takethat.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/32/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
							</p>
							<p>
								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
							</p>

							<p>
								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
							</p>

							<p>
							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
							</p>

							 <p>
							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
							 </p>

						`,
      };
    },
  },

  {
    id: 33,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "The Kooks",
    smltitle: "Getting it on with the Kooks in Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											 Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											27-28.01.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.thekooks.com/">
											  www.thekooks.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/33/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
							</p>
							<p>
								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
							</p>

							<p>
								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
							</p>

							<p>
							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
							</p>

							 <p>
							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
							 </p>

						`,
      };
    },
  },

  {
    id: 34,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Willy William and Farruko",
    smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											  Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											28.11.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.reggaetontelaviv.co.il/indexEN.php">
											  www.reggaetontelaviv.co.il
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/34/1.jpg"} class="img-responsive" />
							</div>
							<p>
								The reggaetón superstars coming to get you movin’ in Tel Aviv!
							</p>
							<p>
								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
							</p>

							<p>
								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
							</p>

							<p>
							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
							</p>

							 <p>
							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
							 </p>

						`,
      };
    },
  },

  {
    id: 35,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Buena Vista",
    smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv and Jerusalem
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											21-26.12.17
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.pasion-de-buena-vista.com/">
											  www.pasion-de-buena-vista.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/35/1.jpg"} class="img-responsive" />
							</div>
							<p>
							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
							</p>
							<p>
								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
							</p>
							<p>
								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
							</p>

							<p>
								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
							</p>



						`,
      };
    },
  },

  {
    id: 36,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Jerry Seinfeld",
    smltitle: "Comedy King Closing 2017 in Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											30.12.2017
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.jerryseinfeld.com/">
											  www.jerryseinfeld.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/36/1.jpg"} class="img-responsive" />
							</div>
							<p>
							  Comedy King Closing 2017 in Tel Aviv!
							</p>
							<p>
								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
							</p>
							<p>
								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
							</p>

							<p>
								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
							</p>

							<p>
							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
							</p>

							<p>
							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
							</p>

							<p>
							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
							</p>

						`,
      };
    },
  },

  {
    id: 37,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Alt-J",
    smltitle: "Comedy King Closing 2017 in Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											29.05.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.altjband.com/">
											  www.altjband.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/37/1.jpg"} class="img-responsive" />
							</div>
							<p>
							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
							</p>
							<p>
								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
							</p>


						`,
      };
    },
  },

  {
    id: 38,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Ozzy Osbourne",
    smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											08.07.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.ozzy.com/">
											  www.ozzy.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/38/1.jpg"} class="img-responsive" />
							</div>
							<p>
							  Ozzy O -  coming to say goodbye to Tel Aviv!
							</p>
							<p>
								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
							</p>

							<p>
							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
							</p>

							<p>
							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
							</p>


						`,
      };
    },
  },

  {
    id: 39,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Jim Jefferies",
    smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											16.01.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//jimjefferies.com/">
											  www.jimjefferies.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/39/1.gif"} class="img-responsive" />
							</div>
							<p>
							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
							</p>
							<p>
								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
							</p>

							<p>
							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
							</p>

							<p>
							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
							</p>

							<p>
							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
							</p>


						`,
      };
    },
  },

  {
    id: 40,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Gerard Depardieu & Isabelle Adjani",
    smltitle: "“Love Letters” Coming to Tel Aviv from France!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											05.03.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="">

											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/40/1.gif"} class="img-responsive" />
							</div>
							<p>
							 “Love Letters” Coming to Tel Aviv from France!
							</p>
							<p>
								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
							</p>

							<p>
							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
							</p>

							<p>
							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
							</p>

							<p>
							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
							</p>


						`,
      };
    },
  },

  {
    id: 41,
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "A-HA",
    smltitle: "An Electric Summer with A-HA!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											21.06.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://a-ha.com/">
											  www.a-ha.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/41/1.gif"} class="img-responsive" />
							</div>
							
							<p>
							 An Electric Summer with A-HA!
							</p>
							<p>
								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
							</p>

							<p>
							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
							</p>

							<p>
							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
							</p>

							<p>
							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
							</p>


						`,
      };
    },
  },

  {
    id: 42,
    bgImage: "/posts/bank/13/1.jpg",
    mobBgImage: "/posts/bank/13/M.jpg",
    title: "Ringo Starr",
    smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											23-24.06.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.ringostarr.com/">
											 www.ringostarr.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/42/1.gif"} class="img-responsive" />
							</div>
							<p>
							 Ringo’s All Starr Band Headed to Tel Aviv!
							</p>
							<p>
								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
							</p>

							<p>
							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
							</p>

							<p>
							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
							</p>

							<p>
							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
							</p>


						`,
      };
    },
  },

  {
    id: 43,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "The Scorpions",
    smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											19.07.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.the-scorpions.com/">
											 www.the-scorpions.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/43/1.gif"} class="img-responsive" />
							</div>
							<p>
							 Tel Aviv to Go Crazy in July with The Scorpions!
							</p>
							<p>
								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
							</p>

							<p>
							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
							</p>

							<p>
							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
							</p>

							<p>
							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
							</p>


						`,
      };
    },
  },

  {
    id: 44,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Natalia Oreiro",
    smltitle: "Natalia to Wow Tel Aviv in March",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											20.03.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.nataliaoreiro.com/">
											 www.nataliaoreiro.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/44/1.jpg"} class="img-responsive" />
							</div>
							<p>
							Natalia to Wow Tel Aviv in March
							</p>
							<p>
								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
							</p>

							<p>
							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
							</p>

							<p>
							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
							</p>

							<p>
							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
							</p>


						`,
      };
    },
  },

  {
    id: 45,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "André Rieu",
    smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											04-05.04.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.andrerieu.com/">
											 www.andrerieu.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/45/1.jpg"} class="img-responsive" />
							</div>
							<p>
							 Tel Aviv to Be Treated to Rieu in 2018
							</p>
							<p>
								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
							</p>

							<p>
							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
							</p>

							<p>
							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
							</p>

							<p>
							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
							</p>


						`,
      };
    },
  },

  {
    id: 46,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Foreigner",
    smltitle: "Foreigner Returning to Israel in May!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											05.05.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.foreigneronline.com/">
											 www.foreigneronline.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/46/1.jpg"} class="img-responsive" />
							</div>
							<p>
							 Foreigner Returning to Israel in May!
							</p>
							<p>
								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
							</p>

							<p>
							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
							</p>

							<p>
							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
							</p>

							<p>
							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
							</p>


						`,
      };
    },
  },

  {
    id: 47,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Don Mclean",
    smltitle: "Enjoy a Piece of “American Pie” in June!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											16.06.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://don-mclean.com/">
											 www.don-mclean.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/47/1.jpg"} class="img-responsive" />
							</div>
							<p>
							    Enjoy a Piece of “American Pie” in June!
							</p>
							<p>
								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
							</p>

							<p>
							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
							</p>

							<p>
							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
							</p>




						`,
      };
    },
  },

  {
    id: 48,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Enrique Iglesias",
    smltitle: "Tel Aviv to Host Spanish Pop Legend!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											28.05.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://enriqueiglesias.com/">
											 www.enriqueiglesias.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/48/1.jpg"} class="img-responsive" />
							</div>
							<p>
							    Tel Aviv to Host Spanish Pop Legend!
							</p>
							<p>
								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
							</p>

							<p>
							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
							</p>

							<p>
							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
							</p>

							<p>
							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
							</p>




						`,
      };
    },
  },

  {
    id: 49,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Blood Sweat and Tears",
    smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											22.10.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//bloodsweatandtears.com/">
											 www.bloodsweatandtears.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/49/1.jpg"} class="img-responsive" />
							</div>
							<p>
							   Blood, Sweat & Tears Headed to Tel Aviv!
							</p>
							<p>
								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
							</p>

							<p>
							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
							</p>

							<p>
							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
							</p>
                            <p>
                                Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
                            </p>



						`,
      };
    },
  },

  {
    id: 50,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Jamiroquai",
    smltitle: "Jamiroquai Heads to Israel in May!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											02.05.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.jamiroquai.com/">
											 www.jamiroquai.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/50/1.jpg"} class="img-responsive" />
							</div>
							<p>
							    Jamiroquai Heads to Israel in May!
							</p>
							<p>
								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
							</p>

							<p>
							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
							</p>

							<p>
							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
							</p>


						`,
      };
    },
  },

  {
    id: 51,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Backstreet Boys",
    smltitle: "The Backstreet Boys are Back and Larger Than Life",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											22.04.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.backstreetboys.com/">
												www.backstreetboys.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/51/1.gif"} class="img-responsive" />
							</div>
							<p>
							    The Backstreet Boys are Back and Larger Than Life
							</p>
							<p>
									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
							</p>

							<p>
									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
							</p>

							<p>
									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
							</p>
							<p>
									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
							</p>

						`,
      };
    },
  },

  {
    id: 52,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Alice in Chains",
    smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											17.07.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.aliceinchains.com/">
												www.aliceinchains.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/52/1.gif"} class="img-responsive" />
							</div>
							<p>
							    Alice in Chains Announces Debut Show in Tel Aviv
							</p>
							<p>
									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
							</p>

							<p>
									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
							</p>

							<p>
									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
							</p>
							<p>
									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
							</p>

						`,
      };
    },
  },

  {
    id: 53,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Hardwell",
    smltitle: "Hardwell Headed to Israel in April",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											06.04.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.djhardwell.com/">
												www.djhardwell.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/53/1.gif"} class="img-responsive" />
							</div>
							<p>
							    Hardwell Headed to Israel in April
							</p>
							<p>
									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
							</p>

							<p>
									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
							</p>

							<p>
									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
							</p>

						`,
      };
    },
  },

  {
    id: 54,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Jethro Tull",
    smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv and Jerusalem
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											27-28.10.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.jethrotull.com/">
												jethrotull.com/
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/54/1.gif"} class="img-responsive" />
							</div>
							<p>
							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
							</p>
							<p>
									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
							</p>

							<p>
									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
							</p>

							<p>
									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
							</p>

						`,
      };
    },
  },

  {
    id: 55,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Israel Calling",
    smltitle: "Good Evening Europe, This is Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											08-10.04.2018
										</p>
									</div>
								</div>
							</div>

						<!--	<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="">

											</a>
										</p>
									</div>
								</div>
							</div>-->


							<h2>
							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
							</h2>
							<p>
								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
							</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/55/1.jpg"} class="img-responsive" />
							</div>

							<p>
								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
							</p>

							<p>
								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.

						</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/Concerts/55/2.jpg"} class="img-responsive" />
						</div>

						<p>
						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
						</p>

						<p>
						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.


						</p>

						<p>
						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
						</p>

						<div class="img-wrapper">
							<img src=${getImgUrl() + "/Concerts/55/3.jpg"} class="img-responsive" />
						</div>

						`,
      };
    },
  },

  {
    id: 56,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Clean Bandit",
    smltitle: "Clean Bandit Announces First Visit to Israel",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											26.06.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//cleanbandit.co.uk/">
												cleanbandit.co.uk
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/56/1.jpg"} class="img-responsive" />
							</div>
							<p>
							   Clean Bandit Announces First Visit to Israel
							</p>
							<p>
									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
							</p>

							<p>
									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015. 
							</p>

							<p>
									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
						    </p>

						    <p>
									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
						    </p>

						`,
      };
    },
  },

  {
    id: 57,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Alanis Morissette",
    smltitle:
      "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											30.07.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//alanis.com/">
												alanis.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/57/1.jpg"} class="img-responsive" />
							</div>
							<p>
							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
							</p>
							<p>
									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
							</p>

							<p>
									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
							</p>

							<p>
									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
							</p>

						`,
      };
    },
  },

  {
    id: 58,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Marc Almond",
    smltitle: "Marc Almond’s Amazing Summer Concert",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											14.08.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
												marcalmond.co.uk
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/58/1.jpg"} class="img-responsive" />
							</div>
							<p>
							   Marc Almond’s Amazing Summer Concert
							</p>
							<p>
									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August. 
							</p>

							<p>
									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion. 
							</p>

							<p>
									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
							</p>

						    <p>
									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert. 
							</p>

						`,
      };
    },
  },
  {
    id: 59,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Shakira",
    smlTitle: "Shakira to heat up the summer in sizzling Tel Aviv ",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											09.07.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.shakira.com/">
												shakira.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
							</div>
							<p>
							  Shakira to heat up the summer in sizzling Tel Aviv
							</p>
							<p>
									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv. 
							</p>

							<p>
									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views. 
							</p>

							<p>
									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue. 
							</p>
							<p>
							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv. 
							</p>

	                    `,
      };
    },
  },
  //     {

  //     id: 60,
  //     bgImage:"/posts/bank/16/1.jpg",
  //     mobBgImage:"/posts/bank/16/M.jpg",
  //     title: "White Night TLV",
  //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
  //     html: function(){
  // 	return {
  // 		__html: `

  // 					<h2 class="align-center">
  // 					   16.05.2019
  // 					</h2>
  // 					<h1 class="align-center">
  // 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
  // 					</h1>
  // 					<div class="responisve-iframe">
  // 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 					</div>
  // 					<p>
  // 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
  // 					</p>

  // 					<p>
  // 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<small>
  // 						Photo By: Adam Primer
  // 					</small>
  // 					<p>
  // 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
  // 					</p>
  // 					<p>
  // 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
  // 					</div>
  // 					<small>
  // 						Photo By: Kfir Sivan
  // 					</small>
  // 					<p>
  // 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
  // 					</div>
  // 					<small>
  // 						Photo by Moshik Lindenbaum
  // 					</small>
  // 					<p>
  // 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
  // 					</div>
  // 					<small>
  // 						Photo by: Guy Yechiely‎.
  // 					</small>

  // 			               `
  // 	}
  // }
  //   },
  {
    id: 60,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "White Night TLV",
    smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
    html: function() {
      return {
        __html: `


							<h2 class="align-center">
							   16.05.2019
							</h2>
							<h1 class="align-center">
							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
							</h1>
							<div class="responisve-iframe">
								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
							</div>
							<p>
								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
							</p>

							<p>
								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.  
							</p>
							<p>
								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
							</p>
							<p>
								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps. 
							</p>
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Adam Primer
							</small>
							<p>
								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
							</p>
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Kfir Sivan
							</small>
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by Moshik Lindenbaum
							</small>
							<p>
								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv! 
							</p>
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by: Guy Yechiely‎.
							</small>


					               `,
      };
    },
  },
  {
    id: 61,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Brian Wilson",
    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											07.08.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.brianwilson.com/">
												brianwilson.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
							</div>
							<p>
							 The legendary Brian Wilson returning to rock Tel Aviv!
							</p>
							<p>
									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
							</p>

							<p>
									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards. 
							</p>

							<p>
									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city. 

                            </p>


					               `,
      };
    },
  },
  {
    id: 62,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Jason Derulo and Rita Ora",
    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											The outskirts of Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											01.08.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.jasonderulo.com/">
												jasonderulo.com
											</a><br>
											<a target="_blank" href="//ritaora.com/">
												ritaora.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
							</div>
							<p>
						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
							</p>
							<p>
									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
							</p>

							<p>
									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
							</p>


					               `,
      };
    },
  },
  {
    id: 63,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Julio Iglesias",
    smlTitle: "The Latin legend returning to wow Tel Aviv!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											06.10.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.julioiglesias.com/">
												julioiglesias.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
							</div>
							<p>
						             The Latin legend returning to wow Tel Aviv!
							</p>
							<p>
									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital. 
							</p>

							<p>
									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year. 
							</p>
							<p>
							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
							</p>

							<p>
							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
							</p>


					               `,
      };
    },
  },
  {
    id: 64,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Maluma",
    smlTitle: "The Reggaeton sensation returns to the white city!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											28.06.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//fame.malumaofficial.com/">
												fame.malumaofficial.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
							</div>
							<p>
						           The Reggaeton sensation returns to the white city!
							</p>
							<p>
									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
							</p>

							<p>
									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
							</p>
							<p>
							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
						    </p>

							<p>
							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
						    </p>


					               `,
      };
    },
  },
  {
    id: 65,
    bgImage: "/posts/bank/16/1.jpg",
    mobBgImage: "/posts/bank/16/M.jpg",
    title: "Martin Garrix",
    smlTitle: "The 1# DJ comes to the nonstop city!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											10.09.2018
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.martingarrix.com/">
												martingarrix.com
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
							</div>
							<p>
						           The 1# DJ comes to the nonstop city!
							</p>
							<p>
									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene. 
							</p>

							<p>
									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
							</p>
							<p>
							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
							</p>

							<p>
							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
						    </p>


					               `,
      };
    },
  },

  {
    id: 66,
    bgImage: "/posts/bank/59/1.jpg",
    mobBgImage: "/posts/bank/59/M.jpg",
    title: "Eurovision Tel Aviv",
    smlTitle: "Epic song contest in the Non-Stop City",
    html: function() {
      return {
        __html: `

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											14-18.05.2019
										</p>
									</div>
								</div>
							</div>

							<!--<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="">
												
											</a>
										</p>
									</div>
								</div>
							</div>-->

							
							<h3>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h3>
							<p>
						     Epic song contest in the Non-Stop City
							</p>
							<p>Semi-final 1: 14 May 2019</p>
                            <p>Semi-final 2: 16 May 2019</p>
                            <p>Grand Final: 18 May 2019</p>
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />
								
							</div>
                            <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
                            <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
                            <div class="img-wrapper">
								
							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
							</div>
                            <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>
                            
                            <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p> 
                            


					               `,
      };
    },
  },

  {
    id: 68,
    bgImage: "/posts/bank/68/1.jpg",
    mobBgImage: "/posts/bank/68/M.jpg",
    title: "",
    smlTitle: "36 Years of Cinema Magic!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Jerusalem
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											25.07-04.08.2019
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.jff.org.il/en">
												
												www.jff.org.il
											</a>
										</p>
									</div>
								</div>
							</div>

							<div class="clear"></div>
							<h2>Jerusalem Film Festival (JFF)</h2>
							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
							</div>
							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
                            <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>

					               `,
      };
    },
  },

  {
    id: 69,
    bgImage: "/posts/bank/69/1.jpg",
    mobBgImage: "/posts/bank/69/M.jpg",
    title: "",
    smlTitle: "Jerusalem Wine Festival (JWF)",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Jerusalem
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											01-31.08.2019
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
												www.imj.org.il
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
							<h2>Jerusalem Wine Festival (JWF)</h2>
							<p>
								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
							</p>
                           <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
							</p>
                           <p>
								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
							</p>
					               `,
      };
    },
  },

  {
    id: 70,
    bgImage: "/posts/bank/70/1.jpg",
    mobBgImage: "/posts/bank/70/M.jpg",
    title: "OPEN RESTAURANTS TLV",
    smlTitle: "Feed Your Curiosity!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											2019 y.
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
												open-restaurants.co.il
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
							<h2>Feed Your Curiosity!</h2>
							<p>
								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
							</p>
							<p>
								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
							</p>
                           <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
							</p>
                           <p>
								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
							</p>
                           <p>
								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
							</p>

					               `,
      };
    },
  },

  {
    id: 71,
    bgImage: "/posts/bank/71/1.jpg",
    mobBgImage: "/posts/bank/71/M.jpg",
    title: "CULINARY FESTIVAL",
    smlTitle: "Round Tables Culinary Festival",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											09-23.11.2019
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
												open-restaurants.co.il
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
							<h2>Round Tables Culinary Festival</h2>
							<p>
								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
							</p>
							<p>
								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
							</p>
                           <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
							</div>
							<p>
								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
							</p>
                           <p>
								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
							</p>

					               `,
      };
    },
  },

  {
    id: 72,
    bgImage: "/posts/bank/72/1.jpg",
    mobBgImage: "/posts/bank/72/M.jpg",
    title: "TEL AVIV FASHION WEEK",
    smlTitle: "Tel Aviv Fashion Week (TAFW)",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											2019
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//fashionweektelaviv.com/">
												fashionweektelaviv.com
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
							<h2>Tel Aviv Fashion Week (TAFW)</h2>
							<p>
								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
							</p>
                           <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
							</div>
							<p>
								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
							</p>
                           <p>
								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
							</p>

					               `,
      };
    },
  },

  {
    id: 73,
    bgImage: "/posts/bank/73/1.jpg",
    mobBgImage: "/posts/bank/73/M.jpg",
    title: "DGTL FESTIVAL",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											2019 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
												
												tlv.dgtl.nl/en
											</a>
										</p>
									</div>
								</div>
							</div>

				          
							<div class="clear"></div>
                            <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

                            <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>
                            
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
							</div>
                            <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
                            <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
                            <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
                            <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>


					               `,
      };
    },
  },
  {
    id: 74,
    bgImage: "/posts/bank/74/1.jpg",
    mobBgImage: "/posts/bank/74/M.jpg",
    title: "Tel Aviv Marathon",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											22.02.2019 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											
											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">	
												www.tlvmarathon.co.il
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                            <h2>Run and fun in the city that doesn’t stop</h2><br/>
                            <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
                            <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
							</div>
                            <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
                            <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
                            <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>


					               `,
      };
    },
  },

  {
    id: 75,
    bgImage: "/posts/bank/75/1.jpg",
    mobBgImage: "/posts/bank/75/M.jpg",
    title: "Jerusalem Marathon",
    smlTitle:
      "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											15.03.2019 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">
												
												jerusalem-marathon.com
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                            <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
                            <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
                            <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
							</div>
                            <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
                            <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p> 
                            <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>


					               `,
      };
    },
  },

  {
    id: 76,
    bgImage: "/posts/bank/76/1.jpg",
    mobBgImage: "/posts/bank/76/M.jpg",
    title: "Bon Jovi",
    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											HaYarkon Park, TLV 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											25.07.2019
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.bonjovi.com/">
												
												bonjovi.com
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                            <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>
                           
                            <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city. 
                            <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv. 
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
							</div>
                            <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide. 
                            <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric . 
                            <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop! 


					               `,
      };
    },
  },

  {
    id: 77,
    bgImage: "/posts/bank/77/1.jpg",
    mobBgImage: "/posts/bank/77/M.jpg",
    title: "TAG 2019",
    smlTitle: "Tel Aviv Games are Back!",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											TAG 2019
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											27-30.3.2019
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.bonjovi.com/">
												www.telavivgames.org
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                           <h2>
                            	Tel Aviv Games are Back!
                          	 </h2>
                           
                            <p>
								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience. 
                            </p>
                            <p>
								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
                            </p>
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
							</div>
                            <p>
								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
                            </p>
                            <p>
								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
                            </p>
                            <p>
								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
							 </p>

					               `,
      };
    },
  },

  {
    id: 78,
    bgImage: "/posts/bank/100/1.jpg",
    mobBgImage: "/posts/bank/100/M.jpg",
    title: "Purim 2019",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv and Jerusalem
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											20-22.03.2019
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
												Tel Aviv Purim 2019
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                           <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
							</div>

                            <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
							</div>
                            <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
							</div>
                            <p>So choose your costume and come celebrate with us!
                            <div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
							</div>
                         
					               `,
      };
    },
  },

  {
    id: "J_Lo",
    bgImage: "/posts/bank/J_Lo/1.jpg",
    mobBgImage: "/posts/bank/J_Lo/M.jpg",
    title: "J.LO",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Hayarkon Park
										</p>
									</div>
								</div>
							</div>

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											01.08.2019
										</p>
									</div>
								</div>
							</div>

							<div class="clear"></div>
							<h3>
								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
							</h3>
							<p>
								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
							</p>
                         <p>
								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
							</p>
							<p>
								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
							</p>
					               `,
      };
    },
  },

  {
    id: "Pride_Parade_2019",
    bgImage: "/posts/bank/Pride_Parade_2019/1.jpg",
    mobBgImage: "/posts/bank/Pride_Parade_2019/M.jpg",
    title: "Pride Parade 2019",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											14.6.2019
										</p>
									</div>
								</div>
							</div>

							<div class="clear"></div>
							<h3>
								The  most fabulous event of the Year
							</h3>
							<p>
								<strong>
									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
								</strong>
							</p>
							<p>
								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade. 
							</p>
                         <p>
								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
							</p>
							<p>
								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more. 
							</p>
							<p>
								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress. 
							</p>
							<p>
								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.  
							</p>
							<p>
								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge. 
							</p>
					               `,
      };
    },
  },

  {
    id: "Open_Restaurants_Jerusalem",
    bgImage: "/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
    mobBgImage: "/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
    title: "Open Restaurants Jerusalem",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Jerusalem
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											19-23.11.2019
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
												www.open-restaurants.co.il
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
							
							<h3>
								Open Restaurants Jerusalem
							</h3>
							<p>
								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem. 
							</p>
							<p>
								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
							</p>
                         <p>
								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens. 
							</p>
							<p>
								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
							</p>
							<p>
								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
							</p>
							<p>
								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019. 
							</p>
					               `,
      };
    },
  },

  {
    id: "Jerusalem_Beer_Festival",
    bgImage: "/posts/bank/jerusalem-beer-festival/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-beer-festival/M.jpg",
    title: "Jerusalem Beer Festival",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-50">
										<div class="top-box yellow">
											<h2>Time</h2>
											<div class="text">
												<p>
													18:00 – 00:00
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-50">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													28 - 29.08.2019
												</p>
											</div>
										</div>
									</div>
							        

	                                <p>The city of Jerusalem is proud to host, for the 15th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’.</p> 
	                                <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>

	                                <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an incomparable atmosphere, guaranteeing an unforgettable experience. </p>

	                                <p>The iconic festival has become over the years, a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe, to enjoy a delicious variety of cold beers, food and people in open air of Jerusalem.</p>

	                                <p>During the festival you will have the opportunity to taste any (or all) of the variety special flavors of beers from around the country and the world (and we have over 120 of them), served in pop up bars, built specifically for the festival. </p>
	                                <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local breweries. </p>

	                                <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>
                                    <a href="https://www.jerusalembeer.com/en" target="_blank" class="jerusalem-link">www.jerusalembeer.com</a>
	                            `,
      };
    },
  },

  {
    id: "DGTL_Festival",
    bgImage: "/posts/bank/dgtl-festival2019/1.jpg",
    mobBgImage: "/posts/bank/dgtl-festival2019/M.jpg",
    title: "DGTL FESTIVAL",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-30">
										<div class="top-box yellow">
											<h2>Location</h2>
											<div class="text">
												<p>
													Hayarkon Park Tel Aviv
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-30">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													14.10.19
												</p>
											</div>
										</div>
									</div>

									<div class="col col-30">
										<div class="top-box yellow">
											<h2>More Info</h2>
											<div class="text info">
												<p>
													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
														
														www.tlv.dgtl.nl
													</a>
												</p>
											</div>
										</div>
									</div>
							        <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to the Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

                                   <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now, Tel Aviv. DGTL brings together the worlds of music, technology and art, as well as the latest discoveries in production and sound.</p> 
                                   <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which, will operate simultaneously at any given moment.</p>
                                   <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for reducing electricity consumption, vegetarian food only, a recycling plan and more. </p>
                                   <p>The Festival will be held in the fabulous Yarkon Park,  situated in the heart of the buzzing city of Tel Aviv. As a hub of innovation, trendiness and exciting nightlife scene, it is the perfect host for DGTL festival. </p>
                                   <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

	                            `,
      };
    },
  },

  {
    id: "The_International_Arts",
    bgImage: "/posts/bank/international-arts/1.jpg",
    mobBgImage: "/posts/bank/international-arts/M.jpg",
    title: "The International Arts",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-50">
										<div class="top-box yellow">
											<h2>Location</h2>
											<div class="text">
												<p>
													Jerusalem
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-50">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													12 - 24.08.2019
												</p>
											</div>
										</div>
									</div>
							
                                    <h2>The International Arts and Crafts Festival 2019<br>
                                    <small>Hutzot Hayotzer Jerusalem<small></h2>
                                    <p>Jerusalem is packed with fantastic events throughout the summer. One of the most celebrated events is the colorful “Hutzot Hayotzer -International Art and Crafts Festival”. </p>
                                    <p>This large-scale annual festival takes place in the Hutzot Hayotzer lane and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
                                    <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years. It has long since became a hugely popular tourist and artistic attraction for visitors from around the world. Visitors will enjoy more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more, as well as an international exhibition, showcasing the work of overseas artists.  They will be able to engage in fascinating art conversations and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music, all wrapped up in an authentic European carnival atmosphere. </p>
                                    <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
                                    <p>Last but definitely not least, don’t miss the “Food around the world” - an Israeli and international food fair, which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>
                                    <a href="https://artfair-jer.com/english/" target="_blank" class="artfair-link">www.artfair-jer.com</a>
	                            `,
      };
    },
  },

  {
    id: "Jerusalem_Marathon",
    bgImage: "/posts/bank/jer-marathon2019/1.jpg",
    mobBgImage: "/posts/bank/jer-marathon2019/M.jpg",
    title: "Jerusalem Marathon",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-30">
										<div class="top-box yellow">
											<h2>Location</h2>
											<div class="text">
												<p>
													Jerusalem
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-30">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													20.03.2020
												</p>
											</div>
										</div>
									</div>
									<div class="col col-30">
										<div class="top-box yellow">
											<h2>More Info</h2>
											<div class="text info">
												<p>
													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">
														
														jerusalem-marathon.com
													</a>
												</p>
											</div>
										</div>
									</div>
									<div class="clear"></div>
                                    <h2>A Spectacular run through the 3,000-Year-old city</h2>
                                    <p>With 30,000 participants including hundreds of elite runners from around the world, The International Jerusalem marathon, is a fantastic celebration of body and mind in the heart of one of the most enchanted cities in the world. </p>
                                    <p>The Jerusalem International Marathon provides the runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event, with a series of cultural happenings planned around the central event.</p>
                                    <p>The marathon offers a variety of tracks, from professional to family friendly.</p>
                                    <p>The course takes you by the fascinating historical sites that reveal the 3,000 years of Jerusalem’s history, the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of the capital. </p>
                                    <p>The course includes the city’s best-known sites, among others the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

                                    <p>Runners are provided with the opportunity to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners. Ultimately guaranteeing an illuminating, challenging, thrilling and unforgettable experience for all runners. </p>

	                            `,
      };
    },
  },

  {
    id: "Open_Houses_Festival",
    bgImage: "/posts/bank/openhf/1.jpg",
    mobBgImage: "/posts/bank/openhf/M.jpg",
    title: "Open Houses Festival",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-30">
										<div class="top-box yellow">
											<h2>Location</h2>
											<div class="text">
												<p>
													Tel Aviv, City -Wide 
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-30">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													19 - 21.09.2019
												</p>
											</div>
										</div>
									</div>
									<div class="col col-30">
										<div class="top-box yellow">
											<h2>More Info</h2>
											<div class="text info">
												<p>
													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">
														
														www.batim-il.org
													</a>
												</p>
											</div>
										</div>
									</div><div class="clear"></div>
                                    <h3>An amazing experience for design lovers everywhere</h3>
                                    <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>

                                    <p>The ‘Open Houses’ opens a one-time door to allow a glimpse into the forms of design, style of living, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
                                    <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical as well as urban buildings. The Festival will also include special guided tours and attractions in unusual places -  from tours of residential apartments to tours of  new buildings. </p>
                                    <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel-Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
                                     <p>"Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
                                    <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>

	                            `,
      };
    },
  },

  {
    id: "TelAviv_Marathon",
    bgImage: "/posts/bank/tlv-marathon2020/1.jpg",
    mobBgImage: "/posts/bank/tlv-marathon2020/M.jpg",
    title: "Tel Aviv Marathon",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-30">
										<div class="top-box yellow">
											<h2>Location</h2>
											<div class="text">
												<p>
													Tel Aviv 
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-30">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													28.02.2020
												</p>
											</div>
										</div>
									</div>
									<div class="col col-30">
										<div class="top-box yellow">
											<h2>More Info</h2>
											<div class="text info">
												<p>
													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">
														
														www.tlvmarathon.co.il
													</a>
												</p>
											</div>
										</div>
									</div>
									<div class="clear"></div>
                                    <h3 >Run and fun in the city that doesn’t stop</h3>
                                    <p>Tel Aviv Marathon is the country’s biggest international sports event. A unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its remarkable sites and views while their heart beat becomes one with the pulse of this adrenaline charged metropolis. </p>
                                     <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
                                     <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
                                     <p>The marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
                                     <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>

	                            `,
      };
    },
  },

  {
    id: "Night_Run_TelAviv",
    bgImage: "/posts/bank/tlv-nightrun2019/1.jpg",
    mobBgImage: "/posts/bank/tlv-nightrun2019/M.jpg",
    title: "Night Run Tel Aviv",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv 
										</p>	
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											30.10.2019
										</p>
									</div>
								</div>
							</div>
							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.tlvnightrun.co.il/MenuDefault.aspx?id=6571">
												
												www.tlvnightrun.co.il
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                                    <h3>The most exhilarating 10km you will ever experience</h3>
                                    <p>A lot has been said about the world-renowned city of Tel Aviv. Named among Lonely Planet’s 'Top 10 Action-Packed Cities’, this city is a truly trendy buzzing metropolis that doesn’t rest. While its official slogan is the Non Stop City, it truly gives NYC a run for its money for the title the City that doesn’t sleep. </p>
                                    <p>This is especially the case when it comes to the amazing Night Run Tel Aviv annual race. </p>
                                    <p>With around 25,000 runners and tens of thousands of cheering spectators, this upbeat adrenaline-charged race is more of a full-blown night time party for the scores of participants and spectators who come from all around the world to take part.</p>
                                    <p>Taking place during the autumn, the 10KM night run begins well after sundown and follows a fantastic urban route along the streets of Tel Aviv, starting at  Rabin Square in the center of town, and south along Rothschild Boulevard, before continuing along Dizengoff Street, Nordau Boulevard, and into Park Hayarkon, reaching the finish line alongside the river. </p>
                                    <p>You will be passing all the trendy,, fascinating attractions and renowned Bauhaus architecture the "White City" of Tel Aviv has been declared a UNESCO World Heritage Site for. </p>
                                    <p>Best of all, The TLV Night Run ends with a celebratory finish line festival at Hayarkon park in the heart of the city where thousands more come to join the runners and spectators in an all-night rager of music, dancing and nonstop fun.</p>

	                            `,
      };
    },
  },

  {
    id: "Celine_Dion",
    bgImage: "/posts/bank/Celine_Dion/1.jpg",
    mobBgImage: "/posts/bank/Celine_Dion/M.jpg",
    title: "Celine Dion",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                             <div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											HaYarkon Park, Tel Aviv
										</p>	
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											04.08.2020
										</p>
									</div>
								</div>
							</div>
							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.celinedion.com">
												
												www.celinedion.com

											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                                    <h3>Our Heart Goes On – for Celine Dion in Tel Aviv!</h3>
										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>

                                        <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>

                                        <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>

                                        <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!

	                            `,
      };
    },
  },

  {
    id: "Nickcave_Badseeds",
    bgImage: "/Concerts/bank/nickcave_badseeds/1.jpg",
    mobBgImage: "/Concerts/bank/nickcave_badseeds/M.jpg",
    title: "NICK CAVE & BAD SEEDS",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                             <div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Bloomfield Stadium, Tel Aviv
										</p>	
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											17.06.2020
										</p>
									</div>
								</div>
							</div>
							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="">
												
												Update Soon

											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                                    <h3 >NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h3>
                                    <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>

                                    <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>

                                    <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>

                                    <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>

                                    <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>
	                            
	                            `,
      };
    },
  },

  {
    id: "Louis_CK",
    bgImage: "/posts/bank/Louis_CK/1.jpg",
    mobBgImage: "/posts/bank/Louis_CK/M.jpg",
    title: "He’s coming back! Louis CK in Tel Aviv",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                             <div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Hangar 11, Tel Aviv
										</p>	
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											23.11.2019
										</p>
									</div>
								</div>
							</div>
							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.facebook.com/events/%D7%A4%D7%99%D7%A1-%D7%90%D7%A8%D7%A0%D7%94-%D7%9E%D7%9C%D7%97%D7%94-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%9C%D7%95%D7%90%D7%99%D7%A1-%D7%A1%D7%99-%D7%A7%D7%99%D7%99-%D7%91%D7%94%D7%95%D7%A4%D7%A2%D7%94-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-louis-ck-live-in-israel/554683431359536/">
												
												Louis CK

											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                                    <p>Back for the second time, Louis CK will preform at the Hangar 11 in Tel Aviv, this upcoming November.</p>

                                    <p>After his tremendous success in Jerusalem in 2016, Louis CK is about to return for another exclusive show; this time, right here in Tel Aviv, one of the hottest cities for live shows.</p>

                                    <p>The talented, hilarious comedian is back in action after a two-year break making this show, bigger, better and funnier than ever. Having a wide following audience in Tel Aviv alone, the sharp comedian is sure to light up the stage.</p>

                                    <p>Tel Aviv has hosted dozens of comedians from all over the world, including Jerry Seinfeld and Chris Rock, Jim Jefferies and many others, is the ultimate city for having a good time. The city is known for its art and culture as well as its exciting club scene and trendy bars and restaurants.</p>

                                    <p>So book your trip now and get ready for an unforgettable time in the city that doesn’t stop!</p>
	                            `,
      };
    },
  },

  {
    id: "Cycle_Tel_Aviv",
    bgImage: "/Concerts/bank/cycle-tlv-2019/1.jpg",
    mobBgImage: "/Concerts/bank/cycle-tlv-2019/M.jpg",
    title: "Cycle Tel Aviv",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                             <div class="col col-50">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											All Around Tel Aviv
										</p>	
									</div>
								</div>
							</div>

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											18.10.2019
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
                                    <p>The mild to warm October weather, combined with the energetic vibe of Tel Aviv, provide the perfect setting for the biggest cycling event in the country.</p>

                                    <p>Thousands of cycling enthusiasts flock to Tel Aviv to ride through the vibrant city, on a scenic course showing you everything Tel Aviv has to offer:</p>

                                    <p>From the beautiful Yarkon Park, along the coast, past the city’s many dazzling beaches and back up to the park through the city center, you’ll get a glimpse of every characteristic place, the “Mediterranean capital” has to offer.</p>

                                    <p>Everyone can experience the thrill and excitement of the event, from the 60 km course for professional riders to the 8 km course for families and beginners, there is even a rollerblades course for those who prefer to make their way through the city on foot.</p>

                                    <p>With the locals coming out in droves to cheer on the event, you’ll see a colorful and diverse crowd, adding to the fun and excitement in the air.</p>

                                    <p>Whether you’re looking for a personal challenge to compete against some of the top riders in the country, or you’re hoping to enjoy a family day out with the crowds, you’re sure to experience the beauty and energy that makes up the unique atmosphere of Tel Aviv.</p>
	                            `,
      };
    },
  },

  {
    id: "DGTL_Festival_2020",
    bgImage: "/posts/bank/dgtl-festival2019/1.jpg",
    mobBgImage: "/posts/bank/dgtl-festival2019/M.jpg",
    title: "DGTL FESTIVAL",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-30">
										<div class="top-box yellow">
											<h2>Location</h2>
											<div class="text">
												<p>
													Hayarkon Park Tel Aviv
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-30">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													08.2020
												</p>
											</div>
										</div>
									</div>

									<div class="col col-30">
										<div class="top-box yellow">
											<h2>More Info</h2>
											<div class="text info">
												<p>
													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
														
														www.tlv.dgtl.nl
													</a>
												</p>
											</div>
										</div>
									</div>
									<div class="clear"></div>
							         <p>DGTL Festival is back!  B</p>
                                    <p>ringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

                                    <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology, and art, as well as the latest discoveries in production and sound. </p>
                                    <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which will operate simultaneously at any given moment.</p>
                                    <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
                                    <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the perfect host for DGTL festival.</p> 
                                    <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! 

	                            `,
      };
    },
  },

  {
    id: "Pride_Week_2020",
    bgImage: "/posts/bank/Pride_Parade_2019/1.jpg",
    mobBgImage: "/posts/bank/Pride_Parade_2019/M.jpg",
    title: "Pride Week 2020",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											12.6.2020
										</p>
									</div>
								</div>
							</div>

							<div class="clear"></div>
							<div class="responisve-iframe">
					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
				             </div>
				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
							<span class="ac-cradit-text">Credits:</span>
								
								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
							</div>
							<p></p>
							</div>
							 <h3>The  most fabulous event of the Year</h3>
							 
                            <p><strong>Tel Aviv 2020 Pride Celebrations – guaranteed to blow your mind!</strong></p>
                            <p>Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties, but by far one of the biggest and hottest events in the city are the Gay Pride Week festivities culminating in the awesome Friday Pride Parade.</p>
                            <p>The parade, a tradition which began as early as 1998 draws a huge crowd of the coolest people from around the world who come together to celebrate and support freedom and the embracing of all lifestyles and genres in an open-minded off the charts celebration.</p>
                            <p>The parade is the highlight of a week of gay pride events that take place around the city and include nonstop pride-themed parties, exhibitions, movie festivals, music concerts and so much more. </p>
                            <p>The parade itself takes place along the buzzing main streets of amazing Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic floats, live music, dance performances and revelers dressed in a colorful festival dress.</p> 
                            <p>The parade culminates at the stunning Tel Aviv promenade by the shores of the beautiful Tel Aviv coastline where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.  </p>
                            <p>The 2020 parade will take place on June 12th 2020 and participation, as always, will be completely free of charge. </p>

					               `,
      };
    },
  },

  {
    id: "Hutzot_Hayotzer_Jerusalem_2020",
    bgImage: "/posts/bank/international-arts/1.jpg",
    mobBgImage: "/posts/bank/international-arts/M.jpg",
    title: "Hutzot Hayotzer Jerusalem",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-50">
										<div class="top-box yellow">
											<h2>Location</h2>
											<div class="text">
												<p>
													The Sultan’s Pool, Jerusalem
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-50">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													08.2020
												</p>
											</div>
										</div>
									</div>
							        <div class="clear"></div>
                                    <h3 >The International Arts and Crafts Festival</h3>
                                    <p>Jerusalem is packed with fantastic events throughout the summer, one of the most celebrated events is the colorful “Hutzot Hayotzer International Art and Crafts Festival”. </p>
                                    <p>This large-scale annual festival takes place in the Hutzot Hayotzer area and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
                                    <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years and has become a hugely popular tourist and artistic attraction for visitors from around the world.</p>
                                    <p>The festival includes more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more. The festival also includes an international exhibition, showcasing the work of overseas artist.</p>
                                    <p>Visitors will get to engage in a fascinating dialogue of art and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music and all in an authentic European carnival atmosphere. </p>
                                    <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
                                    <p>Last but definitely not lease, don’t miss the “Food around the world” - an Israeli and international food fair which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>

	                            `,
      };
    },
  },

  {
    id: "Jerusalem_Beer_Festival_2020",
    bgImage: "/posts/bank/jerusalem-beer-festival/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-beer-festival/M.jpg",
    title: "Jerusalem Beer Festival",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-50">
										<div class="top-box yellow">
											<h2>Time</h2>
											<div class="text">
												<p>
													18:00 – 00:00
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-50">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													08.2020
												</p>
											</div>
										</div>
									</div>
									<div class="clear"></div>
							        <p>The city of Jerusalem is proud to host, for the 16th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’. </p>
                                    <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>

                                    <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an unparalleled atmosphere, guaranteeing an unforgettable experience.</p> 

                                    <p>The iconic festival has become over the years a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe to enjoy a delicious variety of excellent cold beers, food and people in open Jerusalem air.</p>

                                    <p>During the festival, you will have the opportunity to taste any (or all) of the over 120 special flavors of beers from around the country and the world, served in pop up bars, build specifically for the festival. </p>
                                    <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local artisanal breweries.</p> 

                                    <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>

	                            `,
      };
    },
  },

  {
    id: "Jerusalem_Wine_Festival_2020",
    bgImage: "/Concerts/bank/jer-wine-festival-2020/1.jpg",
    mobBgImage: "/Concerts/bank/jer-wine-festival-2020/M.jpg",
    title: "Jerusalem Wine Festival",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Jerusalem
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											08.2020
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
												www.imj.org.il
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
							
							 <h3 >Wine and dine in the holy city!</h3>
							<p>Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world-class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premier social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.</p>
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
							</div>
                            <p>Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.</p>
                            <p>Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!</p>

					     `,
      };
    },
  },

  {
    id: "Open_Houses_Festival_2020",
    bgImage: "/posts/bank/openhf/1.jpg",
    mobBgImage: "/posts/bank/openhf/M.jpg",
    title: "Open Houses Festival",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-30">
										<div class="top-box yellow">
											<h2>Location</h2>
											<div class="text">
												<p>
													Tel Aviv, City -Wide 
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-30">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													09.2020
												</p>
											</div>
										</div>
									</div>
									<div class="col col-30">
										<div class="top-box yellow">
											<h2>More Info</h2>
											<div class="text info">
												<p>
													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">
														
														www.batim-il.org
													</a>
												</p>
											</div>
										</div>
									</div><div class="clear"></div>
                                    <h3 >An amazing experience for design lovers everywhere</h3>
                                    <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year in a row, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>
                                    <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical buildings, and urban buildings. I from tours of residential apartments and new buildings. The Festival will also include special guided tours and attractions in unusual places.</p>
                                    <p>The ‘Open Houses’ opens a one-time door and allow a glimpse into the forms of design, life forms, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
                                    <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel-Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
                                    <p> "Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
                                    <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>

	                            `,
      };
    },
  },

  {
    id: "Purim_2020",
    bgImage: "/Concerts/bank/purim2020/1.jpg",
    mobBgImage: "/Concerts/bank/purim2020/M.jpg",
    title: "Purim 2020",
    smlTitle: "",
    html: function() {
      return {
        __html: `     
                                    <div class="col col-50">
										<div class="top-box yellow">
											<h2>Location</h2>
											<div class="text">
												<p>
													Tel Aviv and Jerusalem
												</p>	
											</div>
										</div>
									</div>

									<div class="col col-50">
										<div class="top-box yellow">
											<h2>Date</h2>
											<div class="text">
												<p>
													09-10.03.2020
												</p>
											</div>
										</div>
									</div>
								
									</div><div class="clear"></div>

                                    <p>Every year in March, Tel Aviv and Jerusalem people dress up in costumes and the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!</p>
		                            <div class="img-wrapper">
										<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
									</div>
		                            <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – with the annual street party being Tel Aviv’s biggest event. Thousands of dressed up people will gather together in Kikar Hamedina to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.</p>
		                            <div class="img-wrapper">
										<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
									</div>
		                            <p>If you prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events are held at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!</p>
		                            <div class="img-wrapper">
										<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
									</div>
		                            <p>So choose your costume and come celebrate with us!</p>
                            
	                            `,
      };
    },
  },

  {
    id: "TelAviv_Fashion_Week_2020",
    bgImage: "/Concerts/bank/fashion-week-2020/1.jpg",
    mobBgImage: "/Concerts/bank/fashion-week-2020/M.jpg",
    title: "TEL AVIV FASHION WEEK",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											03.2020
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//fashionweektelaviv.com/">
												fashionweektelaviv.com
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
							<h3 >C'est chic, magnifique!</h3>
                            <p>Fashion events are always a celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene. </p>
                            
                           <!--<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
							</div>-->
							<p>TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!</p>
                            <p>In 2020, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!</p>


					               `,
      };
    },
  },

  {
    id: "The_Jerusalem_March_2020",
    bgImage: "/Concerts/bank/jerusalem-march/1.jpg",
    mobBgImage: "/Concerts/bank/jerusalem-march/M.jpg",
    title: "The Jerusalem March",
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Jerusalem 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											30.09.2020 
										</p>
									</div>
								</div>
							</div>

							
							<div class="clear"></div>
							<p>Taking place in October, the Jerusalem Walk is one of the most colorful and exciting events in the country, bringing together tens of thousands of marchers from around the world.</p>
                             <p>The Jerusalem march includes three events - a morning walk on nature trails, a happening in Sacher Park and a festive parade that takes place in the streets of central Jerusalem.</p>
                             <p>To ensure the inclusion of all those who want to join, the march offers a variety of routes with different lengths and difficulty levels. </p>
                             <p><strong>Morning Tracks</strong><br/>
                             	<u>Track A</u> - for those who can walk, about 12 km (07:00 to 09:00)</p>
                             <p><strong>Ammunition Hill to Sacher Park.</strong><br/>
                             	<u>Track B</u> - Medium difficulty level, about 9 km (07:30 to 09:30)</p>
                             <p><strong>Mount Scopus to Sacher Park.</strong><br/>
                                <u>Track C </u>- easy / family difficulty level, about 4 km (08:00 to 10:00)</p>
                             <p>Safra Square to Sacher Park.<br/>
                             Sacher Park Festival </p>
                             <p>Between 10:00 and 16:00 a festive happening will take place in Sacher Park that will include performances, live music and children’s shows, and a designated area dedicated for kids. </p>
                             <p>The festive parade will begin at 15:00 and will follow the route of Bezalel, Hillel and King David streets and will end next to the bell park and will include collector vehicles, representative groups from Israel and around the world, orchestras, dance groups, IDF soldiers, street artists, sports teams and more.</p>
                             <p>Don’t miss your chance to take part in this beautiful and lively Jerusalem celebration! </p>


				`,
      };
    },
  },

  {
    id: "The_Pixies_2020",
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "The Pixies",
    smltitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											14.07.2020
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="//www.pixiesmusic.com">
											www.pixiesmusic.com
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>

							<h3 >The Pixies - coming back to rock it live Tel Aviv!</h3>

										<p>The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!</p>
			                            <p>The famous American band, well known for its signature style of aggressive punk rock and pop, is responsible for some of the most iconic tunes in music history, including their all-time audience favorite ‘where is my mind’. The pixies are returning to Tel Aviv for the third time as part of their promotional tour for their new album, ‘Beneath the Eyrie’. </p>
			                            <p>The pixies will be giving a single performance in the nonstop city of Tel Aviv, the perfect way to rock your beach, sun and fun Tel Aviv holiday.  The concert is set to be held in July, a fabulous time to enjoy the famous Tel Aviv summer, the parties, the amazing cuisine, and the stunning beaches. </p>
			                            <p>Tickets are selling fast so hurry up and book your trip today!  </p>

						`,
      };
    },
  },

  {
    id: "White_Night_2020",
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "White Night",
    smltitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-50">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											06.2020
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>

							<h3>A “White Night” Rager In the Non-Stop City!</h3>

							<div class="responisve-iframe">
								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
							</div>
							<p>When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…</p>
                            <p>From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Adam Primer
							</small>
							<p>The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.</p>
                            <p>This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Kfir Sivan
							</small>
							<p>The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time. </p>
											
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by Moshik Lindenbaum
							</small>
							<p>So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv! </p>
											
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by: Guy Yechiely‎.
							</small>

						`,
      };
    },
  },

  {
    id: "Piano_Competition_2020",
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "The Rubinstein International Piano Competition 2020",
    smltitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											Tel Aviv 
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											05-21.05.2020
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://arims.org.il/">
											www.arims.org.il
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
							<p>There is no shortage of fantastic arts and culture events in Tel Aviv, but the Rubinstein International Competition is the pride of the city. </p>
							
							<p>39 extremely talented pianists have been nominated to participate in the 16th Arthur Rubinstein International Piano Master Competition. 15 competitors are coming from Asia, 10 from Eastern Europe, 7 from Europe, 3 local talents, 2 from Georgia, and 2 from the USA. Tel Aviv, the cultural hub, is happy to welcome all of them. </p>
							<div class="img-wrapper">
								<img src=${getImgUrl() +
                  "/Concerts/piano-competition-2020/1.jpg"} class="img-responsive" />
							</div>
							<p>The first two stages of this prestigious competition will be held at the Tel Aviv Museum of Art, one of the country’s leading artistic and cultural institutions. The lively Sarona Market is only a 10-minute stroll from there. </p>
							<p>The final stages will be hosted at the Charles Bronfman Auditorium, also known as the Culture Palace (Heichal HaTarbut), located in Habima Square, next to the national theater. Some of the best cafés and restaurants of Tel Aviv are located nearby, as well as the beautiful Rothschild Boulevard. </p>
							<p>Early tickets sale for friends of the society and newcomers has already started. The regular sale will commence on 16 February 2020. </p>


							

						`,
      };
    },
  },

  {
    id: "Red_Hot_Chili_Peppers_2020",
    bgImage: "/posts/bank/14/1.jpg",
    mobBgImage: "/posts/bank/14/M.jpg",
    title: "Red Hot Chili Peppers",
    smltitle: "",
    html: function() {
      return {
        __html: `

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Location</h2>
									<div class="text">
										<p>
											HaYarkon Park, Tel Aviv
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>Date</h2>
									<div class="text">
										<p>
											10.06.2020
										</p>
									</div>
								</div>
							</div>

							<div class="col col-30">
								<div class="top-box yellow">
									<h2>More Info</h2>
									<div class="text info">
										<p>
											<a target="_blank" href="https://redhotchilipeppers.com/">
											www.redhotchilipeppers.com
											</a>
										</p>
									</div>
								</div>
							</div>
							<div class="clear"></div>
							<h2>Red Hot Chili Peppers are coming to Funkyard Tel Aviv!</h2>
							<p><b>They’re hot, they’re sexy, they’re Red Hot Chili Peppers,<br class="hide-on-mobile"> and they’re coming back to Tel Aviv for the first time since 2012!</b></p>
							<p>With 11 albums, 16 Grammy nominations and six awards, this mega-successful band will make your heart, body, and soul dance at the new Funkyard Festival to be held at the green heart of Tel Aviv - Hayarkon Park. </p>
							<div class="img-wrapper">
								<img src=${getImgUrl() +
                  "/Concerts/red-hot-chili-peppers-2020/1.jpg"} class="img-responsive" />
							</div>
							<p>last December, the band announced the return of the legendary guitarist John Frusciante to the band for the second time, and we’re sure the LA funk-rock icons will rock the park once again.</p> 
							<p>Red Hot Chili Peppers will give a single concert in the city that doesn’t stop, where you can start the day tanning at the beach with ice-cold beers and end up at one of the lively bars open till morning. The Peppers’ will perform at the beginning of summer when the temperatures are not too hot, but the parties across the city are sizzling. </p>
							<p>Tickets are on sale now and the concert is expected to be sold out, so book your trip before it’s gone!</p>

							
							
							

						`,
      };
    },
  },
];

// End live shows

export const newPostdata = [
  {
    id: "eurovision",
    bgImage: "/posts/bank/eurovision/1.jpg",
    mobBgImage: "/posts/bank/eurovision/M/1.jpg",
    title: "EUROVISION TEL AVIV",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/logo.png"} class="img-responsive" />
					</div>
					<h3>
						A ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST
					</h3>
					<p>					
						Epic song contest in the Non-Stop City
					</p>
					<p>
						Semi-final 1: 14 May 2019
					</p>
					<p>
						Semi-final 2: 16 May 2019
					</p>
					<p>
						Grand Final: 18 May 2019
					</p>
					<p>
						It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.
					</p>					
					<p>
						Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.
					</p>            
                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv.
					</p>
					<p>
						The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!
					</p>

            	`,
      };
    },
  },

  {
    id: "Get_ready_to_party",
    bgImage: "/posts/bank/Get_ready_to_party/1.jpg",
    mobBgImage: "/posts/bank/Get_ready_to_party/M/1.jpg",
    title: "The best Eurovision parties to be at",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

               <h3>
               	Your Total Guide to Tel Aviv Eurovision parties
               </h3>
               <p>
					From the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv…
				</p>
				<h3>
					CHARLES CLORE PARTY VENUE
				</h3>
				<h3>
					Charles Clore Park: home to the largest Eurovision Village to have ever been made.
				</h3>
				<p>
					Charles Clore Park is located on the sea-front in the south-west of Tel Aviv. It’s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv. 
					During Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea! 
				</p>
				<p>
					Also, some of Israel’s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.
				</p>
				<p>
					Charles Clore is easy to get to: It’s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you’ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there. 
					It’s a big park and will be having a Eurovision makeover, so you won’t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!
				</p>
				<h3>
					TEL AVIV PORT VENUE (“The Namal”)
				</h3>
				<h3>
					Home to 2019’s official Eurovision Euro Club
				</h3>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					The club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:
					<a href="https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0" target="_blank">https://www.eventer.co.il</a>
				</p>
				<h3>
					EUROVISION VENUE
				</h3>
				<h3>
					Expo Tel Aviv: home to the Eurovision Song Contest itself
				</h3>
				<p>
					The 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you’ve got tickets, this is the place you’ll need to get to.
					It’s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes’ away from the convention centre.
				</p>
				<p>
					Don’t forget about the White Night, all the details are in the next article.
				</p>

         	`,
      };
    },
  },

  {
    id: "Tourist_info",
    bgImage: "/posts/bank/Tourist_info/1.jpg",
    mobBgImage: "/posts/bank/Tourist_info/M/1.jpg",
    title: "Tourist info",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

					<h3>
					How to get to Tel Aviv from the airport:
					</h3>
					<p>
					The cheapest way to get into central Tel Aviv from Ben Gurion airport is by train. Follow the signs to the train station that’s attached to the airport (it’s clearly sign-posted) and look for a train that’s going to Tel Aviv-HaHagana (for south Tel Aviv), Tel Aviv-HaShalom (for Central Tel Aviv), Tel Aviv-Savidor Center (for the Old North area of Tel Aviv), or Tel Aviv-University (for the Eurovision Song Contest venue itself). Please note that Tel Aviv HaShalom is closed on Fridays until September 2019. 
					A one-way single ride ticket will cost 13 shekels 50, and the journey takes around 25 minutes. When you get off the train, you might want to take a taxi to your accommodation. Whenever you get in a taxi, ask the driver to use the meter (“monet”) and have cash ready to pay. Or see below for details of taxi apps. For more information and to plan your journey, visit <a href="https://www.rail.co.il/en" target="_blank">https://www.rail.co.il/en</a>: - it’s in English!
					</p>
					<p>
					If you’d prefer to take a taxi all the way to Tel Aviv from the airport, then join the registered taxi queue outside the arrivals hall. A member of staff will ask you where you’re going and how many passengers and cases you have, then will give you a ticket to hand to your driver. You can either use a meter or accept a fixed price. Journeys usually cost around 150-170 shekels for one person. 
					</p>
					<h3>
					How to get from Tel Aviv to Jerusalem:
					</h3>
					<h3>
					By Bus
					</h3>
					<p>
					Head to the Tel Aviv Savidor train central station take bus no.480. The journey time is around 45 minutes. The bus route finishes at the Jerusalem Central Bus Station on Jaffa Road. From there you can take the tram or any other means of transportation available to you, to get to your final destination. 
					</p>
					<h3>
					By Train
					</h3>            
					<p>
					You can also take the brand new train! If you want to go to Jerusalem directly from Ben Gurion Airport, take the train to Navon Station in Jerusalem. The journey from the airport takes around 25 minutes. If you’re connecting from other Tel Aviv stations, just take a train to Ben Gurion Airport station and change there for a connection to Navon.  
					</p>            
					<h3>
					How to get around Tel Aviv
					</h3>
					<p>
					The municipality of Tel Aviv will offer free public transport throughout the city over the weekend of the Eurovision Song Contest. 
					Free buses will run on Friday and Saturday May 17-18.
					However Usually on Saturday there is no public transport in Tel Aviv (aside from taxies).
					</p>
					<p>
					For the other days of Eurovision week, you’ll need a Rav Kav card: Similar to the “Oyster Card” in London, a Rav Kav is a smart card that can be loaded with credit to allow you to ride on buses without needing to worry about cash. In fact, bus drivers no longer let you pay in cash, so it’s super important to get a Rav Kav as soon as you arrive in Tel Aviv.
					To get a card, just jump on a bus at any bus stop, and ask the driver for a Rav-Kav card - it costs 5 shekels (You will need exact change). Then, when you get off the bus, take the card anywhere with you. Some local 7/11s (Kiosk) provide top up serives, ask to add some credit. 50 shekels is probably enough for a one-week visit, as it will cover the cost of around 10 local journeys (each journey is 5 shekels 90). 
					You can also buy a Rav Kav at the official Rav Kav office at 35 Iban Gabirol Street, which is open Sunday to Thursday 8:00 - 20:00 and Friday and holiday eves 8:00 - 13:00 ,or in the Tel Aviv Savidor train station and Carmelit central. You can also add credit at any train station. 
					</p>
					<h3>
					Cycling
					</h3>
					<p>
					Tel Aviv is a cycling hot-spot and there are bike lanes all around the city, including one that runs all the way along the beach promenade from Jaffa in the south  the north of Tel Aviv and beyond, which are gorgeous locations to take a bike ride while soaking up the atmosphere and architecture of Tel Aviv. If you have a bicycle helmet, bring it with you. 
					</p>
					<h3>
					Electric Scooters
					</h3>
					<p>
					Scooters have become super popular in Tel Aviv! They offer a convenient and fun way to get round the city. There are a few brands around – all you have to do is download the relevant app, follow instructions and off you go. Swap your handbag for a rucksack as this will help with balance and remember to keep an eye on the traffic and not to listen to music while scooting. If you have a helmet, it’s a good idea to wear it while you scoot
					</p>
					<h3>
					Walking
					</h3>
					<p>
					Walking is also a great option too - your step-count will soar after a few days in the non-stop city! Equip yourself with a map, a sun-hat and a bottle fo water, and hit the pavements!
					</p>
					<h3>
					Transportation Apps 
					</h3>
					<p>
					There are various transportation apps you can download before arrival to help you plan your way around. Search for one from each category: there are taxi apps, bicycle rental apps, scooter rental apps and journey planning apps. You can also ask your hotel concierge or apartment host for advice on how to get around Tel Aviv - they will be happy to help! 
					</p>
					<h3>
					WIFI
					</h3>
					<p>
					Tel Aviv has a free Wifi network throughout the city. Look for the ‘Free TLV’ network in your smartphone - it works in 80 locations around the city. Most cafes and bars have free public Wifi networks you can use too; just ask for the password when you make your order. Hotels also have free Wifi so just ask for the password information when you check-in.
					</p>

         	`,
      };
    },
  },

  {
    id: "White_night",
    bgImage: "/posts/bank/White_night/1.jpg",
    mobBgImage: "/posts/bank/White_night/M/1.jpg",
    title: "White night",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<h1 class="align-center">
							  White Night Lights Up Tel Aviv on 16th May 
							</h1>
        					<div class="responisve-iframe">
								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
							</div>

							<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>
                            <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv’s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>
                            <p>And for 2019, it’s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/1.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Adam Primer
							</small>

							<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it’s definitely worth stocking up on sleep so you’re ready to party all night long!</p>
                            <p>And at the Eurovision Village in Charles Clore Park, there’ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>
                            <p>Last year’s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv’s own Neta Barzilai with her smash-hit song “Fuego”, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, “Rise Like a Phoenix” while showcasing his new-look for 2019!</p>
                            <p>They’ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola Häggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition’s official lighting partner OSRAM.</p>
                            <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/2.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Kfir Sivan
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/3.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by Moshik Lindenbaum
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/4.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by: Guy Yechiely‎.
							</small>

         	`,
      };
    },
  },
  //Hadar asked to hide this post on 2021-02-08
  // {
  // 	      id:"Tel_Aviv_Street_Food",
  //               bgImage: "/posts/bank/street-food/1.jpg",
  //               mobBgImage: "/posts/bank/street-food/M/1.jpg",
  //               title :"TEL AVIV STREET FOOD",
  //               ctg:"telaviv",
  //               isVid:true,
  //               vidId:"JQD9JpMaw9g",
  //               smlTitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                      <h3>It is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations</h3>

  //                         <p>Tel Aviv, home to sandy beaches, non-stop action and a raging nightlife, is also chock-full of unique restaurants and bars, making the seaside city a trendy foodie destination. The Tel Aviv food industry is truly the city’s heart and soul and while plenty of high-end eateries can be found throughout Tel Aviv, it is fresh local street food that has taken the city by storm.</p>

  //                         <h3>Taking traditional street food to a whole new level</h3>

  //                         <p>Say goodbye to the days where Tel Aviv street food was mostly limited to the scrumptious, yet singular concept of crisply fried falafel stuffed into a freshly baked pita. Today, the Tel Aviv street food scene is just that - a scene, with gourmet and specialty treats being served to the masses on local street corners. Take a walk down Ibn Gvirol, Ben Yehuda or Carmel streets and choose from a myriad of high-end meats, fish, prepared vegetables and sauces, all artfully inserted inside pita bread, between slices of toast or other casings. Nibble on the succulent delicacies inspired by the four corners of the world - sabich and tahini in laffa bread, unique herring sandwiches and more, as you continue to wander throughout the city, a taste of Israeli culture on your tongue and a pleasant sense of satisfaction in your belly.</p>

  //                         <h3>Restaurant quality meals for the foodie on the go</h3>

  //                         <p>What more could a bustling city full of hurried business professionals and excited tourists want than easy access to flavorful and trendy dishes that can be eaten on the go? With more and more unique streetside quick-stop eateries popping up throughout the city and serving dishes like entrecote-stuffed ciabatta bread and cornflour arepas, it is no wonder that Tel Aviv was named one of Saveur Magazine’s “Outstanding Culinary Destinations.” </p>

  //                         <p>Foodies delight: Tel Aviv and its hip street food scene, with countless delectable choices on every corner, is the ultimate culinary travel destination and a must-visit stop on your next Israel trip.</p>

  //          	`   }
  //   }
  // },
  //End Hadar asked to hide this post on 2021-02-08

  //Hadar asked to hide this post on 2021-02-01
  // {
  // 	      id:"Jerusalem_Old_City",
  //               bgImage: "/posts/bank/jerusalem-old-city/1.jpg",
  //               mobBgImage: "/posts/bank/jerusalem-old-city/M/1.jpg",
  //               title :"JERUSALEM’S OLD CITY",
  //               ctg:"jerusalem",
  //               isVid:false,
  //               smlTitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                      <h3>
  //                          Sensational sites of Ancient Times
  //                      </h3>
  //                      <p>No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. A tour of the Old City of Jerusalem is an opportunity to get lost among the magical walkways and connect with the city’s resplendent past, history, culture and spirituality. </p>

  //                              <h3>The Western Wall</h3>
  //                              <p>Thousands of years old, the Western Wall is the last remaining relic of the Second Jewish Temple and the most important Jewish prayer site in the world, where millions of visitors from around the world place notes with requests and prayers into its cracks.</p>
  //                              <div class="img-wrapper">
  // 								<img src=${getImgUrl() +  "/posts/jerusalem-old-city/1.jpg"} class="img-responsive" />
  // 							 </div>
  //                              <h3>Western Wall Tunnels</h3>
  //                              <p>Located beneath the Western Wall, the tunnels provide a glimpse of the various periods in the history of Jerusalem and are as close as you'll probably get to travelling back in time.</p>

  //                              <h3>City of David</h3>
  //                              <p>Discover the story of Jerusalem during the reigns of Kings David, Solomon and Hezekiah in this captivating archeological site, where many treasures have been unearthed. A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was carved during the reign of King Hezekiah.</p>

  //                              <h3>The Old City Market</h3>
  //                              <p>A must-see attraction made up of a series of alleyways, with numerous stalls offering a staggering variety of products of every imaginable kind. This lively bustling market (or shuk) is a perfect place to pick up a unique souvenir (haggling is a
  //                              must) or try one of the many local delicacies.</p>
  //          	`   }
  //   }
  // },
  // end Hadar asked to hide this post on 2021-02-01

  {
    id: 13,
    bgImage: "/posts/bank/25/1.jpg",
    mobBgImage: "/posts/bank/25/M.jpg",
    vidId: "k4OwoEk5wMw",
    ctg: "jerusalem",
    isVid: true,
    title: "Jerusalem’s Calling",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>The most magical and radiant city on Earth </h3>

					<p>
						What else can you say about the world’s most unique city? Simply put: Welcome to Jerusalem – where a glorious history is intertwined with modern and dynamic life.
					</p>

					<p>
						Jerusalem is home to innumerable fascinating historic sites, magical walkways, breathtaking views at sunset, a wide variety of entertainment options, restaurants that offer culinary excitement, spirited nightlife and a tremendous offering of centers for the arts and culture.
					</p>

					<h3>
					   The Old City
					</h3>
					<p>
						No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. The Old City of Jerusalem brims with opportunities for you to connect with the city’s resplendent past, history, culture and spirituality. In the Old City, you’ll find archaeological treasures that are thousands of years old, contemporary art and bustling markets where you can purchase delectable delights.
					</p>

					<h3>
					  The Western Wall:
					</h3>
					<p>
						Believed to be the only remaining segment of the Second Temple, the Western Wall has become truly synonymous with Jerusalem. Thousands of years old, it is the most important Jewish prayer site in the world, where thirteen-year-old boys come to celebrate their bar mitzvahs, and where millions of visitors and tourists from around the world place notes with requests and prayers into its cracks.
					</p>
					<h3>
					  Western Wall Tunnels:
					</h3>
					<p>
						Visiting the tunnels is like entering a time machine. Located beneath the Western Wall and the Muslim Quarter, provides visitors with a glimpse of the various periods in the history of Jerusalem.
					</p>
					<h3>
					   City of David:
					</h3>
					<p>
						Located next to the Dung Gate, this site presents the story of Jerusalem during the reigns of King David, King Solomon and King Hezekiah. Many archeological treasures were unearthed in the excavation, including a two-thousand year-old gold earring.
					</p>
					<p>
					   A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was built during the reign of King Hezekiah.
					</p>

					<h3>
					 Via Dolorosa
					</h3>
					<p>
						Christian faithful follow in the footsteps of Jesus down the Via Dolorosa and the 14 Stations of the Cross, reenacting the fateful path that had an unprecedented impact on the course of history.
					</p>

					<h3>
					  Church of the Holy Sepulchre:
					</h3>
					<p>
						According to Christian tradition, the Church is the site where Jesus was crucified, buried and where he resurrected from the dead. It has long been and continues to be a major pilgrimage center for Christians world over.
					</p>

					<h3>
					 The market in the Old City:
					</h3>
					<p>
						This must-see attraction is made up of a series of alleyways, with numerous stalls offering a staggering variety of souvenirs, clothing, foods (baked goods, spices, sweets, tehini and more); stands hawking juices of all kinds, Armenian ceramics, drums and other musical instruments, earthenware jugs and much more. The colorful market delivers an authentic and extremely enjoyable experience that simply cannot be missed.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/2.jpg"} class="img-responsive" />
					</div>

					<h3>
						Attractions
					</h3>

					<h3>
						Segway tours:
					</h3>
					<p>
						This adrenaline-packed method of seeing the city will allow you to take in the beauty of Jerusalem from an entirely different perspective. The Segway tours leave from various central spots, including the Armon HaNatziv Promenade (East Talpiot), Yemin Moshe, and the Old City, as well as near the Knesset and the museum area.
					</p>

					<h3>
                        First Station (Hatachana):
					</h3>

					<p>
					   If you like amusement park rides, you love having your senses scintillated by the Time Elevator. It’s an interactive experience that takes visitors on fabulous voyages to fascinating places, with motion-based seating in a unique hall that is filled with special effects.
					</p>

					<h3>
                        Time Elevator:
					</h3>

					<p>
					   The First Station is right in the heart of Jerusalem, between the Old City and the city center, and between the historical neighborhoods of the German Colony and Yemin Moshe. It is the site of the first train station in Jerusalem, which was built in 1892. After undergoing renovation and preservation, the First Station was reopened as a lively entertainment spot.
					</p>

					<h3>
					   Machane Yehuda Market:
					</h3>

					<p>
					   To experience the city as authentically as possible, your itinerary must include a stop at Machane Yehuda Market. It represents Jerusalem of the present and the future. Machane Yehuda uniquely brings together old and new, with its fruit and vegetable market, along with an excellent food and a vibrant entertainment area.
					</p>

					<h3>
					   Museums
					</h3>

					<p>
					   In a city filled with a large number of museums, you have every opportunity to experience and learn about the events of the past and to visit modern and contemporary exhibits.
					</p>

					<h3>
					   Israel Museum
					</h3>

					<p>
					   The Israel Museum is the largest cultural institution in the country. It has many wings and very large collections of art, archeology and Judaica. One of the highlights of any visit to the museum is the Shrine of the Book, with its unique design that has come to be closely associated with the city itself.
					</p>

					<h3>
					   Tower of David Museum:
					</h3>

					<p>
					  Thousands of years ago, Jerusalem was a small city, where kings and prophets walked or rode their horses down the alleys. Since that time, one of the best-known symbols of the city is David’s Tower, with its turret standing proudly above the ancient fortress that has also become one of the city’s important museums.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					   Restaurants
					</h3>

					<p>
					  Jerusalem boasts many restaurants, where you can dine on a wide array of delicacies –local and international, standard and exotic. And if you are looking for the gourmet experience, you can reserve a spot at exclusive chef restaurants. The following are five of Jerusalem’s finest and most popular spots, which attract crowds all day long:
					</p>

					<h3>
					   Café Kadosh
					</h3>

					<p>
					 Highly popular, the café serves kosher dairy cuisine – all made in house, and all delicious!
					</p>

					<h3>
					   Tmol Shilshom
					</h3>

					<p>
					  A dairy bookstore café in the city center, favored for its warmth, delicious food and friendly service. Don’t miss the shakshuka or salmon fillet in fig sauce!
					</p>

					<h3>
					   The Eucalyptus
					</h3>

					<p>
					  The kosher restaurant, located in the Artist’s Quarter, serves Chef Moshe Basson’s interpretation of biblical cuisine. Every dish has its origins in biblical scenes and all the spices and herbs used grow, as in ancient times, in the surrounding hills of Jerusalem and Judea. An unforgettable experience.					</p>

					<h3>
					   Darna
					</h3>

					<p>
					  An authentic, glatt kosher, Moroccan restaurant, located in the heart of the city. Experience the warm welcome and the true meaning of Moroccan hospitality, while enjoying the culinary excellence of the Maghreb.
					</p>

					<h3>
					   Ima Restaurant
					</h3>

					<p>
					  Right down the street from Machane Yehuda market, Ima offers excellent kosher Middle Eastern food, served in a relaxed family atmosphere
					</p>

					<h3>
					   And no visit to Jerusalem is complete without scooping up some hummus with a pita right out of the oven. The following are a few centrally located hummus spots:
					</h3>

					<div class="cradit">
							<p>
							<strong>Azura,</strong><small> in the Iraqi section of the Mahane Yehuda Market </small><br>
							<strong>Lina,</strong><small> in the Christian Quarter of the Old City</small><br>
							<strong>Hummus Acramawi,</strong><small>  in the Muslim Quarter of the Old City </small><br>
							<strong>Hummus</strong><small> Ben Sira, in the city center next to the Mamilla Hotel</small><br>
							<strong>Abu Shukri,</strong><small> in the Muslim Quarter in the Old City of Jerusalem </small><br>
							</p>
				    </div>

				    <h3>
				        Nightlife
				    </h3>

				    <p>
				         Jerusalem is filled with scores of restaurants and entertainment spots that are also open on Friday nights (the Jewish Sabbath). All of Jerusalem’s entertainment areas have excellent options for weekend fun on Friday nights as well as Saturdays, and you can most definitely enjoy a delightful evening over a cold beer or dance to great music.
                         Below is a small selection of bars and clubs that are hopping on Friday nights and will leave you wanting more…
				    </p>

				    <h3>
				       Mantra
				    </h3>

				    <p>
				       An intimate restaurant and wine bar, where a friendly atmosphere meets superb cuisine.
				    </p>

				    <h3>
				       Gatsby Cocktail Room
				    </h3>

				    <p>
				       The cocktail lounge and bar evokes the magic of the Roaring 20’s and the days of cabarets.
				    </p>

				    <h3>
				        HaTaklit
				    </h3>

				    <p>
				       With a name means “the record” in Hebrew, the trendy bar is decorated with record sleeves. Enjoy full bar, live music, DJs and even independent performers.
				    </p>

				    <h3>
				       Toy Bar (HaTza’atzua)
				    </h3>

				    <p>
				      Centrally located, Toy Bar offers great drinks, great music by some of the best local DJs and great dance bar experience.
				    </p>

				    <h3>
                        Sira
				    </h3>

				    <p>
                       One of the city’s most eclectic underground clubs, with an arcade room and dance floor. The pub also hosts events and performances.
				    </p>

				    <h3>
                        Even / Juke
				    </h3>

				    <p>
				       A music club that showcases the most creative bands in Israel, with an emphasis on jazz, blues and funk.
				    </p>

				    <h3>
                       Video Pub
				    </h3>

				    <p>
				       Jerusalem’s only “official” gay bar is home to some of the wildest parties in the city.
				    </p>

				    <p>
				       Jerusalem is the ultimate vacation destination! With so much to see and do, so much to stimulate your senses and pique your curiosity, your trip to Jerusalem promises us an unforgettable experience. Book your vacation now!
				    </p>

				    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/4.jpg"} class="img-responsive" />
					</div>

					<h3>Box:</h3>
					<h3>
					   Annual events
					</h3>

					<p>
					   Jerusalem plays host to a variety of unique annual events. Check the Internet for dates and further information.
					</p>

					<h3>
					   Festival of Light
					</h3>

					<p>
					   Held in the Old City – May 25, 2016 to June 2, 2016. Come and be part of the enchanting games of light and color, with dozens of displays by Israeli and international artists. Follow the paths set up throughout the Old City, guiding visitors from one mesmerizing work to another.
					</p>

					<h3>
					   International Arts and Crafts Fair (Khutsot Hayotser):
					</h3>

					<p>
					  August 15, 2016 – August 29, 2016. Held against the backdrop of the Old City walls, visitors enjoy a very special nighttime atmosphere and happening with musical performances. Walk through the gardens and stop at the various stands, where artists from Israel and the world exhibit paintings, prints, ceramics, metalwork and jewelry, weaving and textiles, Judaica, toys, crafts in various techniques, woodwork and more.
					</p>

					<h3>
					   The Israel Festival
					</h3>

					<p>
					   May 24, 2016 – June 11, 2016. The festival is Israel’s premiere multi-disciplinary international festival. It takes place annually in the spring, presenting outstanding theater performances, contemporary dance, classical music and performances from around the world, along with ground breaking Israeli works. Numerous festival events are held at unique Jerusalem locations that have historic significance of hundreds, if not thousands, of years. There are also many street performances that are open to the public.
					</p>

					<h3>
					  Jerusalem Film Festival
					</h3>

					<p>
					   July 7, 2016 – July 17, 2016. The festival sprinkles star dust across the city, with quality cinema, actors and writers that are guests. Many famous stars have come to the festival of the years. Over 200 Israeli and foreign films will be screened during the festival, highlighting various genres and competing for prizes. The festival offers opportunities for meetings with artists, workshops, parties and musical events.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/5.jpg"} class="img-responsive" />
					</div>


         `,
      };
    },
  },

  // {
  // 	id:"Outdoor_Adventures",
  //         bgImage : "/posts/bank/40/1.jpg",
  //         mobBgImage : "/posts/bank/40/M.jpg",
  //         title : "Outdoor Adventures",
  //         ctg : "telaviv",
  //         vidId : '88OV6xU0vPI',
  //         isVid : true,
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                 <h3>An action-packed city that’s perfect for active people</h3>
  // 			<p>
  // 				People in Tel Aviv live life to the fullest – and they do it outside. This city is chock-full with outdoor activities, and you can pick and choose your favorites. It’s an action packed city – perfect for active people.
  // 			</p>
  // 			<h3>
  // 				Hayarkon Park
  // 			</h3>
  // 			<p>
  // 				Known as the “Central Park” of Tel Aviv, Hayarkon Park is visited by approximately sixteen million people annually. Attractions range from picnics on the huge lawns, pedal boating on its beautiful manmade lake to cycle tracks and tours of the many amazing gardens, portraying nature at the heart of the city.
  // 			</p>
  // 			<h3>
  // 				The Cycling Scene
  // 			</h3>
  // 			<p>
  // 				One of the ultimate ways to discover Tel Aviv is via its 100km of dedicated bike lanes, where you can enjoy the Tel-O-Fun public bike hire system that lets residents and visitors pick up and drop off sleek green bicycles in 150 stations citywide. If you enjoy spending your time on wheels, you should also check out the many dedicated skating parks, where you can watch the local daredevils do their thing, or get your own skateboard or rollerblades and join the action.
  // 			</p>

  //          `
  //     }
  //   }
  // },

  // Hadar asked to hide this video on this post on 2021-02-04
  {
    id: "Port_Pleasures",
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    vidId_post: "tgF0zMUYY2g",
    ctg: "telaviv",
    isVid: false,
    // vidId : "tgF0zMUYY2g",
    title: "متع الميناء",
    smltitle: "",
    html: function() {
      return {
        __html: `

        			
					<p>
						حينما تفكر في ميناء تل أبيب، فإن أول ما يجب أن يخطر على بالك هو مركز ثقافي وترفيهي وتجاري معاصر.
					</p>

					<h3>
						ميناء تل أبيب
					</h3>
					<p>
					ميناء تل أبيب هو موقع معاصر وديناميكي مخصص للتعبير الإبداعي والثقافي. عمل هذا الميناء بين العامين 1983 حتى 1965 كمرفأ، وبعد ذلك خضع لتجديدات واسعة النطاق حولته إلى حي للتسوق والترفيه نابض بالحياة كما هو عليه الحال اليوم. تتكون منطقة الميناء من حظائر (هانغرز) تم تحويلها إلى متاجر ومراكز ترفيه ونواد ليلية، وفي حين يمتلئ المنتزه الطويل الواسع يطل المنتزه الطويل الواسع على واجهة بحرية تمتلئ بالمتاجر والمطاعم، فإنكم ستصادفون، لدى سيركم على امتداد الكورنيش سوق الميناء، وهو مكان مخصص للاتجار بالمنتجات المحلية والدولية، حيث يمكنكم قضاء وقت ممتع مع الاستراحة والمشروب الجيد. وإن كنتم من محبي اليوغا، فستجدون مركزا لها أيضا هناك. ويتدرب الكثير من العدّائن وراكبي الدراجات في تلك المنطقة لأنها تربط الأحياء الشمالية بحديقة اليركون والميناء، وصولا إلى الشاطئ.
					</p>
					<p>عند حلول المساء، يصبح ميناء تل أبيب وجهة شهيرة لمحبي الحياة الليلية والحانات والنوادي. وقد تصادفون عروضا حية للجاز في نادي الجاز المحلي، أو عروضا حيّة أخرى في <span  class="ac-en-font">Hangar 11</span>
					إن كنتم تسعون لتحقيق أقصى استفادة من شاطئ البحر، فانقتلوا إلى ميناء تل أبيب.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small><span  class="ac-en-font">Dana Friedlander</span></small>
					    </div>
					</div>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small><span  class="ac-en-font">Dana Friedlander</span></small>
					    </div>
					</div>

         `,
      };
    },
  },
  // End Hadar asked to hide this video on this post on 2021-02-04

  {
    id: 14,
    bgImage: "/posts/videos/deadsea/1/1.jpg",
    mobBgImage: "/posts/videos/deadsea/1/M.jpg",
    title: "The Dead Sea",
    vidId: "ixFocykfYHo",
    ctg: "deadsea",
    isVid: true,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
			<p>
					A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			</p>
           <p>
					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
           </p>
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    vidId: "tgF0zMUYY2g",
    title: "Port Pleasures",
    isVid: true,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>The different charms of Tel Aviv and Jaffa Ports</h3>
					<p>
						Jaffa Port offers an ancient history, stone buildings and cobbled lanes while Tel Aviv Port is a contemporary cultural, recreational and commercial hub.
					</p>

					<h3>
					    Jaffa Port
					</h3>
					<p>
						The modern city of Tel Aviv had its humble beginnings in the port of Jaffa where immigrants, armies and traders docked their ships. The port is famed as one of the oldest in the world and today it is still used by local fishermen while the historic surrounding area has become a popular tourist destination.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

					<p>
						The waterside hangers have been converted into galleries and cultural spaces like the Nalaga’at Center operated by the deaf and blind community and the Dvir Gallery. From the waterfront the ancient cobbled alleyways wend their way up through stone buildings reminiscent of old Jerusalem. In among the historic buildings are galleries, specialty stores and excellent restaurants. As you reach the upper levels of the Old Port area you can see St. Peter’s Church, the Wishing Bridge, the Old Jaffa Museum and the Ilana Goor Museum.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<h3>
						Tel Aviv Port
					</h3>
					<p>
						In contrast to Jaffa Port Tel Aviv has a more commercial and contemporary feel. The port operated from 1938 to 1965 and has undergone renewal and restoration to convert it into a shopping and entertainment district. The port area consists of converted hangers and a long wide waterfront promenade. It is popular with families visiting the Dyada Center for children’s activities and others visiting the yoga center, center for women, conference venue and the Cavim Institute of Design and Architecture. The promenade is always alive with street performers, musical events and outdoor markets. The port is a contemporary and dynamic area for creative and cultural expression. When the sun goes down the Tel Aviv Port becomes a popular nightlife destination with bars and clubs.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>


         `,
      };
    },
  },

  {
    id: "TelAviv_By_The_Sea",
    bgImage: "posts/bank/telaviv2/1.jpg",
    mobBgImage: "posts/bank/telaviv2/M.jpg",
    title: "شواطئ تل أبيب",
    // vidId: "XDei1Zy_cu4",
    isVid: false,
    ctg: "telaviv",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>
				دقوا الشماسي، في شاطئ تل أبيب
			</h3>
			<p>
				استعدّوا للمتعة الحقيقية تحت الشمس!
			</p>
			<p>هذه الشواطئ الخلابة التي تتمتع بالمياه الصافية والشواطئ التي تفيض بالحيوية، والتي يبلغ عددها 13 شاطئا في تل أبيب، لكلّ منها شخصيته الخاصة. لا تتعجبوا إذا أن <strong>مجلة ناشيونال جيوغرافيك قد صنفت هذه الشواطئ بوصفها واحدة من أفضل عشرة مدن ساحلية في العالم"</strong></p>
			<p>إليكم قائمة بأفضل 11 شاطئا في تل أبيب، لتختاروا أيها ترغبون بزيارته</p>
			<h3>شاطئ تسوك الشمالي</h3>
			<p><strong>الموقع:</strong> يونتزمان 21<br/>
			هذا الشاطئ الذي يقع شمالا على حدود مدينة هرتسليا، هو ملاذ رائع. إلى جانب مناظره الخلابة والمنطقة المخصصة لركوب الأمواج والتزلج على الموج بواسطة الرياح، حيث رمل الشواطئ أبيض، يضم أيضا ملاعب لكرة الطائرة ومروج واسعة ومعلب. إنه شاطئ مثالي للعائلات التي تحب المجيء إلى هنالك لقضاء يوم على البحر مفعم بالمرح، في الوقت الذي تزوره فيه حشود الشباب لتأخذ راحة من المدينة.</p>

			<h3>شاطئ تسوك الجنوبي</h3>
			<p><strong>الموقع:</strong> شاطئ هتسوك<br/>
			يقع هذا الشاطئ الخلاب شمالي تل أبيب، وهو محل استرخاء بحق. تضم المنطقة التي تفضلها العائلات أيضا مطعما وصالة ألعاب رياضية في الهواء الطلق وملعبا للكرة الطائرة. خذوا نظاراتكم الشمسية وملابس السباحة، فقد آن الأوان للحصول على القليل من فيتامين د.</p>

			<h3>شاطئ تل باروخ</h3>
			<p><strong>الموقع:</strong> شارع أرتسي اسحق.<br/>
			للتمتع بأجواء هادئة بعيدا عن صخب المدينة، زوروا شاطئ تل باروخ، بالقرب من حي رمات أفيف. تفتخر هذه البقعة التي تؤمها العائلات بمنطقة للتمرين في الهواء الطلق، ومطعم وملعب للكرة الطائرة، ومروج خضراء ومناظر جميلة. هذه كلها إلى جانب مياه الشاطئ الدافئة والأجواء المريحة، تجعل من الشاطئ مكانا مثاليا لقضاء اليوم. </p>
			
			<h3>شاطئ ميتسيتسيم</h3>
			<p><strong>الموقع:</strong> جنوبي ميناء تل أبيب<br/>
			يتربع هذا الشاطئ بالنسبة للكثير من الإسرائيليين على قمة الشواطئ. إذ تمّت تسميته بعد ظهوره في فيلم ضخم من السبعينيات يحمل الاسم ذاته: "ميتسيتسيم". الشاطئ مناسب للعائلات ومريح ويحاذي مرفأ تل أبيب. وإلى جانب المناظر الجميلة والرمال البيضاء، يمكنكم العثور هنا أيضا على ملاعب لكرة الطائرة ومعدات للتمرن في الهواء الطلق وملعب للأطفال.</p>

			<h3>شاطئ نوردو</h3>
			<p><strong>الموقع:</strong> جادة نوردو<br/>
			هذا الشاطئ المحاط بجدران عالية على كلا الجانبين، والذي يفصل بين الجنسين، مخصص لسكان تل أبيب المتدينين. ويكون الشاطئ في أيام الأحد والثلاثاء والخميس مفتوحا للنساء فقط، أما أيام الإثنين والأربعاء والجمعة، فهو مفتوح للرجال فقط. وفي أيام السبت، يكون الشاطئ مفتوحا للجميع. يعد هذا الشاطئ أكثر شواطئ تل أبيب هدوءا، لذا، فإن كنت تبحث عن تجربة العزلة، فإن شاطئ نوردو هو المكان الأنسب.</p>

			<h3>شاطئ الهيلتون</h3>
			<p><strong>الموقع:</strong> شارع هيركون 205<br/>
			هذا الشاطئ الواقع في وسط تل أبيب، قبالة فندق هيلتون، يمكنك فيه أن تشارك في الرياضات المائية التي تنطوي على المغامرة، كركوب الأمواج والتجديف بالقوارب. يعتبر الجزء الجنوبي من الشاطئ أفضل مواقع تل أبيب لركوب الأمواج، فيما تعد المنطقة الشمالية منطقة صديقة للكلاب. </p>

			<h3>شاطئ غوردون</h3>
			<p><strong>الموقع:</strong> شارع غوردون<br/>
			يقع شاطئ غوردون بالقرب من مرفأ تل أبيب. إنه أحد أكثر شواطئ تل أبيب ازدحاما. إذا رغبت في جرعة من النشاط، فهذا هو المكان الأنسب لك. هنا يمكنك الاستمتاع بملاعب الكرة الطائرة، وحوض السباحة بمياه البحر الذي يطل على البحر، ومعدات التمرين الرياضي، وغيرها. كما تتواجد في المنطقة العديد من البارات التي تعتبر مثالية للتمتع بالغروب.</p>

			<h3>شاطئ فريشمان</h3>
			<p><strong>الموقع:</strong> شارع فريشمان<br/>
			يقع شاطئ فريشمان في قلب تل أبيب، وهو مكان شهير. تتوفر في هذا الشاطئ أيضا ملاعب للكرة الطائرة ومركزا للياقة البدنية في الهواء الطلق، إلى جانب مجموعة متنوعة من المطاعم والبارات القريبة. إذا كنتم تتطلعون إلى ممارسة تمارين اللياقة البدنية وأنتم تتمتعون بمشهد جميل، أو كنتم ترغبون في قضاء اليوم في الاسترخاء تحت أشعة الشمس، فهذا هو المكان المناسب.</p>

			<h3>شاطئ أفيف</h3>
			<p><strong>الموقع:</strong> شارعي هربرت صمويل ونحاميا<br/>
			يقع هذا الشاطئ في الجزء الجنوبي من منتزه تل أبيب، وهو يوفر مجموعة واسعة من الأنشطة المائية، بما فيها نادي ركوب الأمواج.</p>



			 
			<h3>شاطئ تشارلز كلور</h3>
			<p><strong>الموقع:</strong> شارع كاوفمان 6<br/>
			يقع شاطئ تشارلز كلور بالقرب من يافا. الشاطئ مقسم إلى قسمين. يميل الجزء الأقرب إلى برج الإنقاذ إلى أن يكون أكثر مخاطبة للعائلات، بينما كلما توجهت جنوبا، فإنك ستقابل أكثر فأكثر مجموعات من الشباب المتسفعين في الشمس، أو راكبي الأمواج. يصبح الجو أكثر صخبا، مما يوفر ملاذا مائيا من الوسط المزدحم للمدينة. بعد زيارتكم إلى هناك، تفقدوا مطعم "مانتا راي" أو تمشوا إلى ميناء يافا الرائع.</p>
			<h3>شاطئ جفعات عليا</h3>
			<p><strong>الموقع:</strong> شارع بات غاليم 22<br/>
			هذا هو الشاطئ الجنوبي لتل أبيب، والذي يقع على حدود مدينة بات يام. يشتهر الشاطئ بأقواسه الحجرية الجميلة وأشجار النخيل الطويلة. إذا كنتم من عشاق الرياضة، فيمكنكم لعب كرة الشاطئ هنا أو الاطلاع على مجموعة واسعة من الرياضات المائية كرياضة ركوب الأمواج شراعيا والتجديف بواسطة قوارب الكاياك. كما أن الشاطئ يوفر جوا أكثر عزلة. وإذا كنتم تفضلون الأمر: فقوموا ببساطة بنشر منشفة على الرمال واستمتعوا بالمنظر.
			سواء أكان الوقت نهارا أم ليلا، فإن التمشي على الشاطئ يعد واحدا من أفضل طرق قضاء الوقت في تل أبيب.</p>

			

			`,
      };
    },
  },

  {
    id: "Sarona_TelAviv",
    bgImage: "posts/bank/36/1.jpg",
    mobBgImage: "posts/bank/36/M.jpg",
    title: "Sarona Tel Aviv",
    isVid: true,
    ctg: "telaviv",
    vidId: "MJ-gsGs1tqA",
    smlTitle: "",
    html: function() {
      return {
        __html: `
						<!--<h3>At Tel Aviv’s Sarona Market, the culinary options are endless</h3>

						<p>Built in and around 150-year-old Templer structures in the heart of Tel Aviv is Israel’s culinary melting pot: Sarona Market. Reflecting Tel Aviv’s exemplary culinary atmosphere and placing a modern urban twist on the city’s more traditional marketplaces, Sarona is the place to visit to satisfy your every craving - and get a taste for the diverse ethnic inspirations that drive the bustling sea-side city. </p>



						<h3>Visit Israel’s largest covered culinary marketplace</h3>

						<p>From gourmet creations to spins on traditional local dishes, Sarona Market has it all and will satisfy every quaking belly. With over 90 restaurants, food stands, pubs and culinary boutiques operating seven days of the week, all you need to do is decide whether you’d rather tuck into a bowl of succulent ramen, a plate of spicy empanadas, a tangy sub sandwich or a sweet baked confection. Can’t decide? The eateries are all adjacent to one another, making a seafood entree followed by spicy pad thai or a juicy burger an easy feat. </p>

						<p>Need to take a break between courses? Sarona Market is also home to accessory shops, museums, a visitor’s center and other fun, must-see attractions.  </p>

						<h3>Go Green</h3>

						<p>TGIF! Fridays at Sarona are exceptionally enthralling, with farm-fresh produce available for purchase, making the culinary experience that much more interactive and engaging. Once you’ve selected your produce, continue on your urban market adventure, adding savory imported cheeses, top-quality Italian balsamic vinegar, boutique beers and sweet confections to your shopping bag, all tasty additions to a weekend home-cooked meal. </p>

						<p>Experience modern Israeli cuisine in full force at Sarona Market. With no end to the available culinary options reflecting the popular and unique foodie atmosphere of Tel Aviv, Sarona Market is a must-visit hotspot that will certainly satisfy every imaginable gustatory craving.</p>
						-->
			`,
      };
    },
  },

  {
    id: "Neve_Tzedek",
    bgImage: "posts/bank/4/1.jpg",
    mobBgImage: "posts/bank/4/M.jpg",
    title: "نفيه تصيدق",
    vidId: "5jl13Z-38eE",
    smlTitle: "",
    isVid: true,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `

                      	<!--<br/><h3>An artsy oasis in  the heart of bustling Tel Aviv</h3>
                      	<h3>Enjoy the magical ambiance in the shaded courtyards of Neve Tzedek’s restaurants and cafes</h3>
						<p>Tucked inside one of Tel Aviv’s oldest districts, lies an architectural gem with a young, beating heart. Established in 1887, Neve Tzedek, the first Jewish neighborhood outside of the old port city of Jaffa, has recently become a trendy stomping ground for artists of all modalities, who fit in perfectly with the district’s restored quaint Oriental architecture.</p>
						
						<h3>A true oasis within bustling Tel Aviv</h3>
						<p>Whether you’re hunting for a handcrafted ceramic dish, a one-of-a-kind article of clothing, or jewelry made from traditional welding techniques, the countless boutiques, galleries, design ateliers and fashion shops within the Oriental-style buildings lining the narrow side passages and up Shabazi Street provide a unique and personal shopping experience. And with the cool sea breeze cooling you as you roam around the neighborhood, you will begin to feel alive and mirthful, just like the neighborhood’s whimsical spirit.</p>
						<p>Enjoy the magical ambiance in the shaded courtyards of Neve Tzedek’s restaurants and cafes with a light, yet satisfying meal. The many eateries, housed in quaint, historic structures built around the neighborhood’s narrow alleyways, are true culinary treats. The yummy meals, married with the serene air experienced upon walking through the neighborhood streets, transport you to a uniquely bohemian reality.</p>
						<h3>Where creativity knows no bounds</h3>
						<p>Visiting Neve Tzedek would be incomplete without paying homage to Tel Aviv’s ultimate creator at the Nachum Gutman Museum of Art, where standing exhibits and interactive activities enhance the artsy feel exemplified by the serene neighborhood, driving you to visit other local galleries and ceramics studios.</p>
						<p>Visit Tel Aviv’s Suzanne Dellal Center for Dance and Theater, where watching of one of the many performances and festivals the cultural center puts together - including ethnic song dance performances, fosters a true connection between Israeli performing arts and international displays.<br><br>Follow Shabazi Street to its summit and watch as the neighborhood’s creative juices continue to flow, spilling over into HaTachana, the old Jaffa railway station, recently transformed into yet another boutiquey hotspot, where shops and cafes emerge from a surprisingly historic-looking setting.</p>
						<p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>
						-->


						<!--<h3>واحة فنية في قلب تل أبيب الصاخبة</h3>
						<p>استمتع بالأجواء الساحرة في الساحات المظللة لمطاعم ومقاهي <span class="ac-en-fotn">Neve Tzedek</span></p>
						<p>داخل أحد أقدم أحياء تل أبيب ، تقع جوهرة معمارية ذات قلب شاب ينبض. تم إنشاء <span class="ac-en-fotn">Neve Tzedek</span> في عام 1887 ، وهو أول حي يهودي خارج مدينة يافا الساحلية القديمة ، وأصبح مؤخرًا مكانًا عصريًا للفنانين من جميع الأشكال ، الذين يتناسبون تمامًا مع العمارة الشرقية الجذابة التي تم ترميمها في المنطقة.</p>
						<h3>واحة حقيقية داخل تل أبيب الصاخبة</h3>
						<p>سواء كنت تبحث عن طبق خزفي مصنوع يدويًا ، أو قطعة ملابس فريدة من نوعها ، أو مجوهرات مصنوعة من تقنيات اللحام التقليدية ، والمتاجر التي لا حصر لها ، والمعارض ، وورش التصميم ومحلات الأزياء داخل المباني ذات الطراز الشرقي التي تصطف توفر الممرات الجانبية الضيقة وحتى شارع الشبازي تجربة تسوق فريدة وشخصية. ومع نسيم البحر البارد الذي يبردك وأنت تتجول في الحي ، ستبدأ في الشعور بالحياة والبهجة ، تمامًا مثل روح الحي غريب الأطوار.</p>
						<p>استمتع بالأجواء الساحرة في الساحات المظللة لمطاعم ومقاهي <span class="ac-en-fotn">Neve Tzedek</span> مع وجبة خفيفة ولكنها مرضية. تعد المطاعم العديدة ، الموجودة في مبانٍ تاريخية جذابة مبنية حول الأزقة الضيقة في الحي ، من المأكولات الحقيقية. تنقلك الوجبات اللذيذة ، المتزوجة مع الهواء الهادئ الذي تعيشه عند المشي في شوارع الحي ، إلى واقع بوهيمي فريد.</p>
						<h3>حيث الإبداع لا يعرف حدودًا</h3>
						<p>لن تكتمل زيارة <span class="ac-en-fotn">Neve Tzedek</span> دون تكريم منشئ تل أبيب النهائي في متحف Nachum Gutman للفنون ، حيث تعزز المعارض الدائمة والأنشطة التفاعلية الشعور الفني الذي يجسده الحي الهادئ ، مما يدفعك لزيارة المعارض المحلية الأخرى واستوديوهات السيراميك.</p>
						<p>قم بزيارة مركز سوزان دلال للرقص والمسرح في تل أبيب ، حيث تؤدي مشاهدة أحد العروض والمهرجانات العديدة التي يقيمها المركز الثقافي معًا - بما في ذلك عروض رقص الأغاني العرقية ، إلى تعزيز الاتصال الحقيقي بين فنون الأداء الإسرائيلية والعروض الدولية.</p>

						<p>اتبع شارع <span class="ac-en-fotn">Shabazi</span> إلى قمته وشاهد بينما تستمر العصائر الإبداعية في الحي في التدفق ، وتنتقل إلى <span class="ac-en-fotn">HaTachana</span> ، محطة سكة حديد يافا القديمة ، التي تحولت مؤخرًا إلى نقطة ساخنة أخرى في البوتيك ، حيث تظهر المتاجر والمقاهي من بيئة ذات مظهر تاريخي مدهش.</p>
						<p>شاهد المعالم السياحية في تل أبيب والمركز في موقع المعلومات السياحية</p>
						<p>عرض الإقامة في تل أبيب ومركز في موقع المعلومات السياحية</p>
						-->

						<h3>نڤي تسيدك</h3>

						<p>واحة فنية في قلب تل أبيب الصاخب <br/>استمتع بالأجواء الساحرة في الساحات المظللة لمطاعم ومقاهي نڤي تسيدك </p>

						<p>داخل أحد أقدم أحياء تل أبيب تقع جوهرة معمارية ذات قلب شاب ينبض. تم إنشاء حي نڤي تسيدك في عام 1887 كأول حي خارج مدينة يافا القديمة وأصبح مؤخرًا مكانًا عصريًا للفنانين الذين يتناسبون تمامًا مع الهندسة المعمارية الجذابة التي تم ترميمها في المنطقة</p>

						<p>واحة حقيقية داخل تل أبيب الصاخبة</p>

						<p>سواء كنت تبحث عن طبق خزفي مصنوع يدويًا،  قطعة ملابس فريدة من نوعها أو مجوهرات مصنوعة بتقنيات اللحام التقليدية توفر لك المتاجر، المعارض، ورش التصميم ومحلات الأزياء التي لا حصر لها  داخل المباني المميزة تجربة تسوق فريدة من نوعها. ومع نسيم هواء البحر البارد الذي يبردك وأنت تتجول في الحي، ستبدأ في الشعور بالحياة والبهجة</p>

						<p>استمتع بالأجواء الساحرة في الساحات المظللة في مطاعم ومقاهي نڤي تسيدك مع وجبة خفيفة ومشبعة. تعد المطاعم العديدة الموجودة في مبانٍ تاريخية جذابة في أنحاء الأزقة الضيقة في الحي من الافضل في المدينة. تنقلك الوجبات اللذيذة مع الهواء المنعش إلى واقع بوهيمي فريد </p>

						<p>.حيث الإبداع لا يعرف حدودًا  <br/>Nachum Gutman</p>

						
						<p>لن تكتمل زيارة نڤي تسيدك دون تكريم منشئ تل أبيب ناخوم جوتمان في متحف ناخوم جوتمان للفنون، حيث تعزز المعارض الدائمة والأنشطة التفاعلية الشعور الفني الذي يجسده الحي الهادئ، مما سيدفعك لزيارة معارض محلية أخرى واستوديوهات السيراميك</p>

						<p>قم بزيارة مركز سوزان دلال للرقص والمسرح في تل أبيب، حيث يمكنك مشاهدة أحد العروض والمهرجانات العديدة التي  يقيمها المركز الثقافي - بما في ذلك عروض رقص الأغاني العرقية الذي يعزز الصلة بين فنون الأداء الإسرائيلية والعروض الدولية</p>

						<p>اتبع شارع شبازي إلى قمته وتمتع بالمباني الإبداعية حتى تصل الى مجمع “هتخناه” - محطة القطارات القديمة في يافا والتي تحولت مؤخرًا إلى  نقطة جذب سياحي مليء بالمحلات التجارية والمقاهي والمظاهر التاريخية</p>


              
			`,
      };
    },
  },

  {
    id: 9,
    bgImage: "posts/bank/5/1.jpg",
    mobBgImage: "posts/bank/5/M.jpg",
    title: "Jerusalem Old and new ",
    isVid: true,
    ctg: "jerusalem",
    vidId: "V0Acsw3Hf_M",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Ancient treasures and modern luxuries.</h3>

			<p>
				Downtown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.
			</p>
			<p>
				The area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.
			</p>
			<p>
				The center of Jerusalem includes some of the city’s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem’s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem’s Science Museum.
			</p>
			<h3>
				Machane Yehuda Market
			</h3>
			<p>
				Discover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.
			</p>
			<h3>
				Nahalat Shiv’a
			</h3>
			<p>
				This charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor cafés. Nahalat Shiva is home to Kikar Hamusica (Music Square) – a lively and trendy outdoor space that offers live music every day throughout the week.
			</p>
			<h3>
				Yemin Moshe
			</h3>
			<p>
				This lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.
			</p>
			<h3>
				Ein Kerem
			</h3>
			<p>
				Nestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem’s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest
			</p>  

			`,
      };
    },
  },

  // {
  // 	id:"Market_Madness",
  // 	bgImage : "posts/bank/10/1.jpg",
  // 	mobBgImage : "posts/bank/10/M.jpg",
  // 	title: "Market Madness",
  // 	vidId: "2CSCe2WC7Ns",
  // 	isVid:true,
  // 	ctg:"jerusalem",
  // 	smlTitle: "",
  // 	html: function(){
  // 		return {
  // 			__html:`
  //                      <h3>A celebration for all the senses</h3>
  // 					<p>
  // 						Throngs of locals and tourists are drawn during the day to witness the authentic atmosphere and workings of the market, and of course do some shopping, and once the food vendors close up, revellers — foreign and local alike — descend on the market to drink and make marry in the bars, restaurants and alleyways.
  //                         The shuk never really takes a day off during the week, but if you’re looking for a truly electrifying night out, then Thursday is your target. For locals, it’s the only night can go out without having to worry about getting up for work the next day, and it shows, as the bars and restaurants stay open late, throw parties that spill out into the streets and host special events.
  // 					    <br>My “date” and I arrived at 7:20 pm, when many of the vendors were still open, and the aisles were crowded with shoppers looking for weekend bargains. However, as the vendors closed, the shoppers quickly dissipated making room for the party people.
  // 					    <br>Although, it seems like yesterday that the shuk was just a place where you shopped and maybe grabbed a bite to eat from a local, working class eatery, over the past 5 years or so, the number of hip bars and restaurants has skyrocketed to the point that you can hardly keep track of everything between new ones popping every day and secret spots hidden away in corners only the locals know about.
  //                         “When you see the throngs of partiers at the shuk on a Thursday night, it is easy to forget that just a few short years ago you wouldn’t find a soul here at night,” said local tour guide Joel Haber. “But the truth is, this is not just the next logical step in Machane Yehuda’s constant historical development, but also the most vibrant new contribution to the city’s nightlife scene. The shuk has always been the crossroads where all Jerusalemites mix. Now the young and the less so, secular and religious, all sit side by side drinking beers and drinking in the shuk’s special character.”
  // 					    <br>Check out some of the establishments that have more or less attained all-star status and always promise a good time.
  // 					</p>

  // 					<h3>
  // 					   WINE, DINE AND DANCE
  // 					</h3>

  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() + "posts/7/1.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>
  // 					   CASINO DE PARIS
  // 					</h3>

  //                     <p>

  //                           Tucked away in the depths of the Georgian shuk between the covered and uncovered market streets,&nbsp;<a href="//www.itraveljerusalem.com/city/jerusalem/casino-de-paris/" target="_blank"><strong>Casino de Paris</strong></a>&nbsp;has a colourful history. The building it’s housed in has served as a casino, hotel, British officer’s club and a brothel over the years, but now it’s one of the classier joints in the shuk. The crowd skews a little bit older, attracting mostly professionals in their 30′s and 40′s, but Thursday nights still have an air of fun and youth as the bar stays open until 2 or 3 am serving well-made, original house cocktails inspired by the shuk, craft beers, some decent wines and an eclectic dairy menu also inspired by the ingredients and culture of the shuk.

  //                     </p>

  //                     <h3>
  // 					   CINCO DE MAYO
  // 					</h3>

  // 					<p>
  // 					    If you’re looking for a legitimate party atmosphere, Cinco De Mayo isn’t a bad place to start. The bar frequently hosts DJ’s playing a range of different styles and you’ll find people drinking, eating and maybe even dancing until around 2 am on Thursday nights. The revellers really begin to pack the place around 10:30 pm, so don’t be surprised if you have trouble finding a seat after that, but you can always make like the locals and grab a drink from inside and hang out in the alley.
  //                         Despite the name, Cinco de Mayo actually has nothing to do with Mexico or the 5th of May. The group of friends who started the bar took the name from their time living on a commune outside of Jerusalem, where nobody worked on May 5.
  // 					</p>

  //                     <h3>
  // 					  SHUKA BAR
  // 					</h3>

  // 					<p>
  //                        Despite its location off the main drag and relatively small stature, Shuka Bar on Egoz Street is one of the most popular places in the shuk. It’s a relatively meat and potatoes types of place, serving only Israeli beers, choice liquors and small snacks, but on Thursday nights it tends to turn from hole-in-the-wall hangout to a big party.
  //                     </p>

  //                     <div class="img-wrapper">
  // 						<img src=${getImgUrl() + "posts/7/2.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>
  // 					    QUE PASA
  // 					</h3>

  // 					<p>
  // 					    Meanwhile next door, Que Pasa is the valiant effort by owner Yaniv Kovenshtein to recreate the tapas culture he loved so much in Spain.
  //                         Co-owner and chef Avi Betito Golansky brings the vision to life with a menu full of dairy and fish tapas-sized dishes, including tasty Bruschetta Cuca (sardines, onion, hot pepper olive oil on delicious crunchy bread) and Porcini Bruschetta (porcini sautéed in butter with garlic, almond oil and parsley), shaved artichoke with truffles, filleted sardines stuffed with Saint Moor cheese and fried with sage butter atop a lush tomato salad, mullet rings fried with roasted peppers, and more. If you’ve got the appetite they also have larger portions, such as gnocchi, sea bass fillet or red mullet.
  // 					</p>

  // 					<p>
  // 					    While the bar’s motto is “a beer in the afternoon solves all problems,” it also pays to go for one Thursday night at Que Pasa, which also hosts local musicians on a regular basis.
  // 					</p>

  // 					<h3>
  // 					    SHEM TOV
  // 					</h3>

  // 					<p>
  // 					    Located on Eshkol Street, a street off the open shuk, Shem Tov truly captures the shuk vibe with a rich Middle Eastern menu, a pretty expansive selection of Israeli beer, wine and liquor and the coup de gras, music from all over the world that keeps the happy vibes going until 2 or 3 a.m. <br>It’s also a prime place to grab a glass of cold sahleb, a shuk staple usually served hot, made from the flour of ground tubers of orchids with rose water, milk, and cinnamon). Mmmmmm.Delicious!
  // 					</p>

  // 					<h3>
  // 					    LATE NIGHT EATS
  // 					</h3>

  // 					<p>
  // 					   If you’ve been out drinking, you’re probably in the mood for some munchies by around midnight, and lucky for you, there’s still plenty of eateries catering to your (probably) not-so-specific needs.
  // 					</p>

  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() + "posts/7/3.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>
  // 					    SORAMELO
  // 					</h3>

  // 					<p>
  // 					    If all that drinking’s given you a sweet tooth, then head to Soramelo at the Aggripas entrance of the covered shuk for some shuk-inspired waffles.
  //                         Named for a neighbourhood legend known for having a story about everything, Soramelo has no doubt produced a few stories of its own.<br>Soramelo stays steadily busy throughout the night with people stopping in for a microbrew, coffee of a sweet bite to eat, but it really gets busy later when people move on from drinking to late-night snacking. If you’re one of them, you have until 3 am on Thursdays to get a waffle in you to soak up all the beer and arak. Try the one with chocolate and tahina — you won’t be disappointed!
  // 					</p>

  // 					<h3>
  // 					    MICHI’S
  // 					</h3>

  // 					<p>
  // 					    Michi’s is a simple, yet delicious concept that makes for the perfect late-night eatery — high-quality hamburgers and meat sandwiches at a shockingly good price. You can get a simple 100-gram burger on a fresh bun with some serious fixings for just 17 NIS. If you’re really hungry, you can also get larger portions of meat, roast beef and chicken sandwiches and much more. Michi’s is open until 12 am.
  // 					</p>

  // 					<h3>
  // 					    MEORAV YERUSHALMI
  // 					</h3>

  // 					<p>
  // 					   This may be the best place to get the famous Jerusalem mixed grill, made of various meats and organs stuffed into a pita with fries and salad on the side. In addition to the traditional recipe, they also serve a mixed grill with fish. The portions are downright massive and perfect for those who have really worked up an appetite. Just make sure to get there before midnight.
  // 					</p>

  // 					<h3>
  // 					    PASTA BASTA
  // 					</h3>

  // 					<p>
  // 					    By far one of the most popular joints in the shuk, Pasta Basta is the place to go for fresh, homemade pasta dishes that won’t break the bank. All you have to do is choose a type of pasta and sauce and then you’ve got your food. The prices go according to the type of sauce and range from 19-26 NIS. Gnocchi, ravioli and additional toppigngs cost extra.
  // 					    <br>Pasta Basta is open until midnight, and don’t be surprised when you see a line out the door.
  // 					</p>

  // 			`
  // 		}
  // 	}

  // },

  {
    id: 13,
    bgImage: "posts/bank/24/1.jpg",
    mobBgImage: "posts/bank/24/M.jpg",
    title: "The old city ",
    vidId: "k4OwoEk5wMw",
    ctg: "jerusalem",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Feel the story come alive</h3>
			<p>
			   Become inspired by the world renowned treasures of the ancient city of Jerusalem.
			</p>
              
			`,
      };
    },
  },

  {
    id: 14,
    bgImage: "posts/bank/32/1.jpg",
    mobBgImage: "posts/bank/32/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
			<p>
			   Get high on life in the lowest place on earth.
			</p>
              
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "posts/bank/58/1.jpg",
    mobBgImage: "posts/bank/58/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h3>Time to bask in nature’s glory</h3>
              <p>
						The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
              </p>
              <p>
              		This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
              </p>
              <p>
              		The Dead Sea is lined with spas, bathing beaches and spa hotels.
              </p>
			`,
      };
    },
  },

  // {
  // 	id:"Go_To_Guide",
  //               bgImage: "/posts/bank/gotoguide/1.jpg",
  //               mobBgImage: "/posts/bank/gotoguide/M/1.jpg",
  //               title :"Tel Aviv and Jerusalem so Close and yet so Far",
  // 			ctg : "telaviv",
  // 			isVid:false,
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                     <h3>
  //                    Travel from Tel Aviv and Jerusalem
  //                     </h3>
  // 					<p>
  // 						One of the best things in visiting Tel Aviv and Jerusalem is how incredibly different yet amazingly close these two fabulous destinations are. In fact, the two cities are less than one hour’s drive(!) from each other, which means that should you choose to, you could spend the day exploring the awesome and world-famous sites of Jerusalem and be back in time to watch the sunset from one of Tel Aviv’s stunning beaches, before heading on to an all-night party in one of the city’s hottest clubs. Talk about a full day’s fun…
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/gotoguide/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						Getting to and from Tel Aviv and Jerusalem is easy and there are several ways depending on your preference and budget:
  // 					</p>
  // 					<p>
  // 						<strong>By Car</strong>: Should you choose to hire a car you will find route 1 connects the two cities directly, road signs are pretty clear and come in three languages. However, you might also want to use one of the local navigation apps to show you the way and help you avoid heavy traffic.

  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/gotoguide/2.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						<strong>By Bus</strong>: there are several public buses which travel to and from Tel Aviv and Jerusalem. This is by far one of the most convenient and budget-friendly means of travel.</p>
  // 					<p>
  // 						<strong>By Train</strong>: The train service operates in several main stations along Tel Aviv:  From the ‘University’ station, in the north of Tel Aviv, to ‘Savidor’ and ‘Hashalom’ in central Tel Aviv, to ‘Ha-Hagana’ in the south end of Tel Aviv, taking you to Jerusalem and back.
  // 				    </p>
  // 					<p>
  // 						<strong>By Taxi</strong>: Taxis can be flagged on the street or booked via phone or designated apps such as Gett (GetTaxi).
  // 					</p>
  // 					<p>
  // 						<strong>Sherut Taxis</strong>: “Sherut” (service) taxis are 10 - 12 seater vans which generally follow major bus routes in the city and interurban rides. Pricewise, "Sherut" taxi fares have a fixed price, similar to public bus fares. "Sherut "taxis also offer a replacement service to buses on Fridays afternoon till Saturday evening.
  // 					</p>
  // 			            	<p>
  // 			            		For information regarding train stations, routes and schedules, visit <a href="https://www.rail.co.il/" target="_blank">www.rail.co.il</a>
  // 			            	</p>
  // 			            	<p>
  // 			            		For information regarding bus routes and schedules visit  <a href="https://www.bus.co.il/otobusimmvc?" target="_blank">www.bus.co.il</a>
  // 			            	</p>
  // 			            	<p>
  // 			            		Public transport helpline <a href="tel:*8787">*8787</a>
  // 			            	</p>
  // 			            	<p>
  // 			            		Local public transport app - ‘Moovit’
  // 			            	</p>
  // 			            	<p>
  // 						        So come check out Epic Tel Aviv and unforgettable Jerusalem, less than one hour away from each other!
  // 			            	</p>

  //             	`   }
  //   }
  // },

  // {
  // 	id:"Day_IsTrippin",
  //               bgImage: "/posts/bank/48/1.jpg",
  //               mobBgImage: "/posts/bank/48/M/1.jpg",
  //               title :"Day Trippin’",
  // 				isVid:false,
  // 				ctg:"telaviv",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<h3>Fabulous and fascinating one day in Tel Aviv</h3>

  // 				<p>
  // 					Start your day at Jaffa harbor, enjoy the salty refreshing sea air and treat yourself to breakfast at any of the lovely restaurants along the Marina. the Jaffa slope park, with a magnificent panorama over most of the Israeli shoreline, and the historical starting point of the metropolis, some 4000 years ago. Grab a cup of coffee at the renovated ancient port, and head north for a lovely stroll along the promenade and some fantastic seaside fun.
  // 				</p>
  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/37/2.jpg"} class="img-responsive" />
  // 				</div>
  // 				<p>
  // 					Cross the street to the “Tachana Compound”, a fabulously renovated outdoor shopping center housed in a defunct historic train station built in the 1890s as Tel Aviv and Jaffa’s central train station.
  // 				</p>
  // 				<p>
  // 					Head to the picturesque neighborhood of Neve Tzedek and cross the beautiful alleyways. Treat yourself in their boutique shops until you reach the colorful hustle and bustle of Hacarmel market. Stop for some excellent street food and if it's a Tuesday or Friday – consider yourself lucky and get some shopping done at the traditional Nachlat Binyamin fair, where local artisans present their work.
  // 				</p>
  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() + "/thingsToDo/posts/37/1.jpg"} class="img-responsive" />
  // 				</div>
  // 				<p>
  // 					Continue all the way to gorgeous Rothschild Blvd, the heart of the Bauhaus architecture and a UNESCO international heritage site. This is the place to rent a bicycle and join the local flow all the way to Habima Square, home to the national theater and the Israeli philharmonic orchestra. Head down to the trendy, bustling Dizengoff Street or grab a bite in one of the coffee shops around the square and keep walking or cycling along Hen Blvd, all the way to Rabin square.
  // 				</p>
  // 				<p>
  // 					Check out Eben Gabiroll street, a trendy hub of the fabulous city, home to a huge array of award-winning restaurants, and excellent pubs and bars where you can grab a meal or an early drink and hang with the locals.
  // 				</p>
  // 				<p>
  // 					Hop on a number 5 service line, in itself an urban icon, and get off at the Tel Aviv port. Enjoy the sunset and look back south at the Jaffa skyline, where the day started. Spend your evening in the area and watch as it transforms into the city’s hottest nightlife scene, packed with fabulous bars and nightclubs tailor-made for epic nights.
  // 				</p>

  //             	`   }
  //   }
  // },

  {
    id: "Non_Stop_Culture",
    bgImage: "/posts/bank/telaviv9/1.jpg",
    mobBgImage: "/posts/bank/telaviv9/M.jpg",
    title: "ثقافة بلا توقف",
    isVid: false,
    // vidId:"MXtcTm_JXus",
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <!--
				    <p>Tel Aviv is famous around the world for its culture and entertainment scene. Home to fantastic museums and art galleries, theaters, concert halls, and dance centers, your cultural desires are sure to be met. 
                    <h3>Theatres</h3>
                    <p>The Tel Aviv theatre scene is flourishing and visitors to the city will enjoy the many world class plays of the city’s main theatres – Habima, Hakameri and Gesher, located is beautiful surroundings and often hosting shows in English or offer subtitles for non-Hebrew speakers.  
                    <h3>Tel Aviv Museum of Art</h3>
                    <p> The city’s beautifully designed, leading museum for Israeli and international art containing one of the world’s largest contemporary art collections featuring permanent displays alongside rotating exhibitions.
                      

                      

                    <h3>Beit Ha’ir (The old Town Hall)</h3>
                    <p>The recently renovated Beit Ha’ir, was the old city hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history, featuring a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years. 

                    <h3>Eretz Israel Museum</h3>
                    <p>A multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts. 
                     
                    
                    <h3>Private Galleries</h3>
                    <p>All around Tel Aviv, but mainly in Neve Tzedek, Ben Yehuda and Gordon streets you can freely wonder into any of the privately-owned beautiful art galleries featuring original works of local contemporary artists.  
					-->
					<h3>المشهد الثقافي المذهل في تل أبيب</h3>
					<p>تشتهر مدينة تل أبيب، عالميا، بالمشهد الثقافي والترفيهي الموجود فيها، فهذه المدينة تعدّ موطنا للمتاحف الرائعة، والمعارض الفنية المبتكرة، والمسارح الرائدة، وقاعات الحفلات الموسيقية ذات المستوى العالمي، ومراكز الرقص المشهورة عالميا. إننا متأكدون من أن تل أبيب ستتمكن من إشباع رغباتكم الثقافية.</p>
					<h3>المسارح</h3>
					<p>يزدهر المشهد المسرحي في تل أبيب. ويستمتع زوار المدينة بمشاهدة العديد من المسرحيات على المستوى العالمي، التي تعرض في مسارح المدينة الرئيسية: مسرح "هبيما"، "مسرح "الكاميري"، و مسرح "هجيشر"، وهي جميعا تقع وسط مناطق جميلة، وغالبا ما تعرض المسارح مسرحياتها بالإنجليزية، أو تقدّم الترجمات لغير المتحدثين بالعبرية.</p>
					<h3>متحف تل أبيب للفنون</h3>
					<p>يعدّ هذا المبنى- التحفة المعمارية ذو التصميم المذهل حقا، متحفا رائدا للفن الإسرائيلي والعالمي، وهو يضم بين جدرانه واحدة من أكبر مجموعات الفنّ المعاصر في العالم، ويتميز بتوفر المعارض الدائمة فيه، جنبا إلى جنب مع المعارض الدوريّة.</p>
					<div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/posts/non-stop-culture/1.jpg"} class="img-responsive" />
				    </div>  
					<h3>"بيت هعير" (قاعة المدينة القديمة)</h3>
					<p>كان هذا المبنى في السابق مبنى البلدية القديم في  تل أبيب- يافا، وقد تم ترميمه وتجديده مؤخرا،  ويقع في شارع بياليك، أحد أجمل شوارع المدينة بهندسته المعمارية المنتقاة بعناية. يمثل هذا المبنى اليوم تجسيدا حيّا لتاريخ المدينة، وهو يعرض اليوم معرضا جديدا يحتوي على مجموعة واسعة من الصور والقصص التي تستعرض الأحداث والمواقع وتجارب السكان على مرّ السنين.</p>

					<h3>متحف "إيرتز يسرائيل" (أرض إسرائيل)</h3>
					<p>يعرض متحف أرض إسرائيل، وهو مؤسسة متعددة الاختصاصات، تاريخ الأرض وثقافتها من خلال معرض دائم، إلى جانب مجموعة متنوعة من المعروضات المؤقتة المتعلقة بمواضيع علم الآثار، الأثنوجرافيا، الفلكلور، اليهودية، التاريخ الثقافي، الهوية المحلية، الحرف التقليدية، والفنون الوظيفية.</p>
					<h3>المعارض الخاصة</h3>
					<p>يمكنكم التجوال بحرّية في أي من المعارض الفنية الجميلة المملوكة ملكية خاصة، في جميع أرجاء تل أبيب، وخصوصا في شوارع نفيه تسيدك و "بن يهودا" و"غوردون". وتعرض هذه المعارض أعمالا أصلية لفنانين محليين معاصرين</p>


            	`,
      };
    },
  },

  {
    id: "A_Taste_Of_Jerusalem",
    bgImage: "/posts/bank/taste-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/taste-of-jerusalem/M/1.jpg",
    title: "من مذاقات القدس",
    ctg: "culinary",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                <h3>أطباق لا بد من تذوقها لدى زيارتكم للمدينة الساحرة</h3>
				
				<p>في حين يهتم الناس بالأجواء المذهلة والمواقع التي لا تنسى، والمناظر الخلابة وغيرها لإدراك المعنى الحقيقي للقدس، فإن الطريق إلى قلب الإنسان تكون أحيانا، عبر معدته. فيما يلي بعض المأكولات التي يجب عليكم حقا أن تجربوها أثناء زيارتكم للقدس:</p>
 				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/39/1.jpg"} class="img-responsive" />
				</div>
				<p><strong>"معوراف يروشالمي":</strong> والتي تعني حرفيا "خليط القدس"، هذا المزيج اللذيذ من القطع المختلفة من اللحوم، مغمورة تماما بمزيج مميز من التوابل، هو مرتقى أنفاس محبي اللحوم. </p>
				<p><strong>"عشتنور":</strong> والذي يحاكي الاصطلاح العربي "عيش التنور". وهو نوع من خبز الـ "كماج" المحلي الأصيل الذي يمكنكم العثور عليه في وسط المدينة أو الأسواق في وقت الغداء. وإذا كنتم جائعين بشدة، فإن عليكم تجربتها بصيغة اللفة، المحشوة بشرائح الشاورما اللذيذة أو الفلافل الساخن.</p>
				<p><strong>"صبيح":</strong> يتكون هذا الطبق المحلي الأصلي الفريد من خبز الكماج المحشو بالباذنجان المقلي والبيض المسلوق والمخللات، وعادة ما تصب عليه صلصة العمبة، وهي صلصلة محلية لذيذة. ما أن تجربوا الصبيح حتى تدمنوا عليه إلى الأبد.</p>
				<p><strong>الكعك بسمسم:</strong> أينما ولّيتم وجوهكم في القدس القديمة ومحيطها ستجدون صفوفا من المخبوزات المستطيلة المغطاة بالسمسم الذهبي. هذا هو ما يطلق عليه المقدسيون اسم "الكعك"، وهو عبارة عن مخبوزات هشّة من الخارج، طرية من الداخل، مغطاة بالكامل بالسمسم المحمّص، يُخبز في أفران تقليدية تعمل على حطب الزيتون وبقايا أشجاره وأنويته. هنا يأخذ "طعام الشوارع" معنى آخر، إذ غالبا ما ستشاهدون أهل القدس يتناولون الكعك بسمسم مع حبّات عملاقة من الفلافل المحشو، أو الجبن الأبيض، أو البيض المسلوق، أو ببساطة، يقومون برش الزعتر المملح عليها.</p>
				<p><strong>الصفيحة الأرمنية:</strong> انتقل الأرمن إلى القدس في الهجرة الأرمنية الكبرى، واستقروا فيها، وصاروا جزءا من نسيجها الاجتماعي، وقد أضافوا بخبراتهم التي جلبوها معهم الكثير من الفنون والحرف والمأكولات. واحد من المأكولات الأكثر شعبية في القدس هو الصفيحة الأرمنية التي تباع على عربات صغيرة متنقلة في شوارع البلدة القديمة. الصفيحة (مفرد صفائح، وهو تعبير حقيقي جدا عن شكل المخبوزات المدوّرة الرفيعة) تقطر من عصائر اللحم المخلوط بالطماطم، تحاكي مخبوزات اللحم بعجين التركية، مع لمسة مقدسية وأرمنية لن تجدوا مثلها إلا في أزقة البلدة القديمة في القدس.</p>

				<p><strong>المطبّق:</strong> حلوى مقدسية بامتياز. تقول الرواية أن الحاكم دار العثماني قد طلب إلى أحد حلوانجية القدس القديمة أن يصنع له طبقا من الحلوى للسراي لم يذق أحد مثله قبلا. وقد قام الحلوانجي بصنع حلوى من عجين شديد الرخاوة والرّقة، يتم مدّها على رخام بارد، وتحشى بالجبن الحلو، وتخبز في فرن الحطب، ليتم تغطيتها بعد ذلك بالقطر. استمر هذا التقليد في القدس. القليل من عائلات الحلوانجية في المدينة تصنع المطبّق، لكنّه يستحق عناء البحث عنه بكل تأكيد.</p>

				<p><strong>"ملّبي":</strong> وهو مهلبية فريدة للتحلية، مصنوعة من ماء الورد، الحليب، النشاء، والسكر. يعد طبق الملبي طبقا مقدسيا شعبيا جدا، وهو يباع في العديد من المطاعم الشرقية والأكشاك المنتشرة في المدينة. نضمن لكم بأنكم لم تتذوقا أمرا مثله قبلا.</p>

				<p><strong>وهنالك، بالطبع:</strong> الفلافل: أفضل طعام شارع محلي، وهو يتوفر في جميع الشوارع تقريبا. بإمكانكم تجربته بمفرده أو أن تتناولوه (وهذا أفضل) محشوا في خبز الكماج مع الحمص والبطاطا المقلية وسلطة الخضار الطازجة.</p>

				<p>لا يفوتنا التذكير هنا أن أغلب الطعام في مدينة القدس هو طعام حلال. لا تنسوا أن علامة "كوشر" تضمن أيضا عدم وجود محرّمات (إسلامية أيضا) في المأكولات التي تحتوي على لحوم، وذلك بسبب تشابه قوانين الذبح لدى الديانتين.</p>
				<p>لذا، احجزوا عطلتكم الآن، وتذوقوا هذه الأطباق المحلية الرائعة لتبلغوا أقاصي المتعة في رحلة لا تنسى إلى مدينة القدس الساحرة.</p>


            	`,
      };
    },
  },

  // {
  // 	      id:"Sectrets_Of_Jewish_Jerusalem",
  //               bgImage: "/posts/bank/sectrets-of-jewish-jerusalem/1.jpg",
  //               mobBgImage: "/posts/bank/sectrets-of-jewish-jerusalem/M/1.jpg",
  //               title :"Sectrets of jewish Jerusalem",
  //               ctg:"jerusalem",
  //               isVid:false,
  //               smlTitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `
  //                                 <p>Jerusalem is an open invitation for a journey. Climb the mountains, enter the city and feel the unique mix between past and present, ordinary and extraordinary. One of the most ancient cities in the world, sacred for Jews, Christians and Muslims, Jerusalem offers an unparalleled sensory and spiritual experience.</p>

  //                                 <p>Enter. The heart of the holiest city in Judaism is the Old City. Enter through the historic entrance, The Jaffa Gate, or use The Zion Gate that leads straight to the Jewish Quarter, one of the four quarters of the walled city and home to Jews almost consecutively since 8 BCE. Wonder through the alleyways, see the people, visit the Cardo, Jerusalem's ancient main street and absorb the unique atmosphere. You're walking in the footsteps of kings and prophets – It's no ordinary thing.</p>
  //                                 <div class="img-wrapper">
  // 					                <img src=${getImgUrl() +  "/posts/sectrets-of-jewish-jerusalem/1.jpg"} class="img-responsive" />
  // 				                </div>
  // 							    <small style="color:#000; display:block;">
  //                       		        Credit: Noam Chen
  //                       	        </small>
  // 								<p>Witness History Comes alive and Feel the Deep Spiritual Energy within the Walls </h3>

  //                                 <p>What Lays Ahead.  The last remaining segment from the ancient walls that surrounded The Second Temple, The Western Wall, is a symbol of Jewish yearnings for their ancestral and spiritual homeland. Every Jew outside Jerusalem pray facing the place you stand in now, the place where according to Judaism, God resides. No matter what your beliefs are, it's a humbling experience. Honor the spirit of the site and place a note in the wall with a prayer or a wish.</p>

  //                                 <p>What Lays Beneath. Jerusalem is literally covered with layers of history and touching history gets a whole new meaning here.</p>

  //                                 <p>Take the fascinating tour at the Western Wall Tunnels and reveal the hidden sections of the Western Wall. History will come to life as you move through underground passages, discover life in Jerusalem during The Second Temple era and learn about the art, architecture and building practices.</p>

  //                                 <p>Visit the nearby archeological site City of David and learn more about the history of the city King David declared as the unified capital of Israel's 12 tribes 3000 years ago. Go on a journey between ancient walls and fortresses, hidden springs where kings were coroneted and follow the path of fleeing Jerusalem residents after the city was conquered by the Romans.</p>

  //                                 <h3>Marvel at the Breathtaking Extraordinary Vista and Feel on Top of the World</h3>

  //                                 <p>What Lays Above. Originally built to protect the city against intruders, Jerusalem is surrounded by walls.  Today The Walls of Jerusalem offer an opportunity to explore the city from a different angle. Hear the stories, see the city below you and take in all this beauty.</p>

  //                                 <p>You are just beginning to stretch the surface.</p>

  //             	`   }
  //   }
  // },

  {
    id: "Jamie_Oliver",
    bgImage: "/posts/bank/jamie_oliver/1.jpg",
    mobBgImage: "/posts/bank/jamie_oliver/M/1.jpg",
    title: "جيمي أوليفر في تل أبيب",
    ctg: "culinary",
    isVid: true,
    vidId: "gGe4W8WaIiQ",
    smlTitle: "",
    html: function() {
      return {
        __html: `

						<small style="color:#000; display:block;position: relative;top: 5px;">
						حقوق : قناة الطعام الإسرائيلية
						</small>

            	`,
      };
    },
  },

  {
    id: 37,
    bgImage: "/posts/bank/enjoy-and-indulge/1.jpg",
    mobBgImage: "/posts/bank/enjoy-and-indulge/M/1.jpg",
    title: "استمتع وتدلل",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <!--<h3>Tel Aviv - The ultimate luxury destination</h3>
					<p>
						Forget the Caribbean, Cannes or the Maldives, if it’s a luxury vacation you’re after -   Tel Aviv is the place to be! 
					</p>

					<p> 
						First of all, the city, named “the capital of cool” by the NY Times is only a few short hours away, meaning you don’t have to worry about wasting even a minute of your dream vacation on shaking off the Jet Leg.
					</p>
					<p>
						Once here, your first treat is the gorgeous year-round sunny weather – tailor-made for pleasure. 
					</p>
					<p> 
						Next – go and put your feet up and relax in the huge variety of luxury accommodations on offer – from world class 5-star hotels overlooking the beach to the numerous stunning boutique hotels in breathtaking locations all around the city. 
					</p>
                   	
					<p>
						To complete the experience, throw on a towel and head to any of the gorgeous beaches, complete with all amenities needed for a fabulous day, not to mention the gorgeous cool waters.
					</p>
					<p> 
		 				Feeling hungry? No need to stand in line in London and Paris for their award-winning restaurants - Tel Aviv is home to famous chefs revered all over the world.  Aviv is renowned worldwide for its quality of cuisine, enjoy a huge selection of gourmet dining, from local to fusion, offered in exquisitely designed chef restaurant.  
		 			</p>
		 			<p>
						Time for some shopping – get your wallet and come check out the goodies in the local designer boutiques stores, chic upscale shops in places such as Kikar Hamedina and luxury shopping malls where you can find anything from Haute Couture to the latest international trends. 
					</p>
					<p>
						To finish off your day, grab a craft beer or a glamorous cocktail in any of the sensational nightclubs or glamourous bars around the city and dance your night away before heading off to your hotel for a well-earned 5 star slumber. 
					</p>
					<p>
						Luxury? Style? Glamour? We have it all! So hurry up and book your trip to Tel Aviv Today! 
					</p>-->

					<!--<h3>تل أبيب - الوجهة الفخمة المطلقة</h3>
					<p>انسَ البحر الكاريبي أو كان أو جزر المالديف ، إذا كنت تبحث عن إجازة فاخرة - تل أبيب هي المكان المناسب لك!</p>
					<p>بادئ ذي بدء ، المدينة ، التي أطلق عليها نيويورك تايمز اسم "عاصمة الروعة" ، لا تبعد سوى بضع ساعات قصيرة ، مما يعني أنه لا داعي للقلق بشأن إضاعة حتى دقيقة واحدة من إجازتك التي تحلم بها في التخلص من Jet Leg.</p>
					<p>وبمجرد وصولك إلى هنا ، سيكون علاجك الأول هو الطقس المشمس الرائع على مدار العام - المصمم خصيصًا للمتعة.</p>
					
					<p>بعد ذلك - انطلق واسترخي في مجموعة كبيرة ومتنوعة من أماكن الإقامة الفاخرة المعروضة - من الفنادق ذات المستوى العالمي الخمس نجوم المطلة على الشاطئ إلى العديد من الفنادق البوتيك المذهلة في مواقع خلابة في جميع أنحاء المدينة.</p>
					<p>لإكمال التجربة ، قم برمي منشفة وتوجه إلى أي من الشواطئ الرائعة ، كاملة مع جميع وسائل الراحة اللازمة ليوم رائع ، ناهيك عن المياه الرائعة الرائعة.</p>
					<p>الشعور بالجوع؟ لا داعي للوقوف في طابور في لندن وباريس لمطاعمهما الحائزة على جوائز - تل أبيب هي موطن الطهاة المشهورين في جميع أنحاء العالم. تشتهر أفيف في جميع أنحاء العالم بجودتها في المأكولات ، واستمتع بمجموعة كبيرة من المأكولات الذواقة ، من المأكولات المحلية إلى الانصهار ، والتي يتم تقديمها في مطعم الشيف المصمم بشكل رائع.</p>
					<p>حان الوقت لبعض التسوق - احصل على محفظتك وتعرّف على الأشياء الجيدة في متاجر البوتيكات المحلية ، والمتاجر الراقية الأنيقة في أماكن مثل Kikar Hamedina ومراكز التسوق الفاخرة حيث يمكنك العثور على أي شيء من Haute Couture إلى أحدث الاتجاهات العالمية.</p>
					<p>لإنهاء يومك ، احصل على بيرة مصنوعة يدويًا أو كوكتيلًا ساحرًا في أي من النوادي الليلية المثيرة أو الحانات الساحرة في جميع أنحاء المدينة والرقص ليلتك بعيدًا قبل التوجه إلى فندقك للحصول على نوم 5 نجوم جيد.</p>
					<p>فخم. ترف؟ أسلوب؟ بريق؟ لدينا كل شيء! لذا أسرع واحجز رحلتك إلى تل أبيب اليوم!</p>-->

					تل أبيب - الوجهة الفخمة 

					<p>انسَ البحر الكاريبي، كان الفرنسية أو جزر المالديف، إذا كنت تبحث عن إجازة فاخرة - تل أبيب هي المكان المناسب لك</p>
					<p>اولا، المدينة التي أطلق عليها النيويورك تايمز اسم "عاصمة الروعة" تبعد بضع ساعات سفر قصيرة ، ما يعني أنه لا داعي للقلق بشأن إضاعة حتى دقيقة واحدة من إجازتك التي تحلم بها بسبب اضطراب المزاج من الرحلات الجوية الطويلة</p>
					  
					<p>بمجرد وصولك إلى هنا، الطقس المشمس الرائع على مدار العام والمصمم خصيصًا للمتعة سيكون علاجك الأول </p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/38/1.jpg"} class="img-responsive" />
					</div>
					<p>لاحقا، بإمكانك أن تسترخي في مجموعة كبيرة ومتنوعة من أماكن الإقامة الفاخرة - من فنادق الخمس نجوم العالمية المطلة على الشاطئ إلى العديد من فنادق البوتيك المذهلة في مواقع خلابة في جميع أنحاء المدينة.</p>
					<p>لإكمال التجربة خذ منشفة وتوجه إلى أحد الشواطئ المليئة بشتى وسائل الراحة اللازمة ليوم استرخاء، ناهيك عن مياه  البحر الرائعة</p>

					<p>تشعر بالجوع؟ لا داعي للقلق! تل أبيب مليئة بطهاة ذو شهرة وتقدير في جميع أنحاء العالم. تشتهر تل أبيب بجودة مأكولاتها وتعدد مطاعمها الذواقة التي تمنحك الفرصة لتذوق أشهى المأكولات المحلية والعالمية</p>

					<p>حان وقت التسوق -  تعرّف على المدينة وقم بزيارة مواقع التسوق العديدة فيها، من مجمعات التسوق الداخلية والخارجية الى أشهر ميادين المدينة كميدان ديزنجوف وكيكار همدينا وستجد متاجر بوتيك محلية الى جانب متاجر راقية حيث تستطيع شراء كل ما تريد </p>

					<p>لإنهاء يومك توجه لجادة روتشيلد لتناول وجبة العشاء ومن ثم الى الكورنيش للاسترخاء والتمتع بالمشروبات الطازجة وصوت امواج البحر </p>

					<p>ترف رفاهية وأناقة؟  لدينا كل شيء! أحجز رحلتك إلى تل أبيب اليوم</p>



            	`,
      };
    },
  },

  // {
  // 		id:"Cool_Jerusalem",
  //               bgImage: "/posts/bank/cool-jerusalem/1.jpg",
  //               mobBgImage: "/posts/bank/cool-jerusalem/M/1.jpg",
  //               title :"",
  //               ctg:"jerusalem",
  //               isVid:true,
  //               vidId:"FvAWuLQEOJw",
  //               smltitle : "Cool Jerusalem",
  //               html: function(){
  // 			return {
  // 				__html: `
  //                     <h3>A city beyond expectations</h3>
  // 					<p>
  // 					Jerusalem is a globally famous city and one of the most popular vacation destinations in the world. Many people visit Jerusalem every year for its historic significance, its holy sites, its beautiful and unique architecture and remarkable atmosphere. However, Jerusalem is a city of surprises and there are many things on offer in this amazing city which most people won’t associate with it immediately. Here are just some of the things you wouldn’t necessarily expect to find in Jerusalem:
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/40/1.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>Summer Parties</h3>
  // 					<p>
  // 					Every year during the summer the center of Jerusalem becomes awash with Friday noon parties, filled with music, dancing, gorgeous people from around the world and an intoxicating off the hook party vibe to start things off with a bang and get you hot and ready for the rest of the weekend.
  // 					</p>

  // 					<h3>Market Madness </h3>
  // 					<p>
  // 					An amazing experience taking place of Thursday nights, in which the bustling day market of Machne Yehuda becomes a buzzing late night scene packed with fantastic bars and pubs and live music all night long.
  // 					</p>

  // 					<h3>Festivals</h3>
  // 					<p>
  // 					Jerusalem is a city chalk full of festivals – from the famous film festival to the wine festival, an international puppetry festival and even a happening beer festival, whatever you’re into, you’re sure to find a festival to suit your style at taking place at some point in the city.
  // 					</p>
  // 					<h3>Jerusalem Marathon</h3>
  // 					<p>
  // 					A fantastic and extremely popular marathon offering a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, guaranteeing a challenging, thrilling and unforgettable experience for all runners and viewers.
  // 					</p>

  // 					<h3>Museums and Exhibitions</h3>
  // 					<p>
  // 					The diverse nature of the city of Jerusalem extends to its museums and culture event showcased across the city. From the world famous Israel museum to Yad Vashem, to the memorable light and sound spectacular at the citadel and the walk on the walls, and so much more, the city is simply packed with amazing cultural experiences.
  // 					</p>

  // 					<h3>The farmers’ market </h3>
  // 					<p>Every Friday in the German Colony in the heart of the city, you can find the local farmer’s market. Offering a host of great produce and a huge variety of local delicacies and excellent bargains.</p>

  // 					<h3>A World Class Aquarium </h3>
  // 					<p>
  // 					One of the largest aquariums in the middle east, this fabulous attraction for children and adults alike opened its doors to the public for the first time this year. The Aquarium is 7,000sqm in size and houses 40 marine species in 33 water tanks, the largest of which contains 1.6 million liters of water.
  // 					</p>
  // 					<p>
  // 					All these are just a small part of what this magnificent city has to offer. From culture to history, fashion to nightlife, Jerusalem is a city not to be missed!
  // 					</p>

  //             	`   }
  //   }
  // },

  {
    id: "Cycle_TelAviv",
    bgImage: "/posts/bank/cycle-in-telaviv/1.jpg",
    mobBgImage: "/posts/bank/cycle-in-telaviv/M/1.jpg",
    vidId: "5nqL-oIC0GA",
    isVid: true,
    ctg: "telaviv",
    title: "ركوب الدراجات في تل أبيب",
    smltitle: "",
    html: function() {
      return {
        __html: `

					

					<!--<h3>صعد على دراجتك - استكشف المدينة بأناقة</h3>
					<p>باعتبارها واحدة من أكثر المدن عصرية في العالم ، فليس من المستغرب أن تل أبيب انضمت في السنوات الأخيرة إلى الاتجاه الذي يجتاح المدن الأكثر شهرة في العالم - اتجاه الدراجات. استكشاف المدينة على الدراجة له مجموعة متنوعة من الفوائد - إنه صديق للبيئة ، ويقلل بشكل كبير من انبعاثات الكربون ، ويوفر لك وقت الإجازة الثمين الذي تقضيه في محاربة حركة المرور ، وهو بالطبع صحي للغاية. ركوب الدراجة وسيلة رائعة للتمرين ، وكسائح أو زائر ، فإن ركوب الدراجات كوسيلة لاستكشاف المدينة هو وسيلة رائعة للاستمتاع بمشاهدها وأصواتها ورائحتها عن قرب دون تدخل ، وإليك بعض الأشياء التي تصنعها تل أبيب مدينة رائعة لركوب الدراجات:</p>
					
					<p>ممرات الدراجات المخصصة: مدينة تل أبيب من أشد المدافعين عن الدراجات كوسيلة للنقل ولدعم القضية ، هناك أكثر من 100 كم من الممرات المخصصة للدراجات مرصوفة في جميع أنحاء المدينة ، من أجل سلامة وراحة راكبي الدراجات في المدينة. الطقس الرائع: تتمتع تل أبيب بطقس رائع على مدار العام مع هطول قليل من الأمطار ، مما يجعلها مدينة مثالية لركوب الدراجات في الطقس والاستمتاع بالنسيم البارد القادم من الشاطئ على الكورنيش المذهل أو تصغير الشوارع الداخلية المذهلة بهندستها المعمارية الرائعة في باوهاوس .Tel-O-Fun: إن Tel o Fun هو نظام تأجير دراجات بلدية سهل وبسيط وفعال من حيث التكلفة. مع سكان Tel o Fun وزوارها على حدٍ سواء يمكنهم التقاط وتوصيل الدراجات ذات الجودة الممتازة باستخدام بطاقة ائتمان في 150 محطة مناسبة في جميع أنحاء المدينة ، إذا كنت ترغب في ذلك ، يمكنك استئجار دراجة مثالية لك في أي من أماكن تأجير الدراجات في جميع أنحاء المدينة . تقدم معظم الفنادق خيار تأجير الدراجات ، مما يتيح لك استكشاف المدينة على عجلتين ، تمامًا مثل السكان المحليين. أفضل شيء على الإطلاق ، كل شيء في تل أبيب قريب جدًا ، يمكنك ركوب دراجتك إلى الشاطئ ، وركوب الدراجة على طول الكورنيش المذهل ، اصطحب دراجتك واذهب في نزهة رائعة في حديقة Ha'Yarkon وخذها في ليلة في المدينة في النوادي الرائعة والبارات في Dizengoff أو الميناء. مدينة تل أبيب الرائعة.</p>
					-->

					<h3>اصعد على دراجتك  واكتشف المدينة</h3>
					 
					<p>باعتبارها واحدة من أكثر المدن عصرية في العالم فليس من المستغرب أن تل أبيب انضمت في السنوات الأخيرة إلى الاتجاه الذي يجتاح المدن الأكثر شهرة في العالم - ركوب الدراجات الهوائية. استكشاف المدينة على الدراجة الهوائية له مجموعة متنوعة من الفوائد - إنه غير مضر للبيئة، يقلل بشكل كبير من انبعاثات الكربون، ويوفر لك وقتك الثمين وهو بالطبع صحي للغاية. ركوب الدراجة كوسيلة لاستكشاف المدينة يسمح لك بالاستمتاع بمشاهدها وأصواتها ورائحتها عن قرب </p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/41/1.jpg"} class="img-responsive" />
					</div>
					<h3>إليك بعض الأشياء التي تجعل تل أبيب مدينة مثالية لركوب الدراجات</h3>

					<p>ممرات الدراجات: مدينة تل أبيب هي من أشد الداعمين للتشجيع على ركوب الدراجات الهوائية كوسيلة أساسية للنقل. هناك أكثر من 100 كيلومتر من الممرات المخصصة للدراجات في جميع أنحاء المدينة من أجل سلامة وراحة راكبي الدراجات. </p>
					<p>الطقس الرائع: تتمتع تل أبيب بطقس رائع على مدار العام مع هطول قليل من الأمطار، مما يجعلها مدينة مثالية لركوب الدراجات والإستمتاع بنسيم البحر على الكورنيش او في الشوارع الداخلية للتمعن بهندستها المعمارية الرائعة </p>

					<h3><span class="ac-en-font">Tel-O-Fun</span>:</h3>
					<p>هو نظام تأجير دراجات هوائية سهل  المأخذ والاستعمال. يستطيع سكان وزوار تل أبيب على حدٍ سواء باستخدام بطاقة ائتمان في 150 محطة في أنحاء المدينة استئجار وارجاع دراجات ذات جودة ممتازة. وإذا تفضل خيارات اخرى فيمكنك استئجار دراجة في أي من أماكن تأجير الدراجات في جميع أنحاء المدينة. يقدم معظم الفنادق خدمة تأجير الدراجات، مما يتيح لك فرصة استكشاف المدينة على عجلتين، تمامًا مثل السكان المحليين</p>
					<p> الافضل فضل على الإطلاق أن كل شيء في تل أبيب قريب جدًا ، حيث يمكنك ركوب دراجتك إلى الشاطئ ، وعلى طول الكورنيش وفي طريقك لنزهة في الحديقة وباختصار، كل مكان في مدينة الروعة تل أبيب </p>


            	`,
      };
    },
  },

  // {
  // 	id:"TelAviv_Adventures",
  //               bgImage: "/posts/bank/telaviv-adventures/1.jpg",
  //               mobBgImage: "/posts/bank/telaviv-adventures/M/1.jpg",
  //               title :"Tel Aviv Adventures",
  //               smltitle : "",
  //               	isVid:false,
  // 				ctg:"telaviv",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				    <div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/42/1.jpg"} class="img-responsive" />
  // 					</div>
  //                     <br/><h3>Cool things to do in the hot city</h3>
  // 					<p>
  // 					Tel Aviv is world famous for being the city that never stops, renowned for its amazing nightlife, the fabulous beaches, the fantastic culture and art and much more. But here are a few lesser known things you can do in the summer in the city.
  // 					</p>

  // 					<h3>Check out the Bracelet bars</h3>
  // 					<p>
  // 					Bracelet bars are a great way to drink the night away on a budget. Simply wend your way to one of the many bars in Tel Aviv which let you pay a fixed price in advance and drink as much as you want or as much as you can…
  // 					</p>
  // 					<h3>Friday afternoons drum circles<h3>
  // 					<p>
  // 					Make your way to the famous Banana beach on Friday afternoons and treat yourself twice – enjoy the awesome drum session on the beach and check out the gorgeous sunset – both completely free of charge!
  // 					<p>
  // 					<h3>Rooftop fun <h3>
  // 					<p>
  // 					Maybe it’s the weather; maybe it’s the view – one thing’s for sure, Tel Avivians love the outdoors, especially with a drink in hand. During the summer you’ll find most bars and pubs raise the roof (literally!) and turn into outdoor venues, while many bars pop up on rooftops of commercial and office buildings. To find these awesome places all you need to do is simply follow the sounds of music and fun.
  // 					</p>
  // 					<h3>Outdoor fitness <h3>
  // 					<p>
  // 					Nothing’s more important than your health, and one of the best things you can do for your body is to give it some exercise. Tel Aviv offers some great ways to do just that – from swimming in the sea, running along the promenade, bicycling through the fabulous city streets and even getting some gym action on in any of the outdoor (free) exercise stations located around the city.
  // 					</p>
  // 					<h3>Epic Summer Events <h3>
  // 					<p>
  // 					From world famous international artists to amazing tech, art and beer festivals, gallery openings, exhibitions, live street music, to open cinemas and beach parties that last all night, Tel Aviv in the summer is an endless source of fun and entertainment not to be missed!
  // 					</p>

  //             	`   }
  //   }
  // },

  {
    id: "2_AWESOME_CITIES",
    bgImage: "/posts/bank/27/1.jpg",
    mobBgImage: "/posts/bank/27/M.jpg",
    title: "مدينتين رائعتين",
    smltitle: "",
    isVid: false,
    // vidId: "b0QexDxEklA",
    ctg: "general",
    html: function() {
      return {
        __html: `
					<h3>منفذ سحري إلى الشمس، عصي على النسيان</h3>
					<p>تل أبيب مدينة عصرية وشديدة الصخب، وتتميز المدينة بشواطئها الذهبية المتلألئة، وأجوائها الحداثية وتوفر فرص وافرة للاستمتاع المخلوط بالنكهة الشرق أوسطية الأصيلة، ناهيك عن الطعام والقهوة الرائعين فيها. وعلى بعد أربعين دقيقة فحسب من المدينة، بإمكانكم معايشة إيقاع ونضب مختلفين تماما: القدس، المدينة التي لا تضاهيها في روعتها مدينة أخرى، والتي حين تزورونها ستدركون سبب كونها مصدر إلهام للكثيرين منذ آلاف السنوات.</p>
					<p>وفي حين أن كلتي المدينتين المزدحمتين والنابضتين بالحياة تحتويان على عدد كبير من مناطق الجذب التي يجب زيارتها، إلا أنهما شديدتي الاختلاف عن بعضهما البعض. فعلى الرغم من صغر المسافة الفاصلة بينهما، إلا أن كل منهما تتمتع بمناظر طبيعية وروائح ونكهات مختلفة تماما. أين يمكنكم في هذا العالم الجمع المتع اللانهائية للشاطئ، مع واحدة من أقدم المدن وأقدسها في التاريخ؟ إليكم عينة مما يمكنكم القيام به في عطلة واحدة في المدينتين:</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/7.jpg"} class="img-responsive" />
					</div>
					<h3>تل أبيب: المدينة التي لا تعرف النوم</h3>
					<p>ها قد حطّت طائرتكم في تل أبيب إذا... جربوا كل الإثارة في المدينة العبرية الأولى. اكتشفوا الألوان اللازوردية المذهلة لمتوسط، والأماكن الجذابة في المدينة البيضاء، وأسواقها، ومطاعمها، ونكهاتها الخاصة، وحياتها الليلية المتلألئة. جسوا بعض نبضها لتدركوا لماذا تعرف هذه المدينة بكونها المدينة التي لا تتوقف، المدينة التي تتعيش وتتنفس الحيوية، على مدار ساعات اليوم. لننطلق.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/2.jpg"} class="img-responsive" />
					</div>
					<h3>نفيه تصيدق:</h3>
					<p>اكتشفوا سحر هذا الحي الرائع، والجمال المستعاد عبر الترميم، الذي يقع في الطرف الجنوبي من ممشى تل أبيب، قريبا من يافا. ابدأوا يومكم بتجربة تذوق طعام تشمل إفطارا إسرائيليا نموذجيا: المخبوزات اللذيذة، والبيض والجبن والغموس وسلطة الأوراق الخضراء أو السلطة الناعمة مع عصير البرتقال، وبالطبع: القهوة الممتازة. تأخذكم الجولة الموصى بها في نفيه تصيدق إلى المعالم التاريخية والمتاحف الصغيرة الرائعة.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/3.jpg"} class="img-responsive" />
					</div>
					<h3>هَتَحناه</h3>
					<p>بعد استعادتكم لنشاطكم، اذهبوا لزيارة "هتحناه" القريبة. هنالك يمكنكم زيارة المباني التمبلرية المرممة، إلى جانب محطة القطار القديمة في يافا، والتي أعيد بناؤها بالكامل. يروي الموقع حكاية محطة القطار على خط يافا - القدس، الذي كان يعمل ما بين السنوات 1892 - 1948.</p>
 					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/4.jpg"} class="img-responsive" />
					</div>
					<h3>يافا</h3>
					<p>بعد ذلك، تنزهوا على طول كورنيش شاطئ تل أبيب - يافا المذهل. ننصحكم بزيارة ميناء يافا الذي يعد من أقدم موانئ العالم. استرخوا في واحد من المقاهي العديدة المنتشرة على الرصيف، وشاهدوا الصيادين وهم يعملون. وبعدها، واصلوا طريقكم نحو سوق السلع المستعملة الذي يفيض بالألوان، حيث يمكنكم أن تفاجئوا أنفسكم بهدايا من أزمنة قديمة، أو قطعة خزف أرمنية، أو أي من الهدايا التذكارية المتعددة. وتمتعوا بالمكوث في هذه المنطقة التي تتحول في الليل إلى بار مزدحم ومطعم.</p>



           `,
      };
    },
  },

  {
    id: "Tech_tourism",
    bgImage: "/posts/bank/techtourism/1.jpg",
    mobBgImage: "/posts/bank/techtourism/M.jpg",
    title: "سياحة الهايتك",
    smltitle: "",
    isVid: false,
    // vidId: "b0QexDxEklA",
    ctg: "general",
    html: function() {
      return {
        __html: `
					
						<p>إسرائيل، والتي تعتبر احدى الوجهات السياحية الأكثر روعةً وتنوعًا حول العالم، تتمتّع بتعداد المناطق الجغرافية، تنوّع المناخ واختلاف الثقافات المجتمعة في دولة واحدة صغيرة والّتي تضم الكثير من الأماكن المقدسة للأديان السماوية الثلاث الكبرى. غير أنّها تشتهر أيضًا باسم "أمّة الستارت-اب" (Start-up Nation).</p>
						<p>مع أكثر من 80 شركة، والعدد يتزايد، في بورصة NASDAQ، ثالث أكبر رقم بعد الولايات المتحدة والصين، الآلاف من الشركات الناشئة وأعلى إنفاق للفرد في العالم على البحث والتطوير، مجال صناعة الهايتك في إسرائيل ينمو ويزدهر!. في حال كنت هنا في عطلة، لما لا تخلط بين العمل والمتعة وتنغمس في القليل من سياحة الهايتك؟</p>
						<p>هناك الكثير من الفرص للتعرف على المشهد التكنولوجي في إسرائيل. يعرض مركز الابتكار الإسرائيلي في مركز بيرس في يافا الإنجازات التي حققتها إسرائيل في مختلف مجالات التكنولوجيا العالية. أحد هذه المعارض، Israeli Expo هو معرض متجدد للتطورات التكنولوجية الإسرائيلية الرائدة، مع اختيار متجدد للشركات كل عام.</p>
						<p>هنالك قاعة الإلهام ايضاً، وهي تجربة بصريّة تعرض كيف ترك الابتكار الإسرائيلي بصمته في عدة مجالات من الابتكار الزراعي إلى الاتصالات والتقنيّات الطبيّة الرائدة. تتوفر الجولات المصحوبة بمرشدين في المركز بكلتا اللغتين الإنجليزيّة والعربيّة، كما ينظّم المركز جولات خاصة لرجال الأعمال.</p>
						<div class="img-wrapper">
						     <img src=${getImgUrl() +
                   "/posts/techtourism/1.jpg"} class="img-responsive" />
						</div>
						<p>يقدم المعرض الدائم في مركز الإبداع الإسرائيلي في بورصة تل أبيب، شركات التكنولوجيا الإسرائيلية الرائدة والشركات الناشئة الواعدة، كما ويقدّم لمحة عامة عن النظام البيئي للابتكار الإسرائيلي.</p>
						<p>بالإضافة لذلك، توفر العديد من الشركات الخاصّة، والتي يمكن العثور عليها عبر الإنترنت، جولات في النظام البيئي التكنولوجي الصاخب في إسرائيل والتي تشمل مسارات تركّز على التقنيّات الكبرى، البحث والتطوير والشركات الناشئة التي ستكون لك بمثابة مقدمّة للمجتمع التكنولوجي في إسرائيل.</p>
						<p>منظّمة الشركات الناشئة (Startup Nation Central)، هي منظمة غير ربحية تشجّع الابتكار الإسرائيلي، وتقع في شارع ليلنيبلوم، مقابل شارع روتشيلد في تل أبيب، وتدير جولات للشركات في المشهد التكنولوجي المحلية.</p>
						<p>جولة الشركات الناشئة في تل أبيب والمقدمة من قبل بلدية تل أبيب، ستأخذك في جولة في شارع روتشيلد المميز والمناطق المحيطة. حيث تقع العديد من الشركات الناشئة في المدينة، بينما تستعرض الهندسة المعمارية الفريدة من نوعها في المنطقة وتشرح كيف أصبحت تل أبيب موقعًا عالميًا مهمًا في مجال الهايتك.</p>
						<p>من بين الخيارات الأخرى للتعرف على المشهد التكنولوجي في إسرائيل، يمكنكم زيارة أماكن مثل مركز الزوار في معهد وايزمان للعلوم حيث يمكنك سماع أحدث الأبحاث التي أجريت في المعهد، والتي أدت إلى العديد من الثورات التكنولوجية في إسرائيل.</p>
						<p>يعرض مركز فيدور في وادي عربة التقنيّات الزراعيّة المتقدّمة التي مكّنت إسرائيل من تحويل الصحراء إلى مروج خضراء. هذه الجولات متاحة باللغة الإنجليزية.</p>
						<p>مع وجود ستة فائزين بجائزة نوبل في العلوم بالرغم من تاريخها القصير، فمن المنطقي جداً ان يتواجد في إسرائيل العديد من المتاحف العلميّة ذات المستوى العالميّ، منها متحف "مَداع تيك" الوطني للعلوم والتكنولوجيا والفضاء في حيفا، متحف بلومفيلد للعلوم في القدس ومتنزّه كاراسو للعلوم في بئر السبع.</p>


           `,
      };
    },
  },

  {
    id: "Jerusalem",
    bgImage: "/posts/bank/jerusalem-p/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-p/M.jpg",
    title: "أورشليم القدس",
    smltitle: "",
    isVid: true,
    vidId: "FvAWuLQEOJw",
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `

					

                                <h3>مدينة السحر والتألق اللذين يتجاوزان أجمل أحلامك</h3>
								<p><strong>أورشليم القدس هي عاصمة إسرائيل وإحدى أشهر وأبرز المدن حول العالم بفارق كبير عن غيرها، حيث يتشابك تاريخها المجيد الممتد على آلاف السنين مع الحياة المعاصرة بكل سلاسة.</strong></p>
								<p>اكتشف القوة المدهشة التي تملكها هذه المدينة البالغة من العمر <span class="ac-en-font">3000</span> عام بمواقعها التاريخية ومعجزاتها الأثرية التي لا تعد ولا تحصى، وممراتها الساحرة وإطلالاتها الرائعة التي من المضمون أنها ستترك انطباعًا مستدامًا لديك. وفي الحين ذاته، فإن المعالم السياحية العصرية الموجودة في المدينة تعد عشاق الثقافة، والفنون، والموسيقى والمأكولات الشهية بتجربة الإثارة والمتعة على مدار الساعة.</p>

								<h3>المشي عبر <span class="ac-en-font">3000</span> عام من التاريخ</h3>
								<p>تُعتبر البلدة القديمة في أورشليم القدس المكان المفضل بالنسبة لجميع الزوار بدءًا بالذين يزورونها لأول مرة، ومرورًا بالزوار الموسميين وانتهاءً بالسكان المحليين. كونها محاطة بسور قديم أعيد بناؤه على مر التاريخ، هناك 7 أبواب تسمح بالوصول إلى المواقع التاريخية المقدسة هنا. امشِ عبر الشوارع المرصوفة بالأحجار لتجد نفسك متجولاً عبر أربعة آلاف عام من التاريخ، مما سيفضي عليك الشعور بالتواضع وفي الآن ذاته الإثارة بما أنك تربط ما بين حاضر الحياة العصرية والبداية البسيطة للأمور في الحقب التي مضت.</p>
								<h3>التقِ بأورشليم القدس المعاصرة النابضة بالحياة</h3>
								<p>توجه إلى خارج البلدة القديمة واكتشف كل شيء تقدمه المدينة العصرية النمطية يشمل الفنادق، والكورنيش، والمطاعم ومجمعات التسوق. قم بزيارة المتاحف، مثل متحف إسرائيل الذي تم تصنيفه كأحد متاحف الفنون والآثار الرائدة عالميًا كونه يحوي مخطوطات البحر الميت المشهورة (أقدم مخطوطات تراثية) وغيرها من الكنوز. كما وتحيط بأورشليم القدس المزارع المحلية، التي تقدم تشكيلة واسعة من الخيارات لمتذوقي الأطعمة التي تتباين بين المطبخ الإسرائيلي التقليدي والأسلوب المعاصر الممتزج.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Jerusalem-p/1.jpg"} class="img-responsive" />
							    </div>
								<p>قم بزيارة إلى ماحاني يهودا، وهو سوق خارجي مليء بالألوان ونابض بالحياة يتسم بطاقته الجذابة المشحونة بالثقافة والروائح اللذيذة التي تعبق من المأكولات الشهية التي يتم بيعها هناك. انتظر حتى غروب الشمس لتطلع على كيف يتحول "السوق" إلى مكان استراحة عصري يتيح الاستماع إلى الموسيقى الحية التي تناسب كل مزاج وتكون مصحوبة بالأشخاص الحيويين، وغاليريا "فن الشارع" النامية والمأكولات الرائعة والمشروبات الشهية. يتيح ماحاني يهودا عيش تجربة مميزة فامشٍ عبر الشوارع وتوقف عند أحد المطاعم وارقص قليلاً بينما تستمتع بمشروب ثم انتقل إلى محطتك القادمة.</p>
								<p>كونها منقوعة في الفن والتاريخ والثقافة والتنوع فإن العاصمة الإسرائيلية تحب قضاء وقت ممتع وتسمح لك بتجربة التناقض بين العالم القديم والسحر التاريخي والحياة في مدينة عصرية. بينما تقود سيارتك داخل أورشليم القدس لا بد لك من أن تتصل بالثقافة والآثار والتاريخ للعديد من القوميات التي مرت عليها، حيث يلتقي القديم بالجديد خارج أسوار البلدة القديمة في هذه العاصمة العالمية الفريدة.</p>

				


           `,
      };
    },
  },

  {
    id: "Magical_Deadsea",
    bgImage: "/posts/bank/deadsea3/1.jpg",
    mobBgImage: "/posts/bank/deadsea3/M.jpg",
    title: "البحر الميت السحري",
    smltitle: "",
    isVid: true,
    vidId: "M627s8TdaB8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
							    <p>
									<strong>استرخاءِ في "الخير المالح" للبحر الميت وجرّب عطلة منعشة لا تُنسى أبدًا</strong>
								</p>
								<p>
									بجماله الطبيعي الآخذ للأنفاس، ومنتجعاته الصحية المهدئة الغنية بالمعادن، والتي تثبت ميزاتها الشافية والعديد من التجارب الفريدة الذي يتيح الاستمتاع بها، لا عجب أن البحر الميت قد أصبح إحدى الوجهات السياحية الأبرز عالميًا. إن هذه البحيرة الملغزة هي كل ما تحتاجه لعيش تجربة الإجازة المثالية لكل من العقل والجسم. استرخِ. الملح، الطين، الشمس... وهناك المزيد. اغمس في الينابيع الكبريتية الطبيعية (الساخنة) واستمتع بعلاجات السبا. أتعرف معنى عبارة "المتعة المذنبة؟" إنها لا تنطبق هنا. فتخلص من الشعور بـ "الذنب" واستمتع ببساطة بإجازة صحية ومنعشة ومسترخية.
								</p>
								
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Magical-Deadsea/1.jpg"} class="img-responsive" />
							    </div>
								<p>
									<strong>تعال استمتع بإحدى هدايا الطبيعة المعجزة</strong>
								</p>
								<p>
									<strong>الطفو.</strong> بفضل النسبة المرتفعة بشكل استثنائي من الملح في المياه، فإنك ستستطيع إحداث "معجزة"، ليس مشيًا على قدميك وإنما من خلال الطفو الطبيعي على المياه. ادخل المياه، ثم استلقِ على ظهرك وَدَع الطبيعية تؤدي دورها. قد يستغرق التعود على ذلك دقيقة أو دقيقتين لكن بعد ذلك نعدك بالتجربة السحرية. اشفِ نفسك. يضفي دخول منطقة البحر الميت عليك الشعور وكأنك تدخل عالمًا مختلفًا. إطلالة مختلفة، وتيرة مختلفة، هواء مختلف وحتى شمس مختلفة. حيث تنجم الخاصيتان الأخيرتان عن الظروف الجيولوجية الخاصة التي تسود في المنطقة والتي تُعتبر من الأسباب الرئيسية وراء قوى الشفاء لهذه المنطقة. إن أجواءها مختلفة بسبب ذوبان ملح البحر في المعادن الصحية الغنية التي تمتصها عبر الهواء. بينما تُعدّ الشمس مختلفة بسبب موقع البحيرة الأوطأ من سطح البحر بكثير، مما يضعف ويرشح الأشعة فوق البنفسجية الضارة. اخرج من مياه البحيرة واستمتع بهدايا الطبيعة العجيبة.
								</p>
								<p>
									<strong>اكتشف الطفل في داخلك ودع الطبيعة تشفيك</strong>
								</p>
								<p>
									<strong>غطِ نفسك بالطين  –</strong> ثبتت فوائد الطين الخاص بالبحر الميت بالنسبة للصحة، علمًا بأنه ينعش ويمنح جلدك الرخاء. بإمكانك شراؤه واستخدامه في منزلك، لكن لما تفوّت فرصة تمكين الطفل الداخلي لديك؟ غطِ نفسك بالطين الأسود من رأسك إلى قدمك وعِش تجربة المرح ببساطة. نتحداك أن تلتقط صورة لنفسك.
								</p>
                               


           `,
      };
    },
  },
  // {
  // 	    id:"Next_Level_DS",
  //         bgImage : "/posts/bank/1.jpg",
  //         mobBgImage : "/posts/bank/M.jpg",
  //         title : "TAKE RELAXATION TO THE NEXT LEVEL",
  //         smltitle : "",
  //         isVid:true,
  //         vidId: "8p4qfkneH1c",
  //         ctg: "deadsea",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                      <p>
  // 					The Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World’s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.
  // 				</p>
  // 				<p>
  // 					From the healing powers of the Dead Sea’s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.
  // 				</p>
  // 				<p>
  // 					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.
  // 				</p>

  // 				<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/next-level/1.jpg"} class="img-responsive" />
  // 				</div>
  // 				<p>
  // 					The Magical Beaches of the Dead Sea
  // 				</p>
  // 				<p>
  // 					The beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.
  // 				</p>
  // 				<p>
  // 					On the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud – it’s healthy!
  // 				</p>
  // 				<p>
  // 					Discover the desert area around the Dead Sea
  // 				</p>
  // 				<p>
  // 					There is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.
  // 				</p>
  // 				<h3>
  // 					MOUNT KARKOM
  // 				</h3>
  // 				<p>
  // 					In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.
  // 				</p>
  // 				<p>
  // 					Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.
  // 				</p>
  // 				<p>
  // 					Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.
  // 				</p>
  // 				<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/next-level/2.jpg"} class="img-responsive" />
  // 				</div>
  // 				<p>
  // 					Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.
  // 				</p>
  // 				<p>
  // 					To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.
  // 				</p>

  //            `
  //     }
  //   }
  // },
  {
    id: "Next_Level_DS",
    bgImage: "/posts/bank/deadsea2/1.jpg",
    mobBgImage: "/posts/bank/deadsea2/M.jpg",
    title: "البحر الميت",
    smltitle: "",
    isVid: true,
    vidId: "M627s8TdaB8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					<p>نال البحر الميت شهرته في كل أنحاء العالم باعتباره أخفض بقعة على سطح الكرة الأرضية حيث يبلغ منسوب شاطئه 430.5 مترًا تحت مستوى سطح البحر كما أنه يُعدّ عبارة عن بحيرة مالحة تسمح لك بالطفو حقًا. اسمه باللغة العبرية هو يام هميلاخ، بمعنى بحر الملح، بينما يعود الاسم الذي يطلق عليه باللغة الإنجليزية إلى نسبة الملوحة العالية التي يتسم بها. إنه عبارة عن أحد المسطحات المائية الأكثر ملوحةً حول العالم حيث لا يمكن للنبتات وللحيوانات الحياة داخل البحيرة، التي تمتد على مسافة حوالي 67 كيلومترًا طولاً و18 كيلومترًا عرضًا.</p>

                    <p>في كل من الحضارتين اليهودية والإسلامية، اشتهر البحر الميت بكونه موقع مدينة سدوم القديمة، التي دمرها الله بسبب سلوك سكانها الآثم، ولم ينقذ منهم سوى النبي لوط، وبالتالي تم إطلاق عليه اسم بركة لوط، بمعنى بحيرة لوط في اللغة العربية.</p>

                    <p>كما واشتهر البحر الميت بميزاته المعدنية والتي تعود إلى عصر هيرودس الأول حيث تمت الاستفادة من طينه الغني بالمعادن، ومن أملاحه العلاجية وينابيعه الكبريتية الساخنة منذ ذلك الحين لاستيفاء الاحتياجات الصحية.</p>
                  	<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/3.jpg"} class="img-responsive" />
				    </div>
                    <p>تقوم عدة شركات بصناعة منتجات العناية بالبشرة من معادن البحر الميت والتي نالت سمعتها العالمية بفضل مميزاتها التجميلية.</p>

                    <p>هناك عدد من المنتجعات الصحية التي تقع على طول البحيرة وداخل منطقتي الفنادق الرئيسيتين في عين بوكيك وحامي زوهار، حيث يمكنكم أن تجدوا مجمعات التسوق، والمطاعم والشواطئ المرخصة التي تتيح خدمات المنقذين البحريين، والحمامات والمرافق، فضلاً عن الإطلالة الرائعة على البحيرة.</p>

                    <p>وربما تشكل قلعة ميتسادا التي أنشأها هيرودس فوق جروف يبلغ ارتفاعها حوالي 450 مترًا أكثر المواقع شهرةً على امتداد شواطئ البحر الميت. وكانت ميتسادا المكان الذي أطلق منه المقاومون اليهود معركتهم الأخيرة ضد الجيش الروماني الجبار بعد تدمير الهيكل الثاني بسنوات عدة. حيث أقدم المقاومون أخيرًا وبعد صمود دام أشهر طويلة أمام الحصار الروماني على الانتحار الجماعي الذي فضّلوه على الاستسلام بمجرد أن تمكن الرومان من اختراق حيطان القلعة.</p>

                    <p>وتشمل المواقع الأخرى المنتشرة على طول البحر الميت محمية عين جدي الطبيعية، حيث يمكنكم اكتشاف أكبر واحة في إسرائيل، ناهيك عن الينابيع والشلالات، وخربة قمران، حيث تم الكشف عن مخطوطات البحر الميت المشهورة عالميًا.</p>

                    <p>أما بالنسبة للأشخاص الذين يحبون المغامرات، فالمنطقة تتيح مسارات المشي الرائعة، والجولات على متن سيارات جيب وغير ذلك المزيد.</p>

                   
				
				
				
				
				       


           `,
      };
    },
  },
  // {
  // 	    id:"Natures_Glory",
  //         bgImage : "/posts/bank/natures-glory/1.jpg",
  //         mobBgImage : "/posts/bank/natures-glory/M.jpg",
  //         title : "NATURE'S GLORY",
  //         smltitle : "",
  //         isVid:true,
  //         vidId: "M627s8TdaB8",
  //         ctg: "deadsea",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 			    <p>
  // 					Get high on life in the lowest place on earth
  // 				</p>
  // 				<p>
  // 					The Dead Sea, officially the lowest place on earth (428m below sea level) and one the world’s natural wonders, is an enthralling and evocative combination of natural splendor, compelling ancient history, and modern luxuries.
  // 				</p>
  // 				<p>
  // 					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions.
  // 				</p>
  // 				<h3>
  // 					NEW BOARDWALK AT THE DEAD SEA
  // 				</h3>
  // 				<p>
  // 					Just in time for the Passover and Easter holidays, a new, stone 4k boardwalk and free, accessible public beaches with full facilities have opened in the hotels area of the Dead Sea. The promenade will eventually extend another ten kilometers, to include a total of 16 public beaches, connecting Ein Bokek and Hamei Zohar, along the southern part of the Dead Sea. This is part of a major new leisure and hotel complex that is planned for the region.
  // 				</p>
  // 				<div class="img-wrapper">
  // 								   <img src=${getImgUrl() +  "/posts/natures-glory/1.jpg"} class="img-responsive" />
  // 				</div>
  // 				<p>
  // 					Visitors to the Dead Sea - the lowest place on earth and the world’s largest natural spa known for its unique wellness properties since Biblical times – can now enjoy full access to wide, sandy beaches, walking, jogging, cycling or even taking a Segway along the entire length of the new boardwalk. The new beaches are all free to the public, with facilities that include beach chairs, showers, canopies, sports equipment, children’s playgrounds and more.
  // 				</p>
  // 				<p>
  // 					The beaches are accessible for the disabled, with special wheelchairs and trails that can take visitors right into the waters of the Dead Sea. Special illumination allows tourists and visitors to walk the boardwalk at night, while at the same time enjoying the very special atmosphere at the Dead Sea.
  // 				</p>

  //            `
  //     }
  //   }
  // },
  {
    id: "Natural_Spa",
    bgImage: "/posts/bank/deadsea2/1.jpg",
    mobBgImage: "/posts/bank/deadsea2/M.jpg",
    title: "أكبر منتجع صحي في العالم - البحر الميّت",
    smltitle: "",
    isVid: true,
    vidId: "M627s8TdaB8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
				   <!-- <p>
						The Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World’s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.
					</p>
					<p>
						From the healing powers of the Dead Sea’s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.
					</p>
					<p>
						Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.
					</p>			

					

					<p>
						The Magical Beaches of the Dead Sea
					</p>
					<p>
						The beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.
					</p>
					<p>
						On the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud – it’s healthy!
					</p>
					<p>
						Discover the desert area around the Dead Sea
					</p>
					<p>
						There is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.
					</p>-->

					<p>أعلى حد من المتعة، في أخفض بقاع الأرض</p>
					<p>يعدّ البحر الميت، رسميا، أخفض مكان على وجه الأرض (435 مترا تحت مستوى سطح البحر)، وهو يعدّ أيضا واحدا من عجائب الدنيا الطبيعية، مزيجا آسرا ومثيرا للذكريات من روائع الطبيعة، والتاريخ السحيق الجذّاب. </p>
					
					<p>بإمكان المرء أن يطفو على مياه البحر الميت، أو أن يأخذ حمّاما طينيا، أو يذهب للاستكشاف في هذه المنطقة التي تشهد 330 يوما مشمسا في السنة، وتعج منطقة البحر الميت بمناطق الجذب الرائعة، بما فيها منتجعات العلاج الطبيعي، ومسارات المشي المذهلة، ومطاعم الذوّاقة جنبا إلى جنب مع مطاعم الوجبات السريعة، عدا عن أماكن الجذب والإثارة التي ستثير جنون الأدرينالين في أجسادكم.</p>
					<p>المسار المرصوف في البحر الميت</p>

					<p>تم افتتاح مسار حجري مرصوف ومجاني على امتداد 4 كيلومترات، وهو يمتد إلى جانب الشواطئ العامّة المجانية التي تحتوي على كامل المرافق في منطقة الفنادق في البحر الميت. يمتد المنتزه في نهاية المسار المرصوف على امتداد عشرة كيلومترات أخرى، وهو يؤدي في المجموع إلى 16 شاطئا عاما، رابطا منطقة "عين بوقيق" ب "حمي زوهار"، على امتداد الجزء الجنوبي من البحر الميت. هذا المسار هو جزء من مجمع ترفيهي وفندقي رئيسي جديد، تُخطط إقامته في المنطقة</p>
   					<div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/posts/natural-spa/1.jpg"} class="img-responsive" />
					</div>
					<p>يمكن لزوار البحر الميّت، وهو أخفض مكان على وجه الأرض، وأكبر منتجع طبيعي في العالم، معروف بخصائصه الصحية الفريدة منذ العصور التوراثية، التمتع الآن بالوصول الكامل إلى الشواطئ الرملية الواسعة، والمشي، والركض، وركوب الدراجات الهوائية، بل وحتى ركوب دراجة الـسيجواي ثنائية العجلات على امتداد المسار المرصوف الجديد. الشواطئ الجديدة، كلّها، مجانية وعامة، وهي تحتوي على مرافق تشمل مقاعد الشاطئ، مرافق الاستحمام، المظلات، المعدات الرياضية، ملاعب الأطفال، وغير ذلك.</p>
					<p>هذه الشواطئ قد تمت ملائمتها لذوي الاحتياجات الخاصة، بكراسي مدولبة خاصة ومسارات يمكنها أن توصل الزوار إلى قلب مياه البحر الميت مباشرة. وتسمح الإضاءة الخاصة للسائحين والزوار بالسير في هذا الممر ليلا، في الوقت الذي يستمتعون به بالأجواء شديدة الفرادة التي يتميز بها البحر الميت.</p>

                      
           `,
      };
    },
  },
  {
    id: "Natural_Phenomena",
    bgImage: "/posts/bank/natural-phenomena/1.jpg",
    mobBgImage: "/posts/bank/natural-phenomena/M.jpg",
    title: "ظاهرة طبيعية",
    smltitle: "",
    isVid: true,
    vidId: "M627s8TdaB8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

						<p>يعدّ البحر الميت واحدة من أكثر الظواهر الطبيعية الفريدة على وجه الأرض، إذ يتيح الشق الموجود في القشرة الأرضية، وهو جزء من حفرة الانهدام العظيمة لمياه نهر الأردن، التدفق جنوبا نحو بحيرة على شكل معينات، موقعها كائن في أخفض نقطة على وجه القشرة الأرضية. ونظرا لعدم وجود منفذ للمياه المتجمعة، تقوم أشعة الشمس الحارقة بتبخير المياه إلى درجة أن محتواها المعدني شديد التركيز؛ هذه الكثافة من المعادن والأملاح تجعل من المستحيل على المرء الغرق في البحر: حيث يطفو السبّاحون على سطح المياه بسهولة. وإلى جانب ذلك، ونظرا لأن أشعة الشمس تمر بمسافة 1200 قدما إضافية لكي تصل إلى ذلك المكان فإن الأشعة فوق البنفسجية تمر بعملية تصفية في طبقات الهواء، ويثرى الأكسجين إلى درجة أن اصحاب البشرة البيضاء يكتسبون لونا أسمر من دون أن يتعرضوا للحروق.</p> 
						<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natural-phenomena/1.jpg"} class="img-responsive" />
					    </div>
						<p>هذا هو السبب الذي يجعل زيارة البحر الميت تتيح لمن يعانون من الأمراض الرئوية أن يتنفسوا بصورة أفضل، وهو أيضا السبب الذي يفسح المجال أمام ضحايا مرض الصدفية وأمراض الجلد الخطيرة الأخرى، علاجات مؤقتة عن طريق الاستحمام في البحر الميت، وتغطية بشرتهم بطين البحر الميت المليء بالمعادن، والتسفّع تحت الشمس غير الحارقة في هذه المنطقة.</p> 
						<p>تصطف على ضفاف البحر الميّت المنتجعات الصحية وشواطئ الاستجمام وفنادق المنتجعات الصحية (سبا).</p> 

         


           `,
      };
    },
  },
  {
    id: "Masada",
    bgImage: "/posts/bank/deadsea3/1.jpg",
    mobBgImage: "/posts/bank/deadsea3/M.jpg",
    title: "متسادا",
    smltitle: "",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `
			<!--<p>قريبا من البحر الميت، يتواجد موقع يبدو وكأنه، بعكس بقية المناظر الطبيعية، جزء من جرف وادي ريفت، ولكن في الواقع ذو شكل بيضاوي مسطح: جبل محاط تماما بجرف هائل. في الأيام التي سبقت اختراع طائرات الهليكوبتر والطائرات المسيرة، كان هذا موقعا آمنا قدر الإمكان للملك هيرودس, ليبني لنفسه قصرا محصنا، يمكنه اللجوء إليه في حالات الطوارئ وبسبب قربه للبحر الميت، فقد كان مناسبا للملك. يخبرنا المؤرخون أنه كان يعاني من "مرض جلدي مزمن"، ربما كان مرض الصدفية.
			<p>كانت مسادا موقعا ملحميا، كما كانت أيضا أعجوبة من أعاجيب الهندسة التي استخدمت مجاري المياه الصناعية لتحويل الأمطار النادرة في الصحراء نحو صهاريج عملاقة كان بإمكان الناس وقتها، رغم أن درجة الحرارة قد تصل في ذلك المكان إلى 49 درجة مئوية، صناعة الجليد منها، وتخزينه أيضا.
			<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/masada/1.jpg"} class="img-responsive" />
							    </div>
			<p>بعد وفاة هيرودس، صار المكان مهجورا بالكامل، حتى العام 73 ميلادية. إذ بعد أن دمر الرومان القدس في سنة 70 م، وقاموا بطرد اليهود من مدينتهم المقدسة، شقّت مجموعة من اللاجئين اليهود طريقها إلى تلة مسادا، وقامت بتحويل القصر إلى موطن لها.
			<p>وبسبب عدم اهتمام هؤلاء بعظمة القصر، ولكونهم من طائفة الزيلوت، فقد بنوا كنيسا، وأنشأوا مغتسلا دينيا، وقاموا بزراعة المحاصيل ورعاية الماعز. ومع ذلك، لم يتمكن الرومان من احتمال التحدّي الكامن بوجودهم، واستمروا بمحاصرة الجبل لمدة ثلاثة سنوات، وقد حكموا على الآلاف من جنود فيالقهم بالتخييم في الحرارة الشديدة، في محاولة منهم لتجويع سكان قمة الجبل ودفعهم إلى الاستسلام (وتبدو آثار المعسكرات الرومانية واضحة حتى يومنا هذا).
			<p>تم إجبار الآلاف من العبيد اليهود على بناء طريق صاعد إلى القمة، وبعد شهور طويلة استغرقتهم لاستكمال الطريق، أدرك الزيلوت على قمة الجبل أن الجنود الرومان سيصلون في اليوم التالي إلى مخبأهم، وقد عقدوا العزم على الانتحار بدلا من أن يتم استعبادهم مع نسائهم وأطفالهم، أو يتم قتلهم. وحينما تمكّن الرومان أخيرا من شقّ طريقهم إلى قمة الجبل، فوجئوا بعدم ملاقاتهم لأية مقاومة تذكر، واكتشفوا 960 جثة، وقد حدّثت سيدتان اختبئتا من عملية الانتحار الجماعي "الفاتحين" بتفاصيل الانتحار، وقد روى المؤرخ اليهودي الروماني يوسيفوس قصة مسادا في كتابه "الحروب اليهودية".
			<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/masada/2.jpg"} class="img-responsive" />
							    </div>
			<p>لقد دخل زعيم فرقة الزيلوت، إليعيزر بن يائير، في ليلته الأخيرة من الحرية إلى الخلود: لقد عقدنا عزمنا منذ زمن بعيد على ألا نصير خادمين للرومان، ولا لأي جهة سوى الله نفسه، الذي هو وحده الحقيقي والوحيد. فقط يا رب البشرية، لقد حان الوقت الآن الذي يلزمنا بتنفيذ هذا القرار.. لقد كنا أول من ثار، وها نحن هنا الآن آخر من يحارب هؤلاء، ولا يسعني إلا أن أعتبر هذا كله منحة قدمها الله لنا، لأننا لا يزال بوسعنا أن نموت بشجاعة، وأن نموت أحرارا".
			<p>في عام 1964 قاد البروفيسور الإسرائيلي يغئال يادين عملية تنقيب دولية استمرت مدة عامين لاكتشاف أسرار مسادا. وتدعم المئات من اكتشافات فريقه النصوص التي كتبها يوسيفوس، حتى أن علماء الآثار قد عثروا على الرموز الطينية التي نحتها الزيلوت، والتي تحوي الكثير من الأسماء لتحديد من الذي سينفذ عملية "القتل الرحيم" للعائلات أولا، والانتحار أخيرا.
			<p>صارت قصة ما حدث قبل ألفي عام في قمة مسادا، رمزا لتعهّد الإسرائيليين بعدم السماح لـ “مسادا بالسقوط مرة أخرى"، وبعد خمسين عاما من التنقيب، صارت مسادا، بعد القدس، من أكثر المواقع استقطابا للسياح في إسرائيل. يمكن الوصول إلى القمة إما سيرا على الأقدام عبر مسار أفعواني تقليدي هو ذات المسار الذي استخدمه هيرودوس، وإما عبر الطريق المنحدر الروماني. ولكن غالبية الملايين من السياح الذين يزورون مسادا يتنقلون من متحفها ومركز زوارها إلى القمة بواسطة عربات تلفريك هوائية عملاقة تعمل على مدار أيام السنة باستثناء يوم الغفران. 
			      -->    

			       <p>بجوار البحر الميت هناك موقع يبدو للوهلة الأولى وكأنه جزء من جرف وادي "ريفت" ولكنه في الواقع عبارة عن مائدة صحراوية (ميسا).  </p>

					<p>في أيام ما قبل طائرات الهليكوبتر والطائرات بدون طيار كان هذا موقعًا آمنًا بقدر ما يمكن للملك هيرودس ليبني حصنًا لقصره الذي يمكنه اللجوء إليه في حالات الطوارئ (ولأنه كان متاخمًا للبحر الميت، فقد كان مناسبًا لعاهل يخبرنا المؤرخون أنه عانى من "مرض جلدي مزمن" - ربما الصدفية). </p>
					<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/masada/1.jpg"} class="img-responsive" />
					</div>

					<p>كانت روعة متسادا ملحمية, وكانت أيضًا أعجوبة هندسية استخدمت لتوجيه الأمطار الصحراوية النادرة من خلال مجاري المياه الاصطناعية إلى صهاريج عملاقة حيث وعلى الرغم من درجات الحرارة المرتفعة، تمكنوا من صنع وتخزين الجليد.</p>


					<p>بعد وفاة هيرودس هجر الموقع بالكامل حتى عام 73. بعد أن دمر الرومان أورشليم القدس في عام 70 وطردوا اليهود منها شق مجموعة من اللاجئين اليهود طريقهم إلى قمة متسادا وقاموا بتحويل القصر الى منزلهم.</p>


					<p>وبسبب عدم اهتمامهم بعظمة القصر واعتبارهم لأنفسهم متعصبين بنى اللاجئون لأنفسهم كنيسًا وأنشأوا "مكڤيه" وزرعوا المحاصيل وقاموا برعي الماعز. ولكن لم يتقبل الرومان مثل هذا التحدي والتمرد فحاصروهم على الجبل لمدة ثلاث سنوات وأمروا الآلاف من الجنود الرومانيين بالتخييم في الصحراء في محاولة لتجويع سكان قمة الجبل وإجبارهم للاستسلام (آثار المعسكرات الرومانية واضحة للعيان حتى يومنا هذا).</p>


					<p>اجبر الآلاف من العبيد اليهود على بناء منحدر عملاق للقمة وبعد الأشهر التي استغرقت لاستكمال البناء أدرك المتعصبون على قمة الجبل أن الجنود الرومان يقتربون من اقتحام مخبئهم  فقرروا ارتكاب الانتحار الجماعي خوفا من القتل أو الاستعباد </p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/masada/2.jpg"} class="img-responsive" />
					</div>

					<p>اخيرا، وعندما شق الرومان طريقهم إلى قمة الجبل لم يواجهوا أي مقاومة واكتشفوا 960 جثة. شاركت امراتان اختبئا من الانتحار الجماعي تفاصيل الأحداث مع "الفاتحين"، وروى المؤرخ الروماني اليهودي جوزيفوس قصة متسادا في كتابه "الحروب اليهودية".</p>

					<p>عهد زعيم المتعصبين العازار بن يائير في ليلة الحرية الأخيرة خالد: </p>

					<p>"منذ أن قررنا ألا نكون خدما للرومان ولا لأي احد آخر غير الله نفسه الذي هو وحده الرب الحقيقي والعادل للبشرية ، والآن فقد حان الوقت الآن الذي يلزمنا بجعل هذا القرار حقيقيًا في الممارسة . .. كنا أول من ثار ونحن آخر من حاربهم. ولا يسعني إلا أن أقدر على أنه معروف منحه لنا الله أنه لا يزال بوسعنا أن نموت بشجاعة وفي حالة من الحرية ".</p>



					<p>في عام 1964 قاد البروفيسور الإسرائيلي يغئال يادين عملية تنقيب دولية دامت عامين هدفها اكتشاف أسرار متسادا وتدعم المئات من اكتشافاتهم ما كتبه المؤرخ جوزيفوس، حتى أن علماء الآثار عثروا على رموز طينية نحت المتعصبون عليها أسماء واستخدموها لتحديد من سيقوم "بالقتل الرحيم" لعائلاتهم أولاً وأنفسهم أخيراً. </p>


					<p>أصبحت قصة ما حدث قبل ألفي عام على قمة متسادا رمزًا لالتزام الإسرائيليين بعدم السماح لـ "متسادا بالسقوط مرة أخرى" </p>
					<p>وبعد خمسين عامًا من التنقيب أصبح هذا المكان، بعد القدس للموقع الأكثر شعبية في إسرائيل. يمكن الوصول إلى القمة سيرًا على الأقدام عبر مسار الأفعى التقليدي الذي استخدمه هيرودس وحتى طريق المنحدر الروماني. لكن غالبية ملايين السياح الذين يزورون متسادا يتنقلون من متحف متسادا ومركز الزوار إلى القمة في عربات تلفريك عملاقة تعمل يوميًا باستثناء يوم كيبور. في شهر يونيو من كل عام ، تتحول متسادا الى موقع لمهرجان الأوبرا العملاق.</p>



           `,
      };
    },
  },

  {
    id: "Tel_Aviv",
    bgImage: "/posts/bank/telaviv-p/1.jpg",
    mobBgImage: "/posts/bank/telaviv-p/M.jpg",
    title: "تل-أبيب يافا",
    smltitle: "",
    isVid: false,
    // vidId: "I9a4BFWO_6w",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
			                    <p>Hailed as ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’, Tel Aviv is without a doubt THE place to visit in the Mediterranean.</p>
								<p>Named by The New York Times "The Mediterranean Capital of Cool", Tel Aviv is a modern, vibrant cosmopolitan. Buzzing art scene, UNESCO recognized Bauhaus architecture, award-winning cuisine, world-class nightlife, friendly laid-back atmosphere and gorgeous beaches all earned the city its rightful place as one of the world's top travel destinations.</p>

                                <p>But even in the city that has it all, there is only one place to start - the beach.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/telaviv-p/1.jpg"} class="img-responsive" />
							    </div>
								<h3>Discover the Heart of a Sizzling City</h3>

                                <p><strong>What.</strong> The heart of the city National Geographic called "Miami beach of the Mediterranean" and included in its top 10 world's best Beach Cities list, is its coastline.</p>

                                <p><strong>Why.</strong> Sandy beaches, warm waters, plenty of watersports opportunities and great weather, need we say more? Tel-Aviv coastline is comprised of 13 unique beaches that each gives different view and offers a different experience. From the busy and trendy to the chill and laid-back, together they form a rich, colorful tapestry of this exciting and diverse city.</p>

                                <p><strong>Where.</strong> Located at the western edge of the city, in Tel-Aviv you're always one step away from the beach. No need to resist the temptation. Just cross the street, take off your shoes and start having fun.</p>

                                <h3>Choose your own Beach Adventure</h3>

                                <p><strong>Get Active.</strong> Beach and watersports are very popular in Tel-Aviv. Surfing, sailing, rowing, swimming, Supping, diving, volleyball – the list of possibilities goes on and on.</p>

                                <p>Choose your favorite activity and enjoy. Then, when you the click-clock sound of the Matkot on the beach, join the masses in this hugely popular Israeli paddle ball game. There are no winners or losers here, but it's still fun…and very addictive.</p>

                                <p><strong>Sign up</strong> for the SAIL TLV sailing tournament that takes place in the spring and includes sailing yachts, motor yachts and motor boats from all around the world. Enjoy the sports activities and the wonderful embracive community.</p>

                                <p>Want more? Join the locals and bike, walk or jog on the promenade.</p>

                                <p><strong>Get Social.</strong> Build castles in sand with your family, take your dog for a walk and mix with the friendly diverse crowd.</p>

                                <p><strong>Get Chilled.</strong>  Want to slow down and relax? No problem! Find a quiet spot in one of the less crowded beaches, watch (or join) the drum circles and sit at one of the restaurants along the coast. In the afternoon, get close to the water, grab a chair, sit back and watch one of those beautiful Tel-Aviv sunsets. It doesn't get better than this.</p>
            	      


           `,
      };
    },
  },

  {
    id: "Simply_Delicious",
    bgImage: "/posts/bank/simply-delicious/1.jpg",
    mobBgImage: "/posts/bank/simply-delicious/M.jpg",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "JQD9JpMaw9g",
    title: "جنّة للذواقة",
    smltitle: "",
    html: function() {
      return {
        __html: `

                     <h3>تعالوا لتتفقدوا مشهد الطهو المذهل في تل أبيب</h3>
					
					
					<p>إن كنتم من الذوّاقة (ودعونا نعترف بالأمر: معظمنا كذلك) فإن عليكم ببساطة أن تتذوقوا تل أبيب.</p>
					<p>نظرا لأن الطهاة الإسرائيليين قد صاروا مشهورين في جميع أرجاء العالم بسبب أطباقهم المبتكرة، فإن توقعاتكم لا بدّ وأن تكون بالمستوى ذاته من مشهدية الطهي في تل أبيب. فالمدينة، حرفيا، 
					<strong>تفيض بالنكهات المختلفة والمثيرة للاهتمام.</strong></p>
					<p>بوجود 
					<strong>حوالي 4500 مطعم في المدينة، فإن تل أبيب هي جنّة حقيقية للذواقة.</strong>
					 فالعديد من المطاعم هنا مملوكة لطهاة بارعين من جميع أرجاء العالم، ممن تدربوا وعملوا في بعض أفضل المؤسسات حول العالم قبل عودتهم إلى إسرائيل لكي يضعوا بصمتهم الفريدة على مشهد الطهي المحلّي.</p>
					<p>يمكن العثور على المأكولات الأكثر تطورا في المدينة في حي نفيه تصيدق، أو ميناء تل أبيب، أو جادة روتشيلد، أو على امتداد شارع ابن جفيرول، وأي من هذه المطاعم لا بد وأن يقدم لكم مغامرة تذوّق مذهلة.</p>
                    <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/simply-delicious/1.jpg"} class="img-responsive" />
							    </div>
					<p>عليكم أيضا 
					<strong>تفقّد حي سارونا التاريخي، </strong>
					وهو في الأصل مستوطنة تمبلرية ألمانية، وقد تم ترميمها بدقة لتصير 
					<strong>موطنا لسوق المنتجات المحلية </strong>
					إلى جانب بعض متاجر التجزئة. يكمن سحر سارونا في المنازل المرممة ذات المرجات المعشوشبة المتناثرة في كل مكان. تعد منطقة سارونا المكان 
					<strong>المثالي لقضاء نزهة جميلة في الهواء الطلق.</strong></p>
					<p>المطبخ التل أبيبي لديه ما يناسب كلّ الأذواق.</p>


         `,
      };
    },
  },

  // {
  //         id:"Nonstop_Excitement",
  //         bgImage : "/posts/bank/35/1.jpg",
  //         mobBgImage : "/posts/bank/35/M.jpg",
  //         title : "Tel Aviv: Nonstop excitement.",
  //         vidId : "88OV6xU0vPI",
  //         isVid:true,
  //         smltitle : "",
  //         ctg: "telaviv",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                     <h3></h3>
  // 					<p>
  // 					Energetic, inspirational or funfilled relaxation - Your holiday in the vibrant city of Tel Aviv can be
  // 					anything you want it to be. With great weather virtually all year round, you can chill on dazzling
  // 					stretches of golden beaches, take in the colorful markets, cutting edge culture and entertainment,
  // 					outstanding nightlife and an exciting culinary scene. You can also enjoy simply making your way through the streets with their fascinating Bauhaus buildings and just feel the city’s unique ‘non-stop’ vibe, which has made it one of the trendiest destinations for tourists worldwide.<br>
  // 					So get energized, get inspired, get ready – you’re gonna fall in love with Tel Aviv!

  // 					</p>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/3.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>
  // 					NON-STOP Tel Aviv<br> Ultimate Beach Fun
  // 					</h3>

  // 					<p>
  // 					Voted National Geographic Magazine “One of the ten best beach cities in the world” - with clear waters and action-packed beaches, each one of Tel Aviv’s 16 beaches has its own style and attracts certain personalities - from hippie casual to Riviera chic. Day or night, hanging out on the beach is one of the best ways to spend the time in Tel Aviv.
  // 					</p>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/2.jpg"} class="img-responsive" />
  // 					</div>
  // 					<h3>
  // 					Sensational Nightlife
  // 					</h3>
  // 					<p>
  // 					The Israeli weekend starts on Thursday evening and continues until nearly the crack of dawn on Sunday—when the work week resumes. But pretty much every night is “party night” in Tel Aviv. The city that doesn’t stop keeps going all night long and is constantly buzzing with trendy, vibrant hotspots, home to some of the most epic clubs and parties in the world.
  // 					</p>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/4.jpg"} class="img-responsive" />
  // 					</div>

  // 					<br>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/5.jpg"} class="img-responsive" />
  // 					</div>

  // 					<br>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/6.jpg"} class="img-responsive" />
  // 					</div>

  // 					<br>

  // 					<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/posts/2/7.jpg"} class="img-responsive" />
  // 					</div>

  //          `
  //     }
  //   }
  // },

  {
    id: "Vegan_Friendly_TelAviv",
    bgImage: "posts/bank/8/1.jpg",
    mobBgImage: "posts/bank/8/M.jpg",
    title: "Vegan-Friendly Tel Aviv",
    ctg: "culinary",
    isVid: true,
    vidId: "9l04RfZ95J0",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                     <br/><h3>Try this selection of top vegan restaurants in Tel Aviv</h3>
					<h3>Exploring Tel Aviv has never been so fun for vegans, or so yummy</h3>
					<p>Touring foreign cities can be rough on vegans, who adhere to a diet free of animal-based dishes. Not so in Tel Aviv, home to an all-vegan culinary school and scores of vegan-friendly eateries. Already a culinary hotspot for touring foodies and crowned “The World’s Best Culinary City” by Saveur Magazine, Tel Aviv has embraced veganism as it grows in popularity, leading The Daily Meal culinary magazine to declare the city “The World’s Best Vegan Destination,” ahead of eight other “vegan-friendly cities” as well.</p>
					
					<h3>What vegans want</h3>
					<p>Stroll through the city of Tel Aviv and you will stumble upon countless vegan and vegan-friendly restaurants, bistros and fast food stands. Take in the sweet and savory aromas wafting through the city air and know that nearby is a yummy treat you can most proxcbably eat. Keeping up with the tastes and demands of Tel Aviv locals and tourists, most of the city’s eateries- or at least those with any ounce of self-respect, have vegan-friendly options interspersed throughout their menus. Others have shifted to an entirely vegan spread, offering up a spin on local delicacies like egg-free falafel, seitan shawarma and dairy-free cheese pizza.</p>
					
                    <div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/2.jpg"} class="img-responsive" />
					</div>
                    <h3>Taste the fresh Mediterranean flavors</h3>
					<p>Breathing in the fresh Mediterranean air give you an appetite for some fresh local treats? For vegans touring Tel Aviv, your stomach grumbling is but an arrow pointing you in the direction of some of the freshest local produce transformed into scrumptious dishes reflecting many different cultures, culinary directions and trends.</p>
					
					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/6/3.jpg"} class="img-responsive" />
					</div>
                    <p>Israel is blessed with many vegan dining options, but when it comes to vegan eateries, Tel Aviv is a true vegan culinary gem. Whether it’s fast food, a gourmet menu or sweet desserts you are craving, Tel Aviv has a vegan option for you, making the seaside Israeli city a must-visit destination on your next Israel trip.</p>
					<p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in Tel Aviv &amp; Center at Tourist Information site</a></p>



			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "/posts/bank/28/1.jpg",
    mobBgImage: "/posts/bank/28/M.jpg",
    title: "Jerusalem Cuisine",
    ctg: "culinary",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h3>Exhilarating and diverse and oh so yummy</h3>

					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/2CSCe2WC7Ns/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<p>
						Jerusalem is filled with scores of lively and trendy restaurants and entertainment spots. The city is packed with areas offering excellent options for every form of day and night time entertainment, where you can enjoy a delightful evening over a great meal, a cold beer or dance to great music.
					</p>

					<p>
						In Jerusalem, they say that you come for the hummus, but stay for the incredibly diverse cuisine. From traditional Middle Eastern and North African to South American, Asian fusion, and continental European cuisine; from street food to fine dining, Jerusalem’s got it all. Jerusalem’s wide array of culinary options can be found literally everywhere local delicacies in street stalls, authentic restaurants in the markets, and if you are looking for the gourmet experience, you can reserve a spot at one of the city’s many exclusive chef restaurants.
					</p>

         `,
      };
    },
  },

  {
    id: "Coffee_In_TelAviv",
    bgImage: "posts/bank/42/1.jpg",
    mobBgImage: "posts/bank/42/M.jpg",
    title: "قهوة في تل أبيب",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "rVr0gqFC364",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			            
			            <br/><h2 >استيقظوا لتشمّوا رائحة القهوة<br/>هل تعلم: ثقافة المقاهي هي ثقافة أساسية في تل أبيب</h2>
			            <h3>
                      		ثقافة المقاهي
                      	</h3>
                      	<p>
                      		تعجّ تل أبيب بالأماكن الرائعة لاحتساء القهوة، ولكلّ من هذه الأماكن شخصيته الفريدة. <strong>بإمكانكم ارتشاف القهوة المثلّجة على الشاطئ </strong> أثناء استمتاعكم بأشعة الشمس، أو بإمكانكم تجاذب أطراف الحديث مع السكان المحليين في أحد المقاهي الأنيقة التي تتوزع بين البنايات المبنية على طراز "باوهاوس" الشهيرة في وسط المدينة، أو استرخوا <strong>وأنتم تحتسون قهوة اللاتيه في ميناء تل أبيب</strong>. شاهدوا العدّائين النشطين، وراكبي الدراجات النارية والهوائية وهم يتنقلون، بينما تتمتعون بوقت مستقطع للتمتع بمذاق الحياة، ومذاق فنجان قهوة جيد.
                      	</p>
						<div class="img-wrapper">
						    <img src=${getImgUrl() +
                  "posts/coffe-in-tlv/1.jpg"} class="img-responsive" />
					    </div>
						<h3>
							وقت للقهوة
						</h3>
						<p>
							إنك في تل أبيب لن تكتفي فقط باحتساء أنواع مختلفة من القهوة، بل إنك ستستوعب عوالما وتقاليدا مختلفة. يمكن لصباحك أن يبدأ باحتساء كافيه "هافوخ" الحديث والعصري، وهو النسخة الإسرائيلية من الكابتشينو المصنوع مع جرعة قوية من الإسبريسو المصبوب في قلب كوب من الحليب المسخّن بالبخار، وهو المشروب المفضّل للجيل الشاب من أبناء تل أبيب. أما في ساعة استرخاء ما قبل الظهيرة، فيمكنك التمتع بإبريق من القهوة التركية التقليدية، وهي قهوة داكنة وحارة وقوية. هكذا سيكون بوسعك التنقل بين عالمين، بعد انتقالك إلى يافا القديمة، الواقعة على بعد بضعة دقائق. سينقلك الشذى والأجواء عبر السنين إلى روائح ونكهات الشرق الأوسط القديم. وأخيرا، انغمس في عادات البحر المتوسط القديمة المتمثلة في تناول القهوة المسائية على طاولة في الهواء الطلق، مع أبناء البلاد، في جادة روتشيلد.
						</p>
						<p>
							في تل أبيب لا يوجد وقت غير مناسب لاحتساء القهوة.
						</p>
              
			`,
      };
    },
  },

  {
    id: "Non_Stop_Markets",
    bgImage: "posts/bank/non-stop-markets/1.jpg",
    mobBgImage: "posts/bank/non-stop-markets/M.jpg",
    title: "أسواق بلا توقّف",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			                 <p>هذا غيض من فيض ما يمكنكم العثور عليه في أسواق المدينة المفتوحة على مدار الساعة، وطيلة أيام الأسبوع. الأسواق التي لا يمكنكم تفويت زيارتها.
                             لربما كان التجوال في أسواق تل أبيب، بما يحويه من نسيج بشري متميز لا نظير له، وما يقدمه من ضروب المأكولات الشهية المتنوعة الشهية، واحدا من أفضل الطرق للتعرف على الروح الحقيقية للمدينة.</p>
                             <p>نسعى لتعريفكم على بعض الأسواق التي لا ننصحكم بتفويت زيارتها، لدى زيارتكم للمدينة المشمسة:</p>
                             <h3>سوق الكرمل:</h3>
                             <p>هو أشهر أسواق المدينة، وهو معروفٌ بألوانه الزاهية، وامتلائه بأكشاك الطعام التي تقدّم أطباقا محلية طازجة، و احتوائه على المطاعم الممتازة التي تقدم الطعام الطازج مباشرة من السوق. في هذا السوق يمكنكم دائما البحث عن تلك الأماكن الخفية المتخصصة بتقديم الطعام، خلف أكشاك البيع، وفي سائر أرجاء المنطقة. صدّقونا: هذه الأماكن تستحق حقًّا عناء البحث عنها.</p>
                             <h3>سوق البراغيث (سوق الخردوات والتحف):</h3>
                             <p>السوق موجود في يافا، وهو يعج بالتحف الرائعة الأصيلة الآتية من مدينتي تل أبيب والقدس. ويعدّ التجوال فيه متعة للباحثين عن الصفقات الجيّدة. كما يعدّ هذا السوق أيضا مكانا يجمع العديد من المقاهي والمطاعم الفاخرة والممتازة التي تقدم تشكيلات واسعة من المأكولات: من اليونانية إلى الإيطالية إلى العربية.</p>
                             <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/non-stop-markets/1.jpg"} class="img-responsive" />
					         </div>
                             <h3>سوق نحلات بنيامين للفنون والحرف: </h3>
                             <p>يفتح السوق يومي الثلاثاء والجمعة، هذا السوق أشبه ما يكون بـ "معرض" مفتوح في الهواء الطلق للفنانين وأعمالهم، وهو يزخر بالأفكار الإبداعية والفنية، التي ستتيح لكم شراء التذكارات والهدايا الأصيلة التي لن تجدوا مثلها في أي متجر</p>
                             <h3>سوق سارونا:</h3>
                             <p>يعدّ سوق سارونا مغامرة رائعة وفريدة في عالم الطهو، ويقع السوق في سارونا العصري، وهو مركز حديث ونابض بالحياة، ومتخصص في بيع المأكولات ومكوّنات صنع الأطباق ويحوي تشكيلةً متنوعةً وضخمةً من خيارات الطّعام. يلائم سوق سارونا كثيرًا استضافة العائلات، حيث يعجً بالأنشطة المقامة في الهواء الطلق، وهو محاطً  بمساحات اللعب الرائعة التي تناسب الأطفال والكبار معا.</p>
                             <h3>سوق ميناء تل أبيب</h3>
                             <p>مع أن الشعور الذي يراودك لأول مرة بأن هذا السوق يشبه "سوق فلّاحين" تقليدي، إلا أن هذا السوق، الذي هو جزء من الميناء، يفيض بالمأكولات اللذيذة والمنتجات المتخصصة التي يمكنك التمتع بها إما في السوق نفسها، وإما عبر شرائها كتذكارات من عالم الطهي، معك إلى المنزل.</p>

              
			`,
      };
    },
  },

  {
    id: "Joys_Of_Jaffa",
    bgImage: "posts/bank/joys-of-jaffa/1.jpg",
    mobBgImage: "posts/bank/joys-of-jaffa/M.jpg",
    title: "متع يافا",
    ctg: "telaviv",
    isVid: true,
    vidId: "tgF0zMUYY2g",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			            <!--<p>Recently named among CNN Travel’s must visit places for 2019, Jaffa is Tel Aviv’s smaller sister, and even though it dates back thousands of years, a visit to Old Jaffa always feels like an exciting discovery. A tour of Jaffa reveals charming winding alleyways interspersed with art galleries, historic buildings, newly renovated hotels in extraordinary landmark areas and a multitude of quaint authentic restaurants.</p>

                        <h3>Jaffa Flea Market</h3>
                        <p>Located in Jaffa, the famous flea market is a pure delight for the bargain hunters among you, packed with great authentic antiques. The flea market has been experiencing a recent bloom, and is considered a nightlife hub, featuring trendy bars and cool outdoor eateries, packed with young party people until the (very) late.</p> 

                        <h3>Jaffa Port </h3>
                        <p>Considered one of the world’s most ancient ports, the Port of Jaffa served fishermen, sailors, merchants, crusaders, conquerors and immigrants for thousands of years. Today, the port continues to serve as a fishing port, and is also being renovated as an urban attraction that offers cultural and leisure activities, shopping and tourism, while preserving its unique historical and fascinating character.</p>

                        <h3>Around Jaffa </h3>
                        <p>A stone’s throw away from Jaffa you can find the HaTachana complex, Tel Aviv’s renovated Old Railway is now a now vibrant tourist hub and an attractive site in itself and also lovely Neve Tzaedek  neighborhood, perfect for a leisurely stroll. Jaffa also boasts stunning beaches and fantastic restaurants serving a variety of fantastic local cuisine at affordable prices.  </p>
                        
                        <h3>Colorful History and Irresistible Levantine Charm</h3>
                        <p>The smells of the sea flavored with black coffee and spices from the markets, Levantine culture combined with European, ancient mixed with new – this is Jaffa. One of the oldest port cities in the world whose history dates back to the great flood, today's Jaffa is a vibrant city that never ceases to surprise and innovates. Picturesque alleys, art galleries, unique boutiques, ancient building, wonderful landmarks and an abundant of authentic middle-eastern restaurants – a trip to old Jaffa is a must-have multi-sensory stimulating experience for anyone visiting Israel. Prepare to fall in love.<br>&nbsp;</p>
                        <h3>Discover the magic of a vibrant Port City</h3>
                        <p>Situated on a hill overlooking the Mediterranean Sea, in the southern part of Tel-Aviv, Jaffa has been the center of historical events for thousands of years. Still an active port today the Jaffa Port is a great place to explore. Wander through the art galleries, shopping boutiques and gourmet food markets. Stroll by the old docks, listen to live music, drink, eat and absorb the special atmosphere.<br><br>To get a better view of the city, climb up the hill to Peak (Ha'Pisga) Park overlooking the bay and gaze at the beautiful city below. On your way down, make a wish at the Wishing Bridge. Who know, it may come true.</p>
                        <h3>Go on A Romantic urban adventure</h3>
                        <p>Jaffa streets are full of surprises. Stroll in the narrow stone-paved streets of old Jaffa, discover hidden courtyards and notice the small details – painted ceramic tiles, small sculptures and upper open terrace. See the people, enter the art galleries, artists' studios and unique boutique.<br><br>Keep exploring. From the Clock tower square at the heart of the city continue to the well-known Jaffa Flea Market and weave your way through daily basics and hidden treasures. It's time to test those bargaining skills. Enjoy the small quaint cafés, middle-eastern authentic restaurants, great bar and some of best hummus you ever tasted. Guaranteed.</p>
					
                        <p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>
					     -->
					    <h3> واحة من الأصالة الشرقية وسط الحداثة</h3>
						<p>ليس غريبا أن <span class="ac-en-font">CNN Travel</span> قد صنّفت مدينة يافا بوصفها واحدة من أكثر المدن التي تمت زيارتها سنة 2019. ورغم أن يافا اليوم ملحقة بمدينة تل أبيب، إلا أنها قد سبقت تأسيس تل أبيب بآلاف السنوات. </p>
						<p>إن وجود يافا التي تشع أصالة، إلى جانب حداثة تل أبيب، يجعل منها متنفسا للاستكشاف. فأزقتها المرصوفة بالحجارة، وبناياتها التاريخية، وإطلالتها المميزة على البحر، وفنادقها ومطاعمها التي تندمج مع ثقافة المكان البصرية والتاريخية، تجعل من زيارة المدينة فرصة للانغماس في ملذّات العودة للماضي، على بعد بضع مئات من الأمتار من الحداثة والمعاصرة. </p>
						<p>وتعجّ أرصفة المدينة بالمقاهي التي تقدّم الشيشة والمشروبات  الشعبية الرائجة، إلى جانب المطاعم الصغيرة، كما توجد فيها العديد من العديد من المتاحف والمعارض المفتوحة أمام العامّة. يمكن التجوال في مينائها القديم وشاطئها والتمتّع بمشاهدة الحياة في هذه المدينة التي لم تفقد روحها الأصيلة رغم كل الحداثة التي تسري في محيطها.</p>
						<h3>دوّار الساعة:</h3>
						<p>يقع هذا الميدان المركزي شمال شرقي يافا القديمة، في أقصى شمال شارع "ييفت". تلقى الميدان هذا الاسم بسبب برج الساعة الموجود في منتصفه الذي تعلوه ساعة بنيت بأمر من السلطان التركي عبد الحميد الثاني سنة 1900. ويمتد من هذا الميدان شارع "ييفت" الذي يمتلئ بالمطاعم والمخابز والمقاهي التي تفيض بالمذاقات التي اشتهرت بها يافا، والتي يؤمها الزوار من مختلف مناطق البلاد والعالم للتمتع بالمذاق المشرقي الثري إلى جانب الأطباق المبتكرة. هنا يمكنكم التمتع بشرب فنجال قهوة شرقي إلى جانب النرجيلة، أو تذوق حلويّات تشتهر بها يافا، أو الانغماس في أعماق لذائذ الطعام الشرق أوسطي.</p>
						 

						<p>المسرح العربي – العبري: بني هذا المسرح في "بيت السرايا" القديم في يافا، وهو يخدم أيضا كمقر لفرقتين مسرحيتين تعملان معا وكلا على حدة باللغتين العبرية والعربية.</p>
						<h3>سوق الرابش القديم في يافا</h3>
						<p>يقع هذا السوق بالقرب من القلعة القديمة، وهو سوق شهير للسلع المستعملة، مرتقى أنفاس الباحثين عن القطع الأثرية ومحبي السهر معا. إذ يمتلئ السوق بالسلع المستعملة الأصلية الرائعة، بالإضافة إلى المتاجر ومطاعم الطهاة الأشهر في البلاد. أما في الليل، فقد شهد هذا السوق ازدهارا مؤخرا، حيث أصبح مركزا للحياة الليلية، إذ يضم بارات عصرية ومطاعم رائعة في الهواء الطلق، ويؤمّه الشباب حتى وقت متأخر (متأخر جّدا، في الواقع).</p>
						<p>في يافا مساحة إبداعية تشكل رافعة للموسيقى العربية الحديثة والبديلة، التي صارت رائجة جدا في السنوات الأخيرة في المنطقة، ويمكنكم الاستمتاع بموسيقى هذه الفرق في الكثير من المقاهي والبارات والنوادي الليلية. </p>
						<p>في كل صيف، خلال شهري حزيران – يوليو حتى آب – أغسطس، تستضيف البلدية مناسبات ليلية في السوق، وهي تشمل عروضا حية للفرق المحلية، والمدرج المفتوح، الموجود في قمة القلعة القديمة، والذي يتحول إلى سينما في الهواء الطل. </p>
						<p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank"><span class="ac-en-font">View attractions in Tel Aviv &amp; Center at Tourist Information site</span></a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"><span class="ac-en-font">View accommodations in </span></a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank"><span class="ac-en-font">Tel Aviv &amp; Center</span></a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> <span class="ac-en-font">at Tourist Information site</span></a></p>

              
			`,
      };
    },
  },

  {
    id: 22,
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "Shakshuka Time",
    smltitle: "",
    ctg: "culinary",
    isVid: true,
    vidId: "JQD9JpMaw9g",
    html: function() {
      return {
        __html: `

				<h3>Learn how to make the world famous Shakshuka Dish!</h3>

		<!--<div class="responisve-iframe">
			<iframe src="https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
		</div>-->

      		<p>
      		When you ask people who visit Tel Aviv and Jerusalem what was their favorite dish they tried on their trip, the answer, more often than not, will be Shakshuka. This Mediterranean delicacy, a definite local favorite is essentially a dish of eggs poached in a sauce of tomatoes, chili peppers, and onions rich in flavor and often served with bread and tahini. Of course, there are many variations on this dish according to local styles and tastes and it is usually served for breakfast or brunch though you’’ll find it makes for a fantastic dinner as well.
      		</p>
      		<p>
      		The best way to eat Shakshuka is definitely by under the fantastic year round sun of Tel Aviv or Jerusalem, as you enjoy an amazing city break full of flavors and unforgettable experiences.
      		</p>
      		<p>
      		However, should wish to DIY and recreate the taste of the sensational Shakshuka in your own kitchen, here’s how it’s done:
      		</p>
      		<h3>
            Ingredients
          </h3>
          <ul>
             <li>2 tablespoons olive oil</li>
             <li>1 onion, chopped</li>
             <li>1 red bell pepper, seeded and diced</li>
             <li>4 cloves garlic, minced</li>
             <li>2 cans of diced tomatoes</li>
             <li>6 eggs</li>
             <li>2 tablespoon fresh cilantro, chopped</li>
             <li>¾ teaspoon salt</li>
             <li>1 teaspoon paprika</li>
             <li>¼ teaspoon black pepper</li>
             <li>1 jalapeno (optional)</li>
          </ul>
          <h3>
             Instructions
          </h3>
          <ol>
              <li>Preheat oven to 375 degrees while you wait.</li>
              <li>Heat the olive oil in a heavy oven-safe pan over medium heat. Add in onion, bell pepper, and jalapeno and fry until onions are translucent.</li>
              <li>Add in garlic and paprika. Add tomatoes, salt, and black pepper. </li>
              <li>Bring to a simmer and reduce heat. cook for 10- 15 minutes. </li>
              <li>Create 6 small spaces in the sauce and carefully crack each egg into the space.</li>
              <li>Place pan into the preheated oven and cook until eggs whites are set – roughly 10 minutes.</li>
              <li>Add cilantro as garnish before serving.  </li>
              <li>Serve with bread and tahini and enjoy! </li>
          </ol>

         `,
      };
    },
  },

  {
    id: "Gourmet_TelAviv",
    bgImage: "posts/bank/gourmet-telaviv/1.jpg",
    mobBgImage: "posts/bank/gourmet-telaviv/M.jpg",
    title: "TEL AVIV GOURMET SCENE",
    ctg: "culinary",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<p class="ac-cradit">A film by VIA TOLILA</p>
			<h3>Wake up your taste buds in Tel Aviv</h3>
			<p>
			   Tel Aviv's huge variety of amazing restaurants - The perfect place to treat yourself.
			</p>

            <p>A Mouthwatering Culinary Travel Destination - Tel Aviv is a world-class foodie travel destination with thousands of unique restaurants and bars</p>
            <p>Tel Aviv is a foodie travel destination which offers sun, fun, beaches, history, a unique culture as well as delicious and exciting food. Tel Aviv recently made it on to gourmet magazine Sauver’s list of&nbsp;Outstanding Culinary Destinations&nbsp;in their annual Culinary Travel Awards. Tel Aviv was also named “outstanding” in the Best Markets and Shops category. Tel Aviv’s Pastel Brasserie was voted 2014’s&nbsp;Most Beautiful Restaurant in the World&nbsp;in the International Space Design Awards.</p>
            <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/gourmet-telaviv/1.jpg"} class="img-responsive" />
					         </div>
            <h3>Linneah anders</h3>
            <p>Israel is a land of immigrants, each ethnic community brought with it a unique culinary culture and together they have evolved into the Tel Aviv foodie experience. While in Tel Aviv you can try cuisine from Ethiopian, Romanian, Georgian, Russian, Indian, Yemenite, Iraqi, Iranian and more which have been given an Israeli Mediterranean twist. The city has elegant chef restaurants like Chef Mir Adoni’s Mizlala, Chef Avi Conforti’s Topolpompo restaurant and celebrity Chef Eyal Shani’s North Abraxas. There are intimate neighborhood restaurants like Abdu Hadayag. And don’t forget the famous Tel Aviv street food which is the healthiest fast-food in the world and always served with fresh Arabic salad.</p>
            <div class="img-wrapper">
				<img src=${getImgUrl() +
          "posts/gourmet-telaviv/2.jpg"} class="img-responsive" /><br/>Dana Friedlander
		    </div>
            <h3>Tel Aviv Bar Scene</h3>
            <p>It is not just the food that is superior in Tel Aviv the bar scene is also exemplary. Drinks International Magazine included Tel Aviv in their list of World’s 50 Best Bars Awards. Tel Aviv’s Imperial Craft Cocktail Bar was voted the Best Bar in Africa and the Middle East. The Imperial stands out for its amazing made-to-order cocktails and Tel Aviv in general has caught on to the “mixology” trend. Tel Aviv has a buzzing bar scene with about 4,500 food and drink related establishments which means a ratio of one restaurant for every 1,000 people. Time Out Israel recently named Lilienblum Street, the Port, the promenade, Ben Yehuda Street and Dizengoff Street as the best bar areas in the city. Among the top hot spots in Tel Aviv is Trip Advisor’s #1 pick Lima Lima Bar, veteran bar Abraxas, intimate Ozen Bar and beach bar La La Land.</p>
			`,
      };
    },
  },

  {
    id: 34,
    bgImage: "/posts/34/1.jpg",
    mobBgImage: "/posts/34/M/1.jpg",
    title: "the DEAD SEA",
    ctg: "deadsea",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            
				<p>
               		A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction.

                </p>

                <p>
               		Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
					
                </p>

                <p>

					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.

                </p>
				
            	 `,
      };
    },
  },

  {
    id: 22,
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "Shakshuka Time",
    ctg: "culinary",
    isVid: true,
    vidId: "n4kCnPXEX7g",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Learn how to make the world famous Shakshuka Dish!</h3>
				<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/n4kCnPXEX7g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->

      		<p>
      		When you ask people who visit Tel Aviv and Jerusalem what was their favorite dish they tried on their trip, the answer, more often than not, will be Shakshuka. This Mediterranean delicacy, a definite local favorite is essentially a dish of eggs poached in a sauce of tomatoes, chili peppers, and onions rich in flavor and often served with bread and tahini. Of course, there are many variations on this dish according to local styles and tastes and it is usually served for breakfast or brunch though you’’ll find it makes for a fantastic dinner as well.
      		</p>
      		<p>
      		The best way to eat Shakshuka is definitely by under the fantastic year round sun of Tel Aviv or Jerusalem, as you enjoy an amazing city break full of flavors and unforgettable experiences.
      		</p>
      		<p>
      		However, should wish to DIY and recreate the taste of the sensational Shakshuka in your own kitchen, here’s how it’s done:
      		</p>
      		<h3>
            Ingredients
          </h3>
          <ul>
             <li>2 tablespoons olive oil</li>
             <li>1 onion, chopped</li>
             <li>1 red bell pepper, seeded and diced</li>
             <li>4 cloves garlic, minced</li>
             <li>2 cans of diced tomatoes</li>
             <li>6 eggs</li>
             <li>2 tablespoon fresh cilantro, chopped</li>
             <li>¾ teaspoon salt</li>
             <li>1 teaspoon paprika</li>
             <li>¼ teaspoon black pepper</li>
             <li>1 jalapeno (optional)</li>
          </ul>
          <h3>
             Instructions
          </h3>
          <ol>
              <li>Preheat oven to 375 degrees while you wait.</li>
              <li>Heat the olive oil in a heavy oven-safe pan over medium heat. Add in onion, bell pepper, and jalapeno and fry until onions are translucent.</li>
              <li>Add in garlic and paprika. Add tomatoes, salt, and black pepper. </li>
              <li>Bring to a simmer and reduce heat. cook for 10- 15 minutes. </li>
              <li>Create 6 small spaces in the sauce and carefully crack each egg into the space.</li>
              <li>Place pan into the preheated oven and cook until eggs whites are set – roughly 10 minutes.</li>
              <li>Add cilantro as garnish before serving.  </li>
              <li>Serve with bread and tahini and enjoy! </li>
          </ol>

         `,
      };
    },
  },

  {
    id: "The_Gates_Of_Jerusalem",
    ctg: "jerusalem",
    isVid: true,
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/gates-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/gates-of-jerusalem/M.jpg",
    title: "أبواب أورشليم القدس",
    smltitle: "",
    html: function() {
      return {
        __html: `
				  
				              

							    <p>توجد ثمانية أبواب في سور البلدة القديمة المقدسية والتي تم تشييدها في أوائل القرن الـ 16م من قبل السلطان التركي سليمان القانوني. حيث ما زالت كافة هذه الأبواب ما عدا باب واحد (باب الرحمة) تخدم المقدسيين والزوار الذين يرتادون أسواقها، ومواقعها المقدسة والتاريخية.</p>
								<p>فيما يلي لمحة عامة عن الأبواب، على عكس اتجاه عقارب الساعة ومن جهة الجنوب إلى الغرب:</p>
								<p><strong>باب النبي داود:</strong> يسمى هذا الباب باللغة العربية بعد أقدم اسم مقدسي ورد في التوراة باللغة العبرية والإنجليزية ألا هو اسم الملك داود الذي يقع ضريحه على مسافة عدة خطوات عن جبل صهيون. ويؤدي باب النبي داود مباشرةً إلى الحيين الأرميني واليهودي.</p>
								<p><strong>باب المغاربة:</strong> اسم هذا الباب باللغة العبرية والإنجليزية مشتق من القمامة التي تم إلقاؤها فيه في العصور القديمة، حيث كانت الرياح السائدة تحمل الروائح إلى محيطه. ويشير النبي نيحيميا 2:13 إلى باب المغاربة الذي كان يقع بجوار الباب الحالي على الأرجح. يؤدي هذا الباب مباشرةً إلى حائط المبكى وإلى الحديقة الأثرية في الحائط الجنوبي.</p>
								<p><strong>باب الرحمة:</strong> قد يكون هذا الباب، في حائط جبل الهيكل الشرقي، أكثر الأبواب شهرةً. وتمت تسميته كذلك بالباب الذهبي او الباب الشرقي، وتم إغلاقه على مدار قرون طويلة، ويقال إنه ينتظر معجزة افتتاحه عند وصول المسيح وقيامة الأموات.</p>
								<div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/gates-of-jerusalem/1.jpg"} class="img-responsive" />
					            </div>
								<p><strong>باب الأسباط:</strong> يسمى هذا الباب بعد زوج من المنحوتات الحيوانية المذهلة الذي يحيط به. وفي الحقيقة إنهما عبارة عن نمرين، مما كان يُعد الرمز الرئيسي للسلطان بيبرس من القرن الـ 13. وسمي كذلك باب القديس ستيفن، بعد أول شهيد في المسيحية، الذي تروي القصة المسيحية التقليدية عنه أنه استشهد رشقًا بالحجارة في مكان قريب من الباب. وأصحب باب الأسباط المؤدي إلى برك بيت حسدا، وطريق الآلام، والأسواق مشهورًا إبان حرب الأيام الستة.</p>
								<p><strong>باب الزهور (هيرودس):</strong> رغم اسمه، لا توجد صلة ما بين ملك يهودا الشهير وهذا الباب. باللغتين العربية والعبرية يسمى  هذا الباب الواقع على جهة الشمال والمؤدي إلى أسواق البلدة القدية باب الزهور. حيث يقول البعض إن اسمه مشتق من الوردة المنقوشة فوقه. ومع ذلك، إنه سمي اللغة العربية كذلك باسم "الساهرة" مما قد يشير إلى المقبرة الموجودة بجواره ويركز إلى أمل القيامة.</p>
								<p><strong>باب العامود (دمشق):</strong> إنه ربما أبرز أبواب أورشليم القدس من حيث المظهر وهو مواجه لجهة الشمال أيضًا حيث تمت تسميته بعد المدينة الكبرى التي جاء منها حكام أورشليم القدس في الماضي. إنه بمثابة شارع ينبض بالحياة دائمًا بفضل الأسواق الصاخبة التي تقع فيه. وقد عثر علماء الآثار تحت الباب الذي يعود إنشاؤه للقرن الـ 16م قسمًا من المدخل الذي شيدها الإمبراطور هادريان في القرن الثاني بعد الميلاد.</p>
								<p><strong>الباب الجديد:</strong> إنه الباب الوحيد من أبواب البلدة القديمة الذي لا يشكل جزءًا من التصميم الأصلي للسور من القرن الـ 16م. وتم اختراقه خلال الأيام الأخيرة قبل سقوط الإمبراطورية العثمانية من أجل السماح للحجاج المسيحيين بتسريع وصولهم إلى الأماكن المقدسة الواقعة داخل الأسوار.</p>
								<p><strong>باب الخليل:</strong> إنه كان وجهة اليهود والحجاج والمسيحيين الذين كانوا ينزلون في ميناء يافا، وبالتالي فكُني بهذا الاسم. وقد أدى (وما زال يؤدي) مباشرةً إلى الحيين اليهودي والمسيحي، وكذلك إلى الأقسام الأكثر شعبيةً للسوق، وإلى برج متحف دافيد، الذي كان سابقًا قلعة أورشليم القدس أما حاليا فأصبح عرضًا لتاريخها.</p>


         `,
      };
    },
  },

  {
    id: "Shopping_Delights",
    ctg: "jerusalem",
    isVid: true,
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/shopping-delights/1.jpg",
    mobBgImage: "/posts/bank/shopping-delights/M.jpg",
    title: "متع التسوّق",
    smltitle: "",
    html: function() {
      return {
        __html: `
				  
					
					<h3>من الأزياء الراقية إلى الهدايا التذكارية: كل هذا ستجدونه في القدس</h3>
					<p>في القدس توجد الكثير من المناطق التي تحتوي على منتزهات للتسوق في الهواء الطلق، إلى جانب عدد آخر من مجمعات التسوق الداخلية أيضا. كونوا مطمئنين، حينما تذهبون للتسوق في القدس، يمكنكم العثور على كل ما تبحثون عنه، في إطار الميزانية التي تحددونها.</p>
					
					<h3>مركز المدينة: شارع بن يهودا والشوارع المحيطة</h3>
					<p>أصبح مركز القدس بأكمله الآن مركزا تجاريا كبيرا للمتمشّين: <a href="//www.itraveljerusalem.com/ent/ben-yehuda-street/" target="_blank" rel="noopener">شارع بن يهودا</a> المرصوف بالحجارة والمخصص للراجلين مليء بالمتاجر والمطاعم، بممره المستعاد من حجارة القدس، ومصابيح الشارع الأنيقة، ومناطق الجلوس المرتفعة فيه، ونافورته الصغيرة. تمت ترقية الشوارع المحيطة ببن يهودا أيضا مع إعادة رصف لها بالبلاط الرمادي مع الحفاظ على ذات طابع الإنارة بمصابيح الشوارع الأنيقة، هذه التجديدات كلها قد كانت استعدادا لشق <a href="//www.itraveljerusalem.com/ent/jerusalem-light-rail/" target="_blank" rel="noopener">سكة الحديد الخفيفة</a> للمدينة في شارع يافا.</p>
					<p>بالنظر إلى المنطقة الموسّعة التي تم تجديدها، بات المشوار إلى القدس يدفعك إلى التنزه في جميع شوارع وسط المدينة: شارع شاتز، شارع الملك جورج، شارع هيلل، شارع يافا، شارع يوئيل سلومون، وجميع الشوارع المتفرعة عنها. نصيحة: في أيام الجمعة، خلال ساعات النهار، قوموا بزيارة معرض الفنانين في شارعي شاتز وبتصلئيل، حيث لديكم فرصة لشراء هدايا مقدسية من قبل حرفيين محليين.</p>
					<p>أما شارع بن يهودا نفسه فهو عبارة عن تلة، يتصل من الأعلى بشارع الملك جورج، وبشارع يافا في الأسفل، منفتحا على ساحة ميدان صهيون. يعتبر شارع بن يهودا مكانا جيدا أيضا لمعاينة الهدايا التذكارية بأسعار متوسطة - لا تنسوا مساومة التجار! كما توفر المنطقة أيضا إكسسوارات عملية يومية، بدءا من القبعات والمظلات وصولا إلى الإلكترونيات.</p>
					 <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/2.jpg"} class="img-responsive" />
					</div>
					<h3>مجمع ماميلا التجاري المفتوح وكاردو المدينة القديمة: التسوق في أبهج صوره</h3>
					<p>خلال <a href="//www.itraveljerusalem.com/the-old-city/" target="_blank" rel="noopener">تجوالكم في المدينة القديمة،</a> ستجدون تجربة تسوق حصرية في <a href="//www.itraveljerusalem.com/ent/cardo-jerusalem/" target="_blank" rel="noopener"><span class="ac-en-font">Cardo</span></a> الحي اليهودي. يلائم صف المحلات التجارية الفاخرة في هذه المنطقة شراء الهدايا التذكارية من القدس، حيث تستمتعون بالتسوق وفي الخلفية الأعمدة الرومانية القديمة وغيرها من الآثار. إن تجربة التسوق في الكاردو هي تجربة فريدة من نوعها لجميع زوار المدينة، حيث يمكنكم الجمع بين السير على خطى التاريخ، والتمتع بمباهج التسوق الراقي.</p>
					<h3>مجمّع المالحة التجاري في القدس</h3>
					<p>يعد مجمع المالحة التجاري في القدس خيارا رائجا لأي شخص يبحث عن خوض تجربة التسوق في مركز تجاري داخلي في الضواحي، وهو كذلك متعة للعائلات التي تبحث عن نزهة مظللة في مكان عام.</p>
					<p>حين تم إنشاء مجمع المالحة في القدس قبل أكثر من عشرين عاما، أطلق عليه لقب "أكبر مركز تجاري في الشرق الأوسط". ولا يزال المجمع يحتفظ بالتأكيد بمكانته بوصفه أكبر مجمّع للمتاجر في القدس، بوجود أكثر من 250 لافتة لمحال تجارية يمكنكم الاختيار من بينها.</p>
					<p>يضم مجمع المالحة التجاري في القدس المتاجر الدولية والإسرائيلية، وهو يلائم ذوي الميزانيات المنخفضة إلى حد ما إلى ذوي الميزانيات المتوسطة، وصولا إلى البوتيكات الراقية. تجدون في المجمع ماركات </p>
                    <p>عالمية شهيرة تملك فروعا في هذا المجمع التجاري. كما توجد هنا العديد من متاجر الملابس الإسرائيلية التي تناسب جميع الميزانيات، إلى جانب ذلك يقدم المجمع خدمات عملية مثل مكتب بريد وفرع بنكي وصرافات آلية. لكي تتناولوا الطعام، هنالك مجموعة واسعة من المطاعم في قسم الطعام، وكلها مأكولات كاشير (وهذا يعني، من ناحية اللحوم على الأقل، أنها حلال أيضا)..</p>
 					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/3.jpg"} class="img-responsive" />
					</div>
					<p>تشمل الأنشطة في المجمع وجود حلبة داخلية للتزلج على الجليد خلال فصل الشتاء، وورش عمل ترفيهية وحرف يدوية خلال مواسم العطلات: تحققوا من <a href="//www.itraveljerusalem.com/jerusalem-events" target="_blank" rel="noopener">جدول المناسبات</a> من أجل التخطيط لرحلتكم. إلى جانب ذلك، يحتوي المجمع على متجر "شيلاف" للأطفال، كما يحتوي المجمع على منطقة لعب مناسبة للأطفال البالغين من العمر ستة أعوام فأقل</p>
					<p>يمكن الوصول إلى المجمّع بسهولة بواسطة الحافلة من وسط المدينة، أو بواسطة ركوب سيارة الأجرة من أي مكان.</p>
					<h3>اشتروا هدية لا تنسى، من جوهرة المدن</h3>
					<p>بإمكانكم أيضا شراء هدايا ذات قيمة لا تنسى، مجوهرات صنعها أمهر صاغة القدس، لكن شراء قطعة مجوهرات من صانعها هو تجربة تعد طريقة رائعة للاحتفال برحلتك. إذا كنتم تزورون القدس، فإن هنالك أكثر من مكان يمكنكم من خلاله اختيار تحفة فنية ذات معنى فيه، تتواجد بعض هذه المتاجر في وسط المدينة. إن شراء هدية كهذه سيضيف إلى قيمة الشراء، سواء أكنتم قد اشتريتم هدية تذكارية لأنفسكم، أو هدية ذات مغزى لشخص تحبونه.</p>
					<h3>سوق البلدة القديمة العربي في القدس</h3>
					<p>إن كنتم تبحثون عن منتجات محلية أصلية، فإن السوق العربي في المدينة القديمة هو المكان المناسب لكم. يقع هذا السوق في الحيين الإسلامي والمسيحي، ادخلوا عبر باب الخليل واذهبوا مباشرة إلى الحي الإسلامي. فور أن تروا الأثواب المطرزة المعلقة عاليا، ستعرفون أنكم قد وصلتم. هذا السوق الواقع في المدينة القديمة سوق شرق أوسطي يزخر بالفنون المتوطنة في كل من الملابس والأطعمة.</p>
					<p>في السوق العربي ستتعرفون على الطريقة التي كانت عليها الأمور من قبل. يعمل التجار في المدينة منذ آلاف السنين، في هذه الزقاقات الضيقة، يوما إثر يوم؛ إن أصالة هذا السوق الشرق أوسطي الذي يبلغ من العمر قرونا لا مثيل له في الثقافات الغربية بشكل عام، لكنه أيضا يعد واحدا من أكثر الأسواق أصالة في المنطقة العربية أيضا.</p>
					<h3>دللوا أنفسكم وأحباءكم بمنتجات الجمال الطبيعي من البحر الميت </h3>
					<p>صارت منتجات التجميل المستخلصة من البحر الميت وسما معروفا عالميا شق طريقه إلى سوق منتجات الجمال بفضل معادن البحر الميت الموجودة في مستحضرات التجميل التي ينتجها. هذا المنتج لعب دور سفير إسرائيلي في جميع أرجاء العالم. توجد متاجر لمستحضرات التجميل في وسط المدينة وفي مجمع ماميلا التجاري.</p>

					<h3>سوق محانيه يهودا</h3>

					<p>يشتهر سوق <a href="//www.itraveljerusalem.com/city-center/mahane-yehuda-market/" target="_blank" rel="noopener">محانيه يهودا</a> بكونه تعبيرا حقيقيا عن روح القدس، مختلطة بنكهات الطعام المحلي، والمنتجات الطازجة، والمكسرات، والمخابز، وبسطات الفلافل والشاورما. في السنوات الأخيرة شهد سوق محانيه يهودا دخول عدد كبير من المؤسسات الراقية، هذا التحول من "سوق" إلى "شيك" تلمحون أثره في المتاجر المتخصصة في أنواع النبيذ والأجبان، محلات الطعام الصحي، المطاعم النباتية، بل وأيضا محلات تقدم أصناف القهوة المحمصة الطازجة، إلى جانب الطعام، يمكنكم أيضا في السوق أن تعثروا على هدايا وتذكارات يمكنكم شراؤها كتذكار إلى الوطن، ابتداء من فنون الجودايكا، مرورا بالمجوهرات، ووصولا إلى الخزف. كما يمكنكم شراء الأجهزة الإلكترونية والملابس زهيدة الثمن في هذا السوق.</p>
					<p>حتى مع هذه النقلة النوعية نحو الرقي في طابع سوق محانيه بن يهودا، إلا أنه لا يزال يحافظ على أصالته راسخا هنا، ولذا فإن زيارة هذا السوق هي أمر لا ينبغي تفويته.</p>
					<h3>تلخيصا</h3>
					<p>بشكل عام، تشكل تجربة التسوق في القدس انغماسا في تجربة المدينة نفسها، يمكنكم هنا شراء التذكارات أو المجوهرات أو احتياجاتكم اليومية، بخيارات واسعة تناسب جميع الميزانيات. سترون أن التسوق في القدس هو بكل تأكيد تجربة مثيرة ومتنوعة.</p>
					<p>اطّلعوا على المزيد عبر الرابط: <a href="//www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf"  target="_blank" rel="noopener"><span class="ac-en-font">www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf</span></a></p>


         `,
      };
    },
  },

  // {
  // 	    id:"Tel-Aviv_Highlights",
  // 	    ctg : "telaviv",
  // 	    isVid:false,
  //         bgImage : "/posts/bank/37/1.jpg",
  //         mobBgImage : "/posts/bank/37/M.jpg",
  //         title : "Tel-Aviv Highlights",
  //         smltitle : "",
  //         isVid:true,
  //         vidId: "tgF0zMUYY2g",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 					<h3>Top 5 things to see and do in the city:</h3>
  // 					<h3>Old Jaffa</h3>
  // 					<p>Even though it A visit to Old Jaffa always feels like an exciting discovery. Historic buildings dating back thousands of years, charming winding alleyways interspersed with art galleries, extraordinary landmarks and a multitude of quaint authentic restaurants. A tour of old Jaffa is an inspiring experience, a definite must for every tourist visiting Israel.</p>
  // 					<h3>Jaffa Port</h3>
  // 					<p>The Port of Jaffa served fishermen, sailors, merchants, crusaders, conquerors and immigrants for thousands of years and is considered one of the world’s most ancient ports. Today, the port continues to serve as a fishing port, even after its renovation as an urban attraction. When you visit the port, you can now choose between cultural and leisure activities, shopping and tourism while preserving its unique historical atmosphere.</p>
  // 					<h3>Tel Aviv Port</h3>
  // 					<p>The trendy port area has really got it all. During the day, you can find yourself wandering through remarkable hangar style spaces for brand and boutique shopping, sharing a meal in restaurants with magnificent sea views and taking part in lots of activities for the whole family. At night however, crowds of young clubbers descend on the area, which transforms into one of the city’s most popular hotspots with some of the coolest clubs and bars in Tel Aviv.</p>
  // 					<h3>The White City</h3>
  // 					<p>The ‘White City’ is home to the world’s largest grouping of international style buildings, also known as Bauhaus. Built in the 1920’s and 1930’s, and meticulously restored to its original glory, you are encouraged to take a fascinating tour of the “White City” quarter of Tel Aviv and discover why it has been declared a UNESCO World Heritage Site. The ‘White City’ quarter is a truly unique and memorable architectural treasure.</p>
  // 					<h3>Neve Tzedek</h3>
  // 					<p>Take a break from the hectic pace of Tel Aviv; this hidden gem of a neighbourhood boasts beautiful european architectural style and charming narrow streets. Found I 1887, Neve Tzedek was the first Jewish settlement outside of the Jaffa walls. It was founded 22 years before Tel Aviv. An extensive renovation and preservation of the neighborhood, had turned it into a trendy, artistic area. You can find art galleries, boutique shops & trendy restaurants, all which make Neve Tzedek, an actual oasis at the heart of the bustling city.</p>

  //          `
  //     }
  //   }
  // },

  {
    id: "Amazing_Nightlife",
    bgImage: "/posts/bank/telaviv9/1.jpg",
    mobBgImage: "/posts/bank/telaviv9/M.jpg",
    title: "تل أبيب: المدينة التي لا تعرف النوم",
    ctg: "telaviv",
    isVid: false,
    // vidId:"ogEN7aRT0SM",
    // vidId:"WKfjMATNH8Q", - this is an old youtube video
    smltitle: "",
    html: function() {
      return {
        __html: `

					<!--<div class="ac-cradit">
					<span class="ac-cradit-text">Credits:</span>
						
						<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
					</div>
					<p></p>
					</div>

					<div class="ac-cradit">
					<span class="ac-cradit-text">حقوق النشر:</span>
						<br/>
						<span class="ac-cradit-text-1">بلدية يافا – تل أبيب<br/></span<
						<span class="ac-cradit-text-2"><span class="ac-en-font">UDINI prodactions</span><br/></span>
					</div>
					<p></p>
					</div>-->

                    <h3>
                    لا يتوقف الاحتفال، في المدينة التي لا تتوقف عن الحركة</h3>
					<p>
					يحيل مناخ البحر الأبيض المتوسط الدافئ تل أبيب إلى منطقة مثلى للاحتفال في الهواء الطلق معظم أيام السنة. 
					<strong>ومع غروب الشمس، تصبح المدينة مكانا ترغب في أن تختبر لذّاته بينما تحمل كأس مشروب في يدك. </strong>
					فمهما كان المكان الذي ترغب في الذهاب إليه هناك، ستجده يعج بالموسيقى وجموع الناس السعداء.
					</p>
					<h3>تل أبيب ليلا</h3>
					<p>وبغض النظر عن الساعة، فإن هنالك دائما أمرا ما يحصل في تل أبيب. الحانات هنا مليئة بالأجواء والطعام والمشروبات. 
					<strong>ومن المرجّح أن تقدّم أية حانة تدخلها الطعام، أو أن تقترح عليك تذوّق المشروبات المخمّرة يدويا في المكان; </strong>
					وتختلف هويات المطاعم، من الفاخرة، إلى تلك غير الرسمية، إلى تلك التي تقدم الوجبات السريعة في الشوارع، حيث يمكنكم العثور على أي طراز ونوع ممكن من الأطباق.</p>
				

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/2.jpg"} class="img-responsive" />
					</div>

					
                        <h3>لنشرع في الرقص  </h3>
						<p>
						<strong>إن رغبتم في قضاء ليلة احتفالية في المدينة، فإن نوادي تل أبيب الليلية مشهورة على مستوى العالم. </strong>
						فمنسقو أغاني الدي جي العالميين يعدّون، هنا، ضيوفا دائمين. وخلال موسم الصيف الطويل، تقام بعض الحفلات في الهواء الطلق. ولا تصل الحفلات إلى ذروتها قبل الساعة 2 صباحا في معظم الأماكن الشعبية في تل أبيب. هنالك ستجدون نوادٍ من كل نوع، من الرقص الرومانسي الحميم إلى الشعبي الصاخب، ومن الرقص الكلاسيكي إلى الرقص على دقات أحدث إيقاعات الموسيقى المستقلة والبديلة.</p>
                         

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/3.jpg"} class="img-responsive" />
					</div>

					<p>وسواء أكنتم ترغبون في قضاء وقت ممتع أو ترغبون بالتمتع لوحدكم، سواء كنتم ترغبون بعطلة تطلعون فيها على ثقافة المكان، أو تحظون فيها بالمتعة، فإنكم ستجدون عددا لا يحصى من الأماكن للتجول فيها، في كل ساعة من ساعات النهار أو الليل على حد سواء. 
					<strong>وبذا، فإن تل أبيب تستحق شهرتها، لكونها واحدة من أفضل مدن الحياة الليلية في العالم.</strong></p>
                         

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/4.jpg"} class="img-responsive" />
					</div>


         `,
      };
    },
  },

  {
    id: "Boutique_Hospitality",
    bgImage: "/posts/bank/telaviv7/1.jpg",
    mobBgImage: "/posts/bank/telaviv7/M.jpg",
    title: "ضيافة فاخرة",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `

                                <p>طالما عرفت تل أبيب بكونها مدينة ساحلية شابّة نابضة بالحياة، حيث تتسارع وتيرة الحياة بلا توقف. وبوجود عدد لا يحصى من البارات والمطاعم، والشواطئ، والمتاحف، والمتاجر، والمعالم السياحية التي تنبت في كلّ شبر متاح من أراضي تل أبيب، فإن الثورة الأخيرة المتمثلة في عروض فنادق البوتيك في المدينة، على مدار العامين الماضيين، قد مهدت الطريق أمام قضاء إجازات مليئة بالرفاهية والتسلية، والجمع بين العمل والاسترخاء، والرضا التام للزبائن.</p>
								<h3>لمسة فريدة ومخصصة</h3>
								<p>إن كنتم تبحثون عن تجربة ضيافة فريدة من نوعها في حيّ فريد وعصري يمتزج مع الأجواء المحلية، فإن الإقامة في فنادق البوتيك في تل أبيب هي كل ما تحتاجونه. هذه الفنادق تجمع ما بين ميزات الخدمة والرفاهية المطلوبة، مع تقاليد الضيافة الشخصية وخدمة الزبائن، حيث تشتهر فنادق البوتيك بموظفيها النموذجيين, الذين تستدعي أدق التفاصيل انتباههم، والذين يهتمون بجميع مطالب ورغبات الزوار.</p>
								<p>لكل من هذه الفنادق التي تتوزع أبنيتها على المواقع التراثية المحولة، أو المباني القديمة المرممة، وغيرها من المباني المبنية على طراز المعاصر، ثيمات ومفاهيم وخصائص فريدة. وتتميز فنادق البوتيك، التي يمكن التعرف عليها من خلال غرف المبيت المصممة بشكل لافت وفريد، ومن خلال مستوى الخدمة العالي والمخصص المتوفر فيها، بإطلالتها على "المدينة التي لا تعرف النوم"، وتتميز بتوفر التراسات مترامية الأطراف على السطوح، والمنتجعات الصحية الداخلية، ونقاط الإنترنت المتوفرة، والمطاعم الخاصة بها</p>
								<div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/boutique-hospitality/1.jpg"} class="img-responsive" />
						            Credit: Dana Friedlander
					            </div>
								<h3>عيشوا حياة "المدينة الكبيرة"</h3>
								<p>توفّر الطبيعة الدافئة والجذابة لفنادق البوتيك في تل أبيب تجربة ضيافة مثالية تتيح لكم "العيش" في تل أبيب كما لو كنتم من سكانها المحليين.</p>
								<p>فكروا في فنادق البوتيك بوصفها بيوت ضيافة راقية وأصيلة في قلب المدينة الكبيرة. وبوجود العديد من فنادق البوتيك التي تتوزع في أرجاء المناطق العصرية في المدينة، بما في ذلك منطقة نفيه تصيدق، على امتداد الساحل، وفي مقاطعة الألماس، وفي شوارع روتشيلد، شينكين، ومونتيفيوري، فإن الإقامة في فنادق البوتيك في تل أبيب ستمثل إقامة ساحرة وأصلية وممتعة ومثيرة لجميع </p>


         `,
      };
    },
  },

  {
    id: 10,
    bgImage: "/posts/bank/12/1.jpg",
    mobBgImage: "/posts/bank/12/M.jpg",
    ctg: "telaviv",
    isVid: false,
    title: "Culture Time",
    smltitle: " ",
    html: function() {
      return {
        __html: `

					<h3>A variety of fascinating museums and unique galleries</h3>

				    <h3>
				        Tel-Aviv Museum of Art
				    </h3>

					<p>
						The Tel Aviv Museum of Art presents a variety of permanent and temporal exhibits at its home in the Helena Rubenstein Pavilion, located on Shaul Hamelech Boulevard, next to the Mann Auditorium. The permanent exhibits include some of the best works of Israeli art, as well as sculptures from the 20’s until today. It features European paintings – impressionism and post-impressionism – from the 16th to the 19th centuries, as well as European and American works of the 20th century. The museum’s graphic collection includes more than 20,000 prints and sketches. Among the museum’s outstanding works are a unique selection of early painted reliefs of Alexander Archipenko and works by Chagall, which he donated to the museum before its establishment. Helena Rubenstein’s well-known collection of miniature rooms is on permanent display in the pavilion, which bears her name.
					</p>

					<h3>
				        OPENING HOURS:
				    </h3>

				    <p>

                          Sun Closed <br>
                          Mon, Wed, Sat 10:00-18:00 <br>
                          Tue, Thu 10:00-22:00 <br>
                          Fri 10:00-14:00 <br>
                          Sat 10:00-16:00 (July-August closed on Sat)<br>
                    </p>

                    <p>
                       For more information, click to the&nbsp;<a href="//www.tamuseum.org.il/en/default.aspx" target="_blank">Tel-Aviv Museum of Art</a>
                    </p>

                    <h3>
                        Beit Hatfutsot: The Diaspora Museum
                    </h3>

                    <p>
                       Beit Hatefutsot-The Jewish Diaspora Museum, situated on the Tel Aviv University campus, has gained honorary distinction throughout the Jewish world as the first museum of the history of the Jewish people to showcase the Jewish contribution to human creativity and culture over a period of more than two millennia. The Museum’s permanent exhibition brings the story of the Jewish People throughout the Diaspora to life through drawings, video clips, films, reconstructed models and other means. The exhibit focuses on various subjects – including “The Jewish Family life cycle”, “the community”, “the faith”, and “the return to Zion”.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/10/2.jpg"} class="img-responsive" />
					</div>

					<p>

                          For more information, click to the&nbsp;<a href="//www.bh.org.il/" target="_blank">Beit Hatfutsot: The Diaspora Museum</a>

                    </p>

                    <h3>
                         Eretz Israel Museum
                    </h3>

                    <p>

                            The Eretz Israel Museum- Tel Aviv is a multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts. The museum’s pavilions are scattered throughout a spacious courtyard with the ancient archaeological mound of Tel Kassile, at which excavations revealed valuable findings, positioned at its center. The museum houses a variety of reconstructed ancient production devices, including wine presses, an olive oil press, and a flour mill, along with a “craftsperson’s marketplace” which showcases traditional work instruments that were used in the Land of Israel and throughout the region. There is also a sophisticated Planetarium with its “Journey to the Universe” program, and a museum shop offering a unique selection of locally produced gifts and ornaments.<br>

                            OPENING HOURS:<br>

                          Sun-Wed 10:00-16:00 <br>



                          Thu 10:00-20:00<br>



                          Fri-Sat 10:00-14:00<br>

                        </p>

                    <p>
                       For more information, click to the <strong>&nbsp;</strong><a href="//www.eretzmuseum.org.il/e/" target="_blank">Eretz Israel Museum&nbsp;</a>
                    </p>

					<h3>
					    Beit Ha’ir
					</h3>


					<p>

                          Beit Ha’ir, renovated by the city, was the old City Hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history.  Beit Ha’ir has a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years, a project that was part of the centenary celebrations of the city. The main hall has a virtual display, including hundreds of documentary films and thousands of rare photos and documents that showcase major events in the early years of city life.  At Beit Ha’ir you can also visit the Dizengoff House, the restored residence of Meir Dizengoff, first mayor of Tel Aviv-Yafo, which includes a permanent exhibition.

                          <br>
                          OPENING HOURS:
                          Sun Closed
                          Mon-Thu 9:00-17:00 <br>
                          Fri-Sat 10:00-14:00
                    </p>

                    <p>
                      For more information, click to the <a href="//www.eretzmuseum.org.il/e/" target="_blank">Beit Ha’ir</a>
                    </p>

                    <h3>
                        The Olympic Experience Museum
                    <h3>

                    <p>

                          A new museum in Tel Aviv-Yafo, The Olympic Experience Museum, presents a one-hour, five-ring trip through the greatest Olympic records, with a special focus on Israel’s finest moments. The Olympic Experience boasts state-of-the art high tech imaging and illustrations, audio-visuals presentations, holograms, interactive screens, hands-on trials and much, much more.

                          Guided tours for organized groups every 30 minutes. Advanced reservation is recommended.

                          Opening Hours: Sunday-Thursday: 10:00-18:00, Friday:  10:00-14:00

                          The Olympic Experience, 6 Shitrit Street, Hadar-Yosef. Tel: +972-3-6498385

                    </p>

                    <p>
                       For more information, click to the&nbsp;<a href="//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2" target="_blank">The Olympic Experience Museum</a>
                    </p>

                    <p>

                          Ilana Goor Museum in Jaffa

                          The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br>
                          OPENING HOURS: <br>
                          Sun-Fri 10:00-16:00 <br>
                          Sat 10:00-18:00<br>
                          <a href="//www.ilanagoormuseum.org/eng/">www.ilanagoormuseum.org</a>
                    </p>

                    <h3>
                         Palmach Museum
                    </h3>

                    <p>
                        Rated #1 Tel-Aviv museum on Trip Advisor, this museum examines the Palmach, the military wing of the Zionist Movement, which functioned until the establishment of the State of Israel.
                    </p>

                    <p>
                        For more information, click to the&nbsp;<a href="//info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0" target="_blank">Palmach Museum</a>
                    </p>

                    <h3>
                        Other unique Museums
                    </h3>

                    <p>
                        Tel Aviv-Yafo is home to a variety of smaller, specialized museums, such as Beit Ben Gurion (The home of David Ben Gurion, Israel’s first prime minister), Beit Hatanach (The home of the Bible), The Haganah (defense) Museum, The I.Z.L. (the Irgun Zva’I Leumi – National Military Organization) Museum, Beit Hasofer (author’s house), Beit Reuven, The Jabotinsky Museum, and many others. Each of these smaller museums is a treasure house of artifacts. For example, Beit Bialik – the house of the national poet, displays the books, furniture and belongings of Israel’s renowned national poet. Bialik’s personal library of more than 3,000 books has been preserved, and the museum’s archives contain thousands of manuscripts, including the most extensive collection of his writings.
                    </p>

                    <h3>
                        OPENING HOURS OF TEL AVIV MUSEUMS:
                    </h3>
                    <h3>
                        Etzel Museum:
                    </h3>

                    <p>

                          King George 38: Sun-Thu 8:30-16:00 <br>

                          For more information, click to the&nbsp;<a href="//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx" target="_blank">Etzel Museum</a>
                    </p>

                    <h3>
                        Ben Gurion House:
                    </h3>

                    <p>
                            Sun, Tue-Thu 8:00-15:00 <br>
                            Mon 8:00-17:00<br>
                            Fri 8:00-13:00<br>
                            Sat 11:00-14:00
                    </p>

                    <p>
                       For more information, click to the&nbsp;<a href="//www.bg-house.org/?categoryId=6575" target="_blank">Ben Gurion House</a>
                    </p>

                    <h3>
                        Jabotinsky Institute in Israel:
                    </h3>

                    <p>

                        Sun-Thu 8:00-16:00 <br>
                        For more information, click to the&nbsp;<a href="//en.jabotinsky.org/" target="_blank">Jabotinsky Institute in Israel</a>

                    </p>

                    <h3>
                           The Israeli Museum:
                    </h3>

                    <p>
                            Sun, Mon, Wed 9:00-17:00 <br>
                            Tue, Thu 9:00-19:00<br>
                            Fri 9:00-14:00 <br>
                            For more information, click to the
                            <a href="//www.imj.org.il/en/">www.imj.org.il</a>
                    </p>

                    <h3>
                       Jaffa Visitors Center:
                    </h3>

                    <p>

                            Summer Sun-Thu, Sat 9:00-20:00<br>

                            Fri 9:00-17:00<br>

                            Winter Sun-Thu, Sat 9:00-18:00<br>

                            Fri 9:00-15:00<br>

                            For more information, click to the  <br>

                            <a href="//www.touristisrael.com/old-jaffa-visitors-center/3604/" target="_blank">Jaffa Visitors Center</a>

                    </p>

                    <h3>
                         Hall of Independence:
                    </h3>

                   <p>

                            Sun-Thu 9:00-17:00 <br>

                            Fri 9:00-14:00<br>

                            For more information, click to the&nbsp;<a href="//eng.ihi.org.il/" target="_blank">Hall of Independence</a>

                    </p>

                    <h3>
                        The Bible Museum:
                    </h3>

                    <p>

                            Sun-Fri 10:00-13:00 + 16:00-18:30 <br>

                            For more information, click to the&nbsp;<a href="//www.blmj.org/en/" target="_blank">The Bible Museum</a>

                    </p>

                    <h3>
                        Joseph Bau house:
                    </h3>

                    <p>

                            By appointment only (including weekends) <br>

                            For more information, click to the&nbsp;<a href="//www.josephbau.com/" target="_blank">Joseph Bau house</a>

                    </p>

                    <h3>
                        Rubin Museum:
                    </h3>

                    <p>

                            Sun Closed <br>

                            Mon, Wed, Thu 10:00-15:00 <br>

                            Tue 10:00-20:00<br>

                            Sat 11:00-14:00<br>

                            For more information, click to the &nbsp;<a href="//www.rubinmuseum.org.il/" target="_blank">Rubin Museum</a>

                    </p>

                    <h3>
                        Art Galleries
                    </h3>

                    <p>
                        Don’t miss the dozens of fine galleries, primarily located along Gordon Street and in the Old City of Jaffa, featuring the very latest in contemporary Israeli art. We won’t say another word- we’ll let the art speak for itself.
                    </p>

         `,
      };
    },
  },

  // {
  // 	    id:"Jerusalem_Main_Sites",
  //         bgImage : "/posts/bank/20/1.jpg",
  //         mobBgImage : "/posts/bank/20/M.jpg",
  //         ctg:"jerusalem",
  //         isVid:true,
  //         vidId:"k4OwoEk5wMw",
  //         title : "JERUSALEM MAIN SITES",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 					<!--<div class="responisve-iframe">
  // 						<iframe src="https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 					</div>-->
  // 					<h3>
  // 					Discover the history that stretches back thousands of years
  // 					</h3>
  // 					<p>
  // 						Like any city, the charm and essence of Jerusalem is best absorbed by walking its streets. However, depending on your interests, you don’t want to miss out on exploring at least some of these major attractions.
  // 					</p>

  // 					<p>
  //                          When visiting religious sites, it’s advised to dress modestly and wear clothing that covers your knees and elbows.
  //                     </p>

  // 					<p>
  //                        A good place to start is Jerusalem’s Old City, which has a very special and distinct atmosphere and is where many of the major attractions of Jerusalem are found.
  //                     </p>

  //                     <h3>
  //                         OLD CITY
  //                     </h3>

  //                     <h3>
  //                         JERUSALEM WESTERN WALL
  //                     </h3>

  //                     <p>
  //                       The Western Wall, also known as the Wailing Wall and Kotel, is the western retaining wall of the Second Temple. Considered Judaisms’s holiest site, the wall is divided into a men’s and women’s section where worshipers congregate throughout the day for morning, afternoon and evening services. Diverse crowds come to pray against the stones, to tuck small pieces of paper with prayers into the cracks and to simply marvel at the site.
  //                     </p>

  //                     <p>
  //                           Address: Jewish Quarter, Old City <br>
  //                           Phone: +972-2-627-3515<br>
  //                           Hours: 24/7<br>
  //                     </p>

  //                     <h3>
  //                         VIA DOLOROSA
  //                     </h3>

  //                     <p>
  //                         TCrossing the Muslim Quarter from east to west is this street that traces the last steps of Jesus Christ as he was led to his crucifixion. Popular with both pilgrims and general tourists, the route marks 14 events on Christ’s last walk and is also lined with shops and stalls. It is worth visiting on a Friday afternoon (3:00opm in winter; 4:00pm in summer) when the Franciscans lead a procession along the route.
  //                         <br>Address: Via Dolorosa, Muslim Quarter, Old City.
  //                     </p>

  //                     <h3>
  //                         JERUSALEM CHURCH OF THE HOLY SEPULCHER
  //                     </h3>

  //                     <p>
  //                         One of the holiest sites for Christians, this impressive building draws millions of pilgrims from around the world every year. The compound is believed to be the site of Golgotha (the Hill of Calvary), where, according to the New Testament, Jesus was crucified, buried and resurrected.
  //                         <br>
  //                         Address: Between Suq Khan e-Zeit and Christian Quarter Rd, Christian Quarter, Old City<br>
  //                         Phone: +972-2-627-3314 <br>
  //                         Hours: Sun – Sat: 5:00am – 8:00pm/9:00pm
  //                     </p>

  // 					<h3>
  // 					    DAVID’S CITADEL
  // 					</h3>

  // 					<p>
  // 					   David’s Citadel (also known as the Tower of David) was originally built in the second century BC to strategically strengthen a weak point in the city’s defences, and was subsequently destroyed and rebuilt many times over the ensuing centuries. Since 1989, the grounds are home to a fascinating museum, which sheds light on the history of Jerusalem. Don’t forget to take in the splendid view of Jerusalem from its ramparts.
  // 					</p>

  // 					<p>
  //                           Address: Jaffa Gate, Christian Quarter, Old City <br>
  //                           Phone: +972-2-626-5333<br>
  //                           Hours: Sun-Thu: 10:00am -4:00pm, Fri: Closed, Sat: 10:00am – 2:00pm (September-June), Sun-Thu:<br> 10:00am – 5:00pm, Fri: 10:00am – 2:00pm, Sat: 10:00am – 5:00pm (July-August)
  //                     </p>

  //                     <h3>
  //                         CITY OF DAVID
  //                     </h3>

  //                     <p>
  //                         Situated deep below ground in the Arab village of Silwan is the remains of the once-grand citadel where a dynasty of Judean kings once ruled. A massive visitors’ center offers a tour that begins with an observation point overlooking the remains of ancient Jerusalem, then continues underground with a look at recent archaeological finds and ends at the Gihon Spring, where according to tradition Solomon was anointed king. Visitors can also wade through the waters of the 2,700-year-old Hezekiah’s Tunnel.
  //                     </p>

  //                     <p>
  //                           Address: Silwan, East Jerusalem <br>
  //                           Phone: +972-2-626-2341<br>
  //                           Hours: Sun-Thu: 8:00am – 5:00pm (winter), 8:00am – 7:00pm (summer), Fri: 8:00am – 1:00pm (winter), 8:00am – 3:00pm (summer)
  //                     </p>

  //                     <div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/9/3.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>
  //                        MOUNT OF OLIVES
  //                     </h3>

  //                     <p>
  //                         The hill that rises to the east of the Old City, the Mount of Olives, is a great place to take in views of the Old City and the Dome of the Rock. Its slopes are filled with holy and burial sites and are home to several grand churches including the Church of all Nations. To take in all the sights, it’s best to start at the top, near to the Mosque of Ascension, and walk downhill to the Tomb of the Virgin. The Old City views are best in the morning. <br>
  //                         Address: Mount of Olives, East Jerusalem
  //                     </p>

  //                     <h3>
  //                         YEMIN MOSHE
  //                     </h3>

  //                     <p>
  //                         This charming neighbourhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. It is known for its windmill and communal housing block, known as Mishkenot Shaananim, which is now a venue for art and culture. The area is home to artists, writers and academics and is renowned for its Oriental-style houses, green parks, a music center, the YMCA, King David Hotel, Herod’s Family Tomb. <br>
  //                         CITY CENTER
  //                     </p>

  //                     <h3>
  //                         MAMILLA ALROV AVENUE
  //                     </h3>

  //                     <p>
  //                           Situated between the city center and the Old City, Mamilla Alrov Avenue is a pedestrian mall that offers a selection of luxury shops, as well as upscale restaurants and cafes. Mamilla is known for its chic and tasteful European feel, and offers spectacular views of the Old City walls. <br>
  //                           Address: 6 Yitzhak Kariv St, Jerusalem <br>
  //                           Phone: +972-2-636-0000<br>
  //                           Hours: Sun-Thu: 10:00am – 9:30pm (winter), 10:00am – 10:30pm (summer), Fri: 9:00am – 2:00pm (winter), 9:30am – 3:30pm (summer), Sat: One hour after Shabbat – 11:00pm
  //                     </p>

  //                     <h3>
  //                         BEN YEHUDA STREET
  //                     </h3>

  //                     <p>
  //                     One of Jerusalem’s prime hangout spots for locals and tourists alike, Ben Yehuda Street is a pedestrian mall extending between King George Street and Jaffa Road in downtown Jerusalem. The street is filled with gift shops, falafel and ice-cream stores, buskers, beggars, musicians and street performers.
  //                     </p>

  // 					<h3>
  //                         NACHALAT SHIVA
  //                     </h3>

  //                     <p>
  //                           This charming cobblestone neighbourhood just south of Ben Yehuda Street in the&nbsp;<a href="//www.itraveljerusalem.com/placecategory/food-nightlife?multi_hood=11" target="_blank"><strong>city center</strong></a>&nbsp;offers a great selection of shops, restaurants, bars and outdoor cafes. This is a great place to experience in summer and at night with many bustling until late.
  //                     </p>

  //                     <h3>
  //                        MEAH SHEARIM
  //                     </h3>

  //                     <p>
  //                           Though it is just a few minutes’ walk from modern Ben Yehuda Street, the ultra-orthodox enclave of Mea Shearim is an entirely different reality. You will feel as though you have stepped into 18th Century Europe with Jewish Orthodoxy dressed in full traditional attire such as long black coats, black fur hats and stockings. When touring, it’s recommended to dress extremely modestly, covering up your wrists and ankles, and to take photos with discretion. <br>
  //                           Address: Meah Shearim Rd, Jerusalem
  //                     </p>

  //                     <h3>
  //                         Mahane Yehuda Market
  //                     </h3>

  //                     <p>
  //                           Often referred to as “the shuk”, Mahane Yehuda Market offers a huge assortment of fresh produce and food, as well as a variety of other shops like clothing stores, kitchenware shops, jewellery stores, ceramic stores and a variety of gentrified eateries. The shuk includes an open air and closed area, bounded by Jaffa Road on the one side and busy Agripas Street on the other. It’s worth taking public transportation to the shuk as there is not a huge abundance of parking, and a great deal of traffic. If you can handle crowds, go on a Friday to experience last minute Shabbat shopping.<br>
  //                           Address: Agripas and Jaffa Street, Jerusalem
  //                     </p>

  //                     <h3>
  //                         OTHER AREAS OF JERUSALEM
  //                     </h3>

  //                     <h3>
  //                        YAD VASHEM
  //                     </h3>

  //                     <p>
  //                           Yad Vashem, Israel’s national Holocaust memorial, commemorates the six million men, women and children murdered by the Nazis and their allies. Located at the foot of Mt. Herzl, Yad Vashem comprises several moving memorials, including the Hall of Remembrance and the haunting Children’s Memorial; the Holocaust History Museum; the Museum of Holocaust Art; sculptures and installations; a massive archive and a research institute. Dress appropriately, and make sure to reserve at least a few hours for a visit to the Museum.  Address: Har Hazikaron <br>
  //                           Phone: +972-2-644-3400
  //                     </p>

  //                     <h3>
  //                        ISRAEL MUSEUM
  //                     </h3>

  //                     <p>
  //                           You’ll want to devote at least a day to Israel’s largest cultural institution, the Israel Museum, which was re-launched in the summer of 2010 after a major overhaul. The Museum is made up of many different wings and a huge collection of art, archaeological findings and Judaica. One of the major highlights is the distinctly shaped Shrine of the Book, which houses many ancient manuscripts including the Dead Sea Scrolls. Other highlights include the Youth Wing for children, the Billy Rose Art Garden, which showcases the development of western sculpture over the centuries, the Museum’s Fine Arts Wing and its in-depth Archaeology Wing.
  //                     </p>

  //          `
  //     }
  //   }
  // },

  {
    id: "Sensational_Beaches",
    ctg: "telaviv",
    isVid: false,
    // vidId:"XDei1Zy_cu4",
    bgImage: "/posts/bank/telaviv8/1.jpg",
    mobBgImage: "/posts/bank/telaviv8/M.jpg",
    title: "هيا إلى البحر",
    smltitle: "",
    html: function() {
      return {
        __html: `
					
					<h3>استرخوا على رمال الشواطئ المشمسة في تل أبيب، لا تنسوا مرهم التسفّع، خذوا مضارب تنس الشاطئ، وابدأوا باللعب. إليكم بعض الحقائق الممتعة عن الشاطئ</h3>
					<ul>
						<li>
							يستمتع نحو 8،500،000 من المستجمّين بهذه الشواطئ في كل عام.
						</li>
						<li>
							موسم السباحة والاستجمام السنوي يمتد ما بين أيار - مايو وحتى تشرين أول – أكتوبر
						</li>
						<li>
							تتصدر شواطئ تل أبيب مرتبة عالية في الاختبارات التي تجريها وزارة البيئة الإسرائيلية، وهي تعد شواطئ شديدة النظافة.
						</li>
						<li>
							النسخة الإسرائيلية من تنس الشواطئ تسمى بالـ "ماتكوت"، وهي رياضة شعبية تمارس على امتداد الشواطئ (انتبهوا، كرة تطير في اتجاهكم!)
						</li>
						<li>
							يعدّ البطّيخ البارد، سويا مع جبنة "فيتا" البيضاء، وجبة شاطئية شهيرة للغاية. وكذلك الـ "آرتيك" (أي المثلّجات) شديد الشعبية، ويحتل المرتبة الأولى في مذاقات الأرتيك: مثلجات الموز والشوكولاتة، لدى المعظم.
						</li>
					</ul>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>
					<p>إليكم جميع المعلومات التي تحتاجونها:
					<h3>موسم السباحة والاستجمام</h3>
					<h3>خلال هذا الموسم، تتوفر خدمات الإنقاذ والإشراف والإسعافات الأولية في الشواطئ الـ 13 جميعا</h3> 
					<h3>ساعات النشاط"</h3>
					التاسع من أيار – مايو: من 7 صباحا وحتى 5 مساء<br/>
					خلال شهر حزيران – يونيو: من 7 صباحا حتى 6 مساء<br/>
					خلال شهري تموز – يوليو و آب – أغسطس: من 7 صباحا حتى 7 مساء<br/>
					خلال شهري أيلول – سبتمبر و تشرين أول- أكتوبر: من 7 صباحا حتى 5 مساء<br/>
					تتوفر خدمات التفتيش والتنظيف لجميع الشواطئ المذكورة أعلاه يوميا.</p>
                    <!--<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>-->
					<p>بإمكانكم استئجار مظلة أو كرسي أو سرير استلقاء وخزانة لحفظ الأغراض بسعر ثابت. للقيام بذلك، يتعين عليكم شراء تذاكر من ماكينات البيع الموجودة بجوار الأكشاك المتوزعة على الشاطئ، قبل أخذ هذه الأغراض إلى الشاطئ. بمجرد أخذ التذكرة، سيمكنكم الحصول على المعدات وإظهار التذكرة للمشرف.</p>
					<h3>إرشادات بخصوص الشاطئ: تعرّفوا على معاني الأعلام:</h3>
					•	تقوم كل محطة إنقاذ بتحديد حالة الأمان في البحر بواسطة الأعلام:
					فالعلم الأبيض يعني أن الاستحمام في الشاطئ مسموح.
					والعلم الأحمر يعني أن البحر خطير إلى حد ما، وبالتالي لا يسمح بالاستحمام إلا بين الأعلام الحمراء أو المنطقة التي يقوم المنقذ بتحديدها
				   •	يعني العلم الأسود أن الاستحمام ممنوع.
				   •	 أما العلم الأرجواني فيهدف إلى تحذيركم من قناديل البحر
				   •	المستجمّون ملزمون بالامتثال لأوامر رجال الإنقاذ وحراس الإنقاذ
				   •	تحظر السباحة في حال عدم وجود منقذين في الخدمة.
				   •	لا يُسمح باستخدام القوارير الزجاجية في الشاطئ.
				   •	ممنوع ممارسة الرياضات المائية الآلية (الزلاجات النفاثة والقوارب) قرب الشاطئ
				   يحظر إشعال النيران على الشواطئ الرسمية
				   أسرار لا يعرفها سوى السكّان المحلّيون:
				   •	يمكنكم صباح أيام السبت أن تنضموا إلى حلقات الرقص الشعبي الإسرائيلي على شاطئ غوردون..
				   •	شاطئي غيؤولا و غوردون يعدّان مثاليّان للعب كرة الشاطئ.
				   •	يعد الشريط الرملي الضيق القريب من المارينا أقل ازدحاما وأكثر هدوءا من الشواطئ الأخرى. يمكنكم استئجار معدات ركوب الأمواج وألواح الركمجة والمراكب الشراعية ذات الأحجام المختلفة، والقوارب ذات المحركات ومعدات الغوص في نادي اليخت.
				   •	تحظى رياضة الركمجة (ركوب الموج) بشعبية في شاطئ هيلتون، حيث تم تركيب نظام إضاءة خاص مؤخرا للسماح بالتزلج ليلا.
				   •	تحظى رياضة التزلج على الموج، المدفوعة بقوة الطائرات القماشية الهوائية الضخمة، بشعبية كبيرة في شاطئ تل أبيب.
				   •	إن كنتم ترغبون بممارسة رياضة ركوب الأمواج، فاذهبوا إلى أي من شاطئي تل أبيب أو هيلتون.
				   •	تتوفر مرافق لعب الكرة الطائرة في المنطقة الجنوبية من شاطئ أفيف وكذلك في شاطئ غوردون.
				   •	شواطئ المدينة مجهزة تجهيزا جيدا بمرافق الاستحمام (الدوش) المفتوحة، إلى جانب خزائن أمانات قليلة التكلفة لمدة 24 ساعة، وغرف تغيير الملابس والمراحيض، وهي أيضا مجهزة لاستقبال أصحاب الإعاقات.
				   •	جميع الشواطئ باتت متاحة الآن لذوي الإعاقات. تمتعوا بشواطئ أفيف، القدس، فريشمان، بوغارشوف، غوردون، وهيلتون، وبسهولة الوصول المباشر للمياه لمن يعانون من إعاقات حركية. أما أولئك الذين يعانون من الإعاقة البصرية، فبإمكانهم أيضا الاستفادة نظام ’ Step Hear‘الذي يمكن تشغيله بواسطة تطبيق هاتفي: https://www.step-hear.com/
				   •	عادة ما يتواجد عناصر شرطة السياحة في الجوار من أجل توفير خدمات الأمن وتقديم المساعدة والمعلومات.
				   •	تتوفر ألعاب مجانية في الجوار، كالشطرنج، لعبة الضامة، ولعبة الطاولة للكبار، إلى جانب مرافق لعب الأطفال. ما عليكم سوى إعادتها لدى فروغكم من اللعب.
				   

         `,
      };
    },
  },

  //Hadar asked to hide this post on 2021-02-01
  // {
  // 	    id:"Modern_And_Vibrant",
  //         bgImage : "/posts/bank/39/1.jpg",
  //         mobBgImage : "/posts/bank/39/M.jpg",
  //         ctg :"jerusalem",
  //         isVid:true,
  //         vidId: "V0Acsw3Hf_M",
  //         title : "Modern and Vibrant",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                               <p>
  // 						Downtown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.
  // 					</p>
  // 					<p>
  // 						The area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.
  // 					</p>
  // 					<p>
  // 						The center of Jerusalem includes some of the city’s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem’s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem’s Science Museum.
  // 					</p>
  // 					<h3>
  // 						Machane Yehuda Market
  // 					</h3>
  // 					<p>
  // 						Discover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.
  // 					</p>
  // 					<h3>
  // 						Nahalat Shiv’a
  // 					</h3>
  // 					<p>
  // 						This charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor cafés. Nahalat Shiva is home to Kikar Hamusica (Music Square) – a lively and trendy outdoor space that offers live music every day throughout the week.
  // 					</p>
  // 					<h3>
  // 						Yemin Moshe
  // 					</h3>
  // 					<p>
  // 						This lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.
  // 					</p>
  // 					<h3>
  // 						Ein Kerem
  // 					</h3>
  // 					<p>
  // 						Nestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem’s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest.
  // 					</p>

  //          `
  //     }
  //   }
  // },
  //end Hadar asked to hide this post on 2021-02-01

  // {
  // 	    id:"Jerusalem_After_Dark_Fun",
  //         bgImage : "/posts/bank/modern-and-vibrant/1.jpg",
  //         mobBgImage : "/posts/bank/modern-and-vibrant/M.jpg",
  //         ctg :"jerusalem",
  //         isVid:true,
  //         vidId:"FvAWuLQEOJw",
  //         title : "After Dark Fun in the Holy City",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 					            <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
  //                               <p>To check it out, make your way to the City Center and explore the narrow streets just off Jaffa Street. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. Rivlin Street is a popular hangout for young people, while Shoshan Street and the surrounding area offers a more laid-back grown up vibe.</p>
  //                               <div class="img-wrapper">
  // 						          <img src=${getImgUrl() +  "/posts/modern-and-vibrant/1.jpg"} class="img-responsive" />
  // 					          </div>
  //                               <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing. </p>
  //                               <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session. </p>
  //                               <p>For a daytime change of pace head to the German Colony (Moshava) and, particularly, the neighborhood of Baka. Start at Beit Lechem Street where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up Emek Refaim Street or through HaMesila (Railway) Park until you reach The First Station – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>

  //          `
  //     }
  //   }
  // },

  {
    id: "Ramle_ar",
    bgImage: "/posts/bank/ramla-ar/1.jpg",
    mobBgImage: "/posts/bank/ramla-ar/M.jpg",
    ctg: "general",
    isVid: false,
    title: "الرملة",
    smltitle: "",
    html: function() {
      return {
        __html: `
							<p>أهلا بكم في الرملة، واحدة من أقل المدن الإسرائيلية حظّا من الشهرة، لكنها الأكثر تنوّعا، واحتواء على مزيج رائع ومتعدد من الثقافات. أسس الرملة الخليفة الأموي المسلم سليمان بن عبد الملك في بداية القرن الثامن، وقد كانت الرملة مدينة مهمة تقع على مفترق الطرق القديم الواصل بين القاهرة إلى دمشق، مرورا بيافا والقدس. ويرجع أصل التسمية إلى كلمة "الرمل" العربية.</p>
                 			<p>هذه المدينة التي تقع اليوم وسط إسرائيل، تغيرت وجوه المسيطرين عليها على مدار التاريخ لمرات لا تحصى: إذ سيطر الصليبيون والمماليك والأتراك العثمانيون ونابليون بونابرت والبريطانيون عليها. أما اليوم، فالرملة هي موطن لنحو ثمانين ألفا من السكان، ويشكل العرب فيها نحو 30 في المئة، غالبيتهم من المسلمين، وبعضهم من المسيحيين.</p>
                 			<p>توجد في هذه المدينة العديد من المواقع الإسلامية الهامة، ومن ضمنها بقايا الجامع الأبيض، الذي كان يعد ذات مرة أكبر مساجد العالم الإسلامي. والذي يرتفع لـ 30 مترا، وفيه 111 درجة تقود إلى مشهد خلّاب للرملة والطريق المؤدية للساحل. كما يوجد في داخل المجمّع مقام النبي صالح، المقدّس لدى المسلمين.</p>
   							<div class="img-wrapper">
						          <img src=${getImgUrl() +
                        "/posts/ramla-ar/1.jpg"} class="img-responsive" />
					          </div>
                 			<p>هنالك مسجد آخر هام في الرملة، هو الجامع الكبير، الذي كان في الأصل كنيسة صليبية بنيت في القرن الثاني عشر، وقد كان واحدا من المباني القليلة التي بقيت على حالها في البلاد منذ تلك الفترة. يعرف المسجد أيضا باسم المسجد العمري، مما يدل على تحويل المبنى إلى مسجد من قبل المماليك.</p>
                 			<p>المسجد الكبير هو واحد من المباني الصليبية القليلة في البلاد التي بقيت على حالها تقريبا. إذ تم تشييد المعبد في القرن الثاني عشر ككنيسة مسيحية، حيث يمتاز ذلك القرن بنقوش كالنقوش الموجودة داخل المسجد. ولا يزال تصميم المسجد قائما على شكل "بازيليكا" كلاسيكية.  كما يقع قبر الولي شهاب الدين في ساحة المسجد.</p>
                 			<p>هنالك مسجد رئيسي آخر في الرملة هو مسجد حذيفة اليماني، المعروف باسم المسجد الأصغر، والذي تم إطلاقه على اسم مساعد النبي محمد. </p>
                 			<p>تفتخر المدينة أيضا بوجود العديد من الكنائس الهامة فيها، بما في ذلك دير الفرنسيسكان للقديس نيقوديموس، ويوسف الرامي، وهو المكان الذي عسكر فيه نابليون في طريقه إلى عكا سنة 1799، وتوجد في المكان لوحة أصلية بعنوان "يسوع يؤخذ من الصليب"، وهي لوحة تعود لعصر النهضة الإيطالية ورسمها الفنان الشهير تيتان.</p>
                 			<p>هذا، وتعدّ الرملة أيضا موطنا لطائفة القرّائين اليهودية التي لا تعترف إلا بالتوراة المكتوبة.</p>
                 			<p>ربما يكون الموقع الأكثر تفرّدا في مدينة الرملة هو بركة الأقواس، التي بنيت سنة 789 ميلادية في عهد الخليفة المسلم هارون الرشيد، وهي عالم كامل مبني تحت الأرض من خزّانات المياه المتقنة، والتي يمكن التجوال فيها باستخدام قوارب التجديف، بينما يرى الزوار الأقواس المدببة التي كانت سائدة في الفترة الذهبية من العمارة الإسلامية.</p>
                 			<p>وإذا كنتم تزورون الرملة، فلا تنسوا أن تزوروا البازار، وهو أحد أكثر أسواق إسرائيل نشاطا وحيوية، والذي يعرض التوابل والنكهات التي تستخدمها عشرات المجتمعات العرقية التي تتشكل منها التوليفة السكّانية لأهل المدينة.</p>


         `,
      };
    },
  },

  {
    id: "Ashqelon_ar",
    bgImage: "/posts/bank/ashqelonar/1.jpg",
    mobBgImage: "/posts/bank/ashqelonar/M.jpg",
    ctg: "general",
    isVid: false,
    title: "عسقلان ومزار الحسين بن علي",
    smltitle: "",
    html: function() {
      return {
        __html: `
							
					        <p>لدى عسقلان التي تربض على كتف البحر المتوسط المتلألئ، بعض من أفضل الشواطئ في البلاد، وهي تمتد على طول 12 كيلومترا من المنطقة الساحلية الجميلة. تفتخر المدينة بمنتزهها الساحلي الجميل، ومرساها العالمي الذي تمارس فيه أنشطة ركوب الزوارق والرياضات المائية والمطاعم والمقاهي، حيث يمكنكم الجلوس والاستمتاع بالنسيم العليل ليلا ونهارا.</p>

							<p>هنالك أسباب إضافية تدعوكم لزيارة لؤلؤة البحر المتوسط هذه، حيث هنالك الكثبان الرملية النقية، ومنتزه المدينة الوطني الذي يضم آثارا كنعانية ورومانية، والأسوار التي تعود للقرون الوسطى، والتي بناها المسلمون الفاطميون لحماية المدينة من الصليبيين.</p>

							<div class="img-wrapper">
						          <img src=${getImgUrl() +
                        "/posts/ashqelonar/1.jpg"} class="img-responsive" />
					        </div>
							<p>من أهم الاكتشافات الأثرية في المدينة، بوابتها الكنعانية، التي يعود تاريخها إلى العام <span class="ac-en-fotn">1850</span> قبل الميلاد، وهي أقدم بوابات العالم المقببة. وقريبا من هذا المكان، تمّ العثور على بقايا معبد كنعاني قديم، إلى جانب تمثال صغير لعجل من البرونز، ينسب إلى طقوس الإيمان ببعل، والد الآلهة الكنعانية.</p>

							<p>يوجد في عسقلان أيضا سر محفوظ جيدا: إذ يوجد قبر في أرض مستشفى برزيلاي، يعتقد المسلمون الشيعة أنه قد تم دفن رأس الحسين بن علي، حفيد النبي محمد، فيه.

							<p>وتقول الأسطورة بأن والد التشيّع قد قتل وتم قطع رأسه في معركة كربلاء سنة <span class="ac-en-fotn">680</span> م. وقد دفن رأسه في الجامع الكبير في دمشق لما يزيد عن مائتي عام، ثم تم إخفاؤه فيما بعد في عسقلان، حيث بنى الخليفة الفاطمي ضريحا مخصصا للحسين بن علي، وصف بأنه أروع مبنى في المنطقة. وقد تم نقل رأس الحسين بعد حوالي 250 عاما إلى القاهرة، حين قام الصليبيون بغزو الأرض المقدسة.</p>

							<p>تم العثور على بقايا المزار حينما تم بناء المستشفى في خمسينيات القرن الماضي، وفي أوائل العقد الأول من القرن الحالي، بنى زعيم طائفة بهرة الداوودية (أو الإسماعيلية المستعلية) ضريحا رخاميا هناك، حيث يقوم مئات من المؤمنين بالحج إلى الموقع في كل عام</p>

							<p>هنالك مواقع أخرى تستحق الزيارة في المنطقة، من ضمنها محميّتي زيكيم و نيتسانيم الطبيعيتين، حيث توجد طرق سير شهيرة للمسافات الطويلة، ومسارات عربات النقل رباعية الدفع وسط الكثبان الرملية البكر التي تمتد إلى حوالي 30 كيلومترا على طول الساحل</p>

							                 			

         `,
      };
    },
  },
  {
    id: "Nabimusa_ar",
    bgImage: "/posts/bank/nabimusa-ar/1.jpg",
    mobBgImage: "/posts/bank/nabimusa-ar/M.jpg",
    // ctg :"general",
    // ctg :"jerusalem",
    ctg: "deadsea",
    isVid: false,
    title: "مقام النبي موسى",
    smltitle: "",
    html: function() {
      return {
        __html: `
							
					        <p>في قلب صحراء يهودا الرائعة المنعزلة، وعلى بعد حوالي سبعة كيلومترات جنوبي أريحا، ونحو 24 كيلومترا إلى الشرق من القدس، قبالة الطريق المؤدي إلى البحر الميت، يقع مقام النبي موسى، حيث دفن النبي موسى بحسب السردية الإسلامية.</p>
                            <p>مع أن كلا من اليهود والمسيحيين يقدسون النبي موسى الذي سمي هذا الضريح باسمه، إلا أن الديانتان لا تعتبران المكان مقدّسا، وفقا للتقاليد اليهودية، إذ أنهما تعتقدان بأن النبي موسى قد عوقب من الله الذي منعه من دخول أرض إسرائيل، ولا يزال مكان دفنه مجهولا.</p>
							<p>يعدّ هذا الضريح الذي يمتد على مساحة 5000 متر مربع، واحدا من أكبر المجمّعات الدينية في المنطقة، حيث يضمّ نزلا للمسافرين، واسطبلات للخيول، ومئذنة ومسجد.</p>
                            <div class="img-wrapper">
						          <img src=${getImgUrl() +
                        "/posts/nabimusa-ar/1.jpg"} class="img-responsive" />
					        </div>
							<p>تعدّ المنطقة موضعا مفضّلا وشهيرا للرحلات بالسيارات رباعية الدفع، حيث تمتاز بالمناظر الخلابة. خذوا جولة جيب عبر صحراء يهودا، زوروا وادي القلط، وهو واد خلّاب حفرته في الصخر مياه السيول التي تتدفق من القدس إلى أريحا وصولا إلى البحر الميت، ستجدون دير القديس جورج المذهل في الطريق، وقد تمّ بناؤه منذ أكثر من 1500 عام، وهو دير يتدلّى حرفيا من الجرف السحيق.</p>
							<p>تعدّ هذه المنطقة واحدة من المناطق المفضّلة للساعين لتسلق الصخور، والهبوط بواسطة الحبال، وتسلق الكهوف.</p>
							<p>يقع مقام النبي موسى أيضا قريبا من البحر الميت، ويمكنكم القيام برحلة إلى هناك ليوم واحد في قلعة مسادا، وهي القلعة التي وقف فيها الثوار اليهود وقفتهم الأخيرة ضد الجيش الروماني الهائل. بإمكانكم السباحة عبر الطفو في مياه أخفض بقعة في الكرة الأرضية، وزيارة واحد من المنتجعات الصحية التي تنتشر على ضفاف البحر الميت.</p>

                 			

         `,
      };
    },
  },

  {
    id: "Kneset_ar",
    bgImage: "/posts/bank/kneset-ar/1.jpg",
    mobBgImage: "/posts/bank/kneset-ar/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: "الكنيست",
    smltitle: "",
    html: function() {
      return {
        __html: `
							
					        <p> الكنيست، وهو البرلمان الإسرائيلي، هو ليس مجرد قلب الديمقراطية الفوارة للدولة، وإنما يُعدّ بمثابة جوهرة معمارية وموقع يستحق زيارته، رغم ان المجموعات التي تضم 10 أشخاص أو أكثر ملزمة بحجز جولة مسبقًا.</p>
							<p>هناك عدة أنواع من الجولات المتوفرة إلى الكنيست والتي تتم باللغة الإنجليزية، والعربية وبعدة لغات أخرى. حيث لا تستغرق الجولة المعتادة سوى ساعة واحدة وهي تتيح للزوار نبذة عن طبيعة الديمقراطية الإسرائيلية، وكذلك الأدوار التي يؤديها الكنيست ومسؤولياته، والأعمال الفنية المعروضة في أنحاء المبنى. حيث تجوب الجولة جناح لجان الكنيست، وقاعة الجلسات العامة، وقاعة شاغال، ومعرض يتناول وثيقة إعلان قيام دولة إسرائيل.</p>
							<div class="img-wrapper">
						          <img src=${getImgUrl() +
                        "/posts/kneset-ar/1.jpg"} class="img-responsive" />
					        </div>
							<p>بينما تركّز جولة منفصلة على الأعمال الفنية المعروضة في الكنيست، بما في ذلك المنسوجات الجدارية والصور المرسومة بالفسيفساء التي صُنعت على يد الفنان اليهودي الروسي المنشأ مارك شاغال، وكذلك الأعمال الفنية الخاصة بالفنانيْن الإسرائيلييْن موشيه كاستل ورئوفين روبين؛ ومعرض لصور التقطها أحد المصورين الرسميين السابقين للكنيست، دافيد روبينغر؛ وسراديب تعود لفترة الهيكل اليهودي الثاني، وحدائق أثرية؛ وغيرها المزيد.</p>
							<p>يمكن للزوار كذلك الذهاب في جولة سيرا على الأقدام إلى الحدائق الأثرية، والتي تتناول التحف التي تم العثور عليها خلال الحفريات في أورشليم القدس، والتي تمثل ست حِقب مرت على تاريخ المدينة: حقبة الهيكل الثاني، والحقبة الرومانية المتأخرة، والحقبة البيزنطية، والحقبة الإسلامية، والحقبة الصليبية، وحقبة الإمبراطورية العثمانية. حيث تركّز الجولة على التصميم المعماري الذي يميّز الكنيست وعلى الجهود البيئية التي يتم بذلها في سبيل جعل بنيته مستدامة.</p>
							<p>يمكن للزوار كذلك الذهاب في جولة تدمج ما بين زيارة مقر الكنيست ثم زيارة مقر المحكمة العليا المجاور، والذي يُعتبر إحدى الجواهر المعمارية الأخرى الخاصة بالمدينة وركن آخر من أركان طابعها الديمقراطي.</p>


       						
                 			

         `,
      };
    },
  },
  {
    id: "Mount_Of_Olives_ar",
    bgImage: "/posts/bank/mountOolivesar/1.jpg",
    mobBgImage: "/posts/bank/mountOolivesar/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: "جبل الزيتون",
    smltitle: "",
    html: function() {
      return {
        __html: `
							
					        <p>جبل الزيتون [الذي يسمى كذلك جبل الطور] ليس مجرد موقع يحظى بأهمية كبيرة بالنسبة لكل من اليهود، والمسيحيين والمسلمين، وإنما موقع يتيح إطلالة تحبس الأنفاس على أورشليم القدس. نقطة المراقبة الواقعة على الجبل والتي يبلغ ارتفاعها 800 متر فوق سطح البحر تشرف على البلدة القديمة المقدسية وعلى الحرم الشريف، التي تهيمن عليه قبة الصخرة المغطاة بالذهب، بل تتجاوز ذلك كثيرًا.</p>

                            <p>يقدس المسيحيون جبل الزيتون باعتباره الموقع الذي أسرى يسوع عليه السلام منه إلى الجنة بعد بعثه، بينما يؤمن المسلمون أن عيسى [اسم يسوع باللغة العربية] لم يمُت أبدًا بل ارتقى إلى الجنة ليتربع إلى جانب الله عز وجل. وكما ويشكل هذا الموقع موطنًا لمسجد الصعود ولكنيسة الصعود.</p>

                            <p>يؤمن المسلمون بأن الكعبة، بمعنى الحجر الأسود في مكة المكرمة، ستعود إلى جبل الزيتون لتتحد مع الصخرة المشرفة في قبة الصخرة، التي تم خلق العالم منها.</p>
                            <div class="img-wrapper">
						          <img src=${getImgUrl() +
                        "/posts/mountOolivesar/1.jpg"} class="img-responsive" />
					        </div>
                            <p>وفقًا للعقيدة الإسلامية، مع حلول يوم القيامة سيتشكل جسر ذو سبعة أقواس، والذي سيكون أضيق من خصلة شعر، ليربط جبل الزيتون بموقع إسراء النبي محمد صلعم على الحرم الشريف، حيث سيمر الصالحون عبر الجسر ليفوزوا بالحياة الخالدة بينما سيسقط المذنبون منه ليلقوا حتفهم في الجحيم.</p>

                            <p>بالنسبة لليهود، فإن جبل الزيتون يشكل الموقع الذي سيظهر فيه المسيح ليتجه منه إلى جبل الهيكل. وتُعد المنحدرات الواقعة تحت نقطة المراقبة موطن مقبرة جبل الزيتون اليهودية، حيث تم دفن حوالي 150000 يهودي على مدار آخر 3000 عام بسبب الإيمان بأن قيامة الأموات ستبدأ من هناك.</p>

                            <p>وإذا كنت مستعدًا للتحدي، فجرّب تسلق المنحدر الحاد المؤدي إلى الجبل من البلدة القديمة حيث يمكنك الاطلاع على العديد من المواقع المنتشرة على طول الطريق المؤدي إلى قمة الجبل، والتي تشمل مسجد وكنيسة الصعود وكنيسة مريم المجدلية الروسية الأرثوذكسية ذات القبة الذهبية التي تم إنشاؤها من قبل القيصر ألكسندر الثالث في عام 1886، مع حدائقها الجميلة.</p> 

       						

         `,
      };
    },
  },
  {
    id: "Haram_Al_Sharif_ar",
    bgImage: "/posts/bank/haramalsharifar/1.jpg",
    mobBgImage: "/posts/bank/haramalsharifar/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: " كنيسة القيامة ",
    smltitle: "",
    html: function() {
      return {
        __html: `
							
					<p>يُعتبر جبل الهيكل، المعروف باللغة العربية باسم الحرم الشريف موقعًا مقدسًا بالنسبة لكل من المسلمين واليهود. حيث تشكل ساحته الضخمة قلب البلدة القديمة المقدسية النابض. ويشكل مسجد الأقصى، الذي يُعدّ ثالث المواقع قدسيةً بالنسبة للإسلام، وقبة الصخرة الذهبية الفاخرة التي تهيمن على أفق البلدة القديمة والتي يمكن ملاحظتها من أية نقطة تقريبًا حولك، على حد سواء جزءًا من حرم المسجد.</p>
                    <p>وتكون قبة الصخرة موطن الصخرة المشرفة، وهو المكان الذي بدأت منه وفقًا للعقيدة الإسلامية رحلة الأسراء والمعراج للنبي محمد صلعم إلى الجنة على متن دابته السحرية البيضاء ذات الجناحين، البراق. بالنسبة لليهود فإن الصخرة معروفة كحجر الأساس، حيث بدأ خلق العالم منه.</p>
                    <div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/haramalsharifar/1.jpg"} class="img-responsive" />
					</div>
                    <p>هذا ويُعتبر حرم المسجد مقدسًا لكونه موقع الهيكلين القديمين بمعنى هيكل سليمان التي تم تدميره على يد نبوخذ نصر الثاني في عام 586/587 قبل الميلاد، مما أدى إلى نفي اليهود وانتقالهم إلى بابل، والهيكل الثاني، الذي تمت إعادة بنائه من قبل هيرودس الأول، وكان يُعدّ إحدى معجزات العالم القديم قبل أن يتم تدميره على يد الرومان في عام 70 بعد الميلاد. ويقع أحد الحيطان القليلة المتبقية من الهيكل الثاني، حائط المبكى، تحت الحرم الشريف حيث يتخذ منه اليهود موقعًا لإقامة الصلوات. </p>
                    <p>كونه يقع وسط البلدة القديمة الصاخبة، بأحيائها اليهودية والإسلامية والمسيحية والأرمينية، وبازاراتها، وكنائسها، وكنيسها ومساجدها فإن الحرم الشريف يضم كذلك العديد من المواقع الإسلامية الهامة الأخرى، مثل نافورة الوضوء الشهيرة التي تسمى الكأس والتي تم بناؤها بالقرب من مدخل مسجد الأقصى من قبل السلطان الأيوبي في القرن الـ 12، وكذلك المتحف الإسلامي، الذي يتيح الاطلاع على مجموعة تشمل حوالي 750 مخطوطة قرآنية، يعود أصل أقدم مخطوطة منها إلى القرن الـ 8 بعد الميلاد.</p>
        `,
      };
    },
  },
  {
    id: "Church_of_the_Holy_Sepulcher_ar",
    bgImage: "/posts/bank/churchoftheholysepulcher/1.jpg",
    mobBgImage: "/posts/bank/churchoftheholysepulcher/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: " كنيسة القيامة ",
    smltitle: "",
    html: function() {
      return {
        __html: `
							
					<p>موقع صلب وقيامة السيد المسيح<br/>
					
					يقع هذا المكان المقدّس داخل أسوار البلدة القديمة للقدس، ويقدسه المسيحيون بوصفه موقع صلب السيّد المسيح، ومكان دفنه وقيامته من القبر.</p>
					<p>من جهتهم، يعتقد المسلمون أن يسوع (المعروف في الإسلام باسم النبي عيسى)، لم يُصلب ولم يمُت، بل ارتقى إلى السماء، كما يؤمنون أنه سيعود في نهاية الزمان، كما ورد في سورة النساء.</p>
 
					<p>هنالك قصة أخرى لهذه الكنيسة في السردية الإسلامية: فوفقا للأسطورة، عرض البطريرك البيزنطي صفرونيوس على الخليفة عمر بن الخطاب الصلاة فيها حينما سلّمه المدينة في العام 637 ميلادية تقريبا، لكن الخليفة قد رفض قائلا بأنه إن فعل، فإنه يخشى أن تدّعي الأجيال اللاحقة بأن الكنيسة موقع إسلامي. وتقول الحكاية أنه قد قام بدلا من ذلك بإلقاء حجر بعيدا عن الكنيسة، وصلّى مكان سقوطه بدلا من ذلك. تم بناء مسجد في ذلك الموقع، شرقي الكنيسة، لكن "مسجد عمر" الذي ينتصب في ذلك الموقع، فقد بني سنة 1193 ميلادي، إلى الجانب الجنوبي من الكنيسة، من قبل السلطان الأيوبي الأفضل بن صلاح الدين، أحد الأبناء الـ 17 للسلطان صلاح الدين الأيوبي الذي قاد المسلمين لهزيمة جيوش الصليبيين في بلاد الشام.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/churchoftheholysepulcher/1a.jpg"} class="img-responsive" />
					</div>
					<p>أما كنيسة القيامة نفسها فقد بناها الإمبراطور الروماني قسطنطين، وتم الفروغ من البناء وتكريسه ككنيسة سنة 335ميلادي. وفي الوقت الذي كانت فيه الكنيسة تعاني من الحرائق والزلازل والغزوات، وتمت إعادة بناؤها عدة مرات، فإن الأبواب الخشبية لمدخلها الرئيسي هي الأبواب الأصلية التي بناها قسطنطين منذ حوالي 1800 عام!</p>

					<p>تتقاسم عدة طوائف مسيحية السيطرة على الكنيسة: الروم الأرثوذكس، والروم الكاثوليك، والأرمن، والأقباط، والسريان، والإثيوبيون، وفق نظام يفوق عمره 160 عاما.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/churchoftheholysepulcher/2.jpg"} class="img-responsive" />
					</div>
					<p>لكن عائلتان مسلمتان مقدسيّتان هما من تقومان على الكنيسة، وهما عائلتي نسيبة وجودة، وقد شغلا هذا المنصب منذ أن استحدثه صلاح الدين الأيوبي سنة 1192، ولا تزال العائلتين تحملان حتى اليوم مفاتيح الأبواب الخشبية الكبيرة، وهما تمارسان، في كلّ صباح، طقس فتح بوّابات الكنيسة، في إطار تسوية مستندة إلى الوضع القائم، تمّ إقرارها منذ زمن بعيد.</p>

					
                    
        `,
      };
    },
  },
  {
    id: "MosquesOfJaffa_ar",
    bgImage: "/posts/bank/mosquesofjaffa-ar/1.jpg",
    mobBgImage: "/posts/bank/mosquesofjaffa-ar/M.jpg",
    ctg: "telaviv",
    isVid: false,
    title: "مساجد يافا",
    smltitle: "",
    html: function() {
      return {
        __html: `
							
       						<p>تعدّ مدينة يافا موطنا لعدة مساجد، ولعلّ أهمها هما مسجدي المحمودية وحسن بك.
  							<p>يعدّ مسجد المحمودية مجمّعا لعدة مبانٍ شيّدها العثمانيون في بداية العام 1730، أما معظم المباني القائمة اليوم فقد بنيت سنة 1812 على يد محمد آغا (المعروف باسم أبي نبّوت)، حاكم غزة ويافا العثماني، وقد سمّي أبو نبّوت بهذا الاسم نسبة إلى ولعه بضرب كل من يعصيه بهراوة (نبّوت).</p>
 							<p>أما مسجد حسن بك فيقع على شاطئ البحر إلى الشمال من يافا، في حي المنشية السابق. وقد شُرع ببناء المسجد سنة 1914 على يد الحاكم العثماني في تلك الحقبة، حسن بك البصري الجابي، وقد صممه بن تسيون جيني، المهندس اليهودي لمدينة يافا. ومع ذلك، فإن اندلاع الحرب العالمية الأولى وانهيار الخلافة العثمانية في تلك المرحلة قد أديا إلى تأجيل اكتمال بنائه، ليصار إلى إنهائه سنة 1923.</p>
 							<div class="img-wrapper">
						          <img src=${getImgUrl() +
                        "/posts/mosquesofjaffa-ar/1.jpg"} class="img-responsive" />
					        </div>
 							<p>إن كنتم تقومون بزيارة مساجد يافا، فإن هنالك الكثير مما يمكنكم مشاهدته والقيام به في المنطقة. فإلى جانب مسجد المحمودية تماما، يوجد سوق الروبابيكا في يافا (سوق البراغيث)، وهو سوق تعرض فيه تشكيلة متنوعة من بضائع البازار الشرقية إلى مطاعم ومتاجر البوتيك الصغيرة، ويعدّ هذا السوق واحدا من أكثر أحياء المدينة أناقة.</p>
 							<p>تقع مدينة يافا القديمة التي تعج بالمباني العثمانية التي تمّت إعادة إحياؤها، على بعد نحو عشرة دقائق سيرا على الأقدام من المسجد، وهي تستحق الزيارة بسبب وجود معارض الفنون فيها، إلى جانب المتاحف والمطاعم المطلّة على البحر المتوسط ومدينة تل أبيب.</p>
 							<p>يقع مسجد حسن بك إلى جانب واحد من أكثر شواطئ تل أبيب شعبية، حيث يمكنكم من هناك التمشي في منتزه تل أبيب الذي يمتد على طول الطريق من يافا في الجنوب، إلى ميناء تل أبيب القديم في الشمال.</p>
 							<p> كما يوجد بالقرب من المكان سوق الكرمل الصاخب للأطعمة، حيث يمكنكم العثور على بعض المطاعم الرائعة، إلى جانب حي "نفيه تصيدق" الخلاب الذي يعدّ جزيرة من الهدوء تم بناؤها في مطلع القرن الماضي كأحد أول الأحياء اليهودية خارج يافا، وهو يعدّ اليوم واحدا من أكثر المواقع المرغوبة في المدينة. </p>


         `,
      };
    },
  },

  // Hadar asked to hide the video inside this post on 2021-02-04
  {
    id: "Jerusalem_Musts",
    bgImage: "/posts/bank/38/1.jpg",
    mobBgImage: "/posts/bank/38/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    // vidId: "FvAWuLQEOJw",
    title: "5 أفضل الأشياء التي ينبغي القيام بها ومشاهدتها في المدينة المدهشة",
    smltitle: "",
    html: function() {
      return {
        __html: `					
					<h3>
						رحلات سيجواي	
					</h3>
					<p>
						ستسمح لك الطريقة المليئة بالأدرينالين في مشاهدة المدينة بالاستمتاع بجمال أورشليم القدس من زاوية فريدة من نوعها. حيث تنطلق رحلات السيجواي من مواقع مركزية مختلفة، يشمل كورنيش أرمون هنتسيف (تلبيوت الشرقية)، ويمين موشيه والبلدة القديمة، وكذلك بالقرب من الكنيست ومنطقة المتحف.
					</p>
					<h3>
						المحطة الأولى (هاتاخانا) 
					</h3>
					<p>
					تقع المحطة الأولى في قلب أورشليم القدس، بين البلدة القديمة ووسط المدينة، بين الحارات التاريخية للمستعمرة الألمانية ويمين موشيه. إنها موقع أول محطة قطار في أورشليم القدس، حيث تم إنشاؤها عام 1892. وبعد المرور بعملية تجديد وصيانة، تم إعادة افتتاح المحطة الأولى كموقع ترفيهي نابض بالحياة ومفتوح على مدار سبعة أيام أسبوعيًا.
					</p>
					<h3>
						مصعد الوقت (معليت هزمان)
					</h3>
					<p>
						إذا كنت من محبي رحلات المتعة، فستستمتع بمصعد الوقت الذي سيثير حواسك. إنه عبارة عن تجربة تفاعلية تأخذ زوارها عبر رحلات مدهشة إلى أماكن أخاذة، بمقعد متحرك تقع داخل قاعة فريدة من نوعها مليئة بالآثار الخاصة.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/jerusalem-must/1.jpg"} class="img-responsive" />
					</div>
					<h3>
						حديقة الحيوان الكتابية
					</h3>
					<p>
						تقع مراكز حديقة الحيوان الجميلة ذات الطابقين هذه الممتدة على مساحة ما يزيد عن 62 هكتارًا على بحيرة شاسعة من صنع الإنسان تعمّها شلالات المياه والبِرك الجانبية، كما وتحيط بها الحدائق المترامية وأماكن الاستراحة المظللة. وسيكون من دواعي سرور الأطفال والبالغين على حد سواء مشاهدة أكثر من 200 صنف من الحيوانات، يرد ذكر معظمها في التوراة حيث أصبح بعضها شبه منقرض في هذه الأثناء. ولا يعني ذلك عدم وجود حيوانات عادية في الموقع حيث ستكون في انتظاركم البطاريق حتى. بالقرب من حديقة الحيوان يوجد هناك حوض أسماك جميل وهائل وملفت للانتباه، والذي يكون مفتوحًا أمام الزوار خلال ساعات النهار والمساء، ويتيح الإطلالة على الموائل البحرية من البحر الأبيض المتوسط، والبحر الأحمر وغيرهما المزيد.
					</p>
					<h3>
						متنزه تيدي
					</h3>
					<p>
					سمي بعد تيدي كوليك الذي تولى منصب رئيس بلدية أورشليم القدس بين السنوات 1965 و1995: متنزه تيدي يتيح التمتع بتجربة المرح والجمال يحظى بأهمية تاريخية بالغة. حيث يشكل المتنزه نقطة التقاء هامة بين النسخة القديمة والحديثة لأورشليم القدس ويشمل بركة أمنيات، ومنحوتة أصلية على شكل ساعة شمسية مدهش، وتجديدات الخصائص التاريخية ومعلم نافورة المياه الخيالية، التي تقدم عرض مسائي رائع للأضواء والأصوات.
					</p>

         `,
      };
    },
  },
  // End Hadar asked to hide the video inside this post on 2021-02-04

  {
    id: 16,
    bgImage: "/posts/bank/34/1.jpg",
    ctg: "eilat",
    isVid: true,
    vidId: "yXzhH92kREg",
    mobBgImage: "/posts/bank/34/M.jpg",
    title: "NEGEV MAJESTIC DESERT",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Action adventures in the desert sun. With so much to see and do, there is never a dull moment in the Negev</h3>

					
					<h3 class="negev-secondary-title">
								 The Negev Desert - Pure Magic Desert
							</h3>


							\n

                            <!--negev text-->

                            <p>
								The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.
							</p>
							<p>
								Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.
							</p>
							<p class="p-margin">
								There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.
							</p>

							<h3>
                                The Israeli desert is special for the following reasons:
                            </h3>

							<ul class="p-margin">
							    <li>
										<b>The desert is very near:</b> just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).
										Starting from November, there will be direct flights from Europe and Russia to Ovda airport including Ryanair, Wizzair, and SAS.
							    </li>
                                <li>
                                        <b>Easy to Hike and Bike:</b> There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:<br>
                                        <a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a>
                                        <a href="//www.en.aravaway.co.il " target="_blank">www.en.aravaway.co.il</a>
							    </li>
							    <li>
                                        <b>Cordial local population:</b> The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.
							    </li>
							    <li>
                                        <b>Tourists Activities:</b> Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.
							    </li>
							    <li>
                                        <b>Magnificent landscapes:</b> Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety<br>
                                        <ul>
                                        	<li>
                                        		There are spectacular sand dunes in the north.
                                        	</li>
                                        	<li>
                                        		The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.
                                        	</li>
                                        	<li>
                                        		In the east, one experiences the African desert with wide savannas and acacia trees.
                                        	</li>
                                        	<li>
                                        		To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.
                                        	</li>
                                        </ul>
                                        During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.
										Many tourists decide for to stay for 2 or 3 days in each region of the Negev.

							    </li>
							    <li>
                                        <b>The Negev is very safe to travel.</b> In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.
							    </li>
							</ul>
							<h3>
							    More information and tips for accommodation and recommendations:
							</h3>
							<p>
							   <a href="//www.negevtour.co.il/homepage/accommodation/?lang=en" target="_blank">www.negevtour.co.il</a><br>
							   <a href="https://en.aravaway.co.il/business/category/1/" target="_blank">www.en.aravaway.co.il</a>
							</p>
							<p class="p-margin">
							   <a href="//goisrael.de/taxonomy/term/85" target="_blank">Travel deals</a><br>

							</p>




                            <!--Negev - Transportations-->

							<h3>
							    NEGEV - LOCATION AND APPROACH
							</h3>
							<p class="p-margin">
							   Landing at the airports of Ovda or Eilat with the  onward journey to Mitzpe Ramon or Sde Boker:
							</p>

							<h3>
							   Public means of transportation:
							</h3>
							<p>
								Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p>
								Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.
							</p>
							<p>
								Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p class="p-margin">
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Bus service </a><br>
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Shuttle service from Ovda Airport </a>
							</p>
							<h3>
							   Car rental in Eilat, Mitzpe Ramon and Be'erSheva:
							</h3>
							<p>
								There a multiple option in renting a car in these cities.
                                There is a choice of international and Israeli companies.

							</p>
							<p class="p-margin">
								Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon

							</p>
							<h3>
							   Public means of transportation:
							</h3>
							<p>
								Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.
								<a href="//www1.rail.co.il/EN/Pages/Homepage.aspx" target="_blank">Train from Ben Gurion or Tel Aviv to Be'erSheva.</a>
                            </p>
                            <p>
								From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes).
                                Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.
                            </p>
                            <p class="p-margin">
								More information about the public means of transportation is given <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">here</a> or <a href="//www.egged.co.il/HomePage.aspx">here</a>
                            </p>


                             <!--NEGEV DESERT-don't miss-->








                            <h3 class="margin-h">
                                 NEGEV ROAD DISTANCES
                            </h3>
							<table>
							  <tr>
							    <th></th>
							    <th>Tel Aviv</th>
							    <th>Jerusalem</th>
							    <th>Bee'r Sheva</th>
							    <th>Eilat</th>
							  </tr>
							  <tr>
							    <td class="place-table"> <strong>Old Town <br class="show-on-mobile"> Beer Sheva</strong></td>
							    <td>113 Km</td>
							    <td>122 Km</td>
							    <td></td>
							    <td>232 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Tel Arad</strong></td>
							    <td>134 Km</td>
							    <td>144 Km</td>
							    <td>40 Km</td>
							    <td>229 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ben-Gurion's House <br class="show-on-mobile">in Sde Boker</strong></td>
							    <td>162 Km</td>
							    <td>171 Km</td>
							    <td>49 Km</td>
							    <td>185 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ramon Crater</strong></td>
							    <td>210 Km</td>
							    <td>192 Km</td>
							    <td>97 Km</td>
							    <td>141 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Hai Bar Wildlife <br class="show-on-mobile"> reserve Yotvata</strong></td>
							    <td>323 Km</td>
							    <td>288 Km</td>
							    <td>202 Km</td>
							    <td>35 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Timna Park</strong></td>
							    <td>330 Km</td>
							    <td>294 Km</td>
							    <td>208 Km</td>
							    <td>30 Km</td>
							  </tr>
							</table>

                            <h3>
								NEGEV DESERT - DON'T MISS
							</h3>

							 <h3>
                                Ramon Crater
                            </h3>

                            <p>
                                At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon.
								Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.
								Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.
								The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/7.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
                                Timna Park
                            </h3>

                            <p>
                               15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.
                               With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/9.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h2 class="title-to-play">
								CLICK TO PLAY: Timna Park - An Exhilarating Desert Adventure
							</h3>
							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

						

                            <h3>
							    Sandboarding in the desert
							</h3>
							<p>
								An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?
							</p>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/1.jpg"} class="img-responsive" />
							</div>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/2.jpg"} class="img-responsive" />
							</div>

							<!--<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/3.jpg"} class="img-responsive" />
							</div>-->

							<h3>
							    Negev at night
							</h3>
							<p>
								The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/4.jpg"} class="img-responsive" />
							</div>

							<h3>
							    Sunrise at Masada
							</h3>
							<p>
								Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/6.jpg"} class="img-responsive" />
							</div>


							<h3>
                                NEGEV - ISRAEL’S MAJESTIC DESERT
                            </h3>
                            <h3>
                                Where Adventure and Inspiration Await
                            </h3>
                            <p>
                              An ideal destination for travelers who love adventure in the great outdoors.
							  The south of Israel is sparsely populated, but packed with fascinating sites and activities.

                            </p>
                            <p class="p-margin">
                                With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset.
								A desert but definitely not deserted, there is so much to see and do here – there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert.
								Simply put, this majestic Southern region is one of the country’s greatest assets and an absolute must on the itinerary.

                            </p>


							<h3>
                                Sde Boker
                            </h3>

                            <p class="p-margin">
                                A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50’s.
                                Sde Boker is renowned as the home of David Ben Gurion, Israel’s first Prime Minister whose home is now a museum open to the public.


                            </p>

                            <h3>
                                Vidor Center
                            </h3>

                            <p class="p-margin">
                                A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.
                            </p>



                            <h3>
                                Nevatim
                            </h3>

                            <p class="p-margin">
                               A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world.
                               The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.
                            </p>

                            <h3>
							   MidBurn Festival
							</h3>

							<p class="p-margin">
								Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.
							</p>

							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

							<br>

                            <h3>
                                The Bedouin Experience
                            </h3>

                            <p>
                               The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.
                               A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/8.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
                                The Culinary Queens of Yeruham
                            </h3>

                            <p class="p-margin">
                              For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham – a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors.
                              Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.

                            </p>
                            <h3>
                                The Old City of Be'er Sheva
                            </h3>

                            <p class="p-margin">
                               Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.
                            </p>
                            <h3>
                                Carasso Science Park
                            </h3>

                            <p>
                               New in the Old City of Be’er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel.
                               Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.

                            </p>
                            <h3>
                                Arad
                            </h3>

                            <p class="p-margin">
                               Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style.
                               With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.

                            </p>


							<h3>
                               Yotvata Hai-Bar
                            </h3>

                            <p>
                               The Yotvata Hai-Bar Nature Reserve is the area’s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators’ center with its live predators and small desert animals, a Nocturnal animal’s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/10.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>


							<h3>
                               Extreme Adventures
                            </h3>

                            <p>
                               The south of Israel is a total dream destination for adventure-hungry travelers.  Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/11.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h3>
							    Camel rides
							</h3>
							<p>
								A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/5.jpg"} class="img-responsive" />
							</div>


                            <!--NEGEV - וPDATED TEXT SITES-->

                            <h3>
                                EVENTS IN THE NEGEV: CALENDAR
                            </h3>
						


							<div class="row-1 mounth-row">
					             <div class="mounths active">
					            <p id="myHeader1" data-div="newboxes1" onClick="toggleMounth(event)" href="">January <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid">
					            <p id="myHeader2" data-div="newboxes2" onClick="toggleMounth(event)" href="">February <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes3" onClick="toggleMounth(event)" href="">May <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes4"onClick="toggleMounth(event)"  href="">June <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes5" onClick="toggleMounth(event)" href="">July <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>
					        </div>



					        <div class="row-2 mounth-row">
					          <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes6" onClick="toggleMounth(event)" href="">August <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes7"onClick="toggleMounth(event)"  href="">October <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes8" onClick="toggleMounth(event)" href="">November <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid" >
					            <p id="myHeader3" data-div="newboxes9" onClick="toggleMounth(event)" href="">December <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					        </div>



					         <div class="newboxes" id="newboxes1" style="    display: block;"> <!--Jen-->
					                Round The Arava Race - The 63-kilometer bike race named after Yoni Friedman offers a breathtaking desert landscape, endless expanses of nature, the power of spirituality, serenity and serenity and a connection to an extraordinary sporting experience. The starting point and end of the race are in Moshav Hatzeva.<br>
					                <a href="https://www.arava-active.co.il/MenuDefault.aspx?id=4240" target="_blank">www.arava-active.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes2"><!--Feb-->
					                Darom Adom is an annual festival held during the Anemone flower's blossoming season in the northern Negev region. The festival offers agricultural tours, farmers' markets, and countryside lodging, as well as sports activities such as marches, race, bike tours through the red fields of the northern Negev and other activities such as artistic performances. The local tourism association "Shikma Besor" is responsible for the festival and its yearly activities.<br>
					                <a href="//daromadom.habsor.co.il/" target="_blank">www.daromadom.habsor.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes3"><!--May-->
					                The cherry festival takes place in the Yatir Forest, which is the largest forest in Israel where large orchards of orchards grow, and is a 5-minute drive from Be'er Sheva. The event includes a cherry harvest for the whole family, sweet and sour snacks, baking pita bread, sheep herding, cheese gibbon, local farmers' market, klezmer melodies, climbing wall, omega and many other activities for the whole family.<br>
					                <a href="//kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/" target="_blank">www.kinderland.co.il</a>
					        </div>

					        <div class="newboxes" id="newboxes4"><!--June-->
					                Experience the magic of Ramadan nights in Rahat - when the night becomes a day and the streets are bustling with life. Join an unforgettable tour at the most special time of the year, giving a unique glimpse into Bedouin culture in Rahat. Meet the authentic dishes, absorb the fragrances of spices and roasted coffee, discover the secrets of Rahat from local guides and enjoy street performances, Debka music and more.<br>
					                <a href="//ramadan-nights.co.il/" target="_blank">www.ramadan-nights.co.il</a><br>
					                The Cinema South Festival, initiated by the School of Sound and Screen Arts at Sapir Academic College, started in 2002 with an emphasis on student films. Within a few years, however, became the festival an international film festival that provides a central stage for Israeli cinema, international quality and radical cinema. The festival takes place every year in June for five full days in various locations throughout the northern and western Negev. This is a festival that opens its doors to anyone, free of charge. The South Cinema Festival is produced from a unique cultural agenda relevant to the place where it was created.<br>
					                <a href="//csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html" target="_blank">www.csf.sapir.ac.il</a>
					        </div>
					        <div class="newboxes" id="newboxes5"><!--July-->
					               The International Fringe Festival Beer Sheva is a multi-disciplinary festival that crosses audiences and ages and constitutes a quality stage for the best Israeli and international artists from the fields of theater, dance, music, street art and the plastic arts. The festival is considered one of the major fringe events in Israel and the largest and leading cultural festivals in the south of the country. The festival was recently received by the EFFE (European Festivals Association) and is gaining a reputation as a prestigious event.<br>
					               <a href="https://www.iffb7.com/" target="_blank">www.iffb7.com</a>
					        </div>
					        <div class="newboxes" id="newboxes6"> <!--Aug-->
					               Negev Of Stars - Like every summer, the Earth passes through the shrapnel left behind by the comet SWIFT-TATTLE. These fragments penetrate our atmosphere and create a spectacular view of "shooting stars". During this time in the Negev celebratethe people the amazing experience of the Perseid Meters, a number of astronomical events - a joint observation of the meteor shower, observation points with elaborate telescopes, lectures and many other activities.
					        </div>
					        <div class="newboxes" id="newboxes7"><!--Oct-->
					                The Tamar Festival is a combination of the ideal Israeli soundtrack and the spectacular vista of Masada and the Dead Sea region. The extraordinary experience takes place with concerts over 4 days at various locations and at different times over 24 hours, when the audience ventures out to the country's most extraordinary sites and landscapes.<br>
					                <a href="//www.tamarfestival.com/" target="_blank">www.tamarfestival.com</a><br>
					                Desert Magic Festival - The first Bedouin festival: A variety of experiential activities for the whole family that provide an authentic glimpse into the ancient Bedouin tradition.<br>
					                <a href="//www.kesem-hamidbar.co.il/" target="_blank">www.kesem-hamidbar.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes8"><!--Nov-->
					                The Arava Film Festival is a unique event that has been going on for several years every November in the heart of the Arush Nature Reserve, adjacent to Tzukim. The films at the festival are screened in the evening and in the night, under the stars in the open air. They are the first line of international production that has been screened at world film festivals in the last year. Among the films of the festival are films for children and teenagers, as well as short films produced and filmed during the past year in the Arava. The films are screened on a giant screen and the audience can relax on a spacious and surprisingly comfortable platform, which was built especially for this purpose in the valley between the mountain cliffs of the eastern Negev.<br>
					                <a href="https://www.aravaff.co.il/" target="_blank">www.aravaff.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes9"><!--Dec-->
					                Ben-Gurion's march has been taking place for more than 20 years, at the initiative of the Ramat Negev Regional Council, following the daily sporting march of the first Prime Minister, David Ben-Gurion, during his stay in Kibbutz Sde-Boker. The march takes place on three tracks – a short track for families (7 km), a medium pathway (15 km) and a long one (22 km).<br>
					                <a href="//www.zaadatbg.org.il/" target="_blank">www.zaadatbg.org.il</a><br>
					                 Docaviv Negev - Docaviv, the Tel Aviv International Documentary Film Festival, is the largest film festival in the city of Tel Aviv, and the only festival in Israel dedicated in its entirety to documentary films. In order to expose as wide an audience as possible to documentary work, the NPO also organizes a regional festivals: Docaviv Negev, held in Yeruham, as well as dozens of documentary film screenings at cultural centers located throughout the country. Each year, Docaviv NPO awards Israel’s largest prize for an original Israeli documentary production, and alongside it, prizes for the Best International Film Award, prizes for outstanding student filmmakers, and an additional prize within the Depth of Field framework, for innovative, inspiring documentary films from around the world.<br>
					                <a href="//www.docaviv.co.il/" target="_blank">www.docaviv.co.il</a>
					        </div>




                            <a href="//graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#" target="_blank">FOR MORE IMFORMATION CLICK HERE </a>


         `,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: 41,
    bgImage: "/posts/bank/46/1.jpg",
    mobBgImage: "/posts/bank/46/M/1.jpg",
    title: "Tel Aviv and Jerusalem",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h3>Nonstop fun for the whole family</h3>

              		<p>
			Travelling with kids to Tel Aviv and Jerusalem is a fantastic experience. Both cities, as is most of the country, are extremely family oriented, and from nature to culture, there is absolutely loads of amazing attractions and exciting activities for families to enjoy together. Wherever you turn, you’re likely to find children out and about with parents, grandparents or groups.              		
		</p>
              		<p>
			With up to 300 sunny days a year, the beautiful beaches of Tel Aviv are a favorite destination for locals and tourists alike. The beaches themselves offer a fabulous combination of sun and fun the Tel Aviv boardwalk to is a great place for kids to walk, run or ride along on a bike or a mini scooter, and there are plenty of playgrounds and cafes.
              		</p>
              		<p>
			For a fun day outdoors, take a picnic basket to the lovely Yarkon Park and enjoy bike riding, boating or running around. Tel Aviv also offers a multitude of hands-on museums and exhibitions, free performances, especially in the gorgeous Tel Aviv port area and outdoor entertainment guaranteed to keep visitors of all ages entertained.
              		</p>
              		<p>
			A visit to Jerusalem will ignite the imaginations of your little ones with its quaint alleyways, unique museums and fascinating history. with shady parks, water fountains and children-oriented exhibits and shows, there’s definitely something for every age.
              		</p>
              		<p>
			An incredible variety of food will keep all the kids, and adults, of your group happy. From outdoor food stalls to sit-down restaurants there is no shortage of places to eat and most restaurants and cafés offer children’s’ meals at considerably reduced rates. 
              		</p>
              		<p>
			Your visit to Tel Aviv or Jerusalem with the young ones is guaranteed to be fun and rewarding.
			Here are just a few of the fabulous ways you can have a great family time in Jerusalem and Tel Aviv, all you and yours need to do is choose and go go go: 
              		</p>
		<div class="img-wrapper">
			<img src=${getImgUrl() + "/thingsToDo/posts/35/1.jpg"} class="img-responsive" />
		</div>
              		<h3>
              			Tel Aviv
              		</h3>
              		<p>
			<strong>"Luna Park":</strong> A fantastic amusement park in the heart of the city offering a range of fun and exciting rides and attractions for the entire family. Right across from the beautiful Hayarkon Park, the green lung of Tel Aviv.
              		</p>
              		<p>
			<strong>HaYarkon Park:</strong> The tranquil Yarkon Park on the outskirts of the busy city offers beautiful green expanses, boating on the river, cycling along the bike paths, sports fields, and much more for the whole family. Enjoy a picnic with a view of the stunning Tel Aviv Skyline.
              		</p>
              		<p>
			<strong>Hot Air Balloon:</strong> After relaxing in gorgeous HaYarkon Park, get high with a view of gorgeous Tel Aviv like you’ve never seen it before, float above the Yarkon Park in an experience that is suitable for romantic trips or family fun.
              		</p>
              		<p>
			<strong>The Observatory:</strong> While in Azrieli, be sure to check out the amazing top floor observatory located on the top floor for an 360 view of Tel Aviv the little ones will not soon forget.  
              		</p>
              		<p>
			<strong>The Planetarium:</strong> Offering a fun introduction to astronomy, you’ll be transported into space by interactive exhibits, revolving seats and informative presentations to suit the whole family.
              		</p>
              		<p>
			<strong>Safari:</strong> With the largest collection of animals in the Middle East, you can spend a wonderful day in the wild, just 15 minutes from the heart of Tel Aviv, where you can check out the rest of the city’s stunning attractions.
              		</p>
              		<p>
			<strong>HaTachana:</strong> Tel Aviv’s Old Railway Station: A delight for the whole family, the Old Train Station complex offers something for everyone with restaurants, kids activities, art galleries, street performances, and even a train carriage ride.
              		</p>
              		<p>
			<strong>Tel Aviv Port:</strong> Breath in the sea air and vies from the gorgeous marina, get some food in any of the  and check out the awesome street performances of music, magic theatre and more geared specifically for the joy of the little ones. 
              		</p>
              		<p>
			<strong>Nachlat Binyamin Street Fair:</strong> The biggest of its kind in Israel, the fair is a bright and bustling experience of crafts, live music, street performances, and cafes that will appeal to people of all ages.
              		</p>
              		<p>
			<strong>Sarona:</strong> A trendy hub of restaurants, cafes, and bars, the covered market is a popular destination for couples, groups and families looking for one of the most happening places in the city.
              		</p>
              		<h3>
              			Tel Aviv Museums
              		</h3>
              		<p>
			<strong>Tel Aviv Museum of Art:</strong> With a large number of collections, guides, creative and interactive activities, and games, the museum is a treasure for parents and children alike.
              		</p>
              		<p>
			<strong>The Museum of Natural History:</strong> Opened in 2018, the 5-floor museum with its 3,000 items, gives children the possibility to see the country’s creatures right up close.
              		</p>
              		<p>
			<strong>The Olympic Experience Museum:</strong> Available via guided tours, offering an interactive glimpse into the history of sport in Israel through multimedia exhibits that are fun for the whole family.
			Independence Hall- the birthplace of the State of Israel and the birthplace of the first Hebrew speaking city, Tel Aviv. A fascinating journey through history for the entire family. 
              		</p>
		<div class="img-wrapper">
			<img src=${getImgUrl() + "/thingsToDo/posts/35/2.jpg"} class="img-responsive" />
		</div>
              		<h3>
              			Jerusalem 
              		</h3>
              		<p>
              			<strong>City of David:</strong> An immersive archeological experience in the heart of Ancient Jerusalem including archeological digs, guided tours and a walk through an underground water tunnel.
              		</p>
              		<p>
			<strong>Night Spectacular Sound & Light Show:</strong> A stunning first of its kind show where the walls of the Citadel become the stage for a nighttime show celebrating Jerusalem’s 4,000-year-old history through sights and sounds.
              		</p>
              		<p>
			<strong>The Aquarium:</strong> One of the hottest attractions in Jerusalem, opened at the end of 2017, it offers a captivating adventure through the four seas of Israel that will thrill everyone, from young to old.
              		</p>
              		<p>
			<strong>The Time Elevator:</strong> Immerse yourself in virtual reality on a journey through the fascinating history of Jerusalem, with shaking seats and special effects that will amaze the youngsters among you.
              		</p>
              		<p>
			<strong>The Botanical Gardens:</strong> A stunning gem in the heart of the city featuring more than 6,000 species of plants from around the world, it is an interesting and tranquil location for anyone to enjoy.
              		</p>
              		<p>
			<strong>Segway Tours:</strong> Suitable for older teens to adults, Segway tours offer an unforgettable experience through fascinating areas, allowing you to enjoy the modern to the ancient character of the city.
              		</p>
              		<p>
			<strong>Mini Israel:</strong> Offering hundreds of mini replicas of Israeli landmarks, it offers a unique birds-eye view of historical, religious, and modern sites around the country.
              		</p>
              		<h3>
              			Jerusalem Museums
              		</h3>
              		<p>
              			<strong>Israel Museum:</strong> A leading art and archeological museum absorbing you in the rich history and culture of the country and its people, with exhibits to interest visitors of all ages.
              		</p>
              		<p>
			<strong>The Tower of David Museum:</strong> The historic entrance to the Old City of Jerusalem, the medieval citadel features 3D models, hidden passageways, and family tours and activities.
              		</p>
              		<p>
			<strong>Ein Yael Active Museum:</strong> Providing an experiential journey through an old Roman street, creative workshops, pita baking, and one-on-one meetings with period actors, families will love this day out.
              		</p>
              		<p>
			<strong>The Bloomfield Science Museum:</strong> A fantastic children oriented cultural and educational museum, that presents exhibitions and interactive exhibits on subjects of science and Technology. 
              		</p>

            	`,
      };
    },
  },

  // {
  // 	ctg :"telaviv",
  // 	isVid:true,
  // 	vidId:"ogEN7aRT0SM",
  // 	id:"Party_Capital",
  //               bgImage: "/posts/bank/party-capital/1.jpg",
  //               mobBgImage: "/posts/bank/party-capital/M.jpg",
  //               title :"Party Capital",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 						<div class="ac-cradit">
  // 							<span class="ac-cradit-text">Credits:</span>
  // 								<br/>
  // 								<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
  // 								<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
  // 							</div>
  // 							<p></p>
  // 						</div>

  //                             <h3>Epic Nights in the non stop city</h3>
  //               		        <p>Tel Aviv is rightly famous as one of the world’s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that’s pulsing with life.</p>

  //                             <h3>Tel Aviv by Night</h3>
  //                             <p>No matter what time it is, there’s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv’s pumping, pulsing clubs to dance the night away.</p>

  //                             <p>Foodies will love the amazing cocktails mixed by Tel Aviv’s expert baristas, Israel’s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>
  //                             <div class="img-wrapper">
  // 			                    <img src=${getImgUrl() +  "/posts/party-capital/1.jpg"} class="img-responsive" />
  // 		                    </div>
  //                             <h3>Making the Most of Tel Aviv’s Nightlife</h3>
  //                             <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you’ll be introduced to some of Israel’s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv’s new and exciting gallery bars that display pieces by up and coming artists.</p>

  //                             <p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv’s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn’t reach full swing until 2am in most of Tel Aviv’s wildly popular nightclubs, manned by top DJs. You’ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>

  //                             <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you’ll find countless places to hang out at every hour of the day and night.</p>
  //                             <p>Tel Aviv’s awesome nightlife scene has become famous worldwide. The city the doesn’t stop is teaming up with endless possibilities designed for an epic night out! </p>
  //                             <p>Start slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.</p>
  //                             <p>Now that you’re in a mellow mood, it’s time to get your groove on. you’ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv’s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long. </p>
  //                             <div class="img-wrapper">
  // 			                    <img src=${getImgUrl() +  "/posts/party-capital/2.jpg"} class="img-responsive" />
  // 		                    </div>
  //                             <p>A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.</p>
  //                             <p>Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.</p>
  //                             <p>Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv! </p>

  //             	`   }
  //   }
  // },

  {
    ctg: "jerusalem",
    isVid: false,
    id: "Mamilla_Avenue",
    bgImage: "/posts/bank/mamila-avenue/1.jpg",
    mobBgImage: "/posts/bank/mamila-avenue/M.jpg",
    title: "جادة ماميلا",
    smltitle: "",
    isVid: true,
    vidId: "V0Acsw3Hf_M",
    html: function() {
      return {
        __html: `
                                <p>في الحيز الواقع ما بين أورشليم القدس القديمة وأورشليم القدس الجديدة، ومقابل الإطلالة الحابسة للأنفاس لسور البلدة القديمة وعلى بُعد بضع خطوات فقط عن باب الخليل وحائط المبكى، ستجدون جادة ألروي ماميلا. حيث حقق مجمع الشارع التجاري المعاصر في الهواء الطلق رواجًا كبيرًا لدى السكان المحليين والسياح على حد سواء بفضل قربه من البلدة ونظرًا لحقيقة أنه يمزج بين أفضل ما تتيحه كل العوالم بمعنى التاريخ الغني، والثقافة المحلية، وتجربة البيع بالتجزئة الراقية في موقع مميز على المستوى العالمي.</p>
                                <h3>اكتشف مجمع الترفيه العصري على أجناب البلدة القديمة المقدسية</h3>

                                <p>امشِ عبر شوارع أورشليم القدس المعبدة بالحجر وابحث عن اللوحات التي تروي قصص البنى التاريخية للمنطقة. واستمتع بعروض مسرح الشارع، واجلس في واحد (أو أكثر) من المطاعم والمقاهي لتستمتع بمزيج عالي الجودة من محلات المصممين للعلامات التجارية المحلية والرائدة عالميًا.</p>

                                <p>أما مساءً، فحلّ ضيفًا على أحد البارات الموجودة في المنطقة، وارفع رأسك لتشاهد الإطلالة المدهشة للبلدة القديمة أمامك. لا مثيل لهذا المكان حول العالم.</p>
                                <div class="img-wrapper">
			                         <img src=${getImgUrl() +
                                 "/posts/mamila-avenue/1.jpg"} class="img-responsive" />
		                         </div>

							     <h3>قم بزيارة إلى الشوارع التي تجسر بين أورشليم القدس القديمة والجديدة</h3>

                                <p>جادة ماميلا هي عبارة عن مجمع ترفيه معاصر يتيح لزواره تذوق نكهة الثقافة المقدسية الغنية، والأصيلة والتي دائمًا ما تبتكر الأشياء الجديدة.</p>

                                <p>لتجربة كل ما تقدمه جادة ماميلا على أكمل وجه، فإن أفضل الأوقات لإطلاق زيارة إليها هو عندما تكون حالة الطقس دافئة. إذ يتجول آلاف الأشخاص عبر الجادة كل ليلة خلال موسم الصيف ويستمتعون بتشكيلة واسعة من الفعاليات الثقافية. انضم إليهم لتمتع نفسك بفنون الشارع، والمعارض المفتوحة، ومسرح الشارع، وعروض البهلوانات وقارعي الطبول فضلاً عن العروض الموسيقية اليومية. مع كل هذا الكم الهائل من الفعاليات التي يمكن مشاهدتها وممارستها، لن تريد المغادرة أبدًا.</p>
            	
            	`,
      };
    },
  },

  // {
  // 	ctg :"jerusalem",
  // 	isVid:true,
  // 	vidId:"FvAWuLQEOJw",
  // 	id:"First_Time_In_Jerusalem",
  //               bgImage: "/posts/bank/first-time-in-jerusalem/1.jpg",
  //               mobBgImage: "/posts/bank/first-time-in-jerusalem/M.jpg",
  //               title :"FIRST TIME IN JERUSALEM",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<h3>The must list for the first-time visitor</h3>

  //               		<p>
  // 						Scour the globe it’s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it’s difficult to know where to begin. Here are a few suggestions…
  //               		</p>
  // 					<p>
  // 						Jerusalem is the nexus of three of the world’s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.
  // 					</p>
  // 					<p>
  // 						Almost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters – Jewish, Christian, Muslim, and Armenian – and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/first-time-in-jerusalem/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.
  // 					</p>
  // 					<p>
  // 						Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.
  // 					</p>
  // 					<p>
  // 						Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!
  // 					</p>
  //             	`   }
  //             }
  // },

  // {
  // 	ctg :"telaviv",
  // 	isVid:false,
  // 	id:44,
  //               bgImage: "/posts/bank/travelling-on-budget/1.jpg",
  //               mobBgImage: "/posts/bank/travelling-on-budget/M.jpg",
  //               title :"TRAVELLING ON A BUDGET",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				    <h3>Making It Count in Tel Aviv and Jerusalem!</h3>

  //               		<p>
  // 						So you’ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.
  //               		</p>
  // 					<p>
  // 						For affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes’ walk from Tel Aviv’s Beaches and Jerusalem’s main attractions.
  // 					</p>
  // 					<p>
  // 						Getting around? In both cities it’s a snap with a Rav Kav card. Purchase one for little more than a dollar at”Al Hakav” (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.
  // 					</p>
  // 					<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/80/1.jpg"} class="img-responsive" />
  // 					</div>
  // 					<p>
  // 						What to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.
  // 					</p>
  // 					<p>
  // 						Finally, everyone’s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.
  // 					</p>
  // 					<p>
  // 						So come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.
  // 					</p>
  //             	`
  //             }
  //   }
  // },

  {
    ctg: "jerusalem",
    isVid: false,
    id: 45,
    bgImage: "/posts/bank/upscale-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/upscale-jerusalem/M.jpg",
    title: "أورشليم القدس الراقية",
    smltitle: "",
    html: function() {
      return {
        __html: `
                   
					<h3>الكماليات المعاصرة للمسافر المدلل</h3>
					<p>عندما يدور الحديث عن السفر الفاخر، والفنادق من الدرجة الأولى، والطعام المميز، وخيارات التسوق لمألوفات الرسامين المرموقين فإن أورشليم القدس مدينة تستحق زيارتها حقًا.</p>
					<p>حيث أن المدية تقدم فنادق 5 نجوم وبوتيك جاهزة لتلبية احتياجاتك في الراحة والاسترخاء، كما أنها تقدم الإطلالات على مناظر خلابة وعلاجات السبا الداخلي للرفس.</p>
				    <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/81/1.jpg"} class="img-responsive" />
					</div>
					<p>هل تبحث عن المأكولات اللذيذة؟ في عام <span class="ac-en-font">2018</span> تم إدراج عدة مطاعم مقدسية ضمن دليل المطاعم الفخمة الفرنسي، <span class="ac-en-font">Gault & Millau</span>. وما عدا ذلك فإن المدينة تقدم بل تجذب المزيد من أفضل طهاة العالم.</p>
					<p>عندما يدور الحديث عن الأسلوب الأنيق، والأزياء والتسوق الفاخر، فإن أورشليم القدس تتيح زيارة عدة أماكن مناسبة لاحتياجاتك تمامًا، ومن بينها جادة أرلوف ماميلا التي هي عبارة عن مجمع يضم مراكز التسوق المعاصرة والمطابقة للموضة في الهواء الطلق والذي لا بد لك من زيارته خلال مكوثك في المدينة. وزيادةً على ذلك، إنه لا يبعد سوى عدة خطوات عن باب الخليل في البلدة القديمة.</p>
					<p>ومن بين المواقع الذي لا يجوز تفويتها خلال مسار رحلتك هناك المحطة الأولى. حيث تم جعل هذا المكان الذي شكل على مدار أكثر من 100 عام مستودع سكة حديد بؤرة التسوق الحضري والطبخ التي تعج بالمطاعم، والمحلات التجارية، والمعارض الفنية وسوق فنانين ينشط على مدار ثلاث أيام كل أسبوع، فضلاً عن العروض الحية والمزيد غيرها.</p>
					<p>وطالما تواجدت في المدينة، دلّل نفسك بوجبة غداء أو عشاء رومانسية في شارع عيمك ريفائيم، وهو الشارع الرئيسي في الحي الألماني. حيث يتيح تصميمه المعياري الرجعي الملغز، ومحلات البوتيك فيه من الطراز الأنيق، ومطاعمه الأليفة، ودار السينما فيه الذي يعود إنشاؤه لعام 1920 التدليل المطلق لكافة الحواس.</p>

            	
            	     `,
      };
    },
  },

  // End Posts

  {
    id: 5,

    ctg: "deadsea",
    isVid: false,
    bgImage: "posts/bank/100/1.jpg",
    mobBgImage: "posts/bank/100/M.jpg",
    title: "Dead Sea Joys",
    smlTitle: "",
    html: function() {
      return {
        __html: `
					<h3>For a floating good time</h3>

			              <p>
			                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. 
			                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. 
			                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, 
			                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. 
			                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			              </p>

			              <p>
			                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
			              </p>
			              
			`,
      };
    },
  },

  // {
  // 	id:"Ultimate_Beach_Fun",
  //                bgImage : "/posts/bank/telaviv6/1.jpg",
  //         	mobBgImage : "/posts/bank/telaviv6/M.jpg",
  //               title : "ULTIMATE BEACH FUN",
  //               ctg:"telaviv",
  //               isVid:false,
  //             //   vidId:"I9a4BFWO_6w",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //             		<p>Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.</p>

  //         		 	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />

  // 					</div>

  //             		<p>Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!</p>

  //             	 `
  //     }
  //   }
  // },

  // Hadar asked to hide this post on 2021-02-08
  // {
  // 	id:"Purchases_In_Israel",
  //                bgImage : "/posts/bank/purches-in-israel/1.jpg",
  //         	mobBgImage : "/posts/bank/purches-in-israel/M.jpg",
  //               title : "UNIQUE PURCHASES IN ISRAEL",
  //               ctg:"jerusalem",
  //               isVid:false,
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //             		             <p>Shopping in Israel is more than acquiring things; it becomes the best way to think about your loved ones and friends at home, because you’ll be bringing them (and yourself) a bag, bottle, or box symbolizing the wonders you experienced. As you amble through markets, shops and galleries, you’ll see the incredible variety of products means you’ll find something for everyone and have fun while you’re doing it.</p>
  //                                 <div class="img-wrapper">
  // 						               <img src=${getImgUrl() +  "/posts/purches-in-israel/1.jpg"} class="img-responsive" />

  // 					               </div>
  //                                  <h3>Beautiful Middle Eastern souvenirs</h3>

  //                                  <p>Some of the most meaningful mementos are waiting for you at Israel’s holy places in Galilee and Jerusalem. Eye-catching blue and white Armenian pottery items adorned with familiar themes from the holy places are popular as keepsakes, and useful as serving dishes. Olive wood and mother-of-pearl,  crafts that are centuries old, now adorn Bibles, boxes, broaches and many other items that will keep your visit fresh in your mind and heart.</p>

  //                                  <h3>Unique Judaica</h3>

  //                                  <p>And what better way to remember Safed, Jerusalem, Jaffa or other Judaica centers than to adorn a Sabbath and holiday table at home with a hand-embroidered Challah- or matzah-cover (lightweight and easy to pack!) or candlesticks, a Kiddush cup or Chanukkah menorah in contemporary or traditional silver, pewter, glass or pottery. Mezuzahs are the perfect housewarming present, and a prayer shawl is a life-long Bar/Bat Mitzvah keepsake.</p>

  //                                  <h3>Dead Sea mineral products</h3>

  //                                  <p>Israel is home to the word’s largest open-air spa – the Dead Sea – and after bathing in its mineral-rich water, your skin and hair feel silky-smooth. And yes, they do bottle it! You can buy a whole range of Dead Sea mineral products, all beautifully packaged, for the perfect present from Israel.</p>

  //                                  <h3>Shopping</h3>

  //                                  <p>You’ll certainly want to browse the factory-outlet racks or boutiques of Israel’s world-famous clothes designers while you’re here. Cute 100% cotton Israeli-made baby clothes are also easy to tuck into your burgeoning suitcase and make a great shower gift. Did you walk your feet off in Israel? Before your trip ends, pick up a pair of walk-on-air sandals or shoes made in Israel, at prices that can’t be beat at home.</p>

  //                                  <h3>Jewelry</h3>

  //                                  <p>Israeli jewelry designers star in fine stores everywhere and when you buy in Israel you’re at the source. Particularly alluring are trendy bangles with their mutli-colored crystals and beads in seemingly endless patterns, as well creations in fine green-blue malachite (Eilat stone), which that everyone will know you’ve been to Israel when you wear.</p>

  //                                  <p>Israel has long been famous for its cut and polished diamonds, and the experience, knowledge and skill of its diamond experts. And as a diamond-exporting country, purchases in Israel often enjoy a price advantage. You can also tour a diamond cutting and polishing facility to learn all about the industry.</p>

  //                                  <h3>Don 't forget the food</h3>

  //                                  <p>In a country famous for cuisine from the four corners of the earth packaged food products are great to take home. There are spices like the biblical hyssop for your favorite chef, and sweet dates handsomely packaged for passing around at your office or book club, and a variety of herbal teas, honey, prize-winning wines and other products.</p>

  //                                  <p>And when you and your gifts get to the airport, you’ll love the special incentive of a Value Added Tax rebate in purchases over $100 from participating stores.</p>

  //             	 `
  //     }
  //   }
  // },
  // end Hadar asked to hide this post on 2021-02-08

  {
    id: "Jerusalem_Fun",
    bgImage: "/posts/bank/jerusalem-fun/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-fun/M.jpg",
    title: "متعة القدس",
    ctg: "jerusalem",
    isVid: false,
    // vidId: "FvAWuLQEOJw",
    smltitle: "",
    html: function() {
      return {
        __html: `
              
                                
          						<p>غالبا ما يشمل التخطيط لرحلة إلى القدس على العديد من المعالم الثقافية المهمة تاريخيا. ومع ذلك، وعلى ذات القدر من الأهمية بالنسبة للكثيرين، فإن القدس في الليل تتمتع بمناظر رائعة، مليئة بالموسيقى،  ونوادي الرقص، وأكثر من ذلك بكثير.</p>
          						<p>للتحقق من الأمر، توجهوا إلى وسط المدينة واستكشفوا الشوارع الضيقة المقابلة لشارع يافا. هنالك ستجدون الحانات والنوادي الليلية التي تتراوح تصنيفاتها من السائد المريح إلى غير التقليدية والغرائبية. يعد شارع ريفلين مكانا شهيرا يستريح به الشباب، في حين أن شارع شوشان والمنطقة المحيطة به توفر أجواء أكثر انطواء على الاسترخاء.</p>
          						<div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/jerusalem-fun/1.jpg"} class="img-responsive" />
								</div>
          						<p>تنطوي الزيارة الليلية لسوق "محانيه يهودا" على تجربة رائعة بكل المقاييس، حيث يتحول السوق في المساء إلى نقطة ساخنة عصرية حيث تتحول أكشاك البائعين والمتاجر إلى حانات والدي جيه والموسيقى الحية والرقص.</p>
          						<p>يشتهر شارع بتصلئيل بأجوائه الفنية الطلابية، وتعد العديد من الحانات الصغيرة المنتشرة فيه مكانا ممتازا لمصادقة السكان المحليين الذين يأتون لتناول المشروب وسماع الموسيقى المرتجلة.</p>
          						<div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/jerusalem-fun/2.jpg"} class="img-responsive" />
								</div>
          						<p>لتغيير رتم الحركة خلال ساعات النهار، توجهوا إلى الحي الألماني (الموشافاة)، ولا سيما حي "باكا". ابدؤوا من شارع بيت لحم حيث سيكون أمامكم العديد من المطاعم والبارات الشعبية والمعاصرة لتختاروا أحدها. ثم تجولوا على طول الطريق حتى شارع "عيمق رفائيم" أو عبر حديقة "همسيلاة" (السكة الحديدية) حتى تصلوا إلى المحطة الأولى التي كانت في ذات يوم مستودعا تابعا لهيئة السكك الحديدية، تم استخدامه لأكثر من قرن، حيث تحولت المحطة في أيامنا هذا إلى مكان عصري للتمتع بعالم الطهي والثقافة، والتسوق.</p>

                                
            	`,
      };
    },
  },

  {
    id: "Western_Wall_Wonders",
    bgImage: "/posts/bank/jerusalem2/1.jpg",
    mobBgImage: "/posts/bank/jerusalem2/M.jpg",
    title: "عجائب حائط المبكى",
    ctg: "jerusalem",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
              

				<p>
					شكل حائط المبكى (أو "كوتيل" كما يسمى باللغة العبرية) جزءًا من أهم مبنى شهدته مدينة أورشليم القدس، ألا هو الهيكل الثاني، الذي تم  إنشاؤه من قبل الملك هيرودس.
				</p>

				<p>
					تم تدمير الهيكل الثاني في العام 70 ميلادي ورغم ما حلّ به من دمار إلا أن كافة حيطان الهيكل الداعمة الأربعة صمدت. على مر الأجيال منذ خراب الهيكل، كان حائط المبكى الأثر المتبقي الأقرب من موقع "أقدس أماكن الهيكل" وهو المكان الذي لم يُسمح بدخوله سوى لكبار الكهنة، باعتباره المكان حيث استقرت السكينة حسب العقيدة اليهودية. يمكن اكتشاف البقايا الحقيقية من الهيكل من خلال قنوات حائط المبكى، التي تتيح إطلاق رحلة استثنائية عبر الوقت.
				</p>
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/27/1.jpg"} class="img-responsive" />
				</div>

				<p>
				على مر قرون مضت كان أبناء الشعب اليهودي من كل أنحاء العالم يتوجهون إلى هناك حدادًا على فقدان هذا الهيكل الكبير. ربما ستجدون هناك آلاف الأشخاص من حملة الجنسيات المتنوعة والمؤمنين من أبناء الديانات المختلفة وهم يصلّون من صميم قلبهم بما أن الحائط يحظى بأهمية روحية هائلة بالنسبة لهم.
				</p>

				<p>
				وقد أصبحت كتابة ورقة ثم وضعها بين شقوق حائط المبكى أمرًا تقليديًا بالنسبة للأشخاص الذين يرتادونه، ويُعتقد بأن الرسالة يتم توصيلها إلى الله عز وجل. ستجدون أكثر من مرة الحمامات وهي تستريح في صدوع هذا المبنى الباهر، حيث أنها ترمز للسلام.
				</p>

				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/27/2.jpg"} class="img-responsive" />
				</div>

				<p>
					يُعتبر حائط المبكى رمزًا وطنيًا علمًا بأن طوبه القديمة شهدت ولادة نشأة إسرائيل والشعب يهودي، ثم الخروج للمنفى ثم النهضة. كما أنه يُعدّ موقعًا رائجًا جدًا لإقامة المراسم الوطنية وحفلات بار ميتسفا.
				</p>
				<p>
					أعرف المزيد: <a  target="_blank" href="//www.thekotel.org/en/">www.thekotel.org</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: "White_City_Splendor",
    bgImage: "/posts/bank/white-city-splendor/1.jpg",
    mobBgImage: "/posts/bank/white-city-splendor/M.jpg",
    title: "المذهلة  المدينة البيضاء",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
              
				

				<p>
					"المدينة البيضاء" في تل ابيب، هي واحدة من المواقع التي أعلنت عنها منظمة اليونسكو موقعا من مواقع التراث العالمي، وذلك لأن المدينة تضمّ مبانٍ على طراز "باوهاوس"، إلى جانب العمائر المبنيّة على الطراز الحديث، أكثر مما تضم أية مدينة أخرى على وجه الأرض.
				</p>

				
				
             	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/28/1.jpg"} class="img-responsive" />
				</div>

				<p>
					تأسست تل أبيب سنة 1909 ضاحيةً غنّاء لصيقة بمدينة يافا ذات المرفأ المهم، وسرعان ما نمى الحيّ ليصبح مدينة تعدّ عاصمة للصخب. بحلول العام 1929 اصبحت تل أبيب المزدهرة مثالا أعلى للحلم الصهيوني. ومع صعود هتلر إلى رأس السلطة في العام 1933، فرّ العشرات من المهندسين اليهود الألمان إلى فلسطين، حيث كان العديد منهم طلابا في مدرسة "باوهاوس" الأسطورية في التصميم المعماري، أو خرّيجين من هذه المدرسة. وحين تطلّب ازدهار تل أبيب توسّعا معماريا، تسارع المهندسون المعماريون إلى ملاءمة نمط باوهاوس الأوروبي ليناسب احتياجات منطقة شرق المتوسط التي تتسم بالحرارة. 
				    إن تجوالك في وسط تل أبيب سيضعك وجها لوجه في مقابلة عشرات المباني المذهلة من هذا الطراز، التي تتنوع استخداماتها ما بين المباني السكنية، المكاتب، والمتاجر.
				</p>

				<p>
					<a  target="_blank" href="//www.bauhaus-center.com/">www.bauhaus-center.com/</a>
				</p>
                
            	 `,
      };
    },
  },

  {
    id: "Tower_Of_David_Museum",
    bgImage: "/posts/bank/30/1.jpg",
    mobBgImage: "/posts/bank/30/M.jpg",
    title: "متحف برج داوود",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
				<p>تعتبر قلعة القدس، المعروفة باسم "برج داوود"، واحدة من المراجع التاريخية والأثرية ذات الأهمية الدولية. هذا البرج هو عبارة عن حصن مبني في القرون الوسطى، ويقع بالقرب من باب الخليل، المدخل التاريخي للمدينة القديمة، والذي كان رمزا لمدينة القدس منذ أجيال خلت.</p>
 				<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/1.jpg"} class="img-responsive" />
				</div>
				<p>في متحف برج داوود ستجدون أنفسكم قبالة قصة مذهلة عن القدس. وأثناء انغماسكم في أساطير الماضي والسجلات الدرامية التي توثقها، فإنكم سرعان ما تدركون أن أحجار المتحف نفسها هي جزء من التاريخ الحي لهذه المدينة.</p>
				
				 <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/2.jpg"} class="img-responsive" />
				</div>
				<p>هذه الجدران التي يبلغ عمرها 500 عاما هي جزء من القلعة التركية. وقد اشتق اسمها من برج بلغ من الضخامة حد أن سكان القدس الأوائل قد نسبوه إلى ملكهم العظيم، النبي داوود، وعلى الرغم من الاسم، فإن من بنى البرج هو الملك هيرودس.</p>
				 <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/3.jpg"} class="img-responsive" />
				</div>
				<p>يمكنكم أن تبدأوا زيارتكم للمتحف بالإطلالة الخلابة على مدينة القدس بشقيها القديم والجديد من أعلى البرج. لقد تم تجديد كل غرفة قديمة لكي تعرض فترة مختلفة من التاريخ، مما يسمح للأحداث العاصفة التي استغرقت 400 عام أن تقع في موضعها تماما في أذهانكم.</p>
				 <div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
				</div>
				<p>من إطارات النوافذ في القلعة ستلمحون القدس الحديثة، وفي كل مدخل تعبرونه، ستنظرون إلى الأسفل حيث الساحة الرئيسية للحصن، حيث اكتشف علماء الآثار بقايا تعود إلى عهد المكابيين في العصور الوسطى. يعدّ هذا الموقع المذهل، فعلا، متاهة زمنية!</p>
				<p>يستخدم هذا المتحف مساحته الفريدة للمعارض التي تخاطب الحواس المتعددة، لكبار المصممين والفنانين من إسرائيل وخارجها. كما يستضيف هذا المتحف الفريد من نوعه عرض الأضواء الليلي السنوي المذهل، العرض الصوتي والضوئي الفريد، حيث تضاء القلعة بأكملها بتصميمات تحبس الأنفاس!</p>
				<p>لمزيد من المعلومات:<a href="//www.tod.org.il/en/"  target="_blank" rel="noopener">www.tod.org.il/en</a></p>

                
            	 `,
      };
    },
  },

  // {
  // 	id:"Must_Eat_In_Jerusalem",
  //               bgImage : "/posts/bank/must-in-jerusalem/1.jpg",
  //               mobBgImage : "/posts/bank/must-in-jerusalem/M.jpg",
  //               title : "MESMERIZING AND MAGICAL CITY",
  //               ctg:"jerusalem",
  //               isVid:true,
  //               vidId: "2CSCe2WC7Ns",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //                                 <p>
  // 						            Jerusalem is a mesmerizing and magical city. Many people who visit Jerusalem rave about the amazing atmosphere, the unforgettable sites, the breathtaking views and more. However, to truly understand what Jerusalem is all about, there are some things that you simply have to experience through your stomach. Here are just a few of the things you really should try while visiting Jerusalem:
  // 						        </p>
  //                                <div class="img-wrapper">
  // 						                 <img src=${getImgUrl() +  "/posts/must-in-jerusalem/1.jpg"} class="img-responsive" />
  // 				                 </div>

  // 							    <p><strong>Malabi:</strong> A unique a combination of beverage and dessert, made of a mixture of rosewater, milk, cornstarch and sugar. Malabi is a very popular Jerusalem dish, sold in many middle eastern restaurants and kiosks throughout the city. Guaranteed to be nothing like anything you have ever tasted.</p>

  //                                 <p><strong>Knafe:</strong> A very interesting and sensationally tasty dish when served and eaten fresh. Knafe is essentially an Arabic desert made of melted goats cheese and topped with hairs of orange pastry hairs, dipped in sweet rosewater syrup. Finding the perfect Knafe is a mission, once you find it, eating it becomes an addiction.</p>

  //                                 <p><strong>Jerusalem Pretzel:</strong> An absolute must when touring the fascinating sites of the old city is stopping by one of the small green carts and purchasing an authentic Jerusalem pretzel. Along with it, you will get a fragrant local green herb called Zaatar which goes great with the delicious warm doe.</p>

  //                                 <p><strong>“Meorav Yerushalmi”:</strong> Directly translates to “Mixed Jerusalem” this delicious mix of different meats in a special local blend of spices is an absolute carnivores’ heaven.</p>

  //                                 <p><strong>“Ashtanur”:</strong> Short in Hebrew for “fire in the oven” Ashtanur is an authentic local pitta bread which you can find in midtown or the markets during lunchtime. If you’re especially hungry, try it wrapped around a portion of shawarma or falafel.</p>

  //                                 <p><strong>Sabich:</strong> an absolute original, the Sabich is a truly unique local dish comprised of a Pitta bread packed with fried eggplant, hard-boiled eggs, and pickles, usually topped by Amba, a local, flavorful condiment. Once you try it, you’ll be hooked for life.</p>

  //             	 `
  //     }
  //   }
  // },

  {
    id: "Jerusalem_Arts",
    bgImage: "/posts/bank/jerusalem-art/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-art/M.jpg",
    title: "فنون القدس",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                               <!--<h3>القدس مهبط الإلهام الفنّي أيضا</h3>
				<p>ما من شك في أن القدس تعدّ واحدة من أروع مدن العالم. فخليط الأديان المتنوعة والتقاليد الثابتة والتاريخ الزاخر، والحياة المدينية الحديثة الكامنة فيها تجتذب اهتمام الزوار منذ عدة قرون، وهذا بالضبط ما يجذب الفنانين أيضا إلى هناك. تمتلئ القدس اليوم بالمتاحف والمعارض والأسواق والمهرجانات الثقافية التي تشكل مشهدا مقدسيا فنيا وثقافيا حيويا وفريدا. استعدوا أثناء زيارتكم للمدينة لتتلقوا الإلهام هناك.</p>
				<p>على تلة تقع بجوار الكنيست، والمحكمة العليا في إسرائيل، تقع أكبر مؤسسة ثقافية في البلاد، وواحد من المتاحف الرائدة عالميا في مجالي الفن والآثار: اكتشفوا متحف إسرائيل! ابدأوا زيارتكم بالجناح الأثري الذي تشكل القطع الأثرية الموجودة فيه، والمرتبة ترتيبا زمنيا، المجموعة الأكثر شمولا في العالم لعلم الآثار التوراتي وعلم آثار الأراضي المقدسة. تابعوا السير إلى جناح الفن والحياة اليهوديين المتميّزين، ومجموعة الفنون الجميلة الرائعة، والمعارض الدورية للفن المعاصر. لا تفوتوا زيارة المعالم الأكثر بروزا في المتحف: ضريح الكتاب الذي يحتوي مخطوطات البحر الميت، وحديقة الفن المذهلة المطلة على جبال القدس. ننصحكم بأن تمنحوا أنفسكم وقتا. إنه متحف رائع يسهل الوصول إليه، وهنالك الكثير لتروه هناك.</p>
				
				 
				<h3>الصورة لنوعام حِن</h3>
				<p>على مقربة من متحف إسرائيل، ستجدون متحف أراضي الكتاب المقدس الرائع. يوصف هذا المتحف أنه "كبسولة زمنية تفاعلية"، وهو متحف فريد من نوعه عالميا. تجولوا في صالات العرض واكتشفوا عجائب حياة الثقافات القديمة في الشرق الأدنى، وعلاقاتها المتبادلة منذ فجر الحضارة وحتى العصر المسيحي المبكّر.</p>
				<p>اذهبوا إلى حارة الفنانين في القدس (حوتسوت هيوتسير)، وخوضوا تجربة الإبداع. هذا المجمع المخصص للفنون والحرف هو مكان عمل الفنانين والمصممين من مختلف المجالات. تجولوا في هذا الشارع الخلّاب الذي يعج بالمحلات التجارية والمعارض أسفل الجدران الشمالية لمدينة القدس القديمة، وشاهدوا الفنانين أثناء عملهم. استمعوا إلى القصص وتعرفوا على تقنيات الفن التقليدي والمعاصر، واشتروا الأعمال الفنية مباشرة من صانعيها..</p>
				<p>شاهدوا عرض الأضواء في برج داوود، المعروف باسم "ليلة القدس المذهلة". يجمع هذا العرض المثير حقا بين التكنلوجيا الحديثة وتاريخ المدينة وجمال البرج. ستشاهدون الجدران والممرات تنبض بالحياة، في عرض ضوئي ثلاثي الأبعاد وموسيقى نابضة بالحياة تجذب المشاهدين إلى تجربة تشبه الحلم تقريبا.</p>
				<p>احتفلوا. تتمتع القدس بتاريخ أثري، ولكنها أيضا بذات المقدار مدينة صاخبة وتحب الاحتفال. تأكدوا من مراجعة جدول احتفالات المدينة الثري بالمهرجانات والفعاليات الثقافية، واستمتعوا بأفضل ما تقدمه القدس على مدار العام.</p>
				<p>شاركوا أيضا باحتفالات مهرجان إسرائيل، المهرجان الدولي متعدد التخصصات في إسرائيل، والذي يقدم مجموعة كبيرة ومتنوعة تشمل العروض المسرحية المتميزة والرقص المعاصر والموسيقى الكلاسيكية والأداء الذي يقدمه فنانون من جميع أنحاء العالم. انضموا إلى معرض الفنون والحرف في القدس، في "حوتسوت هيوتسير" حيث ستلتقون بفنانين إسرائيليين وعالميين وتستمتعون بالموسيقى الرائعة؛ زوروا سوق القدس ليلا للتجول في الأكشاك العديدة التي يقيمها الفنانون والمصممون من جميع المدارس، والتي يعرضون فيها بضائعهم ويبيعونها؛ استمتعوا بمهرجان الأضواء في القدس الذي يوفر بعدا دراميا وفنيا فريدا للمدينة القديمة من خلال استخدام الضوء؛ استمعوا إلى موسيقى الأوبرا في مهرجان أوبرا القدس. اجلسوا في بركة السلطان، حيث ستشاهدون عروضا رائعة أثناء استنشاقكم لهواء القدس الصيفي العليل ليلا، مع إطلالة خلّابة في الخلفية.</p>
				<p>لا تفوّتوا مهرجان القدس للموسيقى الروحية. كجزء من الموسم الثقافي في القدس، يجمع هذا المهرجان الاستثنائي فنانين متنوعين يمثلون مجموعة كبيرة من الثقافات والتقاليد، تعرض وتستكشف الموسيقى الدينية من جميع أرجاء الأرض.</p>
					-->


					<h3>القدس مهبط الإلهام الفنّي أيضا</h3>
					<p>ما من شك في أن القدس تعدّ واحدة من أروع مدن العالم. فخليط الأديان المتنوعة والتقاليد الثابتة والتاريخ الزاخر، والحياة المدينية الحديثة الكامنة فيها تجتذب اهتمام الزوار منذ عدة قرون، وهذا بالضبط ما يجذب الفنانين أيضا إلى هناك. تمتلئ القدس اليوم بالمتاحف والمعارض والأسواق والمهرجانات الثقافية التي تشكل مشهدا مقدسيا فنيا وثقافيا حيويا وفريدا. استعدوا أثناء زيارتكم للمدينة لتتلقوا الإلهام هناك.</p>
					<p>على تلة تقع بجوار الكنيست، والمحكمة العليا في إسرائيل، تقع أكبر مؤسسة ثقافية في البلاد، وواحد من المتاحف الرائدة عالميا في مجالي الفن والآثار: اكتشفوا متحف إسرائيل! ابدأوا زيارتكم بالجناح الأثري الذي تشكل القطع الأثرية الموجودة فيه، والمرتبة ترتيبا زمنيا، المجموعة الأكثر شمولا في العالم لعلم الآثار التوراتي وعلم آثار الأراضي المقدسة. تابعوا السير إلى جناح الفن والحياة اليهوديين المتميّزين، ومجموعة الفنون الجميلة الرائعة، والمعارض الدورية للفن المعاصر. لا تفوتوا زيارة المعالم الأكثر بروزا في المتحف: ضريح الكتاب الذي يحتوي مخطوطات البحر الميت، وحديقة الفن المذهلة المطلة على جبال القدس. ننصحكم بأن تمنحوا أنفسكم وقتا. إنه متحف رائع يسهل الوصول إليه، وهنالك الكثير لتروه هناك.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/jerusalem-art/1.jpg"} class="img-responsive" />
					</div>
					<small style="color:#000; display:block;">
	                    الصورة لنوعام حِن
	                </small>
					 
					<h3>الصورة لنوعام حِن</h3>
					<p>على مقربة من متحف إسرائيل، ستجدون متحف أراضي الكتاب المقدس الرائع. يوصف هذا المتحف أنه "كبسولة زمنية تفاعلية"، وهو متحف فريد من نوعه عالميا. تجولوا في صالات العرض واكتشفوا عجائب حياة الثقافات القديمة في الشرق الأدنى، وعلاقاتها المتبادلة منذ فجر الحضارة وحتى العصر المسيحي المبكّر.</p>
					<p>اذهبوا إلى حارة الفنانين في القدس (حوتسوت هيوتسير)، وخوضوا تجربة الإبداع. هذا المجمع المخصص للفنون والحرف هو مكان عمل الفنانين والمصممين من مختلف المجالات. تجولوا في هذا الشارع الخلّاب الذي يعج بالمحلات التجارية والمعارض أسفل الجدران الشمالية لمدينة القدس القديمة، وشاهدوا الفنانين أثناء عملهم. استمعوا إلى القصص وتعرفوا على تقنيات الفن التقليدي والمعاصر، واشتروا الأعمال الفنية مباشرة من صانعيها..</p>
					<p>شاهدوا عرض الأضواء في برج داوود، المعروف باسم "ليلة القدس المذهلة". يجمع هذا العرض المثير حقا بين التكنلوجيا الحديثة وتاريخ المدينة وجمال البرج. ستشاهدون الجدران والممرات تنبض بالحياة، في عرض ضوئي ثلاثي الأبعاد وموسيقى نابضة بالحياة تجذب المشاهدين إلى تجربة تشبه الحلم تقريبا.</p>
					<p>احتفلوا. تتمتع القدس بتاريخ أثري، ولكنها أيضا بذات المقدار مدينة صاخبة وتحب الاحتفال. تأكدوا من مراجعة جدول احتفالات المدينة الثري بالمهرجانات والفعاليات الثقافية، واستمتعوا بأفضل ما تقدمه القدس على مدار العام.</p>
					<p>شاركوا أيضا باحتفالات مهرجان إسرائيل، المهرجان الدولي متعدد التخصصات في إسرائيل، والذي يقدم مجموعة كبيرة ومتنوعة تشمل العروض المسرحية المتميزة والرقص المعاصر والموسيقى الكلاسيكية والأداء الذي يقدمه فنانون من جميع أنحاء العالم. انضموا إلى معرض الفنون والحرف في القدس، في "حوتسوت هيوتسير" حيث ستلتقون بفنانين إسرائيليين وعالميين وتستمتعون بالموسيقى الرائعة؛ زوروا سوق القدس ليلا للتجول في الأكشاك العديدة التي يقيمها الفنانون والمصممون من جميع المدارس، والتي يعرضون فيها بضائعهم ويبيعونها؛ استمتعوا بمهرجان الأضواء في القدس الذي يوفر بعدا دراميا وفنيا فريدا للمدينة القديمة من خلال استخدام الضوء؛ استمعوا إلى موسيقى الأوبرا في مهرجان أوبرا القدس. اجلسوا في بركة السلطان، حيث ستشاهدون عروضا رائعة أثناء استنشاقكم لهواء القدس الصيفي العليل ليلا، مع إطلالة خلّابة في الخلفية.</p>
					<p>لا تفوّتوا مهرجان القدس للموسيقى الروحية. كجزء من الموسم الثقافي في القدس، يجمع هذا المهرجان الاستثنائي فنانين متنوعين يمثلون مجموعة كبيرة من الثقافات والتقاليد، تعرض وتستكشف الموسيقى الدينية من جميع أرجاء الأرض.</p>

                
            	 `,
      };
    },
  },

  {
    id: "All_Sensory_Markets",
    bgImage: "/posts/bank/allsensorymarkets/1.jpg",
    mobBgImage: "/posts/bank/allsensorymarkets/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: "أسواق زاخرة بالألوان، والسحر معا",
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            


				<p>لا شيء يضاهي زيارة أسواق إسرائيل للانغماس في تجربة زيارتها حقا. يمكن لتعدد الألوان، أو القوامات، أو الروائح، أو المذاقات، أو الأصوات المختلفة أن يكون السبغة الحقيقية لمعنى زيارة هذه البلد.</p>
				<p>تعد هذه الأسواق بوتقة تنصهر فيها الثقافات، ومكانا رائعة لاختبار خبرتكم في المساومة على بضاعة ما. ستجدون عبر الشوارع المتعرجة المرصوفة بالحجارة منتجات طازجة وهدايا تذكارية ومصوغات يدوية وقطع فنية. قائمة لا تنتهي من السلع. اجلبوا هدايا إلى المنزل، أهدوا أصدقاءكم وأبناء عائلتكم وتمتعوا بالتجول وتذوق النكهات المختلفة.</p>
				 <div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/1.jpg"} class="img-responsive" />
				</div>
				<h3>تل أبيب</h3>
				<p>سوق الكرمل أو "شوك هكرمل"، هو الأكثر شهرة من بين جميع أسواق تل أبيب. وقد صار السوق يعد في صفّ الأماكن العصرية في تل أبيب حيث تنتشر الحانات والمطاعم والمقاهي وأكشاك الطعام التي يديرها طهاة مشهورين. لا عجب أن سوق الكرمل إذا هو أكبر أسواق تل أبيب وأكثرها مركزية: إذ أن هذا السوق يحتوي على كل شيء، ابتداء من الـ "جحنون" المصنوع يدويا، وهو طبق يمني تقليدي، وصولا إلى أجبان البوتيك، ومن الملابس القطنية الفريدة إلى أرقى الأزياء الموقعة بتوقيع مصممين كبار. هيئوا زيارتكم، وحلمات التذوق على أطراف ألسنتكم، للالتقاء بالأسماك المملحة، واللحوم المقددة، والمأكولات الشرق أوسطية، والمعجنات الفرنسية الطازجة، والقهوة المحمصة محليا، أو مزيج الفواكه أو عصائر الخضروات الطازجة، ليصير لزيارتكم مذاق لا ينسى.</p>
				<p><a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market"www.shuktlv.co.il/en/category/carmel-market</a></p>
				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/2.jpg"} class="img-responsive" />
				</div>
				 
				<p>تأسس سوق "نحلات بنيامين" لعرض الفنون والحرف في العام 1988، وهو الأقدم والأكبر من نوعه في إسرائيل، وواحد من أجمل المعارض في العالم. هذا السوق هو منزل أكثر من مائتي فنان يستخدمون مواد أولية كالخشب والزجاج والنسيج والبلاستيك والورق، وصولا إلى الصخور (إنهم يستخدمون أي شيء، وكل شيء تقريبا) ليصنعوا بأيديهما السلع التي يبيعونها في أكشاكهم.</p>
				<p><a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">www.shuktlv.co.il/en/category/carmel-market</a></p>
				 <div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/3.jpg"} class="img-responsive" />
				</div>
				<h3>القدس</h3>
				<p>يعرف سوق "محانيه يهودا" بأنه رمز للقدس على نطاق واسع. السبب الداعي لذلك شديد الوجاهة: إذ يرى سكان القدس بأنه مكان يمثلهم ويرمز إليهم ويمنحهم هوية فريدة في السياق الاجتماعي الإسرائيلي الأكبر. يوجد في القدس اليوم العديد من مراكز التسوق والترفيه، ولكن أمرا ما في "محانيه يهودا" يجتذب الناس، حتى لو لم يأتوه حاملين قائمة تسوق. من رائحة التوابل القوية إلى المعروضات الملونة المكونة من الفواكه والخضروات: إن زيارة إلى هذا السوق ستتكفل بإرضاء جميع حواسك. </p>
				<!--<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
				</div>-->
				<p>واحد من خيارات تجربة هذا السوق هو شراء بطاقة "لقيمات محانيه يهودا" (Machane Yehuda (Bites Cardهذه البطاقة تحتوي على قسائم مصممة لمنحك فرصة لتجربة مجموعة متنوعة من المنتجات والنكهات في السوق، من دون اضطرارك إلى الاعتماد على وجود مجموعة منظمة أو جولة يقودها مرشد. لمزيد من المعلومات، يرجى الضغط على الرابط:</p>
				<p><a target="_blank" href="//www.machne.co.il/en/"  target="_blank" rel="noopener">www.machne.co.il/en</a></p>

				
                
            	 `,
      };
    },
  },

  {
    id: 31,
    bgImage: "/posts/bank/20/1.jpg",
    mobBgImage: "/posts/bank/20/M.jpg",
    title: 'متحف "ياد فاشيم" العصيّ على النسيان',
    ctg: "jerusalem",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <p>يقع مركز "ياد فاشيم" لإحياء ذكرى ضحايا المحرقة النازية، على المنحدرات الخضراء لجبل الذكرى في القدس.</p>
					<p>انطلق مشروع إحياء ذكرى ضحايا المحرقة النازية في إسرائيل سنة 1953، حاملا على عاتقه مهمة تخليد ذكرى ضحايا المحرقة النازية وتوثيق تاريخ الشعب اليهودي خلال الهولوكوست بحيث تتذكره الأجيال القادمة. كان هذا المشروع خطوة مهمة للشعب الإسرائيلي الفتي في ذلك الوقت، وكان أمرا مهما لمواطني إسرائيل، وخصوصا للناجين من الغيتوهات ومن معسكرات الاعتقال.</p>
					<div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/thingsToDo/posts/31/1.jpg"} class="img-responsive" />
				    </div>
					 
					<p>تمت إعادة افتتاح متحف "ياد فاشيم" مجددا سنة 2005، حيث تم تصميم المتحف على شكل موشور يخترق الجبل. وينقسم المتحف إلى تسع صالات للعرض، تروي قصص الجاليات اليهودية قبل الحرب العالمية الثانية، كما تروي تسلسل الأحداث التي بدأت من صعود النازيين إلى السلطة، وملاحقة اليهود، وطردهم إلى الغيتوهات (الأحياء اليهودية)، وصولا إلى "الحل النهائي" و الإبادة الجماعية.</p>
					 <div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/thingsToDo/posts/31/2.jpg"} class="img-responsive" />
				    </div>
					<p>تشكل التجارب والمشاعر الشخصية لضحايا الهولوكوست أساس معارض المتحف التسعة. وتعد الصور الفوتوغرافية والأفلام والوثائق والرسائل والأعمال الفنية والمتعلقات الشخصية الموجودة في المخيمات والأحياء اليهودية جزءا لا يتجزأ من المعروضات. لدى خروجكم من المتحف نفسه، توجد قاعة الأسماء، وهي نصب تذكاري ملهم يحتوي على أكثر من ثلاثة ملايين اسم لضحايا الهولوكوست، تم تجميعها من قبل عائلات وأقارب الضحايا. ولا يزال بإمكان زوار النصب تقديم الأسماء وإضافتها إلى الأرشيف المحوسب.</p>
					<p>بالإضافة إلى متحف تاريخ المحرقة، توجد في ياد فاشيم نصب تذكارية وآثار أخرى، تشمل قاعة الذكرى، حيث يتم دفن رماد الموتى، وحيث تحترق شعلة أبدية إحياء لذكرى الضحايا؛ "ياد لا ييلد" التي تعني بالعبرية "لذكرى الطفل"، هي نصب تذكاري أقيم تخليدا لذكرى مليون ونصف المليون من الأطفال اليهود الذين قضوا في المحرقة النازية؛</p>
					 <div class="img-wrapper">
					    <img src=${getImgUrl() +
                "/thingsToDo/posts/31/3.jpg"} class="img-responsive" />
				    </div>
					<p>النصب التذكاري للمبعدين، وهي عربة قطار أصلية معلقة فوق جرف، على طريق متعرج من الجبل. وتم استخدام هذه العربة لنقل اليهود الذين طردوا من منازلهم ونقلوا إلى معسكرات الاعتقال.</p>
					<p>أما شارع "الصالحين بين الأمم" فيحتوي على أكثر من 2000 شجرة زرعت تكريما لغير اليهود الذين عرضوا حياتهم للخطر من أجل إنقاذ اليهود من النازيين؛ وتعتبر أرشيفات ومكتبة ياد فاشيم أكبر مستودع للمواد حول المحرقة النازية في العالم أجمع؛</p>
					<p>إن زيارة متحف ياد فاشيم لهي تجربة عاطفية ومؤلمة للقلب، بيد أن مشاهدة المعروضات وتذكر المحرقة النازية يوفر للمليون إنسان، بما فيهم قادة العالم وكبريات الشخصيات الذين يمرون عبر أبوابه سنويا طريقة مهمة لإحياء ذكرى ستة ملايين يهودي من ضحايا المحرقة.</p>
					<p> لمزيد من المعلومات: <a target="_blank" href="//www.yadvashem.org/" target="_blank" rel="noopener">www.yadvashem.org</a></p>

                
            	 `,
      };
    },
  },

  {
    id: "What_To_Pack",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/page-tourist/1.jpg",
    mobBgImage: "/posts/bank/page-tourist/M.jpg",
    isVid: false,
    title: "WHAT TO PACK",
    smltitle: "",
    html: function() {
      return {
        __html: `

								<p>Israel is a modern, developed country, and you can purchase virtually anything you need during your stay, including clothing, cosmetics, and hygiene products.</p>
                                <p>If you are visiting Israel during the summer you will need lightweight clothing - short-sleeved and sleeveless shirts, shorts, sandals, beach shoes and a bathing suit.&nbsp;&nbsp;It’s also a good idea to pack a sweater or jacket, since nights in the mountains and the desert can be cool.</p>
                                <p>If you are visiting Israel in the winter, you will need warm clothing, a coat (preferably a raincoat as well), good shoes, an umbrella, gloves, a scarf and other warm clothing.&nbsp;&nbsp;Weather in Israel is not cold as it is in Europe, but days can be rainy and cold.</p>
                                <p>It’s a good idea to bring a small bag for day trips.&nbsp;&nbsp;If you are traveling to Eilat or the Dead Sea, it’s a good idea to bring a bathing suit, since it is warm enough to swim there even in the winter.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/what-to-pack/1.jpg"} class="img-responsive">
							    </div>
								<p>
								Sunscreen, a sun hat, and sunglasses are essential items throughout the year.
If you are planning on hiking, you will need good shoes and a lot of water, either in a canteen or in several bottles. You will need a sleeping bag, tent, and camping equipment only if you are planning on sleeping outdoors.  Most youth hostels supply sheets and blankets.</p>

		                        `,
      };
    },
  },
  {
    id: "Electrical_Appliances",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/page-tourist/1.jpg",
    mobBgImage: "/posts/bank/page-tourist/M.jpg",
    isVid: false,
    title: "الأجهزة الكهربائية",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<!--<p>
									​The Israeli power supply is single phase 220 volts at 50 Hertz. Most power sockets in Israel have three pinholes, but many of them will work with double-pin European plugs. Visitors who want to use shavers, traveling irons and other small appliances may need both transformers and adaptor plugs.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/electrical-appliances/1.jpg"} class="img-responsive">
							    </div>-->
							  <p>  إمداد الكهرباء المتبع في إسرائيل هو 220 فولت في 50 هرتز أحادي المرحلة. معظم المقابس في إسرائيل هي ذات ثلاثة دبابيس، لكن الكثير منها سيعمل بقوابس أوروبية مزدوجة الدبوس. وقد يحتاج الزوار الذين يرغبون باستخدام أدوات الحلاقة الإلكترونية، ومكاوي السفر وغيرها من الأدوات صغيرة الحجم إلى كل من المحولات الكهربائية والقوابس المهايأة.</p>
							  	<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/electrical-appliances/1.jpg"} class="img-responsive">
							    </div>
		                        `,
      };
    },
  },
  {
    id: "Weather",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/page-tourist/1.jpg",
    mobBgImage: "/posts/bank/page-tourist/M.jpg",
    isVid: false,
    title: "حالة الطقس",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<!--<p>With around merely 40 rainy days a year on average, Israel is known for its sunny disposition, yet keep in mind this is a 4 season country. Summers are long, lasting from April to October and the height of heat and humidity is usually around July-August. Fall and winter last from November to March.</p>
<p>The southern city of Eilat enjoys nearly 360(!) sunny days a year, making it the hottest city in Israel (no pun intended).<br>
The Israeli Meteorological Service: <a href="//www.ims.gov.il/ims/all_tahazit/" target="_blank" rel="nofollow noopener noreferrer" data-mk-aweb-org-font-size="17">www.ims.gov.il</a></p>
<p></p>
								-->
							    <p> بمعدل 50 يومًا ماطرًا كل عام فقط، إسرائيل معروفة بأجوائها المشمسة، ومع ذلك يجب أخذ حقيقة أن البلد يشهد 4 فصول كل عام في عين الاعتبار. حيث يدوم موسم الصيف فترة طويلة تمتد اعتبارًا من شهر أبريل ولغاية شهر أكتوبر وتبلغ درجات الحرارة ومستويات الرطوبة ذروتها في حوالي الشهرين يوليو وأغسطس، بينما يحل موسما الخريف والشتاء بدءًا بشهر نوفمبر وانتهاءً بشهر مارس.</p>
								<p>هذا وتتمتع مدينة إيلات الجنوبية بمعدل قرابة 300 يومًا مشمسًا كل عام، مما يجعلها أكثر المدن الإسرائيلية حرارةً (ولا نقصد التورية).</p>
								<p>إليكم رابط إلى موقع دائرة الأرصاد الإسرائيلية الإلكتروني: <a href="https://ims.gov.il/ar" target="_blank" rel="nofollow noopener noreferrer">www.ims.gov.il</a></p>
    							<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/weather-planyour-trip/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Transportation",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/page-tourist/1.jpg",
    mobBgImage: "/posts/bank/page-tourist/M.jpg",
    isVid: false,
    title: "وسائل النقل والمواصلات",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<!--<p>Israel is a small country, which makes getting around fast and convenient. Taxis are common in Israel for urban and interurban travel and can be flagged in the street or booked via phone or designated international apps such as GetTexi.</p>
								<p>The main forms of public transportation are busses and the national train service both offering a convenient, reasonably priced means of travel to nearly every destination in the country.</p>
								<p>Train Information Services:<a href="//www.rail.co.il" target="_blank" rel="noopener noreferrer"> www.rail.co.il</a> / Telephone: 08-6831222 or *5770</p>
								<p>Busses Information Services:<a href="//bus.gov.il/?language=en#/origindestination/1/0" target="_blank" rel="noopener noreferrer"> www.bus.co.il</a> / Telephone: 1-900-72-1111</p>
								<p>Tickets can be purchased at the ticket booths in the central bus station in each city or town, or from the driver. Most of the bus lines do not run on Shabbat or on Jewish holidays. Service ends on Friday afternoon and resumes Saturday evening.</p>
								<p>Students are entitled to discounts on intercity bus lines. To receive a discount they must present an international student card when purchasing tickets.</p>
								<p></p>
								
							    <h3>Smart ride card - Rav Kav</h3>
								<p>Tourists can purchase an Anonymous Rav Kav Card. It can be purchased on board for a small fee, and then can be reloaded with a regular Multi-Ride or Single ticket, usually within the region offering a 20% discount.</p>
								<p>Tourists cannot use a Personal Rav Kav Card which has all the passenger’s personal details and is for citizens.</p>
								<p>Please note:<br>
								- The Rav Kav can be used to pay for the transportation of several passengers.<br>
								- The fee of a child is like an adult.<br>
								- The Rav Kav can be used in a region and not between regions unless specifically reloaded for the desired routes.<br>
								- In some areas, it is possible to get daily unlimited rides within that region only.</p>
								<h3>Domestic Flights</h3>
								<p>Israel is a small country, and for this reason, it is only worthwhile to consider flying between Eilat and Tel Aviv. Several companies operate flights from Eilat to Ben Gurion Airport, or Sde Dov in north Tel Aviv. Airfares are reasonable, but are higher than bus fares.</p>
								<p>There are also private companies that operate special flights from anywhere in the country upon request.</p>
								<h3>Renting a Car</h3>
								<p>Most international car rental companies and local companies have offices in the large cities and at Ben Gurion Airport. It is recommended to reserve a car in advance from abroad.</p>
								<p>To rent a car in Israel the driver must be over 24 years of age, and must hold a valid international driver’s license and an international credit card.</p>
								<p>Israel has an extensive road system and clear signage in most places (in Hebrew, English, and Arabic).</p>
								<h3>Driving in Israel</h3>
								<h3>The minimum</strong> driving age in Israel is 17 and the driving side of the road is the right. Speed limits are 30 to 50km/h in cities, 80-90 on freeways, 130 on highways and Route no.6. Safety belts are obligatory, and if you’re enjoying a night on the town, keep in mind there is a zero tolerance policy for drinking and driving so find a designated driver and enjoy safely.</p>
								<h3>Highway 6</h3>
								<p>Highway 6 operates as an electronic toll road with no barriers at entrances or exits and no traffic lights which allows for uninterrupted trips. Advanced computerized information systems installed along the highway include electronic tollgates, identify vehicles, categorize types of fees (subscription or unregistered) and calculate the number of highway sections each vehicle travels. Every trip is automatically tabulated and invoiced. Drivers enjoy a rich, convenient, and safe traveling experience with a speed limit of 130 kilometers per hour.</p>
								<p>Tourists renting a car will be charged via their credit card. Please inquire with the rental company the conditions and tariffs.</p>
								<p>Most Rent a Car companies do not offer insurance for the areas in the West Bank under the control of the Palestinian Authority. Tourists wishing to drive with rented cars into the areas of the Palestinian Authority are recommended to secure appropriate insurance.</p>
								-->

								<p>تعتبر إسرائيل دولة صغيرة، مما يجعل التنقل فيها سريعًا ومريحًا. سيارات الأجرة شائعة في إسرائيل للتنقل داخل وخارج المدن، ويمكن توقيفها في الشارع أو حجزها مسبقاً عبر الهاتف أو عبر التطبيقات المخصصة مثل Gett وYango.</p>
								<p>الباصات والقطارات هي وسائل المواصلات الرئيسية، كلاهما يوفّر وسيلة تنقّل مريحة وبأسعار معقولة للسفر تقريبًا لكل وجهة في الدولة.</p>
								<p>خدمات معلومات القطارات: <a href="//bus.gov.il/?language=en#/origindestination/1/0">www.rail.co.il</a> / هاتف: <a href="tel:086831222">6831222-08</a> أو <a href="tel:*5770">5770*</a>.</p>
								<p>خدمات معلومات الباصات: <a href="//bus.gov.il/?language=en#/origindestination/1/0">www.bus.co.il</a> / هاتف: <a href="tel:1900721111">1111-72-900-1</a>.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/transportation/1.jpg"} class="img-responsive">
							    </div>
								<p>يمكن شراء التذاكر من أكشاك بيع التذاكر في محطة الباصات المركزية في كل مدينة أو بلدة، أو من السائق. يمكن أيضًا شراء تذاكر الباصات عبر تطبيقات الركوب الذكية.</p>
								<p>معظم خطوط الباصات لا تعمل يوم السبت أو في الأعياد اليهودية. تنتهي الخدمة بعد ظهر يوم الجمعة وتعود للعمل مساء يوم السبت.</p>
								<p>يحق للطلاب الحصول على خصومات على خطوط الباصات بين المدن. للحصول على خصم، يجب عليهم تقديم بطاقة طالب دولية عند شراء التذاكر.</p>
								<h3>تطبيقات التذاكر الذكية</h3>
								<p>اعتبارًا من ديسمبر 2020، يمكن الدفع مقابل خدمات الباصات العامة باستخدام تطبيقات الهواتف الذكية. التطبيق الرسمي هو The Station وهو متاح على Google Play لنظام Android وعلى App Store لـ IOS. هناك أيضًا العديد من تطبيقات التنقل الخاصة التي يمكن الدفع عليها.</p>
								<p>يوفر تطبيق The Station للمستخدمين أفضل الخيارات عبر الباصات والقطارات وغير ذلك، باستخدام البيانات في الوقت الفعلي، مع مراعاة الجداول الزمنية وأحدث التغييرات. من أجل استخدام التطبيق، قم بإعداد حساب وإرسال نوع الأجرة الخاص بك، إذا أتيح.</p>
								<p>في الباص، قم بمسح ملصق QR للتحقق من صحة رحلتك وشاركه مع المفتش إذا طُلب منك ذلك.</p>
								<p>بالنسبة للسياح أو حاملي بطاقات الخصم، يحسب التطبيق أفضل سعر لرحلاتك في نهاية كل يوم.</p>
								<p>بالنسبة لحاملي بطاقات الائتمان الإسرائيلية، يتم حساب وخصم أفضل سعر على أساس شهري.</p>
								<p>التطبيقات متاحة حاليًا فقط للتنقل عبر الباصات، ولكن ستصبح متاحة قريبًا للتنقل عبر قطار إسرائيل وقطار القدس الخفيف.</p>
								<h3>الرحلات الداخلية</h3>
								<p>تقوم عدة شركات بتسيير رحلات جوية بين إيلات ومطار بن غوريون. أسعار تذاكر الطيران معقولة، لكنها أعلى بكثير من أسعار الباصات. هناك أيضًا شركات خاصة تدير رحلات طيران خاصة من أي مكان في الدولة عند الطلب.</p>

								تأجير السيارات
								<p>تمتلك معظم شركات تأجير السيارات الدولية والشركات المحلية مكاتب في المدن الكبرى وفي مطار بن غوريون. يوصى بحجز السيارة مقدمًا من الخارج.</p>
								<p>لاستئجار سيارة في إسرائيل، يجب أن يكون عمر السائق أكثر من 24 عامًا، ويجب عليه أن يحمل رخصة قيادة دولية سارية وبطاقة ائتمان دولية.</p>
								<p>يوجد في إسرائيل نظام طرق واسع وإشارات واضحة في معظم الأماكن (باللغات العبرية، الإنجليزية والعربية).</p>
								<h3>القيادة في إسرائيل</h3>
								<p>تكون القيادة في إسرائيل على الجانب الأيمن من الطريق. حدود السرعة هي 30 إلى 50 كم / ساعة في المدن، 80-90 على الطرق 	بين المدن، 110 على الطرق السريعة و120 على الطريق السريع (أوتوستراد) 6. أحزمة الأمان إلزامية، وإذا كنت تستمتع بليلة في المدينة، خذ بعين الاعتبار أنه لا يوجد تساهل مع القيادة تحت تأثير الكحول، لذا ابحث عن سائق خاصّ وعد إلى المنزل بأمان!</p>
								<h3>الطريق السريع 6</h3>
								<p>يعمل الطريق السريع 6 كطريق إلكتروني بدون حواجز عند المداخل أو المخارج ولا توجد إشارات مرور مما يتيح السفر المتواصل. أنظمة المعلومات المحوسبة المتقدمة المثبتة على طول الطريق السريع تحدد المركبات وتصنف أنواع الرسوم (مشترك أو غير مسجل) وحساب عدد أقسام الطرق السريعة التي تسافر بها كل مركبة. يتم جدولة كل رحلة وإصدار فواتير بها تلقائيًا. الحد الأقصى للسرعة هو 120 كيلومترًا في الساعة.</p>
								<p>سيتم فرض رسوم على السياح الذين يستأجرون سيارة عن طريق بطاقة الائتمان الخاصة بهم. يرجى الاستفسار من الشركة المؤجرة عن الشروط والتسعيرات.</p>
								<p>معظم شركات تأجير السيارات لا تقدم التأمين على مناطق الضفة الغربية الخاضعة لسيطرة السلطة الفلسطينية. ينصح السياح الذين يرغبون في القيادة بالسيارات المستأجرة في مناطق السلطة الفلسطينية بالحصول على التأمين المناسب. </p>

								
            	

		                        `,
      };
    },
  },
  {
    id: "Israeli_Currency",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/page-tourist/1.jpg",
    mobBgImage: "/posts/bank/page-tourist/M.jpg",
    isVid: false,
    title: "العملة الإسرائيلية",
    smltitle: "",
    html: function() {
      return {
        __html: `

								<!--<h3>Currency exchange rates</h3>
									<p>The State of Israel’s currency is the New Israel Shekel (NIS) or shekel for short (pluralized as shkalim in Hebrew or shekels in English). There are 100 agorot (agora in singular) in each shekel. Bank notes are in denominations of NIS 20, 50, 100, and 200; coins are in denominations of NIS10, NIS5, NIS2 NIS1 and 50 and 10 agorot.</p>
									<p></p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/israeli-currency/1.jpg"} class="img-responsive">
							    </div>
							    <h3>Currency exchange rates</h3>
								<p>The State of Israel’s currency is the New Israel Shekel (NIS) or shekel for short (pluralized as shkalim in Hebrew or shekels in English). There are 100 agorot (agora in singular) in each shekel. Bank notes are in denominations of NIS 20, 50, 100, and 200; coins are in denominations of NIS10, NIS5, NIS2 NIS1 and 50 and 10 agorot.</p>
								<p></p>-->

            					<h3>أسعار صرف العملة</h3>
								<p>إن العملة المستخدمة في دولة إسرائيل هي الشيكل الإسرائيلي الجديد <span class="ac-en-font">(NIS)</span> أو الشيكل اختصارًا (جمعها شكاليم بالعبرية أو شواقل باللغة العربية). قيمة كل شيكل تعادل قيمة 100 أغورة. الأوراق النقدية مصنفة إلى ورقة قيمتها 20 شيكل جديد وورقة قيمتها 50 شيكل جديد وورقة قيمتها 100 شيكل جديد وأخرى قيمتها 200 شيكل جديد، بينما القطع النقدية تصنف على قطعة قيمتها 10 شواقل جديدة وقطعة قيمتها 5 شواقل جديدة وقطعة قيمتها 2 شيكل جديد وأخرى قيمتها 1 شيكل جديد. هناك أيضًا عملة معدنية من فئة نصف شيكل وعملة معدنية من فئة 10 أغورات. </p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/israeli-currency/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Immigration_Customs",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/page-tourist/1.jpg",
    mobBgImage: "/posts/bank/page-tourist/M.jpg",
    isVid: false,
    title: "IMMIGRATION & CUSTOMS",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <h3>Passport Control</h3>
                                <p>Upon arrival in Israel, visitors go to passport control and must present a passport that is valid for at least six months from the <strong>date of their departure.</strong><br>
                                   Please note, Israel has incorporated a new and modern technological system instrumental in meeting the needs of the various Immigration, security, Airport and Tourism authorities as well as providing the tourist with the credentials necessary to prove his visa status without stamping the passport. At a press of a button, the Border Control station will print a card including the principle details of the traveler as in the first page of the passport. The card will also depict the date of arrival and visa information. This card is called The “Electronic Gate Pass”.
                                </p>
                                <div class="img-wrapper">
								    <img src=${getImgUrl() +
                      "/posts/immigration-customs/1.jpg"} class="img-responsive">
							    </div>
							    <h3>The Gate Pass is an official form of identification while in Israel. We ask all tourists to keep the card at hand at all times as proof of their status.</strong><br>
										Arrival by Air and Land Crossings – Incoming travelers continue to the passenger luggage area after having their passports inspected. Carts are at their disposal. From there, they continue to customs control and to the airport exit.</p>
										<p><a href="https://www.gov.il/BlobFolder/service/group_entry_to_israel/en/land%20gateways%202017ENGLISH%20update.doc" target="_blank" rel="nofollow noopener" data-mk-aweb-org-font-size="17">Information Regarding&nbsp;Israel’s Land Gateways&#8203;</a></p>
										<h3>Customs</h3>
										<p>General information regarding the laws and policies of the Customs Authority can be downloaded:<br>
										<a href="https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page" target="_blank" rel="noopener">https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page</a></p>
										<h3>يرجى ملاحظة أن السفر عبر معبر جسر أللنبي خاضع لقيود وتوجيهات محددة. فعلى سبيل المثال، لا يجوز للزوار الذين يمرون عبر جسر أللنبي الواصل بين إسرائيل والأردن أن يحملوا نقدا أكثر من 2000 دينار أردني.</h3>
										<h3>الجمارك، وضريبة القيمة المضافة للسياح:</h3>
										<p><a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a><br>
										<strong>باستثناء معبر جسر أللنبي، وبما يخص سائر بوابات الدخول، بما فيها المطارات، </strong>فإن دليل السيّاح التالي يخص الزوار كما تعرّفهم سلطة المكوس والضرائب:<br>
										<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br>
										<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a><br>
										نرجو لفت عنايتكم إلى وجود نظام عبور جمركي ذو مسلكين، أحدهما أخضر والآخر أحمر في مطار بن غوريون ونقاط العبور المختلفة. يمكن للزوار الذين لا يحملون بضائع يتوجب التصريح عنها المرور عبر الممر الأخضر عند مخرج صالة وصول الركاب.</p>
								
		                        `,
      };
    },
  },

  // This post had moved to the Passport post/ ASked by HADAR 18.05.2020
  // {
  // 		id:"Immigration_Customs",
  //        	ctg : "TouristInfo",
  //         bgImage : "/posts/bank/plan-your-trip/1.jpg",
  //         mobBgImage : "/posts/bank/plan-your-trip/M.jpg",
  //        	isVid:false,
  //         title : "IMMIGRATION & CUSTOMS",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                               <h3>Passport Control</h3>
  //                               <p>Upon arrival in Israel, visitors go to passport control and must present a passport that is valid for at least six months from the <strong>date of their departure.</strong><br>
  //                                  Please note, Israel has incorporated a new and modern technological system instrumental in meeting the needs of the various Immigration, security, Airport and Tourism authorities as well as providing the tourist with the credentials necessary to prove his visa status without stamping the passport. At a press of a button, the Border Control station will print a card including the principle details of the traveler as in the first page of the passport. The card will also depict the date of arrival and visa information. This card is called The “Electronic Gate Pass”.
  //                               </p>
  //                               <div class="img-wrapper">
  // 						    <img src=${getImgUrl()+ "/posts/immigration-customs/1.jpg"} class="img-responsive">
  // 					    </div>
  // 					    <h3>The Gate Pass is an official form of identification while in Israel. We ask all tourists to keep the card at hand at all times as proof of their status.</strong><br>
  // 								Arrival by Air and Land Crossings – Incoming travelers continue to the passenger luggage area after having their passports inspected. Carts are at their disposal. From there, they continue to customs control and to the airport exit.</p>
  // 								<p><a href="https://www.gov.il/BlobFolder/service/group_entry_to_israel/en/land%20gateways%202017ENGLISH%20update.doc" target="_blank" rel="nofollow noopener" data-mk-aweb-org-font-size="17">Information Regarding&nbsp;Israel’s Land Gateways&#8203;</a></p>
  // 								<h3>Customs</h3>
  // 								<p>General information regarding the laws and policies of the Customs Authority can be downloaded:<br>
  // 								<a href="https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page" target="_blank" rel="noopener">https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page</a></p>
  // 								<h3>Please make note that travel through Allenby Bridge Crossing has specific limitations and directives. For example, visitors passing through the Allenby Bridge between Israel/Jordan may carry no more than the cash value of 2000 Jordanian Dinars.</h3>
  // 								<h3>Customs and V.A.T. for Tourists:</h3>
  // 								<p><a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a><br>
  // 								<strong>Aside from Allenby Bridge Crossing, and for all other Gateways including airports,</strong> the following tourist guide is relevant for visitors as defined by the Customs and Tax Authority:<br>
  // 								<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br>
  // 								<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a><br>
  // 								Please note: there is a two-lane customs transit system, one green and the other red, at Ben Gurion Airport and the various Crossing Points. Visitors who do not have goods to be declared may go through the green lane at the exit from the passenger arrival hall.</p>

  //                         `
  //     }
  //   }
  // },
  // END This post had moved to the Passport post/ ASked by HADAR 18.05.2020
  {
    id: "Frequently_Asked_Questions",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/faq/1.jpg",
    mobBgImage: "/posts/bank/faq/M.jpg",
    isVid: false,
    title: "أسئلة شائعة بخصوص",
    smltitle: "",
    html: function() {
      return {
        __html: `
								    <!--<h3>Frequently Asked Questions about the COVID-19 </h3>

                                    <p>
                                        <ol start="1">
									        <li>I am a tourist in Israel and I am concerned that I may have COVID-19, where should I go?<br/>
									           <ul>
									               <li>
									                  If you have a fever of 100.4F (38C) or higher, cough, trouble breathing, or other respiratory symptoms, you must immediately enter self-isolation and call the 101 MDA Emergency Services Hotline for medical advice.
									                <strong>
									                  Do not go to an HMO clinic or emergency ward.
									                </strong>
									         
									               </li>
									           </ul>
									        </li>
									        <li>When will Israel be open to incoming visitors again?<br/>
									           <ul>
									               <li>
									                At this moment there is not a known date in which Israel will be open to incoming visitors.
									         
									               </li>
									           </ul>
									        </li>
									       
									      </ol>
                                    </p>
								    <h3>Isn’t Israel a long way away?</h3>
									<p>Not nearly as far as you may think: just 10 hours from New York (it’s quicker to fly from New York to Israel than from New York to Hawaii!), or 14 hours from Los Angeles. There are about ten nonstop flights a day from North America to Israel, on Air Canada, American Airlines/US Airways, Delta, El Al Israel Airlines and United. Plus you can connect to Israel through dozens of European cities.</p>
									<h3>What documents do I need to travel to Israel?</h3>
									<p>For U.S. and Canadian citizens, all you need is a passport that’s valid at least six months longer than your date of arrival in Israel. (For stays up to three months, you don’t need a visa.) If you’re not a U.S. or Canadian citizen, the same conditions apply to citizens of most western countries, but just to be sure: click here.</p>
									<h3>Is it safe to travel to Israel?</h3>
									<p>We wouldn’t urge you to come if it wasn’t. Every year between 3 and 4 million tourists vacation in Israel – and apart from those who fall in love with an Israeli – or with Israel – they all go home again safe and sound. The planes of 90+ airlines wouldn’t fly to Israel if it weren’t safe.</p>
									<h3>I hear there is a security interview before my flight…</h3>
									<p>If you are flying EL AL Israel Airlines (or from Europe on Arkia Israel Airlines or Israir), please know that the security precautions taken by Israeli airlines are the stuff of legend and the envy of the world’s airlines. On check-in for your flights you will be asked a variety of questions during a security interview. Some of the questions may seem un-PC, intrusive, irrelevant or repetitive. Just answer truthfully, go with the flow and don’t lose your cool. Remember, the questions are designed to protect you and your fellow passengers. When you leave Israel, the departure process is identical to that outlined above for all airlines.</p>
									<h3>What about health, medicines, vaccinations?</h3>
									<p>Israel is an ultra-modern country with the world’s highest number of doctors per capita, and a health and hospital system that is the envy of the world. No vaccinations are required to visit Israel (unless you have recently been in an area where there have been epidemics of yellow fever, cholera or ebola). You can buy most standard over-the-counter equivalent of North American drugs in Israel. You can also bring supplies of your standard prescription drugs with you. (If you need to bring syringes and vials of medicine – bring along a letter from your doctor attesting to your needs, just in case.) If you need to see a doctor in Israel, check with your hotel concierge. Travel insurance (including medical coverage) is always recommended for all foreign travel.)</p>
									<h3>What to wear?</h3>
									<p>Like almost everywhere in the world, casual is the "rule" for everyday sightseeing. Bring good walking shoes or sneakers and "layers." Israelis (especially women) like to be “elegant casual” on evenings in Tel Aviv and Jerusalem. Some religious shrines require modest dress (arms and legs covered, and, occasionally, no pants for women). Don't forget your swimsuit and, for the Dead Sea, plastic shoes or aqausox.</p>
									<h3>What about money?</h3>
									<p>The Israeli currency is the Shekel (officially “New Israeli Shekel”), worth around 30 cents. Click here for the current conversion rate. On arrival in Israel, it’s a good idea to use your bank-card to withdraw some Shekels from the ATM in the arrival-halls at Ben Gurion - or change small amounts of dollars/or travelers’ checks at a bank or your hotel. There are ATM machines all over Israel and credit cards are widely accepted.</p>
									<h3>Electricity</h3>
									<p>Almost all hotel rooms are equipped with hairdryers, and all have shaver sockets. For other appliances, Israel's electricity is 220V A/C, single phase 50-cycles; 110V-220V transformers can be used. Israeli outlets have three prongs, but European two-prong adapters usually work. If you don’t have an adapter that seems to work, call the hotel’s front desk or visit a hardware store.</p>
									<h3>Keeping in touch</h3>
									<p>Most hotels have free wi-fi in the lobby, and some hotels provide it free in the room. Many hotels also have Business Centers where you can access e-mail and the internet without charge. American cell-phones that work overseas will work in Israel too. Israel is 6 or 7 hours ahead of the East Coast of the USA depending on the season.</p>
									<h3>Temperatures</h3>
									<p>Temperatures can vary widely so just pack for the "right" weather and you'll be fine. Seasons overlap of course, but general guidelines are:</p>
									<h3>SUMMER</h3>
									<p> (Jun/Jul/Aug/early Sep): Temperatures in the high 80º's, 90º's. Tel Aviv, and Tiberias will be hot and humid (like New York or Miami). Jerusalem is dryer and cooler, particularly at night. Masada and Eilat are extremely hot (110º+!)...but dry. There won't be a drop of rain.</p>
									<h3>SHOULDERS</h3>
									<p> (late Mar/Apr/May/late Sep/Oct/Nov): Daytime temperatures will be very pleasant: 75º-ish in most of the country (but hotter at the Red and Dead Seas). Jerusalem will be in the 70º's, 50º's in the evening. There'll be some rain - nothing torrential.</p>
									<h3>WINTER</h3>
									<p> (Dec/Jan/Feb/early Mar): Winter weather can fluctuate. Some winters are mild and sunny, some severe and overcast. There's often heavy rain and, in January and February, even snow sometimes. It'll probably be in the 50º's, 60º's most places, but in Jerusalem and the Galilee in the forties, and cold at night.</p>
									<h3>Getting around</h3>
									<p><strong>BUS</strong>: Israel has one of the world’s best and most inexpensive bus systems, with almost every city, town, village and settlement connected to the system. Click here for schedules and prices.</p>
									<p><strong>TRAIN</strong>: High speed trains link Ben Gurion Airport with Tel Aviv, Jerusalem and Haifa, and there are fast and, efficient and inexpensive train service throughout much of the country. Rail travel is inexpensive and very easy to navigate. Click for full information.</p>
									<p><strong>FLIGHTS</strong>: Tel Aviv and Eilat are connected by multiple flights daily aboard Arkia, El Al and Israir, and there are also flights to Haifa and the Galilee.</p>
									<p><strong>TAXIS</strong>: There are taxis available in the cities, and taxi drivers are also happy to take you between cities. Check the price before you start your journey.</p>
									<p><strong>SHARED TAXIS</strong>: Shared taxis or “Sherut” are very popular. There are “Sherut” stations throughout the cities. Ask at your hotel for the nearest Sherut stand.</p>
									<p><strong>CAR RENTAL</strong>: Most international car rental groups have offices in Israel – and there are excellent Israeli car rental firms too. Your American or Canadian drivers’ license is valid in Israel.</p>
										-->

										 <h3>أسئلة شائعة بخصوص فيروس كوفيد-19</h3>
    
      <ol start="1">
        <li><strong>أنا سائح أتواجد في إسرائيل  وأنا قلق. من احتمال إصابتي بفيروس كورونا، إلى أين  عليّ أن اتوجّه؟</strong><br/>
           <ul>
               <li>
                  إن كانت درجة حرارتكم تفوق الـ 38 درجة مئوية (100.4 فهرنهايت)، أو كنتم تسعلون، وتواجهون مصاعب في التنفس، أو ظهرت لديكم  أية أعراض تنفّسية أخرى،  فإن عليكم أن تقوموا  فورا  بحجر أنفسكم ذاتيا، والاتصال بالخط الساخن على الرقم 101 من أجل الحصول على المشورة الطبية. لا تذهبوا إلى العيادة أو قسم الطوارئ.
               </li>
           </ul>
        </li>
        <li><strong>متى ستفتح إسرائيل أبوابها للزوار مجددا؟</strong><br/>
           <ul>
               <li>
                 في هذه اللحظة ليس هنالك تاريخ معروف لعودة إسرائيل لاستقبال الزوار القادمين إليها
               </li>
           </ul>
        </li>
       
       
      </ol>
   
      <h3> هل القدس وتل أبيب بعيدتان كثيرا؟ </h3>
    
      <p>
       بالعكس! إنهما أقرب مما قد تتصوروا، تستغرق سفرة سريعة بالطائرة ما بين 4 -5 ساعات، وبعدها سيكون بإمكانكم الاستمتاع بشواطئ تل أبيب المشمسة،  والمعالم الرائعة في القدس. أفضل ما في الأمر هو أن تل أبيب تبعدان عن بعضهما مسافة ساعة واحدة بالسيارة.
      </p>
     
     <h3> كيف يمكنني التجوال في القدس وتل أبيب؟</h3>
    
      
      <p>
       الباصات وسيارات الأجرة وخطوط سكة الحديد الوطنية هي وسائل النقل الأكثر شعبية وملاءمة. توجد في القدس أيضا خدمة سكة حديد خفيفة مريحة توصلكم إلى المواقع الأكثر شهرة في أرجاء المدينة.
      </p>
      <p>
       للاطلاع على معلومات بشأن محطات القطارات، ومساراتها، وجداول تسييرها، ادخلوا إلى الموقع <a target="_blank" href="//www.rail.co.il">www.rail.co.il</a>
      </p>
      <p>
       للاطلاع على معلومات بشأن مسارات الباصات وجداولها الزمنية بإمكانكم زيارة الموقع <a target="_blank" href="//www.bus.gov.il">www.bus.gov.il</a>  
      </p>
      <p>
       خط المساعدة بشأن المواصلات العامة <a href="tel:*8787">*8787</a>  
      </p>
      <p>
       تطبيق هاتفي خاص بالمواصلات العامة المحلية "Moovit"
      </p>
      <h4>
      سيارات الأجرة
      </h4>
      <p>
        يمكن الإشارة لسيارات الأجرة المخصصة للسفر داخل المدن وما بينها في الشارع، للتوقّف أو يمكنكم حجزها عبر الهاتف والتطبيقات المتخصصة كتطبيق <span class="ac-en-font">Gett (Get Taxi)</a>
      </p>

      <h4>
      سيارات الخدمة (شيروت)
      </h4>
      <p>
        تتسع سيارات الخدمة (شيروت)  لـ10 -12 مقعدا، وهي عادة ما تسير على المسارات الرئيسية المخصصة للباصات، داخل المدن وما بينها. من ناحية الأسعار،  فإن تسعيرة استخدام المواصلات لها أسعار محددة مسبقا، كما هو حال الباصات.
      </p>

      <h4>
      استئجار السيارات
      </h4>
      <p>
        يمكن العثور على غالبية مكاتب تأجير السيارات في وسط تل أبيب على امتداد شارع "هيركون"، قريبا من الواجهة البحرية لتل أبيب وفي باقي المناطق، توجد هذه المكاتب في المناطق المحيطة بالفنادق.
      </p>

      <h4>
      <span class="ac-en-font">Tel-O-Fun</span> 
      </h4>
      <p>
        خدمة <span class="ac-en-font">Tel-O-Fun</span> هي خدمة لمشاركة الدراجات الهوائية، مقدمة من بلدية تل أبيب، وهي متوفرة للسكان وللسياح معا
        لدى خدمة <span class="ac-en-font">Tel-O-Fun</span> أسطول مكون من 2000 دراجة هوائية موزعة على 200 محطة، وتتيح الخدمة استئجار دراجة وقيادتها على امتداد مسارات الدراجات الهوائية المخصصة لذلك، التي تمتد لمسافة 130 كيلومترا
        بإمكانكم شراء بطاقة تعاقد استئجار يومي أو أسبوعي بواسطة بطاقتك الائتمانية، في أي من محطات التأجير 

      </p>
     
      <h3>ماذا عن النقود؟</h3>
    
      <p>
        العملة الإسرائيلية هي الشيكل. يمكن سحب النقود من خلال الصرّافات الآلية في البنوك في أرجاء المدينة.
        تتوفر أيضا صرّافات آلية خاصة في الأكشاك المحلّية، وهي تجبي عمولة تتراوح ما بين 5.90 شيكل إلى 7.90 شيكل مقابل كل عملية سحب نقدي
        خدمات تصريف العملات متوفرة في مكاتب الصرافة من دون عمولات، في المناطق السياحية، وهي عادة ما تكون مفتوحة حتى وقت متأخر.
        بالطبع، فإن بطاقات الاعتماد مقبولة بشكل واسع. كما أن خدمة "ويسترن يونيون" تعمل من خلال مكاتب البريد، وهي توفّر خدمة تحويل الأموال.
      </p>
    
      <h3>البقاء على اتصال</h3>
    

        <h4>
          خدمات الهاتف
        </h4>
        <p>
          إن رغبتم، فإن بإمكانكم شراء بطاقة SIM ذكية من متاجر الهواتف أو مراكز تقديم المعلومات المحلية، واستخدام بطاقات الدفع المسبق التي تنشر في الكثير من المتاجر، ومكاتب تصريف العملات
        </p>

        <h4>
          نقاط الـ <span class="ac-en-font">Hotspot</span>- الانترنت اللاسلكي المجاني
        </h4>
        <p>
          تفخر تل أبيب بكونها مدينة ذكية حتى أقصى حد. تتوفر تغطية <span class="ac-en-font">WIFI</span> لراحتكم في 80 موقعا مختلفا جول المدينة (بما فيها الشاطئ، مراكز التسلية، وغالبية المناطق السياحية)
        </p>
        <p>
          في القدس، يمكن العثور على مناطق الـ <span class="ac-en-font">WIFI</span> في محطات القطار، الجامعات، المتاحف، مراكز الزوار، قاعات المؤتمرات، المواقع السياحية، والمجمعات التجارية، إلى جانب المركز المحلي لتقديم المعلومات للسيّاح
        </p>

      <h3>عن حالة الطقس</h3>
    
        <p>
        الطقس في تل أبيب دافئ ولطيف في معظم أيام السنة، أيام الصيف طويلة ومن المناسب قضاؤها على الشاطئ وفي التجوال في المدينة، بينما فصول الشتاء ودودة ومن دون مطر غزير. معدّل  الحرارة العامّ في الشتاء يتراوح ما بين 1-17 درجة مئوية، بينما يتراوح معدلها في الصيف ما بين 24 - 30 مئوية.

        </p>
        <p>
          تتمتع القدس بمواسم صيف طويلة (تمتد ما بين أيار- مايو وحتى أيلول- سبتمبر) أما فصول الشتاء (التي تمتد ما بين تشرين ثاني - نوفمبر وحتى آذار - مارس) فيمكنها أن تكون شديدة البرودة، وغزيرة المطر، مع احتمالات تساقط الثلج أحيانا، كما تنخفض درجة الحرارة إلى درجة التجمد في بعض الأحيان. للاطلاع على معلومات محدّثة بإمكانك زيارة موقع الأرصاد الجوية الإسرائيلية على العنوان: <a target="_blank" href="//ims.gov.il/ar"><span class="ac-en-font">www.ims.gov.il</span></a>

        </p>
     
      <h3>هل تختلف ساعات وأيام الدوام؟</h3>
    
        
        <p>
           نعم، فأيام الدوام الأسبوعية تمتد من الأحد حتى أيام الخميس، في حين أن عطلة نهاية الأسبوع هي يومي الجمعة والسبت. غالبية المحال التجارية تكون مفتوحة أيام الجمعة حتى بداية العصر، قبل دخول السبت اليهودي، والذي يبدأ منذ غروب شمس الجمعة وحتى ما بعد غروب شمس السبت بقليل. <a target="_blank" href="//www.timeanddate.com/worldclock/Israel"><span class="ac-en-font">www.timeanddate.com/worldclock/Israel</span></a>
        </p>
     
      					
		                        `,
      };
    },
  },
  {
    id: "Passports_Visa",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/page-tourist/1.jpg",
    mobBgImage: "/posts/bank/page-tourist/M.jpg",
    isVid: false,
    title: "معلومات حول جوازات السفر والتأشيرات",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <!--<p>يجب على جميع زوار إسرائيل أن يحملوا جواز سفر ساري المفعول لمدة ستة أشهر على الأقل من تاريخ مغادرتهم لمواطنهم. ويجب على من ليست لديهم جنسية حيازة وثيقة سفر سارية المفعولة، إلى جانب تأشيرة العودة إلى البلد الذي أصدرها.</p>
                                <p>يحق للزوار المكوث لفترة تصل إلى ثلاثة أشهر من تاريخ وصولهم، وفقا لشروط التأشيرة الصادرة لهم. ويجب على الزائرين الراغبين في العمل في إسرائيل تقديم طلب إلى وزارة الداخلية من أجل الحصول على تأشيرة خاصة.</p>
                                <p>لم تعد إسرائيل تختم جوازات السفر في المطارات والمعابر البرّية. بل سيتم فحص جواز سفرك وستتلقى ورقة إذن دخول او ما يسمى "تصريح البوابة الإلكترونية"، وكذلك عند الخروج. </p>
								
							    <h3>"تصريح البوابة الإلكترونية"</h3>
								<p>وفقا للمادة 13 من القانون المتعلق بالدخول إلى إسرائيل، والصادر سنة 1952، يمكن لمفتش رسمي أو ضابط شرطة أن يطلب إبراز إثبات الهوية وإثبات الوضع القانوني في إسرائيل، مع أخذ ذلك بالاعتبار، يمكن للمحطة التابعة لشرطة الحدود أن تطبع، بضغطة زر، بطاقة تشمل التفاصيل الأساسية للمسافر كما تظهر في الصفحة الأولى من جواز السفر. وستوضح البطاقة أيضا تاريخ الوصول ومعلومات التأشيرة. يطلق على هذه البطاقة اسم "تصريح البوابة الإلكترونية" وهي عبارة عن نظام تكنولوجي جديد ومتطور، يساعد في تلبية احتياجات مختلفة سلطات الهجرة والأمن والمطارات والسياحة، إلى جانب توفير الأدوات اللازمة للسائح/ـة لإثبات حالة التأشيرة الخاصة به / بها.
								 <strong>يحل تصريح البوابة الالكترونية" نظام ختم جوازات السفر.</strong>
								 وفي المطار، تتيح هذه البطاقة للمسافر الخروج من صالة الوصول من دون تأخير زائد عن الحاجة.</p>
								<h3>هذا، وتعد بطاقة تصريح البوابة نموذجا رسميا للتشخيص أثناء تواجدكم في إسرائيل. إننا نطلب من جميع السائحين الاحتفاظ بالبطاقة في متناول اليد في جميع الأوقات كدليل على حالة التأشيرة الخاصة بهم. وفي المطار والمعابر البرية المخصصة، تتيح هذه البطاقة للمسافر الخروج من صالة الوصول ومتابعة طريقهم إلى منطقة استلام الأمتعة.</p>
								<h3>التأشيرات السياحية</h3><br>
								<p>نحن نرحّب بالزوار القادمين إلى إسرائيل. 
								<strong>لدى العديد من الدول برنامج إعفاء متبادل من التأشيرة مع إسرائيل، </strong>
								وهو برنامج يتيح لمواطنيها زيارة البلاد من دون الاضطرار إلى ترتيب أمور تأشيرة بشكل مسبق. قبل الشروع في السفر، يجب على الزائرين الراغبين بالتوقف في إسرائيل على طريقهم إلى وجهات أخرى التحقق إذا ما كانوا بحاجة إلى تأشيرات سياحية مسبقة. وتحدد قائمة البلدان المذكورة في الرابط التالي الدول التي يطلب من السائحين القادمين منها استصدار تأشيرة مسبقا.</p>
								<p><a href="https://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" target="_blank" rel="noopener"><span class="ac-en-font">https://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</span></a></p>
								<p>يجب على جميع المسافرين في إطار نظام الإعفاء من التأشيرة تقديم جواز سفر قابل للقراءة الآلية في ميناء الدخول لدخول إسرائيل من دون استصدار تأشيرة مسبقا؛ ما عدا هذه الحالات، تكون التأشيرة مطلوبة، وهذا ينطبق أيضا على السائحين القادمين ببطاقة مرور من البلدان التي لديها برنامج إعفاء.</p><br>
								<h3>تمديد إقامتكم</h3>
								<p>&#8203;تمديد إقامتكم
								يمكنكم تمديد فترة إقامتكم (لقاء دفع الرسوم) في مكتب وزارة الداخلية الأقرب إليكم، يرجى الاتصال بمركز الخدمة على الأرقام <a href="tel:*2450">*2450</a> أو على الرقم <a href="tel:12223450">12223450</a>.
							   </p>
            	                <h3>الهجرة والجمارك</h3>
            	                <h3>مراقبة جوازات السفر</h3>
                                <p>
								عند الوصول إلى إسرائيل، يتوجب على الزوار الذهاب إلى نقطة مراقبة الجوازات، ويجب عليهم إبراز جواز سفر ساري المفعول لمدة ستة أشهر على الأقل
								 <strong>من تاريخ مغادرتهم.</strong>
								نلفت عنايتكم إلى أن إسرائيل قد أدركت نظاما تكنولوجيا جديدا وعصريا مهما لتلبية احتياجات مختلف سلطات الهجرة والأمن والمطارات والسياحة، إلى جانب تزويد السائح بأوراق الاعتماد اللازمة لإثبات حالة التأشيرة الخاصة به من دون ختم جواز السفر. إذ أن محطة مراقبة الحدود يمكنها بضغطة زر أن تطبع بطاقة تتضمن التفاصيل الأساسية للمسافر كما هي واردة في الصفحة الأولى من جواز سفره. كما توضح البطاقة أيضا تاريخ الوصول ومعلومات التأشيرة. وتسمى هذه البطاقة "بطاقة بوابة الدخول الإلكترونية"								
                                </p>
                                
							    <h3><strong>تعد بطاقة البوابة وثيقة رسمية لتشخيص الهوية أثناء تواجدكم في إسرائيل. إننا نطلب من جميع السائحين الاحتفاظ بالبطاقة في متناول اليد في جميع الأوقات، لإثبات وضعهم.</strong>
								<br>
								الوصول عن طريق المعابر الجوية والبرية: يواصل المسافرون القادمون الوصول إلى منطقة أمتعة الركاب بعد خضوعهم لفحص جوازات سفرهم. تتوفر هنالك عربات تحت تصرفهم. ومن هنالك، يمكنهم المواصلة نحو مراقبة الجمارك، وصولا إلى مخرج المطار.
								</h3>
								
								<p><a href="https://www.gov.il/BlobFolder/service/group_entry_to_israel/en/land gateways 2017ENGLISH update.doc" target="_blank" rel="nofollow noopener" data-mk-aweb-org-font-size="17">معلومات حول المعابر البرّية الإسرائيلية </a></p>
								<h3>الجمارك</h3>
								<p>يمكن عن طريق هذا الرابط تنزيل وثيقة تشمل معلومات عامة عن قوانين وسياسات مصلحة الجمارك:
								<br>
								<a href="https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page" target="_blank" rel="noopener">https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page</a></p>
								<h3>Please make note that travel through Allenby Bridge Crossing has specific limitations and directives. For example, visitors passing through the Allenby Bridge between Israel/Jordan may carry no more than the cash value of 2000 Jordanian Dinars.</h3>
								<h3>Customs and V.A.T. for Tourists:</h3>
								<p><a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a><br>
								<strong>Aside from Allenby Bridge Crossing, and for all other Gateways including airports,</strong> the following tourist guide is relevant for visitors as defined by the Customs and Tax Authority:<br>
								<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a><br>
								<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" target="_blank" rel="noopener">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a><br>
								Please note: there is a two-lane customs transit system, one green and the other red, at Ben Gurion Airport and the various Crossing Points. Visitors who do not have goods to be declared may go through the green lane at the exit from the passenger arrival hall.</p>
						        -->



						        <p>يجب على جميع زوار إسرائيل أن يحملوا جواز سفر ساري المفعول لمدة ستة أشهر على الأقل من تاريخ مغادرتهم لمواطنهم. ويجب على من ليست لديهم جنسية حيازة وثيقة سفر سارية المفعولة، إلى جانب تأشيرة العودة إلى البلد الذي أصدرها.</p>
								<p>يحق للزوار المكوث لفترة تصل إلى ثلاثة أشهر من تاريخ وصولهم، وفقا لشروط التأشيرة الصادرة لهم. ويجب على الزائرين الراغبين في العمل في إسرائيل تقديم طلب إلى وزارة الداخلية من أجل الحصول على تأشيرة خاصة.</p>
								<p>لم تعد إسرائيل تختم جوازات السفر في المطارات والمعابر البرّية. بل سيتم فحص جواز سفرك وستتلقى ورقة إذن دخول او ما يسمى "تصريح البوابة الإلكترونية"، وكذلك عند الخروج. </p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/passports-visa/1.jpg"} class="img-responsive">
							    </div><br>
								<h3>"تصريح البوابة الإلكترونية"</h3>
								<p>وفقا للمادة 13 من القانون المتعلق بالدخول إلى إسرائيل، والصادر سنة 1952، يمكن لمفتش رسمي أو ضابط شرطة أن يطلب إبراز إثبات الهوية وإثبات الوضع القانوني في إسرائيل، مع أخذ ذلك بالاعتبار، يمكن للمحطة التابعة لشرطة الحدود أن تطبع، بضغطة زر، بطاقة تشمل التفاصيل الأساسية للمسافر كما تظهر في الصفحة الأولى من جواز السفر. وستوضح البطاقة أيضا تاريخ الوصول ومعلومات التأشيرة. يطلق على هذه البطاقة اسم "تصريح البوابة الإلكترونية" وهي عبارة عن نظام تكنولوجي جديد ومتطور، يساعد في تلبية احتياجات مختلفة سلطات الهجرة والأمن والمطارات والسياحة، إلى جانب توفير الأدوات اللازمة للسائح/ـة لإثبات حالة التأشيرة الخاصة به / بها. يحل تصريح البوابة الالكترونية" نظام ختم جوازات السفر. وفي المطار، تتيح هذه البطاقة للمسافر الخروج من صالة الوصول من دون تأخير زائد عن الحاجة.</p>
								<p>هذا، وتعد بطاقة تصريح البوابة نموذجا رسميا للتشخيص أثناء تواجدكم في إسرائيل. إننا نطلب من جميع السائحين الاحتفاظ بالبطاقة في متناول اليد في جميع الأوقات كدليل على حالة التأشيرة الخاصة بهم. وفي المطار والمعابر البرية المخصصة، تتيح هذه البطاقة للمسافر الخروج من صالة الوصول ومتابعة طريقهم إلى منطقة استلام الأمتعة.</p>
								التأشيرات السياحية
								<p>نحن نرحّب بالزوار القادمين إلى إسرائيل. لدى العديد من الدول برنامج إعفاء متبادل من التأشيرة مع إسرائيل، وهو برنامج يتيح لمواطنيها زيارة البلاد من دون الاضطرار إلى ترتيب أمور تأشيرة بشكل مسبق. قبل الشروع في السفر، يجب على الزائرين الراغبين بالتوقف في إسرائيل على طريقهم إلى وجهات أخرى التحقق إذا ما كانوا بحاجة إلى تأشيرات سياحية مسبقة. وتحدد قائمة البلدان المذكورة في الرابط التالي الدول التي يطلب من السائحين القادمين منها استصدار تأشيرة مسبقا.
								<a href="//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" target="_blank" rel="noopener"><span class="ac-en-font">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</span></a></p>
								<p>يجب على جميع المسافرين في إطار نظام الإعفاء من التأشيرة تقديم جواز سفر قابل للقراءة الآلية في ميناء الدخول لدخول إسرائيل من دون استصدار تأشيرة مسبقا؛ ما عدا هذه الحالات، تكون التأشيرة مطلوبة، وهذا ينطبق أيضا على السائحين القادمين ببطاقة مرور من البلدان التي لديها برنامج إعفاء.</p>
								<p><strong>تمديد إقامتكم</strong><br/>
								 يمكنكم تمديد فترة إقامتكم (لقاء دفع الرسوم) في مكتب وزارة الداخلية الأقرب إليكم، يرجى الاتصال بمركز الخدمة على الأرقام *2450 أو على الرقم 12223450.</p>
								<h3>الهجرة والجمارك</h3>
								<h3>مراقبة جوازات السفر</h3>
								<p>عند الوصول إلى إسرائيل، يتوجب على الزوار الذهاب إلى نقطة مراقبة الجوازات، ويجب عليهم إبراز جواز سفر ساري المفعول لمدة ستة أشهر على الأقل من تاريخ مغادرتهم.</p>
								<p>نلفت عنايتكم إلى أن إسرائيل قد أدركت نظاما تكنولوجيا جديدا وعصريا مهما لتلبية احتياجات مختلف سلطات الهجرة والأمن والمطارات والسياحة، إلى جانب تزويد السائح بأوراق الاعتماد اللازمة لإثبات حالة التأشيرة الخاصة به من دون ختم جواز السفر. إذ أن محطة مراقبة الحدود يمكنها بضغطة زر أن تطبع بطاقة تتضمن التفاصيل الأساسية للمسافر كما هي واردة في الصفحة الأولى من جواز سفره. كما توضح البطاقة أيضا تاريخ الوصول ومعلومات التأشيرة. وتسمى هذه البطاقة "بطاقة بوابة الدخول الإلكترونية"</p>

								<p>تعد بطاقة البوابة وثيقة رسمية لتشخيص الهوية أثناء تواجدكم في إسرائيل. إننا نطلب من جميع السائحين الاحتفاظ بالبطاقة في متناول اليد في جميع الأوقات، لإثبات وضعهم.</p>
								<p>الوصول عن طريق المعابر الجوية والبرية: يواصل المسافرون القادمون الوصول إلى منطقة أمتعة الركاب بعد خضوعهم لفحص جوازات سفرهم. تتوفر هنالك عربات تحت تصرفهم. ومن هنالك، يمكنهم المواصلة نحو مراقبة الجمارك، وصولا إلى مخرج المطار.</p>
								<div class="img-wrapper">
								    <img src=${getImgUrl() +
                      "/posts/immigration-customs/1.jpg"} class="img-responsive">
							    </div>
								<h3>معلومات حول المعابر البرّية الإسرائيلية </h3>
								<h3>الجمارك</h3>
								<p>يمكن عن طريق هذا الرابط تنزيل وثيقة تشمل معلومات عامة عن قوانين وسياسات مصلحة الجمارك:<br/><a href="" target="_blank" rel="noopener"><span class="ac-en-font">https://www.gov.il/en/departments/topics/tourist-and-travelers-info/govil-landing-page</span></a></p>
								<p>يرجى ملاحظة أن السفر عبر معبر جسر أللنبي خاضع لقيود وتوجيهات محددة. فعلى سبيل المثال، لا يجوز للزوار الذين يمرون عبر جسر أللنبي الواصل بين إسرائيل والأردن أن يحملوا نقدا أكثر من 2000 دينار أردني.</p>
								الجمارك، وضريبة القيمة المضافة للسياح:
								<a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" target="_blank" rel="noopener"><span class="ac-en-font">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</span></a>
								باستثناء معبر جسر أللنبي، وبما يخص سائر بوابات الدخول، بما فيها المطارات، فإن دليل السيّاح التالي يخص الزوار كما تعرّفهم سلطة المكوس والضرائب:
								<a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" target="_blank" rel="noopener"><span class="ac-en-font">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</span></a>
								<a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" target="_blank" rel="noopener"><span class="ac-en-font">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</span></a>
								<p>نرجو لفت عنايتكم إلى وجود نظام عبور جمركي ذو مسلكين، أحدهما أخضر والآخر أحمر في مطار بن غوريون ونقاط العبور المختلفة. يمكن للزوار الذين لا يحملون بضائع يتوجب التصريح عنها المرور عبر الممر الأخضر عند مخرج صالة وصول الركاب.</p>


		                        `,
      };
    },
  },

  {
    id: "Destination_For_All",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/page-tourist/1.jpg",
    mobBgImage: "/posts/bank/page-tourist/M.jpg",
    isVid: true,
    vidId: "QWA7qwsbbGY",
    title: "وجهة للجميع",
    smltitle: "",
    html: function() {
      return {
        __html: `
		
		
					<p>المزيد من الناس من جميع أنحاء العالم يحققون حلمهم في زيارة إسرائيل كل عام. وزارة السياحة تلتزم بتمكين الزيارة لكل من يرغب بذلك، بغض النظر عن أي عائق محتمل. عندما يتعلق الأمر بإمكانية الوصول، فإن إسرائيل هي دولة رائدة عالميًا في اتاحة ذلك. من البنية التحتية إلى الخدمة، تتكيف إسرائيل لتوفير إقامة سلسة ومقبولة.</p>
					<p>يرجى الاطلاع على الروابط أدناه لجميع أولئك الذين يمكنهم المساعدة وضمان إقامة سلسة وممتعة وخالية من العوائق.</p>
					<div class="img-wrapper">
					   <img src=${getImgUrl() +
               "/posts/destination-for-all/1.jpg"} class="img-responsive">
					</div><br>
					<h2 class="ac-margin-bottom-20">المنظمات غير الحكومية والسفر</h3>
					<p><b>كيرين كايميت ليسرائيل</b></p>
					<p><u>الغابات، الحدائق والمواقع المتاحة في إسرائيل</u><br/>
					في السنوات الأخيرة، عملت كيرين كايميت ليسرائيل <span class="ac-en-font">(KKL-JNF)</span> على تطوير مرافق مناسبة لذوي الاحتياجات الخاصّة في غاباتها وحدائقها. هدفنا هو فتح الطبيعة لجميع قطاعات السكان، من خلال خلق بيئة تمكّن الأشخاص ذوي الاحتياجات الخاصّة من التحرّك بأمان وراحة. لقد قطعنا خطوة إلى الأمام، وجلبنا الطبيعة إلى ساحة المدرسة بمشاريع فريدة في مدارس التربية الخاصة. 
					<a href="//www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/"  target="_blank" rel="noopener"><span class="ac-en-font">www.kkl-jnf.org</span></a>
				   </p>
		
				   <p><b>سلطة الطبيعة والحدائق الإسرائيلية </b></p>
				   <p>عملت سلطة الطبيعة والحدائق الإسرائيلية <span class="ac-en-font">(INPA)</span> في السنوات الأخيرة لجعل مواقعها في متناول الأشخاص ذوي الاحتياجات الخاصّة. في جميع الحدائق الوطنية والمحميات الطبيعية والمواقع الأثرية والتراثية، يجري العمل على تحسين إمكانية الوصول وتوفير مساعدات الوصول. تبذل <span class="ac-en-font">INPA</span> كل ما في وسعها لزيادة عدد الزوار ذوي الاحتياجات الخاصّة الذين يمكنهم التجول في المواقع والاستمتاع بها، مع جميع الأنشطة التي لديهم لتقديمها.<br/>
					يمكنك العثور على مزيد من المعلومات والخرائط ذات الصلة على الموقع. <a href="https://www.parks.org.il/en/accessibility/"  target="_blank" rel="noopener"><span class="ac-en-font">www.parks.org.il</span></a></p>
					 
					<div class="img-wrapper">
					<img src=${getImgUrl() +
            "/posts/destination-for-all/2.jpg"} class="img-responsive">
				 </div><br>
					 <p><b> "ياد سارة" للسياح</b></p>
					 <p>يمثل السفر إلى الخارج تحديات كبيرة لذوي الاحتياجات الخاصة. تقدم شركة ياد سارة المساعدة للسياح، والتي تضمن إجازة ممتعة ومريحة للفرد من ذوي الاحتياجات الخاصة وعائلته. بمجرد الانتهاء من الخطط مع مكتب السياحة، يمكن للزائر الجلوس والاسترخاء، مع العلم أن جميع الترتيبات تكون من قبل مندوب ياد سارة.</p>
				   
						<p> <u>بعض الخدمات المتوفرة</u>:<br/>
						 
						• إعارة المعدات الطبية اللازمة. يمكن ترتيب التسليم إلى فندق أو سكن مقابل رسوم معقولة.<br/>
						• تجهيز غرفتك في الفندق لجعل إقامتك أكثر راحة، بما في ذلك الأسرّة الخاصة والكراسي وما إلى ذلك.<br/>
						• إقراض اسطوانات / مكثفات الأكسجين.<br/>
						• النقل والمواصلات بواسطة عربات نقل الكراسي المتحركة، بما في ذلك التنقل من وإلى المطار وللمعالم السياحية.<br/>
						• توصية المرشدين السياحيين المتخصصين في إرشاد السياح محدودي الحركة وذوي الاحتياجات الخاصة بما في ذلك توصية بالمواقع السياحية المريحة.<br/>
						<br/>
						
		
					خدمة ياد سارة الشخصية متوفّرة بترتيب مسبق مع مكتب السياحة، لأي سائح من ذوي الاحتياجات الخاصة، الخدمة متوفرة في جميع أنحاء إسرائيل. لمزيد من التفاصيل، أو لترتيب النقل أو جولة، يرجى الاتصال بمكتب السياحة على <a href="tel:+97226444382">6444382-2-972+</a> أو مراسلتنا عبر البريد الإلكتروني: <a href="mailto:chaimvi@yadsarah.org.il"><span class="ac-en-font">chaimvi@yadsarah.org.il</span></a></p>
					<div class="img-wrapper">
					<img src=${getImgUrl() +
            "/posts/destination-for-all/3.jpg"} class="img-responsive">
				 </div><br>
					<p><b><span cLass="ac-en-font">Access Israel</span></b></p>
					<p><span cLass="ac-en-font">Israel</span> هي منظمة غير ربحية تعمل على تعزيز إمكانية الوصول ودمج الأشخاص ذوي الاحتياجات الخاصّة وكبار السن في جميع مجالات الحياة. تأسست شركة <span cLass="ac-en-font">Access Israel</span> في عام <span cLass="ac-en-font">1999</span> على يد يوفال واجنر، طيار مروحية سابق، والذي أنتهى به الامر على كرسي متحرك بعد حادث مروحية. تقوم شركة <span cLass="ac-en-font">Access Israel</span> بتنفيذ مشاريع مختلفة لتحقيق هدف الوصول إلى مجتمع كامل وشامل مثل مشاريع التوعية في المدارس، واستشارات إمكانية الوصول للشركات، ودورات الوصول، ودورات لغة الإشارة، والمؤتمرات حول مواضيع مختلفة وأكثر من ذلك. بالإضافة إلى ذلك، تعمل <span cLass="ac-en-font">Access Israel</span> على تعزيز إمكانية الوصول في القانون الإسرائيلي، وتدير مركزًا لشكاوى إمكانية الوصول وتنظم فعاليات توعية للجمهور. يعزز <span cLass="ac-en-font">Access Israel</span> إمكانية الوصول والاندماج في جميع مجالات الحياة والتعليم والسياحة والثقافة وحالات الطوارئ وغير ذلك.
						<a href="https://www.aisrael.org/?CategoryID=3030" target="_blank"><span cLass="ac-en-font">Accessible Tourism on Access Israel website</span></a></p>
		
						<p><u><span cLass="ac-en-font">LOTEM</span></u> هي أكبر منظمة في إسرائيل لأنشطة التعلم في الهواء الطلق للأطفال ذوي الاحتياجات الخاصة، وتوفر أنشطة تعليمية في الهواء الطلق بالإضافة إلى المشي لمسافات طويلة. سورين هيرشكو، بطل حرب أصيب بجروح بالغة في عملية عنتيبي عام <span class="ac-en-font">1976</span>، هو مؤسس ورئيس مجلس إدارة <span cLass="ac-en-font">LOTEM</span>. مصدر إلهامه لـ <span cLass="ac-en-font">LOTEM</span> يأتي من القلب: "إن منح الأطفال الحق الأساسي لتجربة الحياة في الهواء الطلق هو الهدف من حياتي ويملأني بفرح كبير." الموقع الرئيسي، <span cLass="ac-en-font">Emek HaShalom</span> (وادي السلام)، عبارة عن مزرعة مساحتها 40 فدانًا تقع في شمال إسرائيل، بالقرب من يوكنعام. تقع المزرعة في وسط واد جميل، وتحيط بها الطبيعة المزهرة والتدفق الهادئ للمياه. يوفر تجربة تعليمية عملية مع حديقة تعليمية، كما انه يمكن الوصول لمعاصر الزيتون والنبيذ، المخبز، والمسارات بواسطة الكراسي المتحركة.</p>
						<p><u><span cLass="ac-en-font">LOTEM</span></u> مدركة للدور المهم الذي يلعبه الهواء الطلق في حياة الإسرائيليين، والتأثير الذي لا يُحصى في إتاحة الوصول إلى المجتمع، ليس فقط على الأفراد ذوي الاحتياجات الخاصة ولكن على أسرهم والمجتمع أيضًا. كجزء من عملها لضمان عدم ترك أي عضو في المجتمع في الخلف، توفر <span cLass="ac-en-font">LOTEM</span> الفرصة للأطفال والكبار من ذوي الاحتياجات الخاصة للتعلم والمشاركة في الأنشطة الخارجية في جميع أنحاء البلاد. 
						<a href="https://www.lotem.net/?page_id=386" target="_blank"><span cLass="ac-en-font">www.lotem.net</span></a></p>
		
						<h2 class="ac-margin-bottom-20 ac-margin-top-20"> وسائل النقل والمواصلات</h3>
						<p><b>سلطة مطار إسرائيل</b></p>
						<p>بموجب القانون، فإن سلطة المطارات مسؤولة عن توفير البنية التحتية المادية لنشاط الكيانات التي تقدم الخدمة للمسافرين الذين يتلقون المساعدة. ومع ذلك، وفقًا لأنظمة النقل، فإن مسؤولية التعامل مع الركاب الذين يتلقون المساعدة وأمتعتهم، من لحظة دخولهم مبنى المطار، أو نزولهم من الطائرة، تقع على عاتق شركة الطيران المعنية التي يسافر عللا متنها الركاب. يتم توفير الخدمة الفعلية في مطار بن غوريون من قبل شركات المناولة الأرضية. تشمل الخدمة المرافقة والمساعدة للمسافرين ذوي الاحتياجات الخاصّة من خلال إجراءات المغادرة والوصول. 
						<a href="https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx" target="_blank"><span cLass="ac-en-font">www.iaa.gov.il</span></a></p>
						<p><b>هذه هي شركات المناولة الأرضية: </b></p>
						<p>ايرو هاندلينج: <a href="//www.aerohandling.com/" target="_blank"><span cLass="ac-en-font">www.aerohandling.com</span></a><br/>
						لاوفر للطيران: <span cLass="ac-en-font">GHI</span> <a href="//lauferghi.com/" target="_blank"><span cLass="ac-en-font">www.lauferghi.com</span></a><br/>
						 <a href="//www.qasisrael.co.il" target="_blank"><span cLass="ac-en-font">www.qasisrael.co.il</span></a>:<span cLass="ac-en-font">QAS</span><br/>
		
		
						</p>
						<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/destination-for-all/4.jpg"} class="img-responsive">
					 </div><br>
		
						<p>خط مساعدة وزارة السياحة (مكالمة محلية) <a href="tel:5678*">5678*</a></p>
						
						<p><b>وسائل النقل العامة</b></p>
						<p>القطارات - إذا احتجت إلى مساعدة من موظف في محطة القطار في الصعود والنزول من القطار، يرجى تنسيق رحلتك مع شركة قطار إسرائيل مسبقًا، من خلال الموقع الإلكتروني أو من خلال الخط المباشر للخدمة على <a href="tel:*5770">*5770</a>.</p>
						 
						<p>ستبذل شركة قطار اسرائيل قصارى جهدها لتزويدك بأفضل خدمة ممكنة، حتى لو لم تكن قد قمت بتنسيق رحلتك مسبقًا. على أي حال، يرجى تنسيق الرحلات التي تتم بين الساعة 20:00 مساءً والساعة 06:00 صباح اليوم التالي، وكذلك الرحلات التي تتم في ليلة السبت مسبقًا.</p>
						<p><u>الباصات</u> – جميع خطوط الباصات داخل المدن مهيئة لتقديم الخدمة للجميع. اما الباصات داخل الدولة متاحة بشكل جزئي. </p>
						<p><u>سيارات الأجرة</u>– من النادر ايجاد سيارة أجرة أثناء تنقلّها، يوصى بالطلب المسبق من  <a href="https://www.aisrael.org/?CategoryID=2657&ArticleID=64179" target="_blank"><span cLass="ac-en-font">https://www.aisrael.org/?CategoryID=2657&ArticleID=64179</span></a>.</p>
		
		
						<h2  class="ac-margin-bottom-20 ac-margin-top-20">الإقامة</h3>
						<p>جميع أنواع الإقامات في إسرائيل، التي تحتوي على 7 غرف أو أكثر، مطالبة بموجب القانون لتوفير غرفة واحدة على الأقل يمكن الوصول إليها. يُطلب أيضًا من جميع مزودي الخدمة الذين لديهم 25 موظفًا على الأقل أن يكون لديهم مشرف إمكانية الوصول. يمكن أن تؤكد لك هذه القوانين أنه لا يوجد ركن في إسرائيل لا يمكن العثور فيه على حل الإقامة المثالي. يوصى دائمًا بإجراء تنسيق سريع عبر البريد الإلكتروني قبل الزيارة.</p>
						<div class="img-wrapper">
							<img src=${getImgUrl() +
                "/posts/destination-for-all/5.jpg"} class="img-responsive">
					 	</div><br>
						
						
						<div id="ac-left-nav">
						<h2 class="ac-margin-bottom-20 pr-fs-28 chapter-title inline-block">
											<span class="ng-binding">امكانية الوصول إلى الشواطئ لذوي الاحتياجات الخاصة</span>
										</h3>
						<ul id="chaptersList" class="list-unstyled xs-mb-0">
							
							
								<li data-show="1" class="ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0">
									
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt nounderline  ng-binding reforma-bold">المنطقة الشماليّة</span>						                  
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
								
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<li data-show="2" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">منطقة حيفا</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<li data-show="3" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">المنطقة المركزية</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<div class="clear show-on-mobile"></div>
								<li data-show="4" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">منطقة تل ابيب</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li>
								<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show="5" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">المنطقة الجنوبيّة</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<div class="clear"></div>
							</ul>
						</div>
		
						<div id="res">
							<!-- ac part -->
							<div class="ac-part ac-part-1 ac-part-active">
		
								<div ng-include="chapterItem" class="row row-gov ng-scope">
									<!-- Sub Title -->
									<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
										<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
											<!-- ngIf: Guide.ShowChaptersIndex -->
											<span class="ng-binding">Northern District</span>
										</h3>
									</div>
		
									<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
										<!-- IMAGE TAG  ------->
										<!--- Image-->
		
								<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
									<div class="position-relative col-lg-10 lg-p-0">
										<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
										<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
										</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
										<!--Image desc-->
										<div>
											<div class="position-absolute">
												<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
											</div>
											<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
												<span class="small-txt ng-binding"></span>
												<span class="small-txt ng-binding"></span>
											</div><!-- end ngIf: CurrChapter.Image -->
										</div>
									</div>
								</div><!-- end ngIf: CurrChapter.Image -->
															<!-- End IMAGE TAG  ------->
		
															<div class="row row-gov no-gutters">
																<!--Content Text-->
																<div id="GuidesChapterContent-1" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
									<tbody>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Kineret Municipal Unio</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking&nbsp;&nbsp; &nbsp;</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Tzinbari</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Berniki</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>At the nearby Shikmim beach</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Shikmim</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Hukok</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Amnon</td>
											<td>نعم&nbsp;</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Kinar</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Doga</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>Closed</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Tze’elon</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Kursi</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>At the nearby Levanon beach</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Levanon</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Halukim</td>
											<td>At the nearby Levanon beach</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>At the nearby Levanon beach</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Shizaf</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Dugit – Golan</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Gofra</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Tiberias</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Guy</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Galei Kineret - Rimonim</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Leonardo Pacific</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>Closed for renovations</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Coco Hot / Holiday Inn</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Jordan Valley Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Ein Gev Vacation</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Ginnosar</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Migdal Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Restal Magdala</td>
											<td>نعم</td>
											<td>لا</td>
											<td>&nbsp;</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Mateh Asher Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Banana Beach Achziv</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Nahariya</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Sokolov</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Galil Central</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Acco</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Argaman Central</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Hatmarim</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
									</tbody>
								</table></div></div>
		
								<p>&nbsp;</p>
								</div>
		
																<!--Chapters/Collapse-->
																<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
																	<!-- ngRepeat: collapse in CurrChapter.Collapses -->
																</div>
		
																<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
																<!--End of Chapters/Collapse-->
		
																<div class="col-12 xs-mb-25 lg-mb-30">
																	<!-- Files for Download-->
																	<!-- Files for Download-->
								<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
																	<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
																		<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																			<!-- horizontal line -->
																			<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																				<div class="horizontal-line"></div>
																			</div>
																		</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
																		<!--arrows subject nav  דפדוף-->
																		<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																			<!--  לדף הקודם -->
																			<!-- ngIf: CurrChapterindex > 0 -->
		
																			<!--  לדף הבא -->
																			<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																				<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																					<span class="small-txt gray-txt width-100">الصفحة التالية:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">منطقة حيفا</span>
																				</div>
																				<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																			</div>
																		</div>
																	</div><!-- end ngIf: !isOnPrintMode -->
																</div>
															</div>
														</div>
													</div>
		
							</div>
							<!-- ac- part -->
		
							<!-- ac part 2 -->
							<div class="ac-part ac-part-2">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding"> منطقة حيفا </span>
								</h3>
							</div>
		
							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
			<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
			<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
			</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
			<!--Image desc-->
			<div>
				<div class="position-absolute">
					<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
				</div>
				<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
					<span class="small-txt ng-binding"></span>
					<span class="small-txt ng-binding"></span>
				</div><!-- end ngIf: CurrChapter.Image -->
			</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
								<!-- End IMAGE TAG  ------->
		
								<div class="row row-gov no-gutters">
									<!--Content Text-->
									<div id="GuidesChapterContent-2" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table align="left" cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong> بلدية كريات يام </strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>اسم الشاطئ</strong></td>
				<td><strong>موقف سيارات</strong></td>
				<td><strong>حمامات ومراحيض</strong></td>
				<td><strong>وجود ظل</strong></td>
				<td><strong>وجود ماء</strong></td>
				<td><strong>كراسي استحمام لذوي الاحتياجات الخاصّة</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>زفولون</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>بلدية حيفا</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>اسم الشاطئ</strong></td>
				<td><strong>موقف سيارات</strong></td>
				<td><strong>حمامات ومراحيض</strong></td>
				<td><strong>وجود ظل</strong></td>
				<td><strong>وجود ماء</strong></td>
				<td><strong>كراسي استحمام لذوي الاحتياجات الخاصّة</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>زمير  1</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>زمير  2</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>نيوت مركز كريات حاييم</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>بات جاليم 1</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>بات جاليم 2</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>المجلس الإقليمي حوف هكرمل</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>اسم الشاطئ</strong></td>
				<td><strong>موقف سيارات</strong></td>
				<td><strong>حمامات ومراحيض</strong></td>
				<td><strong>وجود ظل</strong></td>
				<td><strong>وجود ماء</strong></td>
				<td><strong>كراسي استحمام لذوي الاحتياجات الخاصّة</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>دور المركزية 2</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
				<td>لا</td>
				<td>نعم</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>نيفي يام</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
				<td>لا</td>
				<td>نعم</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>القناة المائية</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
				<td>لا</td>
				<td>نعم</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>المجلس الإقليمي جسر الزرقاء</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>اسم الشاطئ</strong></td>
				<td><strong>موقف سيارات</strong></td>
				<td><strong>حمامات ومراحيض</strong></td>
				<td><strong>وجود ظل</strong></td>
				<td><strong>وجود ماء</strong></td>
				<td><strong>كراسي استحمام لذوي الاحتياجات الخاصّة</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>الجسر</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>بلدية الخضيرة</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>اسم الشاطئ</strong></td>
				<td><strong>موقف سيارات</strong></td>
				<td><strong>حمامات ومراحيض</strong></td>
				<td><strong>وجود ظل</strong></td>
				<td><strong>وجود ماء</strong></td>
				<td><strong>كراسي استحمام لذوي الاحتياجات الخاصّة</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>كفار يام</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>اولغا سنترال 2</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
		</tbody>
		</table></div></div>
		
		<p>&nbsp;</p>
		</div>
		
									<!--Chapters/Collapse-->
									<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
										<!-- ngRepeat: collapse in CurrChapter.Collapses -->
									</div>
		
									<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
									<!--End of Chapters/Collapse-->
		
									<div class="col-12 xs-mb-25 lg-mb-30">
										<!-- Files for Download-->
										<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
										<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
											<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
												<!-- horizontal line -->
												<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
													<div class="horizontal-line"></div>
												</div>
											</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
											<!--arrows subject nav  דפדוף-->
											<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
												<!--  לדף הקודם -->
												<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
													<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
													<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
														<span class="small-txt gray-txt width-100"> الصفحة السابقة:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">المنطقة الشمالية</span>
													</div>
												</div><!-- end ngIf: CurrChapterindex > 0 -->
		
												<!--  לדף הבא -->
												<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
													<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
														<span class="small-txt gray-txt width-100">الصفحة التالية:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">المنطقة المركزية</span>
													</div>
													<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
												</div>
											</div>
										</div><!-- end ngIf: !isOnPrintMode -->
									</div>
								</div>
							</div>
						</div>
							</div>
							<!-- end ac part-2 -->
		
							<!-- ac-part-3 -->
							<div class="ac-part ac-part-3">
														<div ng-include="chapterItem" class="row row-gov ng-scope">
														<!-- Sub Title -->
														<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
															<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
																<!-- ngIf: Guide.ShowChaptersIndex -->
																<span class="ng-binding">Central District</span>
															</h3>
														</div>
								
														<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
															<!-- IMAGE TAG  ------->
															<!--- Image-->
								
								<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
									<div class="position-relative col-lg-10 lg-p-0">
										<!-- ngIf: CurrChapter.Image.ClickURLRef -->
								
										<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
										</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
										<!--Image desc-->
										<div>
											<div class="position-absolute">
												<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
											</div>
											<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
												<span class="small-txt ng-binding"></span>
												<span class="small-txt ng-binding"></span>
											</div><!-- end ngIf: CurrChapter.Image -->
										</div>
									</div>
								</div><!-- end ngIf: CurrChapter.Image -->
															<!-- End IMAGE TAG  ------->
								
															<div class="row row-gov no-gutters">
																<!--Content Text-->
																<div id="GuidesChapterContent-3" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
									<tbody>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Emek Hefer Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Michmoret – Station number 1</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Michmoret – Station number 2</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>Joint with number 1</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beit Yannai</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>NeUrim Beach</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Netanya</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Kiryat Tzanz</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>HaOnot Beach</td>
											<td>אין חניה בחוף עצמו</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Ampi Beach</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Herzl</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>لا</td>
											<td>نعم</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Sironit Beach A</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Sironit Beach B</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>نعم</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Argaman Beach</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Poleg Beach</td>
											<td>نعم</td>
											<td>Bathrooms only</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Hof Hasharon Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Shefayim (Ga’ash)</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Rishon Le-Zion</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 1 – Hakachol (Blue) Beach</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 2 – Neve Hof Beach</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>نعم</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 3 – Hofit Beach</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 4 – Tel Yonah Beach</td>
											<td>لا</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 5 – Hayeladim (Children’s) Beach</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 6 – separate beach</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Gan Raveh Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Palmahim Beach</td>
											<td>نعم</td>
											<td>نعم</td>
											<td>لا</td>
											<td>لا</td>
											<td>لا</td>
										</tr>
									</tbody>
								</table></div></div>
								
								<p>&nbsp;</p>
								</div>
								
																<!--Chapters/Collapse-->
																<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
																	<!-- ngRepeat: collapse in CurrChapter.Collapses -->
																</div>
								
																<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
																<!--End of Chapters/Collapse-->
								
																<div class="col-12 xs-mb-25 lg-mb-30">
																	<!-- Files for Download-->
																	<!-- Files for Download-->
								<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
								
																	<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
								
																		<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																			<!-- horizontal line -->
																			<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																				<div class="horizontal-line"></div>
																			</div>
																		</div><!-- end ngIf: Guide.Chapters.length > 1 -->
								
																		<!--arrows subject nav  דפדוף-->
																		<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																			<!--  לדף הקודם -->
																			<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
																				<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
																				<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
																					<span class="small-txt gray-txt width-100"> الصفحة السابقة:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">منطقة حيفا</span>
																				</div>
																			</div><!-- end ngIf: CurrChapterindex > 0 -->
								
																			<!--  לדף הבא -->
																			<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																				<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																					<span class="small-txt gray-txt width-100">الصفحة التالية:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
																				</div>
																				<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																			</div>
																		</div>
																	</div><!-- end ngIf: !isOnPrintMode -->
																</div>
															</div>
														</div>
													</div>
							</div>
							<!-- end ac-part-3 -->
		
							<!-- ac-part-4 -->
							<div class="ac-part ac-part-4">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Tel Aviv District</span>
						</h3>
					</div>
		
					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
		<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
		<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
		</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
		<!--Image desc-->
		<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
		</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->
		
						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-4" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
		<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Herzliya</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Nof Yam</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Hasharon&nbsp;&nbsp; &nbsp;Yes</td>
		<td>نعم</td>
		<td>لا</td>
		<td>لا</td>
		<td>نعم</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Zevulun</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Acadia North Beach&nbsp;&nbsp; &nbsp;</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>لا</td>
		<td>نعم</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Acadia South Beach</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>لا</td>
		<td>نعم</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Acadia South Beach – Disabled</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>لا</td>
		<td>نعم</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Tel Aviv - Jaffa</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaTzuk Beach – Station number 1</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>لا</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Tel Baruch Beach – Station number 1</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>لا</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Nordau (Metzitzim) Beach</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Nordau separate beach</td>
		<td>نعم</td>
		<td>Bathrooms only</td>
		<td>نعم</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Gordon</td>
		<td>لا</td>
		<td>Bathrooms only</td>
		<td>لا</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Bograshov</td>
		<td>لا</td>
		<td>Bathrooms only</td>
		<td>لا</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Allenby (Jerusalem)</td>
		<td>لا</td>
		<td>نعم</td>
		<td>لا</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Charles Clore</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Jaffa – Givat HaAliyah</td>
		<td>نعم</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Hilton North</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>نعم</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaTzuk Beach – Station number 2</td>
		<td>نعم</td>
		<td>Bathrooms only</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Frishman</td>
		<td>لا</td>
		<td>Bathrooms only</td>
		<td>لا</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Aviv Beach</td>
		<td>لا</td>
		<td>Bathrooms only</td>
		<td>لا</td>
		<td>لا</td>
		<td>نعم</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Bat Yam</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>HaSela – Station number 1</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaSela – Station number 2</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>HaSela – Station number 3</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Sample Beach</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Riviera</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Separate beach</td>
		<td>نعم</td>
		<td>Bathrooms only</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Tayo</td>
		<td>نعم</td>
		<td>Bathrooms only</td>
		<td>لا</td>
		<td>لا</td>
		<td>لا</td>
		</tr>
		</tbody>
		</table></div></div>
		
		<p>&nbsp;</p>
		</div>
		
							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>
		
							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->
		
							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> الصفحة السابقة:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->
		
										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">الصفحة التالية:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Southern District</span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
							</div>
							<!-- end ac-part-4 -->
		
							<!-- ac-part-5 -->
							<div class="ac-part ac-part-5">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Southern District</span>
								</h3>
							</div>
		
							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
			<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
			<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
			</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
			<!--Image desc-->
			<div>
				<div class="position-absolute">
					<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
				</div>
				<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
					<span class="small-txt ng-binding"></span>
					<span class="small-txt ng-binding"></span>
				</div><!-- end ngIf: CurrChapter.Image -->
			</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
								<!-- End IMAGE TAG  ------->
		
								<div class="row row-gov no-gutters">
									<!--Content Text-->
									<div id="GuidesChapterContent-5" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Ashdod</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Mei Ami Beach</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Lido</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Oranim</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>لا</td>
				<td>نعم</td>
				<td>نعم</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Hakshatot</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Separate beach</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Rova K</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Riviera</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td colspan="6" style="text-align: center;"><strong>Hof Ashkelon Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Nitzanim</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zikim</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Ashkelon</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Bar Kochva North</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Bar Kochva South</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Delila North</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Delila South</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Ashkelon National Park Beach</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Separate beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Tamar Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Mazor Springs</td>
				<td>نعم</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Meridian Beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Hod Hotel Beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Tzel Harim</td>
				<td>نعم</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Crown Plaza Beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Lot</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Lot’s Wife</td>
				<td>نعم</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Ein Bokek South</td>
				<td>نعم</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Daniel Hotel Beach</td>
				<td>نعم</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Solarium Beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Isrotel Beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>International Beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Leonardo Plaza Beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zohar Springs (North)</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Separate beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Leonardo Club Beach</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>نعم</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Eilat&nbsp;&nbsp; &nbsp;</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><br>
				Separate beach</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
				<td>لا</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Herod’s beach</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><br>
				Northwestern Beach</td>
				<td>نعم</td>
				<td>Bathrooms only</td>
				<td>لا</td>
				<td>لا</td>
				<td>نعم</td>
			</tr>
		</tbody>
		</table></div></div>
		
		<p>&nbsp;</p>
		</div>
		
									<!--Chapters/Collapse-->
									<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
										<!-- ngRepeat: collapse in CurrChapter.Collapses -->
									</div>
		
									<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
									<!--End of Chapters/Collapse-->
		
									<div class="col-12 xs-mb-25 lg-mb-30">
										<!-- Files for Download-->
										<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
										<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
											<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
												<!-- horizontal line -->
												<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
													<div class="horizontal-line"></div>
												</div>
											</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
											<!--arrows subject nav  דפדוף-->
											<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
												<!--  לדף הקודם -->
												<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
													<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
													<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
														<span class="small-txt gray-txt width-100"> الصفحة السابقة:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
													</div>
												</div><!-- end ngIf: CurrChapterindex > 0 -->
		
												<!--  לדף הבא -->
												<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="true">
													<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
														<span class="small-txt gray-txt width-100">الصفحة التالية:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding"></span>
													</div>
													<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
												</div>
											</div>
										</div><!-- end ngIf: !isOnPrintMode -->
									</div>
								</div>
							</div>
						</div>
							</div>
							<!-- end ac-part-5 -->
		
						</div>
						<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/destination-for-all/6.jpg"} class="img-responsive">
					 </div><br>
							
							`,
      };
    },
  },

  {
    id: "Crazy_Night",
    ctg: "telaviv",
    bgImage: "/posts/bank/crazy-night/1.jpg",
    mobBgImage: "/posts/bank/crazy-night/M.jpg",
    isVid: false,
    // vidId: "ogEN7aRT0SM",
    title: "Looking for a crazy nightlife?",
    smltitle: "",
    html: function() {
      return {
        __html: `<div class="ac-cradit">
								<span class="ac-cradit-text">Credits:</span>
									<br/>
									<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
									<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
								</div>
								<p></p>
								</div>
                               <h3>
                                 Book your trip to Tel Aviv!
                               </h3>
                               <p>
                                 Amazing nightlife in Tel Aviv <a href="https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife" target="_blank">Click here >> </a>
                               </p>
		                        `,
      };
    },
  },
  //Hadar asked to hide this post on 2021-02-01
  // {
  // 		id:"Heart_Of_The_World",
  //        	ctg : "jerusalem",
  //         bgImage : "/posts/bank/heart-of-the-world/1.jpg",
  //         mobBgImage : "/posts/bank/heart-of-the-world/M.jpg",
  //        	isVid:true,
  //        	vidId: "FvAWuLQEOJw",
  //         title : "JERUSALEM - THE HEART OF THE WORLD",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         `
  //     }
  //   }
  // },
  //end Hadar asked to hide this post on 2021-02-01

  {
    id: "Nabi_Samuel_ar",
    // ctg : "eilat-negev",
    ctg: "jerusalem",
    bgImage: "/posts/bank/nabisamuelar/1.jpg",
    mobBgImage: "/posts/bank/nabisamuelar/M.jpg",
    isVid: false,
    title: "قبر النبي صموئيل",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                

                        
					    <p>قبر النبي صموئيل هو مكان مقدس بالنسبة لليهود والمسلمين والمسيحيين باعتباره موقع ضريح النبي صموئيل الذي قاد بني إسرائيل خلال حقبة القضاة. وبحسب العقيدة اليهودية فإنه الشخص الذي اختار الملك شاؤول والملك دافيد بينما تعبره العقيدة الإسلامية الشخص الذي اختار الملك طالوت.</p>
                        <p>يقع الموقع المعروف باللغة العربية باسم النبي صموئيل شمالي أورشليم القدس على قمة ارتفاعها <span class="ac-en-font">809</span> أمتار فوق سطح البحر. ويشكل قبر النبي صموئيل حديقة وطنية وموطن أطلال قلعة صليبة، ومسجد وكنيس، وحطام بلدة تعود لفترة الهيكل الثاني، وكهوف دفن تعود لفترة الهيكل الأول، وبقايا معصرة عنب من الحقبة البيزنطية، ومحجر صليبي فضلاً عن بيارات قديمة.</p>
                        <div class="img-wrapper">
						    <img src=${getImgUrl() +
                  "/posts/nabisamuelar/1.jpg"} class="img-responsive">
					    </div>
                        <p>المبنى الرئيسي الذي ما زال موجودًا هذه الأيام هو كنيسة القلعة التي أنشأها الصليبيون في القرن الـ <span class="ac-en-font">12</span>. ويضم مبنى الكنيسة مسجدًا أنشأه المماليك في القرن الـ 14، بينا يصلي اليهود في كهف تحت المبنى في المكان الذي تم تحديده كموقع ضريح النبي.</p>
                        <p>بفضل ارتفاعه الشاهق، يتيح قبر النبي صموئيل إطلالة رائعة على كل الأماكن المحيطة، بدءًا بأورشليم القدس ورام الله، ومرورًا بمرتفعات يهودا، ونزولاً إلى الساحل الساحلي إذا كانت الأجواء صافية.</p>
                        <p>بينما كان يُعتبر قبر النبي صموئيل على مر العصور التي مضت مسرحًا للعديد من المعارك، أبرزها المعركة التي دارت ما بين الصليبيين وصلاح الدين، نظرًا لموقعه الاستراتيجي، إلا أن المشهد هناك بات أهدأ بكثير حاليًا مما كان عليه. فبإمكانك الاسترخاء في الظل في منطقة النزهات تحت أشجار التين على مقربة من ينبوع حانا، الذي سُمي بعد والدة النبي ويتدفق من الكهف نحو الخارج.</p>

                        
                       
						 `,
      };
    },
  },
  // {
  // 		id:"Welcome_To_Eilat",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/eilat2/1.jpg",
  //         mobBgImage : "/posts/bank/eilat2/M.jpg",
  //        	isVid:false,
  //        	// vidId:"ZdnNT-GDJv4",
  //         title : "WELCOME TO EILAT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                           <h3>A city of sun and fun!</h3>
  // 							<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
  // 							<p>Whether you come to stay in Eilat as a family, a couple or even by yourself, you will find loads to see and do here. Accommodations are abundant, ranging from youth hostels to the r luxury resorts, offering visitors an unforgettable 5 star experience, with everything from the finest restaurants to beach side service.</p>
  // 							<p></p>
  // 							<div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/welcome-to-eilat/1.jpg"} class="img-responsive">
  // 							</div>
  // 							<p>With a whopping 360 Sunny days a year, a visit to Eilat is a fun-filled experience, where you get to relax, recharge and get energized all at the same time. This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
  // 							<h3>The Red Sea</h3>
  // 							<p>An amazing attraction, Eilat’s gorgeous Red Sea and the 10-kilometer-long shoreline surrounding it are the city’s focal point and the main attraction for tourists from far and wide. With their clean, clear and unexpectedly cool water, allowing a welcome escape from the city’s high temperatures and dry air, and the wide variety of facilities and attractions, Eilat’s beaches are the perfect spot for sunbathing, rest and relaxation.</p>
  // 							<p>Extreme sports enthusiasts will love the dozens of water sports clubs spread along the Southern and Northern coasts of Eilat, and the range of activities such as Jet skiing, banana boats, tubing, kayaking and much more.</p>

  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"The_Ultimate_Holiday",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/eilat1/1.jpg",
  //         mobBgImage : "/posts/bank/eilat1/M.jpg",
  //        	isVid:false,
  //         title : "THE ULTIMATE HOLIDAY DESTINATION",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 					   <p><strong data-mk-aweb-org-font-size="17">Eilat,&nbsp;</strong>the southernmost town in Israel, has all you need for a perfect vacation. Whether you're looking for a romantic gateway, family vacation, action-packed adventure or partying with your friends, this bustling resort town on the shores of the Red Sea is the place for you. Mediterranean Sun, crystal clear water, soothing Spas, vibrant night life, Tax free shopping, and endless list of attractions – that's Eilat.</p>
  // 					   <p><strong data-mk-aweb-org-font-size="17">Soak up the sun.&nbsp;</strong>With summer sun that shines throughout the year, the best time to visit Eilat is…anytime! Even in the middle of a freezing European winter Eilat offers an escape from the cold. Just hop on a plane and in few short hours you'll stop shivering and feel revived.</p>
  // 					   <p><strong data-mk-aweb-org-font-size="17">Choose your vacation home. &nbsp;</strong>Hostels and on the budget inns or luxury world-class and boutique hotels. Family and groups oriented resorts or secluded, peaceful and romantic ones - Eilat offers a large variety of accommodations to fit every budget and need.</p>
  // 					   <p><strong data-mk-aweb-org-font-size="17">Jump into the water.</strong>&nbsp;With over 7 kilometers of breathtaking Rad Sea coastline, Eilat has plenty to offer when it comes to water activities. From snorkeling and scuba-diving to wind- surfing, kite-surfing, sailing and so much more – this city got you covered.</p>
  // 					   <p>Experience the&nbsp;<strong data-mk-aweb-org-font-size="17">Dolphin's reef</strong>, a family friendly ecological beach with a gorgeous botanical garden, relaxation pools and the main attraction – an opportunity to watch, touch, swim and dive with Dolphins. &nbsp;(<em>Don't worry, all interaction with these beautiful creatures is based solely on the Dolphin's free will</em>).</p>

  //                              <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/the-ultimate-holiday/1.jpg"} class="img-responsive">
  // 							</div>
  // 					   <p>Visit the&nbsp;<strong data-mk-aweb-org-font-size="17">Underwater Observatory</strong>, one of Eilat's most popular attractions that allows you and your family to view and learn about the Red Sea unique Marine life. Through the huge glass windows you'll see sharks, turtles, stings rays and multicolored Red Sea fishes. Through sailing on a glass ship, you'll feel a part of this magical underwater kingdom.</p>
  // 					   <p>Don't miss the world famous<strong data-mk-aweb-org-font-size="17">&nbsp;Coral Beach Nature Reserve&nbsp;</strong>and its stunning coral reef<strong data-mk-aweb-org-font-size="17">.&nbsp;</strong>Go snorkeling and scuba diving to see the colorful fish and extraordinary water plants in this rare delicate natural habitat.</p>
  // 					   <p><strong data-mk-aweb-org-font-size="17">Go on a desert adventure.&nbsp;</strong>The Negev desert offers some of the most spectacular scenic routes in Israel.&nbsp; Hike, mount bike or take a Jeep tour to explore and marvel at the beauty that surrounds you.</p>
  // 					   <p>Only 25 kilometers north of Eilat you'll find the&nbsp;<strong data-mk-aweb-org-font-size="17">Timna Park Valley</strong>. Go on a tour, explore the gorgeous scenery and special antiquities of the world's first copper mine and enjoy the many attractions it offers for families and adventurers among you.</p>
  // 					   <p>Want to expand your adventure? The city is easily accessible to the rest of the country. Take a day trip to the Dead Sea or Jerusalem.</p>
  // 					   <p><strong data-mk-aweb-org-font-size="17">Allow yourself to relax.&nbsp;</strong>Eilat is a laid back town where you can truly slow down and rest. True to its nature, it's also filled with fantastic Spa facilities that offers lots of different treatments from traditional messages to water therapy.&nbsp;<em>Trust us, it's worth it!</em></p>
  // 					   <p><strong data-mk-aweb-org-font-size="17">Buy, eat, drink and party.&nbsp;</strong>Shop in the city's promenade's Bazaar, Luxurious shopping Boulevard and numerous malls<strong data-mk-aweb-org-font-size="17">&nbsp;–&nbsp;</strong>it's all TAX free<strong data-mk-aweb-org-font-size="17">!&nbsp;</h3>
  // 					   <p><strong data-mk-aweb-org-font-size="17">Go out to a night on the town.</strong>&nbsp;Get entertained a see the amazing colorful audiovisual show of the musical fountain; prepare to be wowed with the Broadway style Wow show that combines dancing, acrobatics light effects, great soundtrack and many more surprises.</p>
  // 					   <p>Dine in one of the many restaurants and bars in town and then go hit the dancefloor in a club.</p>
  // 					   <p>It doesn't get better than this.</p>

  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"Eilat_Calling",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/eilat2/1.jpg",
  //         mobBgImage : "/posts/bank/eilat2/M.jpg",
  //        	isVid:false,
  //        	// vidId:"ZdnNT-GDJv4",
  //         title : "365 DAYS OF NONSTOP SUNNY JOY",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 							<p>Incredible adventure in Israel’s no. 1 vacation resort by the red sea.</p>
  // 							<p>The capital of the red sea, Eilat is Israel's famous resort city drawing nearly 2.8 million visitors a year who come to vacation by the shores of the stunning red sea.</p>
  // 							<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
  // 							<p>A visit to Eilat is a fun-filled experience where you get to relax, recharge and get energized all at the same time. Eilat boasts a whopping 360 sunny days a year, making it extremely popular with tourists from far and wide looking to get away from their cold winter climate.</p>
  // 							<p>This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
  // 									                        `
  //     }
  //   }
  // },
  {
    id: "Eilat_Doolphin_Reef",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    vidId: "3Cvz8GoxNzA",
    title: "ذكرى تدوم مدى الحياة",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
							    <!--<p><strong>تعال واستمتع بكنوز البحر الأحمر هذه في دولفين ريف إيلات.<br/>
								تواصل مع الدلافين في منطقة الجذب الفريدة على شاطئ البحر في إيلات</strong></p>
								<p>يعد شعاب الدلافين  إيلات نزًا للحياة البرية على شواطئ البحر الأحمر ، حيث تسير المغامرات المليئة بالإثارة جنبًا إلى جنب مع الطبيعة والاسترخاء. في الشعاب المرجانية ، يدخل الزوار إلى موقع سحري يتفاعلون مع الدلافين في بيئتها الطبيعية ؛ شاطئ مذهل ، حيث الحياة النباتية في ازدهار كامل والمنظر خلاب.</p>
								<p>يُعد الرصيف الطويل بالموقع مكانًا رائعًا لمشاهدة الدلافين "قارورية الأنف" المحلية أثناء قيامها بأعمالها الروتينية اليومية المتمثلة في تناول الطعام واللعب والصيد والتزاوج والتواصل الاجتماعي - وفي بعض الأحيان تختار التفاعل مع زوار الموقع من البشر أيضًا. يمكن للزوار الذين يبحثون عن المزيد من الخبرة العملية محاولة التفاعل مع الدلافين من خلال أي نشاط من الأنشطة العديدة المفتوحة للجمهور.</p>
								<p>تجربة سحرية حقًا هي مشاهدة الدلافين أثناء وجبات الطعام ، والتي تم تحديد موعد لها مع أوقات إطعام جذابة. هناك شيء مثير في اللعب الطفولي والحيوي للدلافين مع معالجيها ، في انتظار طعامهم بفارغ الصبر. إن البهجة المطلقة التي تشعر بها بمجرد أن تلتقي الوجبة بالعشاء بشكل غريزي تقريبًا تثير جولة من التصفيق من قبل جميع أفراد الجمهور. في الواقع ، يميل الزائرون إلى الشعور بالإثارة والرضا كما لو كانوا هم من تلقوا أنفسهم.</p>
								<h3>قم بالغطس والغوص مع الدلافين</h3>
								<p>يكمن جمال شعاب الدلافين في أن الزوار لا يحتاجون إلى البقاء على مسافة ، ولكن يمكنهم الغطس والغوص مع الدلافين ، ملاحظتها في نظامها البيئي الفريد ؛ السباحة حتى عمق ستة أمتار والاستمتاع بالحياة الرائعة والسرية كما تحدث بشكل طبيعي تحت سطح البحر. أو يمكن للزوار اختيار الغطس مع الدلافين بالقرب من مستوى سطح البحر ؛ تطفو بجانب الدلافين ، مما يتيح تفاعلًا مرحًا بين البشر والدلافين</p>
								<p>"حمامات الاسترخاء" في شعاب الدلافين هي المكان الذي يمكن للزوار فيه ترك مخاوفهم تتلاشى بينما تطفو على صوت الموسيقى الهادئة. تحافظ المطاعم الموجودة في الموقع على شعور الزائرين بالدلال والرعاية ، دون الحاجة إلى الخروج من الملاذ الصغير للجمال الطبيعي.</p>
								-->

								<h3>ذكرى تدوم مدى الحياة</h3>


								<p>تعال واستمتع بكنوز البحر الأحمر في دولفين ريف إيلات</p>

								<h3>تمتع مع الدلافين في شاطئ البحر في إيلات</h3>


								<p>يعد الدولفين ريف في ايلات  كنزًا للحياة البرية على شواطئ البحر الأحمر، حيث تقام المغامرات المليئة بالإثارة جنبًا إلى جنب مع الطبيعة والاسترخاء. يدخل الزوار إلى موقع سحري ويتفاعلون مع الدلافين في بيئتها الطبيعية ويتمتعون بالمناظر الخلابة من الشاطئ حيث تزدهر الحياة.</p>

								<p>يُعد الرصيف الطويل بالموقع مكانًا مثاليا لمشاهدة الدلافين المحلية والتي تعرف ايضا باسم الدلافين قارورية الأنف أثناء قيامها بأعمالها اليومية المتمثلة في تناول الطعام واللعب والصيد والتزاوج والتواصل الاجتماعي - وفي بعض الأحيان تختار حتى التفاعل مع زوار الموقع من البشر أيضًا. يمكن للزوار الذين يبحثون عن المزيد من التفاعل مع الدلافين المشاركة في الكثير من الانشطة المفتوحة للجمهور.</p>

								<p>تجربة سحرية اخرى هي مشاهدة الدلافين أثناء تناولهم وجبات الطعام. هناك شيء مثير للحماس في اللعب الطفولي والحيوي للدلافين مع مدربيها خلال انتظارهم  لطعامهم بفارغ الصبر. إن البهجة الغريزية المطلقة التي تشعر بها الدلافين بمجرد أن تلتقي بوجبة العشاء تكاد تثير جولة من التصفيق من قبل جميع أفراد الجمهور. في الواقع ، يميل الزائرون إلى الشعور بالإثارة والرضا كما لو كانوا هم من تلقوا الطعام بأنفسهم.</p>

								<h3>قم بالغطس والغوص مع الدلافين </h3>


								<p>يكمن جمال دولفين ريف في أن الزوار لا يحتاجون إلى البقاء على مسافة بل يمكنهم الغطس والغوص مع الدلافين، مشاهدتها عن قرب في نظامها البيئي الفريد؛ السباحة حتى عمق ستة أمتار والاستمتاع بالحياة الرائعة والسرية كما تحدث بشكل طبيعي تحت سطح البحر، أو يمكن للزوار اختيار الغطس مع الدلافين بالقرب من سطح البحر، مما يتيح تفاعلًا مرحًا بين البشر والدلافين</p>

								<p>"حمامات الاسترخاء" في دولفين ريف هي المكان الذي يمكن للزوار فيه ترك مخاوفهم والاسترخاء مع صوت الموسيقى الهادئة. تحافظ المطاعم الموجودة في الموقع على شعور الزائرين بالدلال والرعاية ، دون الحاجة إلى الخروج من هذه الواحة الطبيعية الصغيرة.</p>

		                        `,
      };
    },
  },
  {
    id: "Action_Packed_Eilat",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: false,
    title: "العمل معبأ في إيلات",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               <!--<p>So, you’ve heard about the fabulous beaches, the awesome nightlife and fantastic atmosphere of year round sunny Eilat, but aren’t you wondering, amongst all the leisure, what to do with the excess energy? Well wonder no more. Here are just some of the amazing ways to have some action-packed fun in the sun:</p>
		                       
                                   
								   <p>Eilat’s stunning red sea offers loads of fantastic adventures. For one, its gorgeous underwater environment is known as a world-famous <b>scuba diving destination</b>. Not a pro? No problem. There are short courses that run for 1-2 days.</p>
								   <p>Atop the waves, you’ll find, <b>windsurfing</b>, <b>kitesurfing</b>, and <b>stand-up paddle boarding</b> options for which it’s always an ideal time in Eilat, with its pristine beaches, calm waters, and perfect sunny weather almost year-round. By the way, don’t worry about equipment or experience, as there are plenty of options for rentals and individual or group lessons for all ages as well as all-inclusive packages. You’ll be flying across the sea in no time!</p>
								   <p>Looking to flex a few more muscles? Eilat’s nearby desert area offers <b>fantastic hikes</b> in stunning trails where you can <b>walk or bike</b> through breathtaking desert scenery.<span class="Apple-converted-space">&nbsp; </span>Feeling adventurous? Check out the huge array of unique action attractions from unforgettable camel rides to <b>adrenaline charged ATV rides</b> to thrilling off cliff <b>paragliding,</b> guaranteed to get the heart racing.</p>
								   <p>If your holidays are all about breathtaking adventures, Eilat is definitely the place for you!</p>
								 -->

								<p> لقد سمعت عن الشواطئ الرائعة والحياة الليلية الرائعة والجو الرائع في إيلات المشمسة على مدار العام ، لكن ألا تتساءل ، من بين كل أوقات الفراغ ، ماذا تفعل بالطاقة الزائدة؟ حسنا لا عجب بعد الآن. فيما يلي بعض الطرق المذهلة للحصول على بعض المرح المليء بالحركة في الشمس:</p>
								<div class="img-wrapper">
									<img src=${getImgUrl() +
                    "/posts/action-packed-eilat/1.jpg"} class="img-responsive">
							    </div>
								<p>يقدم البحر الأحمر المذهل في إيلات الكثير من المغامرات الرائعة. على سبيل المثال ، تُعرف بيئتها الرائعة تحت الماء بأنها وجهة غوص السكوبا المشهورة عالميًا. لست محترفًا؟ ليس هناك أى مشكلة. هناك دورات قصيرة تستمر من يوم إلى يومين.</p>
								<p>على قمة الأمواج ، ستجد خيارات ركوب الأمواج شراعيًا وركوب الأمواج شراعيًا وركوب الأمواج بالمضرب بالوقوف وهي دائمًا وقت مثالي في إيلات ، بشواطئها النقية ومياهها الهادئة وطقسها المشمس المثالي على مدار العام تقريبًا. بالمناسبة ، لا تقلق بشأن المعدات أو الخبرة ، فهناك الكثير من الخيارات للتأجير والدروس الفردية أو الجماعية لجميع الأعمار بالإضافة إلى الحزم الشاملة كليًا. ستطير عبر البحر في لمح البصر!</p>
								<p>تبحث عن ثني المزيد من العضلات؟ توفر المنطقة الصحراوية القريبة في إيلات نزهات رائعة في مسارات مذهلة حيث يمكنك المشي أو ركوب الدراجة عبر مناظر الصحراء الخلابة. الشعور بالمغامرة؟ تحقق من المجموعة الضخمة من عوامل الجذب الفريدة من نوعها من ركوب الجمال الذي لا يُنسى إلى ركوب ATV المشحون بالأدرينالين إلى الطيران المظلي على المنحدرات ، وهو مضمون للحصول على نبضات القلب.</p>
								<p>إذا كانت عطلتك تدور حول مغامرات تخطف الأنفاس ، فإن إيلات هي بالتأكيد المكان المناسب لك.</p>



		                        `,
      };
    },
  },
  // {
  // 		id:"Eilat_Ultimate_Beachside",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/eilat1/1.jpg",
  //         mobBgImage : "/posts/bank/eilat1/M.jpg",
  //        	isVid:false,
  //        	// vidId:"ZdnNT-GDJv4",
  //         title : "EILAT ULTIMATE BEACHSIDE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 						   <h3>Enjoy the water attractions that make Eilat the ultimate beachside getaway</h3>
  // 						   <p>Surrounded by water, Eilat, Israel’s most southern city, is a wet and wild adventure hub unlike anywhere else in the country. Eilat boasts top beaches, water sports, activities and attractions, open to the public year-round due to the warm local climate.</p>
  // 						   <p>Dip your toes in the clear, blue waters of Eilat’s beaches, spanning over twelve kilometers of sand, boardwalk, hotel and commercial attractions.</p>
  // 						   <p>Relax at one of the more secluded and quiet southern beach locations and swim around the coral reefs, or enjoy a vibrant tourist scene at one of the northern beaches, where nearby hotels, restaurants and shops keep the public satisfied and entertained. Or, enjoy the region from aboard a yacht sailing through the waters, allowing you to soak up the sun, unwind and socialize.</p>
  // 						   <p>Delve into the uniquely beautiful habitat of the Eilat Coral Beach Nature Reserve. Put on snorkeling gear and observe or interact with the local sea creatures as they swim about.</p>
  // 						   <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/eilat-ultimate-beachside/1.jpg"} class="img-responsive">
  // 							</div>

  // 						   <h3>The heart of Israel’s extreme water adventures</h3>
  // 						   <p>Eilat is the heart of Israel’s extreme water adventures. Feel the wind in your hair and sun on your cheeks as you embark upon a water ski, jetski, banana boat, surfing or glass bottom boat ride, speeding through the waters at an exhilarating pace. Prefer to remain above water? Opt instead to take in an aerial view of the waters and parasail over the Eilat Bay.</p>
  // 						   <p>Do you love wildlife? Swim or snorkel with dolphins at Eilat’s Dolphin Reef. The unique ecological site, in the midst of a magical beach, allows visitors an up-close glimpse into the dolphins’ lives and makes for an exciting outdoor adventure. Fancy an underwater experience without getting wet? Take a tour of the Eilat Underwater Observatory, a captivating glimpse into life below sea level, combined with interactive activities and special exhibits.</p>

  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"One_Day_In_Eilat",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/eilat2/1.jpg",
  //         mobBgImage : "/posts/bank/eilat2/M.jpg",
  //        	isVid:false,
  //         title : "ONE DAY IN EILAT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 						   <h3>Suggestions for an awesome day in the sun</h3>
  // 						   <p>Whether you’re staying in one of the city’s 5 star hotels, a hostel or have opted for the cool camping alternative, we recommend to start your day with a delicious breakfast and make your way to the <b>Dolphin Reef</b>. This is one of the most popular attractions in Eilat, where you can touch, swim and dive with these beautiful creatures. Watch the dolphins in their natural habitat, visit the underwater photo center, or take part in either scuba diving or snorkeling. Check out also <b>Coral Beach</b>, the natural underwater reserve that extends for 1,200 meters along the coast and gives you the opportunity to go snorkeling with an extraordinary variety of tropical fish in a beautiful coral reef.</p>
  // 						   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/one-day-in-eilat/1.jpg"} class="img-responsive">
  // 							</div>

  // 						   <p>Once you’ve dried off, head to the stunning <b>Botanical Gardens</b> within Eilat. You’ll find there more than 1,000 types of trees and plants from all around the world, streams, waterfalls, a rainforest and bird sanctuaries.</p>
  // 						   <p>To end of your day with something slightly different, head just outside of Eilat to the <b>Red Canyon,</b> where you can track through the riverbed and between the red Nubian sandstone walls that have been sculpted over the centuries by wind and water.</p>
  // 						   <p>When evening comes, make your way to the buzzing Eilat promenade ,stroll by the shops and market stands which are open until late. You can treat yourself to a meal in any of the dozens of the excellent restaurants and cafés or a drink in any of the lively seaside pubs and bars.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Majestic_Desert",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "نيجيف - الصحراء الكبرى في إسرائيل",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <!--
								   <h3>Where Adventure and Inspiration Await</h3>
								   <p>An ideal destination for travelers who love adventure in the great outdoors. The south of Israel is sparsely populated, but packed with fascinating sites and activities.</p>
								   <p>With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset. A desert but definitely not deserted, there is so much to see and do here – there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert. Simply put, this majestic Southern region is one of the country’s greatest assets and an absolute must on the itinerary.</p>
								   <h3>Sde Boker</h3>
								   <p>A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50’s. Sde Boker is renowned as the home of David Ben Gurion, Israel’s first Prime Minister whose home is now a museum open to the public.</p>
								   <h3>Vidor Center</h3>
								   <p>A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.</p>
								   <h3>Nevatim</h3>
								   <p>A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world. The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.</p>
								   <h3>MidBurn Festival</h3>
								   <p>Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.</p>
								   <h3>Negev - Where Adventure and Inspiration Await</h3>
								   <div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/QL3BGy2p77g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
						           <h3>The Bedouin Experience</h3>
                                    <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging. A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.</p>
		                           <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/1.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>
								
								   <h3>The Culinary Queens of Yeruham</h3>
								   <p>For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham – a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors. Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.</p>
								   <h3>The Old City of Be'er Sheva</h3>
								   <p>Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.</p>
								   <h3>Carasso Science Park</h3>
								   <p>New in the Old City of Be’er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel. Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.</p>
								   <h3>Arad</h3>
								   <p>Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style. With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.</p>
								   <h3>Yotvata Hai-Bar</h3>
								   <p>The Yotvata Hai-Bar Nature Reserve is the area’s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators’ center with its live predators and small desert animals, a Nocturnal animal’s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.</p>
								   
                                   <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/2.jpg"} class="img-responsive">
									</div>
									<h3>Extreme Adventures</h3>
                                    <p>The south of Israel is a total dream destination for adventure-hungry travelers. Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.</p>
                                      <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/3.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>
									<h3>Camel rides</h3>
                                    <p>A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.</p>
                                    <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/4.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>-->

									<div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/yXzhH92kREg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>

									<h3></h3>
									<p>النقب - الصحراء الكبرى في إسرائيل </p>


									<p>وجهة مثالية للسياح الذين يحبون المغامرات في الهواء الطلق.</p>


									<p>يتميز جنوب إسرائيل بقلة السكان والعجائب الطبيعة المذهلة، اذ انه مليء بالمواقع المثيرة والأنشطة الرائعة والمناظر الخلابة التي ستحبس أنفاسك من شروق الشمس الى غروبها. هناك الكثير لترى وتفعل هنا</p>


									<p>في النقب ستجد العديد من العجائب الجيولوجية، المعالم التاريخية الهامة والمحميات الطبيعية الرائعة</p>

									<p>باختصار، هذه المنطقة الجنوبية في اسرائيل هي واحدة من أهم وأجمل المناطق في البلاد ورحلتك لن تكتمل من دون ممارسة رياضة المشي لمسافات طويلة في تلالها وركوب الدراجات أو الاستمتاع برحلات السفاري المشحونة بالأدرينالين في وسط الصحراء. </p>


									<p>إليك بعض المواقع التي لا ينبغي تفويتها:</p>

									<h3>سديه بوكر: </h3>

									<p>يعطيك سديه بوكر وهو كيبوتس تم إنشائه في اوائل خمسينيات القرن الماضي لتشجيع السكن في النقب لمحة رائعة عن تاريخ دولة إسرائيل. يشتهر سديه بوكير بكونه الكيبوتس الذي سكن فيه ديفيد بن غوريون، أول رئيس وزراء إسرائيلي الذي تم تحويل منزله لاحقا الى متحف مفتوح للعامة.</p>

									<h3>مركز فيدور: </h3>

									<p>موقع سياحي فريد من نوعه يقدم تجربة متعددة الحواس للطبيعة الاستثنائية في منطقة وادي عربة ويتيح لزواره اكتشاف طرق الزراعة المتقدمة، النباتات والحيوانات المحلية وتحديات المناخ بالإضافة للصفات الخاصة بتربة ومياه الصحراء.</p>


									<h3>نيفاتيم: </h3>

									<p>زيارة نيفاتيم ، موطن يهود كوتشين هي تجربة رائعة</p>

									<p>تعود أصول يهود الكوتشين الى الهند، اذ هاجروا إلى دولة إسرائيل بعد إقامتها. يعتبر يهود الكوتشين أنفسهم من من أقدم المجتمعات اليهودية في العالم</p>

									<p>المركز التراثي ليهود الكوتشين في موشاف (قرية)  نيفاتيم يروي قصة هذا المجتمع الفريد </p>



		                        `,
      };
    },
  },
  // {
  // 		id:"Negev1",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/negev2/1.jpg",
  //         mobBgImage : "/posts/bank/negev2/M.jpg",
  //        	isVid:true,
  //        	vidId:"yXzhH92kREg",
  //         title : "NEGEV",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                              <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
  // 					   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
  // 					   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
  // 					   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/negev/1.jpg"} class="img-responsive">
  // 							</div>

  // 					   <h3>The Israeli desert is special for the following reasons:</h3>
  // 					   <ul>
  // 					      <li><strong>The desert is very near:</strong>&nbsp;just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half). Starting from November, there will be direct flights from Europe and Russia to Ovda airport including&nbsp;Ryanair, Wizzair, and SAS.</li>
  // 					      <li><strong>Easy to Hike and Bike:</strong>&nbsp;There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert.</li>
  // 					      <li><strong>Cordial local population:</strong>&nbsp;The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
  // 					      <li><strong>Tourists Activities:</strong>&nbsp;Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
  // 					      <li>
  // 					         <strong>Magnificent landscapes:</strong>&nbsp;Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety
  // 					         <ul>
  // 					            <li>There are spectacular sand dunes in the north.</li>
  // 					            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
  // 					            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
  // 					            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
  // 					         </ul>
  // 					         <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers. Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
  // 					      </li>
  // 					      <li><strong>The Negev is very safe to travel.</strong>&nbsp;In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
  // 					   </ul>
  // 					   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/negev/2.jpg"} class="img-responsive">
  // 							</div>

  //                         `
  //     }
  //   }
  // },
  {
    id: "EILAT1",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: false,
    // vidId: "ZdnNT-GDJv4",
    title: "ايلات",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                

                        <!--<h3>الوجهة النهائية للعطلات</h3>

						<p>إيلات ميناء يمثل منفذ إسرائيل إلى الهند وشرق آسيا وأفريقيا. قبل ستة عقود كانت بلدة حدودية على طراز الصفيح ، ولكن إيلات تطورت لتصبح واحدة من المنتجعات الرئيسية في إسرائيل التي تجذب شواطئ البحر الأحمر وعشرات الفنادق فيها الإسرائيليين والسياح من 100 دولة. إيلات مكرسة لقضاء الإجازة. تصطف المنتجعات على الكورنيش والبحيرة ، إلى جانب مركز تسوق عملاق ومطاعم ومجموعة متنوعة من أماكن الجذب للزوار الصغار والكبار. تعتبر إيلات أيضًا مدخلًا لواحد من أروع الشعاب المرجانية في العالم: يعد مرصد إيلات تحت الماء أمرًا ضروريًا لكل زائر ، وكذلك شعاب الدلافين حيث يسبح السائحون مع الدلافين.</p>
						<p>تبعد إيلات مسافة 4/5 ساعات بالسيارة عن تل أبيب والقدس - أو رحلة طيران مدتها ساعة واحدة إلى مطار إيلات الذي يقع في قلب المدينة. على بعد 15 دقيقة بالسيارة جنوبًا من إيلات ينقل الزوار إلى نقطة العبور إلى مصر. وعلى بعد 10 دقائق إلى الشمال ، يعبر السائحون إلى الأردن ومدينة العقبة الساحلية المجاورة. يقوم العديد من زوار إيلات برحلات يومية إلى البتراء في الأردن.</p>
						<div class="img-wrapper">
						     <img src=${getImgUrl() + "/posts/eilat1/1.jpg"} class="img-responsive">
					    </div>
						<h3>خذ عميقا في البحر الأحمر</h3>
						<p>يعد البحر الأحمر الرائع في إيلات والخط الساحلي الذي يبلغ طوله 10 كيلومترات من الأماكن الجذابة المذهلة بحد ذاته نقطة محورية في المدينة وجذب السياح الرئيسيين من كل مكان.</p>
						<p>بفضل مياهها النظيفة والواضحة والباردة بشكل غير متوقع مما يتيح ملاذًا ترحيبيًا من درجات الحرارة المرتفعة في المدينة والهواء الجاف ، ومجموعة متنوعة من المرافق والمعالم السياحية ، تعد شواطئ إيلات المكان المثالي للاستمتاع بحمامات الشمس والراحة والاسترخاء.</p>
						<p>سيحب عشاق الرياضات الشديدة العشرات من نوادي الرياضات المائية المنتشرة على طول السواحل الجنوبية والشمالية لإيلات ، ومجموعة من الأنشطة مثل التزلج على الماء وقوارب الموز والأنابيب والتجديف بالكاياك وغير ذلك الكثير.</p>
						<div class="img-wrapper">
						    <img src=${getImgUrl() + "/posts/eilat1/2.jpg"} class="img-responsive">
					    </div>
						<h3>يشعر فيبي</h3>
						<p>عندما يحل المساء وغروب شمس الصحراء الحارة في إيلات وتغلق المسابح والشواطئ ، فهذا هو الوقت المناسب للاستحمام والتغيير والاستمتاع بمشهد الحياة الليلية الرائع في المدينة. تمتلك إيلات رقمًا قياسيًا فريدًا - المدينة التي تضم أكبر عدد من النوادي والحانات وأماكن الترفيه الأخرى بالنسبة للفرد في إسرائيل ، لذلك لا يوجد نقص في النقاط الساخنة لجعل ليلتك مليئة بالمرح مثل يومك.</p>
						<h3>مغامرة صحراوية</h3>
						<p>يقع شمال المدينة في جنوب وادي عربة ، وهي منطقة ذات مناظر صحراوية خلابة ، وواحدة من أكثر المناطق الموصى بها للزيارة في البلاد ، حيث يمكنك أن تشعر بالمساحات الشاسعة والمشي لمسافات طويلة على المنحدرات شديدة الانحدار والوديان والجداول وأكثر من ذلك.</p>
						<p>ستوفر الجبال الملونة والمذهلة في منطقة إيلات ، إلى جانب المساهمة في منظر المدينة الخلاب ، تجربة لا تُنسى لجميع عشاق الطبيعة. هناك مجموعة متنوعة من الطرق والمواقع التي يمكن زيارتها والاستمتاع بالمشي لمسافات طويلة وركوب الدراجات والقيادة وركوب الجمال وحتى تسلق الصخور أو الانحدار أسفل المنحدرات لعشاق الرياضة المتطرفة.</p>
						<p>لا تنتظر. قم بزيارة إيلات. اهرب إلى الشمس.</p>
						-->
						<p>بالتاكيد قد سمعت عن الشاطئ والحياة الليلية والأجواء الرائعة في إيلات المشمسة على مدار العام، ولكن بالتأكيد تتساءل أيضا، ماذا نفعل بالطاقات الزائدة في أوقات الفراغ؟ إليك بعض الاقتراحات:</p>
						<div class="img-wrapper">
						     <img src=${getImgUrl() + "/posts/eilat1/1.jpg"} class="img-responsive">
					    </div>
						<p>يوفر لك البحر الأحمر الكثير من المغامرات الرائعة. على سبيل المثال ، تُعرف البيئة تحت سطح الماء بأنها وجهة غوص ذات شهرة عالمية. لست غواصا محترفًا؟  ليس هناك أي مشكلة. هناك دورات قصيرة تستمر من يوم إلى يومين.</p>


						<p>فوق سطح البحر ستجد خيارات عديدة لركوب الأمواج والاستمتاع بشواطئ المدينة ومياهها الهادئة وطقسها المشمس والمثالي. واذ كنت تبحث عن المغامرات البرية، توفر لك المنطقة الصحراوية القريبة موقع مثالي للنزهات الرائعة في مسارات مذهلة حيث يمكنك المشي أو ركوب الدراجة والتمعن في مناظر الصحراء الخلابة. ترغب بالمزيد من  المغامرات؟ يمكنك ركوب الجمال أو القفز المشحون بالأدرينالين من المنحدرات مع طائرات مظلية</p>
						<div class="img-wrapper">
						    <img src=${getImgUrl() + "/posts/eilat1/2.jpg"} class="img-responsive">
					    </div>
						<p>إذا كانت عطلتك تدور حول مغامرات تخطف الأنفاس ، فإن إيلات هي بالتأكيد المكان المناسب لك!</p>


						 `,
      };
    },
  },
  // {
  // 		id:"Location_And_Approach",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/negev3/1.jpg",
  //         mobBgImage : "/posts/bank/negev3/M.jpg",
  //        	isVid:true,
  //        	vidId:"5AAqIhkq_tQ",
  //         title : "NEGEV – LOCATION AND APPROACH",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 						   <p>Landing at the airports of Ovda or Eilat with the onward journey to Mitzpe Ramon or Sde Boker:</p>
  // 						   <h3>Public means of transportation:</h3>
  // 						   <p>Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.</p>
  // 						   <p>Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.</p>
  // 						   <p>Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.</p>
  // 						   <h3>Car rental in Eilat, Mitzpe Ramon and Be'erSheva:</h3>
  // 						   <p>There a multiple option in renting a car in these cities. There is a choice of international and Israeli companies.</p>
  // 						   <p>Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon</p>
  // 						   <h3>Public means of transportation:</h3>
  // 						   <p>Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.Train from Ben Gurion or Tel Aviv to Be'erSheva.</p>
  // 						   <p>From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes). Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.</p>
  // 						   <h3>NEGEV ROAD DISTANCES</h3>
  // 						   <table>
  // 						      <tbody>
  // 						         <tr>
  // 						            <th></th>
  // 						            <th>Tel Aviv</th>
  // 						            <th>Jerusalem</th>
  // 						            <th>Bee'r Sheva</th>
  // 						            <th>Eilat</th>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Old Town&nbsp;Beer Sheva</strong></td>
  // 						            <td>113 Km</td>
  // 						            <td>122 Km</td>
  // 						            <td></td>
  // 						            <td>232 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Tel Arad</strong></td>
  // 						            <td>134 Km</td>
  // 						            <td>144 Km</td>
  // 						            <td>40 Km</td>
  // 						            <td>229 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Ben-Gurion's House&nbsp;in Sde Boker</strong></td>
  // 						            <td>162 Km</td>
  // 						            <td>171 Km</td>
  // 						            <td>49 Km</td>
  // 						            <td>185 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Ramon Crater</strong></td>
  // 						            <td>210 Km</td>
  // 						            <td>192 Km</td>
  // 						            <td>97 Km</td>
  // 						            <td>141 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Hai Bar Wildlife&nbsp;reserve Yotvata</strong></td>
  // 						            <td>323 Km</td>
  // 						            <td>288 Km</td>
  // 						            <td>202 Km</td>
  // 						            <td>35 Km</td>
  // 						         </tr>
  // 						         <tr>
  // 						            <td><strong>Timna Park</strong></td>
  // 						            <td>330 Km</td>
  // 						            <td>294 Km</td>
  // 						            <td>208 Km</td>
  // 						            <td>30 Km</td>
  // 						         </tr>
  // 						      </tbody>
  // 						   </table>
  // 						   <h3>NEGEV DESERT - DON'T MISS</h3>
  // 						   <h3>Ramon Crater</h3>
  //                                  <p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve. Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon. The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
  //                                   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/1.jpg"} class="img-responsive">
  // 										Credit: Daphna Tal
  // 							</div>
  // 							<h3>Timna Park</h3>
  //                                   <p>15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions. With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.</p>
  //                             <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/2.jpg"} class="img-responsive">
  // 										Credit: Daphna Tal
  // 							</div>
  // 							<h3>Timna Park - An Exhilarating Desert Adventure</h3>
  // 							<div class="responisve-iframe">
  // 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/i_4QKtXIeto" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 				           </div>
  // 				           <h3>Sandboarding in the desert</h3>
  //                                  <p>An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?</p>
  //                                   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/3.jpg"} class="img-responsive">
  // 							</div>
  // 							<div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/4.jpg"} class="img-responsive">
  // 							</div>
  // 							<h3>Negev at night</h3>

  //                                   <p>The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.</p>
  //                            <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/location-and-approach/5.jpg"} class="img-responsive">
  // 							</div>
  // 							<h3>Sunrise at Masada</h3>

  //                                   <p>Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Stay_In_The_Negev",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: false,
    title: "STAY IN THE NEGEV",
    smltitle: "",
    html: function() {
      return {
        __html: `<p> A trip to the Negev offers so much more than just grand vistas and tranquil surroundings one tends to think about when conjuring up the word desert. While the Negev still offers all the natural beauty, calmness and wondrous sites, which the desert tourist is looking for, it is also extremely interesting, westernized and packed with activities and adventures and even offers all the comforts of a modern holiday.</p>
                                 <p> The Negev offers a huge variety of accommodation options. So much more than just a place to lay your hat down, the form of accommodation you choose will offer you opportunity to acquaint yourself with the undisputable gem of the Negev - its local community. From the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, you will find the people of the Negev are warm, hospitable and always ready to lend a hand. Here are just a few examples of hospitality options, which can be found in the Negev:</p>
                                 <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/stay-in-the-negev/1.jpg"} class="img-responsive">
								  </div>

								   <p>Hotels – the Negev has a huge host of hotel options ranging from budget hotels to 5-star international prize-winning luxury hotels, where you can chill in style during your desert break.</p>
								   <p>Hostels – an affordable accommodation geared mostly towards young travelers. Here many tourists enjoy the opportunity to meet and engage with other like-minded travelers from all over the world and spend their evenings socializing and often creating lasting friendships.</p>
								   <p>Zimmers -This is Israel’s version of the Bed and Breakfast, usually separate from the owners’ own home, these are often more secluded and cozy lodgings, suitable for travelers looking for romance and peaceful settings.</p>
								   <p>Bedouin Hospitality tents- the definite Negev must, this truly unique and authentic form of hospitality, which welcomes you into the indigenous Bedouin community’s way of life, affords an exceptional opportunity to take part in the Bedouin traditions in their natural environment – highly recommended.</p>
								   <p>Khans – again, unique to the Negev, the popular Kahns are in fact large outdoors complexes, which offer huts and communal sleep areas as well as all basic facilities. While Kahns are often a more basic and rustic form of accommodation, they are an excellent way to experience the chilled atmosphere of the area, connect with other travelers and locals and feel part of the natural surroundings of the desert.</p>
								   <p>Lone farms – a more recently developed form of accommodation, lone farms are in fact guest rooms in quaint and remote family-run farms throughout the Negev. &nbsp;Combining tranquil settings with home comforts, the lone farms offer privacy, incredible views and an authentic way to experience the awesome desert atmosphere of the Negev.</p>
								   <p>Kibbutz - a distinctly Israeli form of collective communal settlements, Kibbutz accommodations offer good value accommodation at affordable prices. The true appeal of the Kibbutz, however, is their uncountably their special atmosphere and communal spirit, and the residents warm, inviting and hospitable spirit, guaranteeing a pleasant and memorable stay.</p>
								  
		                        `,
      };
    },
  },
  // {
  // 		id:"Pure_Desert_Magic",
  //        	ctg : "eilat-negev",
  //        	bgImage : "/posts/bank/negev1/1.jpg",
  //         mobBgImage : "/posts/bank/negev1/M.jpg",

  //        	isVid:false,
  //         title : "NEGEV PURE DESERT MAGIC",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				               <p>The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.</p>
  // 							   <p>Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.</p>
  // 							   <p>There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.</p>
  // 							   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/pure-desert-magic/1.jpg"} class="img-responsive">
  // 						       </div>
  // 						       <p><strong data-mk-aweb-org-font-size="17">The Israeli desert is special for the following reasons</strong>:</p>
  // 							   <ul>
  // 							      <li><strong>The desert is very near</strong>&nbsp;- just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).</li>
  // 							   </ul>
  // 							   <p>Starting from November, there will be direct flights from Europe and Russia to Ovda airport including&nbsp;<strong>Ryanair</strong>,&nbsp;<strong>Wizzair</strong>, and&nbsp;<strong>SAS</strong>.</p>
  // 							   <p>For further details check the following link:&nbsp;<a href="//www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx" target="_blank" rel="noopener">www.iaa.gov.il</a></p>
  // 							   <ul>
  // 							      <li><strong>Easy to Hike and Bike</strong>: There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:&nbsp;<a href="//www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a>&nbsp;;&nbsp;<br/><a href="//www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></li>
  // 							      <li><strong>Cordial local population</strong>: The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.</li>
  // 							      <li><strong>Tourists Activities:</strong>&nbsp;Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.</li>
  // 							      <li>
  // 							         <strong><strong>Magnificent landscapes:&nbsp;Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety</strong></strong>
  // 							         <ul>
  // 							            <li>There are spectacular sand dunes in the north.</li>
  // 							            <li>The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.</li>
  // 							            <li>In the east, one experiences the African desert with wide savannas and acacia trees.</li>
  // 							            <li>To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.</li>
  // 							         </ul>
  // 							      </li>
  // 							   </ul>
  // 							   <p>During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.</p>
  // 							   <p>Many tourists decide for to stay for 2 or 3 days in each region of the Negev.</p>
  // 							   <ul>
  // 							      <li><strong>The Negev is very safe to travel</strong>. In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.</li>
  // 							   </ul>
  // 							   <h3>More information and tips for accommodation and recommendations:</h3>
  // 							   <p><a href="//www.negevtour.co.il/" target="_blank" rel="noopener">www.negevtour.co.il</a></p>
  // 							   <p><a href="//www.en.aravaway.co.il/" target="_blank" rel="noopener">www.en.aravaway.co.il</a></p>
  // 									                        `
  //     }
  //   }
  // },
  {
    id: "Action_Fun_In_The_Desert",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "yXzhH92kREg",
    title: "متعة المغامرة في الصحراء الإسرائيلية",
    smltitle: "",
    html: function() {
      return {
        __html: `

						          <!--<h3>The Uniqueness of the Desert</h3>
								   <p>You’ll be wowed by the natural beauty of Israel’s four main desert areas: the Dead Sea, the Eilat mountain range, the Negev and the Judean desert. Tourists can step out-of-this-world on a hike through the unique colors and rock formations of the Ramon Crater and the deeply glowing hues of Timna Park outside Eilat. Rappelling down multicolored cliffs or challenging yourself on dusty, challenging hike is even better when you end it with a refreshing plunge into a desert oasis like Ein Gedi near the Dead Sea. You’ll see more stars than you could have believed if you camp overnight at one of the many fully serviced campsites. You might even glimpse some of the desert’s shy nocturnal wildlife!</p>
								   <p>Spring, Fall and Winter are the best times to visit the dry, bracing climate of Israel’s desert. Step back in time at the famous Masada fortress to rediscover the bitter end of the last Jews fighting against the Romans and be awed by the grandeur of Herod’s palace. Explore Unexpected Byzantine ruins and the astonishing culture of the Nabateans’ ancient settlements carved out of the desert rock are waiting for you to explore them.</p>
								    <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/action-fun-in-the-desert/1.jpg"} class="img-responsive">
								       </div> 
								       <h3>Action Fun in the Desert</h3>
								   <p>Israel’s desert is full of fun activities. An exciting jeep tour will bounce you through the unique terrain of the Negev, or you can hire mountain bikes to challenge yourself in the unearthly beauty of Timna Park’s colorful rocks or across desert paths. Slow down to bond as a family or with friends on a calming horseback ride in the Judean desert or Eilat mountains, or sip mint tea and eat plump dates as you experience real Bedouin hospitality in the Negev. You can even ride on a camel to feel like a true ancient Israelite!</p>
								   <p>You could slather on the therapeutic mineral mud on the shores of the Dead Sea as you marvel at the towering mountains around you and the blue water beside you. Lovers of extreme sports can try their hand at sandsurfing down the Negev’s sweeping sand dunes, feeling the thrill of racing across acres of sand.</p>
								   <p>Israel’s deserts are full of more fun than you’d believe.</p>
								   <p>Photo credit:Alon Ron,&nbsp;Dafna Tal.</p> -->

								   <h3>ستنبهر من جمال الطبيعة في المناطق الصحراوية الرئيسية الأربع في إسرائيل:</h3>

									<p>البحر الميت وصحراء يهودا وسلسلة جبال إيلات والنقب.</p>

									<p>يستطيع السياح القادمين الى اسرائيل الخروج من هذا العالم لنزهة في الطبيعة ذات الألوان الفريدة ومشاهدة التكوينات الصخرية المتوهجة في منتزه "تمنع" خارج إيلات أو المشي في المنحدرات الصحراوية متعددة الألوان والانتهاء بالغطس المنعش في واحة صحراوية مثل عين جدي بالقرب من البحر الميت. </p>


									<p>سترى النجوم كما لم ترهم من قبل إذا قررت التخييم وقضاء ليلتك في أحد مجمعات التخييم العديدة والمجهزة بالكامل في المنطقة، وإذا حالفك الحظ قد تسنح لك الفرصة للمح الحياة البرية الليلية الخجولة في الصحراء</p>

									<p>فصل الخريف الشتاء والربيع هم أفضل الفصول لزيارة صحراء إسرائيل الحارة </p>

									<p>عد بالزمن إلى الوراء وقم بزيارة قلعة "متساده" الشهيرة لإكتشاف قصة ونهاية آخر اليهود الذين قاتلوا ضد الرومانيين واكتشف الآثار البيزنطية والثقافة المذهلة للمستوطنات النبطية القديمة المنحوتة في صخور الصحراء والتي في انتظارك </p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/action-fun-in-the-desert/1.jpg"} class="img-responsive">
								       </div> 
									<h3>الاستمتاع في الصحراء: </h3>

									<p>الصحراء الاسرائيلية مليئة بالانشطة الترفيهية اذ يمكنك التمتع بجولة جيب مثيرة للتعرف على تضاريس النقب الفريدة أو استئجار دراجات جبلية للتمعن بجمال الصخور الملونة في بارك "تمنع"</p>

									<p>تمهل للاسترخاء وركوب الخيل والجمال في صحراء يهودا وجبال ايلات او لشرب الشاي بالنعناع وتناول التمر بينما تستمتع بالضيافة البدوية في النقب. </p>

									<p>يمكنك لاحقا الانغماس في الطين العلاجي على شواطئ البحر الميت والتعجب من الجبال الشاهقة من حولك والمياه الزرقاء بجانبك. بالاضافة، يستطيع عشاق الرياضة أن يجربوا "ركوب الأمواج" على كثبان النقب الرملية الواسعة </p>
									                         
		                        `,
      };
    },
  },
  {
    id: "The_Incense_Route",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/theincenseroute/1.jpg",
    mobBgImage: "/posts/bank/theincenseroute/M.jpg",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    title: "طريق البخور",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						          
							        <p>ثل طريق البخور الأسطوري قصّة نجاح تجاري يمتد عمرها إلى 2000 عام.</p>
									<p>في الزمن القديم، حينما لم تكن هنالك وسائل نقل أو طرق أو خرائط، كانت قوافل الجمال الطويلة تتنقل عبر مسافات صعبة بين اللصوص وقطاع الطرق والعوائق والحكّام ضيّقي الأفق. كانت البضائع الثمينة تمر في هذا الطريق الذي يبتدئ من اليمن شرقا، عبر الحجاز والأردن، لتنتهي في البلاد في ميناء غزة، حيث يتم تحميل البضائع على سفن تجارية متجهة إلى أوروبا، حيث يمكن لنساء الإمبراطورية الرومانية الاستمتاع بعطور اللبان والمرّ ونكهات البهارات الشرقية والأملاح المفيدة للطبخ ولحفظ الأطعمة.</p>
									<p>كان قطع طريق البخور هذه، التي يبلغ طولها 2400 كيلومترا، يتطلب حوالي ستة أشهر. حيث تتحرك قوافل الجمال التي تضم الآلاف بخطى بطيئة، مارّة بـ 56 محطة توقف، حيث كانت القوافل ترتاح، وتعتني بالحيوانات، وتستجمع طاقتها لليوم التالي.</p>
									<p>يبلغ طول المقطع الإسرائيلي في طريق البخور نحو 150 كيلومترا. ولا تزال هنالك آثار للطريق عبر صحراء النقب، حيث ينطلق العديد من المستكشفين لمتابعتها، مستكشفين الصحراء نفسها، ومحاولين تقليد نمط حياة سادة الصحراء. ولا تزال هنالك العديد من المحطات المتبقية التي تبدأ من وادي عربة على الحدود الأردنية، حيث توجد آثار خان، ومركز حراسة، وزراعة، وكهوف، ومخازن، وقناة ظاهرة للمياه. من عربة، يستمر الطريق باتجاه الشمال الغربي إلى منطقة "مشميت"، وهي موضع مدينة كبيرة تضم أطلالها الرائعة خانا وكنائس وحماما وبركا لتجميع مياه الأمطار إلى جانب مبان أخرى.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-incense-route/1.jpg"} class="img-responsive">
								    </div> 
									<p>المحطة التالية على هذا الطريق هي مدينة "عوفدات" الواقعة على تلة مشرفة. تحتوي أطلال المدينة أيضا على قلعة وكنائس ومعصرة للزيت ومعمل خزف إلى جانب منازل وحمّام عام إلى جانب كهوف تم تحويلها إلى مدافن.</p>
									<p>كانت القوافل تواصل سيرها من "عوفدات" إلى "شيفتا"، وهي بلدة صغيرة كان فيها نظام سقاية شديد التطور، إلى جانب البرك ومعاصر الزيت وعدد قليل من الكنائس. أما المحطة التالية والأخيرة الواقعة إلى الشمال، فهي "حالوتسا" التي لا تزال فيها أنقاض مسرح وكنيسة، من حيث توجهت القوافل مباشرة إلى غزة. وقد تمت إضافة عدد قليل من المحطات الصغيرة على امتداد الطريق، على غرار "قصرة"، "نيكاروت"، "ماخمال"، و"غرافون"، إلى جانب خان إضافي هو "عين سهرونيم"، الذي لا يزال بالإمكان رؤية الفناء المتبقي منه، والمحاط بورش عمل وحمام عامّ.</p>
									<p>وعلى امتداد الطريق، توجد خزّانات وأبراج حراسة ومواقع لأداء الطقوس، ومرافق للاستحمام، إلى جانب معالم بارزة تميز الطريق.</p>
									<p>يمكن الوصول إلى كل من "مواه"، و"ممشيت"، و "عوفدات" و "شيفتا" و "حلوتسا" و "عين سهرونيم" بأية مركبة. أما الطريق نفسه، عبر الصحراء، فيمكن اجتيازه فقط بواسطة سيارات الجيب، وعلى الرغم من أن راكبي الدراجات والراجلين يمكنهم أيضا التمتع بالمسار الرائع. هذا، وقد أعلنت منظمة اليونسكو سنة 2005 عن طريق البخور بوصفه موقعا للتراث العالمي، وتدعوكم إسرائيل إلى زيارة كل من النقب والعربة لاتباع خطى البدو والاستمتاع بالقصص الرائعة والتاريخ المذهل الذي ظلّت أطلاله شاهدا صامتا على عصر عاصف.</p>
									   
										                        `,
      };
    },
  },
  {
    id: "Mount_Karkom",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/mountkarkom/1.jpg",
    mobBgImage: "/posts/bank/mountkarkom/M.jpg",
    isVid: false,
    title: "جبل عديد ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                  <!--<p>In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.</p>
								   <p>Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.</p>
								   <p>Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/mount-karkom/1.jpg"} class="img-responsive">
								       </div>	
								       <p>Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.</p>
                                    <p>To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.</p>                      
                                    -->
                                   <p> يقع جبل عديد في قلب النقب الغربي ويعتبر أحد أهم المعالم التاريخية المسيحية.</p>

									<p>يتميز هذا الجبل بالمناظر الطبيعية الخلابة ويصل ارتفاعه لأكثر من 800 متر ويعتقد بعض العلماء أن جبل عديد هو موقع جبل سيناء التوراتي الذي كلم الله عليه موسى وأوحى له بالوصايا العشر</p>
									 
									<p>يمكنك المشي على درب طوله ثمانية كيلومترات، على ضفاف مجرى نهر عديد الجاف حيث سترى صفان من الحجارة القائمة وجدار دائري - بقايا لضريح من النوع الذي بناه بني إسرائيل في ذلك الوقت وبالنظر عن كثب يمكنك ان ترى 12 حجرًا قائمًا يعتقد البعض أنها تمثل 12 قبائل بني إسرائيل</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/mount-karkom/1.jpg"} class="img-responsive">
								       </div>

									<p>بالإضافة، يضم الجبل العديد من الرسومات الصخرية الشهيرة لشخصيات تصلي وحيوانات ورموز غامضة اخرى.</p>


									<p>لزيارة المنطقة يجب على المتنزهين تنسيق الجولة مسبقًا واستخدام خريطة مسار الجمعية لحماية الطبيعة (المتوفرة باللغة العبرية فقط) لاستكشاف جبل عديد.</p>

										                        `,
      };
    },
  },
  {
    id: "Machtesh_Ramon",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/machteshramon/1.jpg",
    mobBgImage: "/posts/bank/machteshramon/M.jpg",
    isVid: false,
    title: "مختيش رامون ",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <!--<p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater, also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an elongated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.</p>
		                        <div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/machtes-ramon/1.jpg"} class="img-responsive">
								</div>
								<p>Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock, and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.</p>
								<p>The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
								<p>A visit to Machtesh Ramon offers a range of exciting experiences and attractions specifically geared towards tourists and world travelers:</p>
								<p><strong>Ramon Crater Visitor Center</strong>&nbsp;–&nbsp; Built on the crater’s edge, the visitor center overlooks the awesome views from the Machtesh and offers an opportunity to learn about its unique natural phenomena, and also about the life and work of Ilan Ramon, the first Israeli astronaut.</p>
								<p><strong>Hai Ramon</strong>&nbsp;- Raising awareness to the local animal population, The Hai Ramon animal park offers a fascinating encounter with the often obscure and unseen small animals of the desert, The site features about 40 species of animals: lizards, snakes, turtles, spurs, hedgehogs, falcons, pheasants and more.</p>
								<p><strong>Kahn Saharonim</strong>&nbsp;– a short walk from this once station on the Nabatean Spice Route, is Ein Saharonim, a beautiful spring (dry in the summer) which features rich vegetation and the footprints of the many animals that come to enjoy its waters.</p>
								<p><strong>The Carpentry</strong>&nbsp;– a fascinating geological phenomenon, The Carpentry is a concentration of elongated stones in the form of prisms formed when the sandstone was "baked" at the high temperature created by a hot lava flow from the depths of the earth. During its cooling, the rock formed into thousands of ribbed columns, and the fragments of the columns act as the prisms.</p>
								<p><strong>The Ammonite Wall</strong>&nbsp;- a rock wall featuring fossils of ammonites - marine animals that lived millions of years ago in the sea which then covered the entire Negev area.</p>
								<p>A trip to Machtesh Ramon is a fascinating experience, one guaranteed to create a strong impression and a lasting memory.</p>
								-->
								<p>يقع مختيش (جرن) رامون "وادي الرمان" في قلب صحراء النقب جنوبي اسرائيل ويُعد هذا الوادي فوهة بركانية قديمة إذ تقع في أعلى جبل في النقب ويبلغ طول الوادي 40 كيلومتر، ويتسع من 2-10 كيلومتر على شكل قلب ممدود. تشكل الحفرة والمنطقة المحيطة بها اليوم أكبر حديقة وطنية في إسرائيل. </p>
								<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/machtes-ramon/1.jpg"} class="img-responsive">
								</div>
								<p>بعيدًا عن أضواء المدينة والحشود، غالبًا ما توصف حفرة رامون بأنها الجراند كانيون الخاص بإسرائيل إذ تتميز المنطقة بالحجر الرملي متعدد الألوان والصخور البركانية والحفريات </p>


								<p>توفر نقطة المراقبة التي يبلغ ارتفاعها 300 متر فرصة للتمتع بالمناظر الخلابة وتجربة لا تنسى للسياح من جميع أنحاء العالم وعلى مدار السنة.</p>


								<p>تتيح زيارة مختيش رامون مجموعة من التجارب المثيرة والمعالم السياحية الموجهة خصيصًا للسياح:</p>

								<p><strong>مركز الزوار:</strong> تم بناء مركز الزوار على حافة فوهة الوادي ويطل على مناظر رائعة ويوفر فرصة للتعرف على الظواهر الطبيعية الفريدة في المنطقة وكذلك حول حياة وعمل إيلان رامون، أول رائد فضاء إسرائيلي.</p>

								<p><strong>"حاي رامون":</strong> لزيادة الوعي للحيوانات المحلية، توفر حديقة الحيوانات في حاي رامون لقاءً مع الحيوانات المختلفة في الصحراء التي غالبًا ما تكون غامضة وغير مرئية، ويضم الموقع حوالي 40 نوعًا من الحيوانات، من السحالي والثعابين والسلاحف والقنافذ والصقور.</p>

								<p><strong>"خان سهرونيم":</strong> على بعد مسافة قصيرة سيرًا على الأقدام من هذه المحطة الواقعة على طريق التوابل النبطية ، يقع عين سهرونيم، وهو نبع جميل (جاف في الصيف) يتميز بالنباتات الغنية وآثار أقدام العديد من الحيوانات التي تأتي للاستمتاع بمياهها</p>

								<p><strong>"النجارة":</strong> ظاهرة جيولوجية رائعة، النجارة عبارة عن تركيز من الأحجار الممدودة تشكلت عندما تم "خبز" الحجر الرملي في درجة حرارة عالية نتيجة عن تدفق الحمم الساخنة من أعماق الأرض. أثناء عملية التبريد، تشكلت الصخور إلى آلاف الأعمدة المضلعة، وكانت شظايا الأعمدة بمثابة المنشور.</p>

								<p><strong>جدار الامونيت:</strong> جدار صخري يعرض أحافير الأمونيت - حيوانات بحرية عاشت منذ ملايين السنين في البحر الذي غطى حينها منطقة النقب بأكملها. </p>

								<p>رحلة إلى مختيش رامون "وادي الرمان" هي تجربة رائعة لخلق انطباع قوي وذكرى لا تنسى.</p>

		                        `,
      };
    },
  },
  // {
  // 		id:"Epic_Masada",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/negev4/1.jpg",
  //         mobBgImage : "/posts/bank/negev4/M.jpg",
  //        	isVid:true,
  //        	vidId:"XxWa_MNm5x8",
  //         title : "EPIC MASADA",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                            <h3>Re-live epic history atop the Judean Desert’s glorious fortification</h3>
  // 						   <p>Journey to Masada National Park, the lone, isolated, ancient Judean Desert clifftop fortification, overlooking the nearby Dead Sea oasis. Hike up the winding snake path or Roman staircase from the fortification’s base, or enter the Masada Visitors’ Center and travel to the site’s summit via cable car and begin to experience a part of ancient history, as if it were still in the making.</p>
  // 						   <h3>Explore regal ruins and feel a part of history</h3>
  // 						   <p>Enter what was once a series of luxurious castles forming the final stronghold inhabited by freedom fighters, who courageously waged war against the Roman Empire following the destruction of the Second Temple. A site so rich in historical narrative, that the cool, stone walls practically weep for the brave souls who chose untimely death over enslavement under enemy regime.</p>
  // 					       <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/epic-masada/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <h3>Where experiencing culture and religion reaches new heights</h3>
  // 						   <p>Stroll through the castle ruins and discover rooms and structures, archaeological findings highlighting life on Masada during the Roman siege. Enter the Northern Castle, the ruins of King Herod’s private fortress palace. Whisper a prayer in the ancient synagogue, where Jews congregated thrice daily to pray for salvation. Pay homage to the departed freedom fighters, who drew lots in the “Lottery Room” to determine the order of the men’s impending deaths, until the last remaining man put an end to his own life as well.</p>
  // 						   <p>Gaze at what is left of a Byzantine-era church and its mosaic artwork, possibly used for centuries by escaped Christian monks as early as the 1st Century, for a period of roughly 600 years.</p>
  // 						   <p>Experience Masada as one of UNESCO’s World Heritage Sites, complete with a sunset sound and light show at the fortification’s base, which delves into the way of life and battles experienced on site centuries ago.</p>

  // 					    `
  //     }
  //   }
  // },
  // {
  // 		id:"The_Bedouin_Experience",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/negev2/1.jpg",
  //         mobBgImage : "/posts/bank/negev2/M.jpg",
  //        	isVid:false,
  //         title : "THE BEDOUIN EXPERIENCE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 				           <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.</p>
  //                                  <p>A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality.</p>
  //                                  <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/the-bedouin-experience/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a long-forgotten way of life.</p>
  //                         `
  //     }
  //   }
  // },
  {
    id: "The_Israel_National_Trail",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: false,
    title: "مسار إسرائيل",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                    <p>مسار إسرائيل (الذي يسمى "شفيل يسرائيل" باللغة العبرية) هو عبارة عن مشروع وطني يُعنى بتهيئة مسار آمن ومحدد العلامات للمشي عبر البلاد. إذ يشكل المسار الممتد على مسافة تزيد عن 900 كيلومتر أحد الطرق المفيدة لتجريب طبيعة وحياة المجتمعات العائشة في إسرائيل.</p>
		                            <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-israel-national-trail/1.jpg"} class="img-responsive">
								    </div>
								    <p>أما مسار إسرائيل للدراجات الهوائية (قسم من مشروع مسار إسرائيل) فهو عبارة عن مشروع هدفه تكوين مسار مخصص لركوب الدراجات الهوائية عبر الجبال والذي يجوب البلاد من أقصى شمالها إلى أقصى جنوبها، علمًا بكونه يربط جبل حرمون شمالاً بمدينة إيلات الجنوبية. المسار الذي يُعدّ مثاليًا لسياحة الدراجات الهوائية يمر عبر مواقع التراث الوطني والمناظر الطبيعية الخلابة، مما يسمح للركاب بتجربة ألوان الثقافة الإسرائيلية المتنوعة طوال الطريق. ويُعتبر المسار أحد أطول المسارات المحددة حول العالم كما ويمكنكم أن تجدوا فيه اللافتات التي تشير إلى المسار المخصص لركوب الدراجات الهوائية عبر الجبال.</p>

		                        `,
      };
    },
  },
  {
    id: "Timna_Treasures",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    vidId: "i_4QKtXIeto",
    title: 'كنوز "تيمنع"',
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <!--<p>15,000 acres in a horseshoe-shaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.</p>
		                       
                                    <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/1.jpg"} class="img-responsive">
								   </div>
								   <h3>Explore the Natural Beauty and Exciting Attractions Timna Park Has to Offer</h3>
								   <p>Timna Park is a one-of-a-kind experience, located just 20 minutes from Eilat, in the heart of the enchanted Israeli desert and ensconced between breathtaking natural scenery. With attractions and activities that combine nature, historical antiquities and adventure, the expansive grounds house excitement and enchantment that dare to impress visitors of all ages and interests.</p>
								   <h3>Witness outstanding natural phenomena</h3>
								   <p>Walk through the park’s grounds and gaze at the site’s unique rock formations With interesting names and rare shapes you can touch with your bare hands “Mushroom,” “Mushroom &amp; a Half,” “Pink Canyon,” “Arches,” “Solomon’s Pillars” and “Valley of Rock Drawings -” depict life from an era long ago, allowing you to feel as though you are witnessing something truly spectacular.</p>
								  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/2.jpg"} class="img-responsive">
								   </div>
								   <h3>Trek through the great outdoors</h3>
								   <p>Embark upon one of the park’s 20 well-marked hiking trails, each varying in level of difficulty, selected to fit your individual or group needs and capabilities. Trek through the spectacular, geological and archaeologically-significant trails, or choose instead to take it easy and lounge by the shaded Timna Lake and its adjacent camping grounds and King Solomon’s Khan restaurant, where desert-related crafts such as colored sand bottles can be made, or pedal boats can be taken for a spin.</p>
								   <p>Extreme sports more up your alley? Try out the park’s rappelling, zip line and bike tours, each sure to leave you feeling invigorated and accomplished.</p>
								   <h3>Experience ancient times today</h3>
								   <p>Learn about biblical history in the desert, during a guided visit of the reconstructed Tabernacle, complete with a replica of the Altar, Holy of Holies and Ark. Watch as younger visitors gaze in awe at the reproduction of the holy structure God commanded the Jews to build in the desert - and older visitors examine the reconstruction for historical accuracy, learning a thing or two along the way.</p>
								   <p>Timna Park. Where history meets adventure, deep in the Israeli desert.</p>-->                   
								   <p>15000 فدان في وادي على شكل حدوة حصان محاط بالمنحدرات شديدة الانحدار، يعتبر "بارك تيمنع" تجربة مذهلة لعشاق المشي لمسافات طويلة. هنا ستشاهد خلابة الطبيعة بالاضافة للحياة البرية المدهشة والنباتات والأشجار التي تجعل من الصحراء موطنا لها بالرغم من الظروف المناخية القاسية </p>

									<h3>اكتشف الجمال الطبيعي في "بارك تيمنع" </h3>

									<p>يقع "بارك تيمنع"  في قلب الصحراء الإسرائيلية وعلى بعد 20 دقيقة فقط من إيلات ويمنح تجربة فريدة من نوعها وتجذب الانشطة المختلفة والمناظر الطبيعية الخلابة  في المكان, الزوار من جميع الأعمار والاهتمامات  </p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/1.jpg"} class="img-responsive">
								   </div>
									<h3>شاهد الظواهر الطبيعية </h3>

									<p>تجول في المنتزه وتمعن بالتكوينات الصخرية الفريدة في الموقع التي تحمل أسماء مثيرة للاهتمام وأشكال نادرة يمكنك لمسها بيديك وتصور الحياة في حقبة زمنية اخرى </p>

									<h3>رحلة في الهواء الطلق </h3>
									
									<p>انطلق في واحد من 20 مسارًا مميزًا للمشي لمسافات طويلة في المنتزه، يتفاوت كل منها في مستوى الصعوبة ويتم اختياره ليلائم احتياجاتك وقدراتك الفردية أو الجماعية. تمتع بالاثار الجيولوجية المهمة أو استرخي بجوار بحيرة "تيمنع" المظللة وأراضي التخييم المجاورة لها واذ كنت من محبي الرياضات المتطرفة يمكنك المشاركة في جولات على الدراجات الهوائية او الانزلاق على الخط الانزلاقي ما سيشعرك بالتأكيد بالحيوية والإنجاز</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/2.jpg"} class="img-responsive">
								    </div>
									<h3>تعلم تاريخ المنطقة </h3>

									<p>تعرف على تاريخ الكتاب المقدس في الصحراء ، خلال زيارة إرشادية للمعبد المعاد بناؤه وشاهد الزوار الأصغر سنًا وهم ينظرون بتعجب إلى إعادة بناء الهيكل المقدس الذي أمر الله اليهود ببنائه في الصحراء </p>

		                        `,
      };
    },
  },
  // {
  // 		id:"Negev_Desert_Dont_Miss",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/negev1/1.jpg",
  //         mobBgImage : "/posts/bank/negev1/M.jpg",
  //        	isVid:false,
  //         title : "NEGEV DESERT – DON’T MISS",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                 <h3>Sandboarding in the desert</h3>
  //                                 <p>An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/negev-desert-dont-miss/1.jpg"} class="img-responsive">
  // 						   </div>

  // 						   <h3>Negev at night</h3>
  // 						   <p>The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.</p>
  // 						   <h3>Camel rides</h3>
  // 						   <p>A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.</p>
  // 						   <p>Photo taken by photographer: Dafna Tal</p>
  // 						   <h3>MidBurn Festival</h3>
  // 						   <p>Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.</p>
  // 						   <h3>Sunrise at Masada</h3>
  // 						   <p>Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.</p>

  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"Negev_Charms",
  //        	ctg : "eilat-negev",
  //         bgImage : "/posts/bank/negev2/1.jpg",
  //         mobBgImage : "/posts/bank/negev2/M.jpg",
  //        	isVid:true,
  //        	vidId:"3UddwPEzDXo",
  //         title : "ESCAPE TO THE NEVEG",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                           <p>A desert holiday is unlike any other - the tranquility, the awe inspiring grand vistas, the clear star-studded night skies, all come together to create a truly mesmerizing and exotic experience most of us do not to partake in during our day to day lives.</p>
  //                           <p>The Negev is so much more than just a Desert. While it still offers all the natural beauty, calmness and wonderous sites which the desert tourist is looking for, it is also extremely westernized and packed with activities and adventures while offering all the comforts of a holiday. This is exactly what makes a trip to the Negev the perfect destination for travelers from all over the world. Another gem of the Negev is undoubtedly its local community, from the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, the people of the Negev are warm, hospitable and always ready to lend a hand. The Negev is rich in geological and archeological treasures and offers loads of exciting activities for the more adventurous travelers.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/negev-charms/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>At the same time, visitors looking for relaxation are sure to find it in the tranquil surroundings, and for some urban excitement, the nearby cities provide a wide range of city fun from culinary treats to exciting nightlife.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Galilee",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "5Ep3GgxELag",
    title: "الجليل",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						         <!-- <p>Most of northern Israel is generically known as The Galilee (Galil in Hebrew). It stretches virtually from the Mediterranean to the harp-shaped Sea Of Galilee and River Jordan on whose shores vast history has been made. Here is Mount Gilboa where King Saul and his son, Jonathan, died in battle against the Phillistines. Here is Hazor, where Deborah killed Sisera. Here, at Mount Meron, is the grave of Rabbi Hillel. Here in Tzippori, Hamat Tveriya and Bet Alpha, gorgeous 1,800-year-old synagogue mosaics have been discovered. Here is Armageddon (Megiddo) where Solomon built giant stables. Here is the lakeshore city of Tiberias, one of the “Four Holy Cities of Judaism” (another is Galilee’s Safed), which reached fame 2,000 years ago as one of the chief locations in which the Talmud was written.</p>
                                  <h3 >Galilee</h3>
                                  <div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/lzYzxyvnfng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
						           <p>The restoration of the Jewish homeland in the period beginning in the 1880’s was largely centered in the Galilee, and in the ensuing 130 years a much neglected landscape of not much more than olive trees has been transformed into one of the most fertile areas in the world. Here are dozens of kibbutzim and independently owned farms – whose produce feeds not only Israelis but is also flown daily to the grocery stores and flower markets of Europe. Here are some of Israel’s 300+ vineyards producing award winning wines. And here are pretty villages, towns and cities including Nazareth and Carmiel.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/galilee/1.jpg"} class="img-responsive">
								   </div>
								   <p>In addition to hotels and very comfortable kibbutz guest houses, the Galilee is filled with dozens of country bed-and-breakfast accommodations, known as zimmerim. Many offer luxurious accommodations, including pools, and make a delightful base for relaxing and touring.</p> -->
								  	<p>يُطلق على معظم المنطقة الشمالية من إسرائيل اسم الجليل. ويمتد الجليل فعليا من البحر الأبيض المتوسط إلى الحوض المشابه للقيثارة، والذي يحتوي على كلّ من نهر الأردن وبحيرة طبرية، والتي نما تاريخ عميق على ضفافها. هنا جبل الجلبوع حيث مات الملك شاؤول وابنه جوناثان في معركة ضد الفلستيين. ووفقا لنصوص الكتاب المقدس التاريخية، قتلت ديبورا سيسيرا في هذا المكان. هنا، في جبل ميرون، يوجد قبر الرابي هيلل. هنا توجد صفورية، حمات طبريا، وبيت ألفا، وهو كنيس رائع اكتشفت فيه فسيفساء عمرها 1800 عاما، هنا تقع مجيدو (هرمجيدون) حيث بنى سليمان اسطبلاته العملاقة. ثم هنالك مدينة طبريا المبنية على ضفاف البحيرة، وهي إحدى المدن الأربعة المقدسة في اليهودية إلى جانب مدينة صفد، التي تقع في الجليل هي الأخرى، والتي اشتهرت قبل <span class="ac-en-font">2000</span> عاما باعتبارها واحدة من المواقع الرئيسية التي كُتب فيها التلمود (كتاب تعليم الديانة اليهودية).</p>
								  	
                                    <h3 >الجليل</h3>
								  	<div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/lzYzxyvnfng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           	</div>
									<p>تركّزت عملية إعادة إحياء الوطن اليهودي في الفترة التي بدأت في ثمانينيات القرن التاسع عشر بشكل أساسي في الجليل، وفي السنوات الـ 130 التي تلت ذلك، تحولت المناظر الطبيعية المهملة إلى حد كبير، والتي لم تكن تتجاوز أشجار الزيتون، إلى واحدة من أكثر المناطق خصوبة في العالم. ولاحقا انبثقت العشرات من مزارع الكيبوتسات والمزارع المستقلة التي لا تكتفي منتجاتها بتغذية الإسرائيليين فحسب، بل يتم نقلها يوميا أيضا إلى محلات البقالة وأسواق الزهور في أوروبا. هنالك مصانع النبيذ التي يزيد عددها عن 300 والتي تنتج نبيذا حائزا على جوائز عالمية. كما تتناثر في الجليل قرى وبلدات ومدن جميلة بما فيها الناصرة.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/galilee/1.jpg"} class="img-responsive">
								   	</div>
									<p>إلى جانب الفنادق وبيوت الضيافة المريحة جدا المتوفرة في الكيبوتسات، فإن الجليل مليء بالعشرات من أماكن المبيت والإفطار الريفية المعروفة باسم "تسيمريم" B&B. وتوفر هذه الأماكن إقامة فاخرة، وتشمل حمامات السباحة، وتشكل مرتكزا مبهجا للاسترخاء والتجول.</p>

								   
		                        `,
      };
    },
  },

  {
    id: "Caesarea",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "eLZ433_S6HI",
    title: "قيسارية",
    smltitle: "",
    html: function() {
      return {
        __html: `  <!-- <p>The Roman port city of Caesarea is one of Israel’s wonders, combining ancient structures, archeology and a picture-perfect harbor, and adapting them for modern use.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/caesarea/1.jpg"} class="img-responsive">
								   </div>
								   <p>Built by Rome’s Judean Governor, Pontius Pilate, two millennia ago, Caesarea was one of the largest and most magnificent ports in the Mediterranean, with giant piers stretching out into the sea to accommodate dozens of ships. The city of Caesarea contained a giant hippodrome, aqueduct and theater; a thousand years later the Crusaders arrived and built a giant fortress, and then came the Ottomans, who turned it into a seaside town. Today, the Roman theatre is a venue for concerts, the Crusader fortress is thrilling to visit and the Ottoman harbor and beach are full of cafes, restaurants and a visitors’ center. Caesarea is 45 minutes’ drive from Tel Aviv, 20 from Haifa.</p> -->

								   	<p>تعد مدينة قيسارية، التي كانت مرفأ رومانيا، واحدة من عجائب إسرائيل، حيث تجمع بين الهياكل القديمة وعلم الآثار، والميناء المثالي لالتقاط الصور، وتكييف كل هذه المواضع للاستخدام الحديث.</p>
								   	<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/caesarea/1.jpg"} class="img-responsive">
								   </div>
									<p>بنى هذه المدينة هيرودس العظيم، حاكم منطقة يهودا الروماني قبل ألفي عام. كانت قيسارية واحدة من أكبر وأروع الموانئ في البحر المتوسط، بأرصفة عملاقة تمتد إلى قلب البحر لاستيعاب عشرات السفن. احتوت مدينة قيسارية على ميدان سباق للخيل وقناة مياه ومسرح عملاق. وبعد ألف عام، وصل الصليبيون إلى المدينة وقاموا ببناء قلعة عملاقة، ثم جاء العثمانيون الذين حولوها إلى مدينة ساحلية. يستخدم المسرح الروماني فيها اليوم لإقامة الحفلات الموسيقية، ولا تزال القلعة الصليبية في المدينة قائمة وتعد مكان جذب سياحي، إلى جانب الميناء والشاطئ العثمانيان اللذان يعجان بالمقاهي والمطاعم ومركز الزوار. تبعد قيسارية عن تل أبيب مدة 30 دقيقة بالسيارة، وتبعد عن حيفا مسافة 20 دقيقة.</p>

								   
		                        `,
      };
    },
  },

  {
    id: "Museum_Of_Islamic_Art",
    ctg: "jerusalem",
    bgImage: "/posts/bank/museumofislamicart/1.jpg",
    mobBgImage: "/posts/bank/museumofislamicart/M.jpg",
    isVid: false,
    title: "متحف القدس للفن الإسلامي",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						         <p>يضم متحف القدس للفن الإسلامي واحدة من أهم مجموعات الفن الإسلامي في العالم ويعد مصدرًا ثقافيًا فريدًا من نوعه في إسرائيل وجزء لا يتجزأ من تاريخ المدينة</p>
 
								<p>يقع المتحف في حي الطالبية بالعاصمة، بالقرب من مسرح القدس وتقدم المعارض الدائمة فيه نظرة عن كثب لكنوز العالم الإسلامي وتحكي قصته من القرن السابع إلى القرن التاسع عشر. تمثل المجموعات الفنية المعروضة  تقاليد الفن الإسلامي في مصر وسوريا والعراق وتركيا والهند وأفغانستان وإسبانيا وإيران</p>

								<p>من بين القطع المعروضة في المتحف صفحات قديمة من القرآن وأسلحة وسجاد ومجوهرات وفخار والخط العربي - مما يعكس ثراء أشكال وأنماط وأصول الفن الإسلامي</p>

								<p>تأسس المتحف في الستينيات وافتتح في عام 1974 من قبل ڤيرا سلومونس، التي تصورت ونفذت فكرة التعبير عن إنجازات فن الحضارة الإسلامية لجيران إسرائيل وهي منحدرة من أسرة يهودية بريطانية وحفيدة شقيق السير ديفيد سلومونس، أول يهودي في منصب رئيس بلدية لندن وعضو برلماني. </p>

								<p>منذ تأسيسه، ساهم المتحف في رفع مستوى الوعي العام بالثقافة والفن الإسلامي وتشجيع وتطوير البحث حول هذا الموضوع، إذ يمثل جسر متعدد الثقافات يربط بين مختلف تيارات المجتمع الإسرائيلي. </p>

								<p>يتم ترتيب المعارض الدائمة الستة بالمتحف بترتيب زمني، من ظهور الإسلام في القرن السابع الميلادي إلى تفكك الإمبراطورية التركية العثمانية في أواخر القرن التاسع عشر وأوائل القرن العشرين </p>

								<p>كما يستضيف المتحف معارض اضافية ومنها معرض للفن الأندلسي يغطي فترة الفتح الإسلامي لإسبانيا ومعرض الأرابيسْك المُعاصِر والذي يهدف إلى دراسة كيفية تبني الفنانين الفلسطينيين والإسرائيليين المحليين زخارف مختلفة تتعلق بالزخرفة الإسلامية المعروفة باسم أرابيسك ودمجها في أعمالهم ومعرض "خمسة خمسة خمسة" واحدة من أكثر الأشكال الشائعة والشعبية في الثقافات الشرق اوسطية </p>



								<p>بالإضافة إلى المعروضات الإسلامية ، يستضيف المتحف أيضًا واحدة من أهم مجموعات الساعات في العالم. يضم المتحف مجموعة ساعات السير ديفيد سالومونس النادرة. تعتبر هذه المجموعة من أندر المجموعات في العالم وتم تجميعها من قبل والد فيرا سالومونس، السير ديفيد ليونيل سالومونس وتضم حوالي 55 ساعة من صنع صانع الساعات الباريسي الشهير: أبراهام لويس بريجيه (1747-1823).</p>

								<p>أكثر الساعات شهرة في المجموعة، ساعة الملكة ماري أنطوانيت من الأغلى في العالم، وتقدر قيمتها بنحو 30 مليون دولار.</p>


		                        `,
      };
    },
  },

  {
    id: "Acre",
    ctg: "general",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "KlXXyToCmCM",
    title: "عكا",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						          <!--<p>Recognized by UNESCO as a World Heritage Site, visiting Acre (Akko) promises visitors an emotional journey to a glorious past and a one-of-a-kind experience. An ancient and wondrous city, Akko boasts many remarkable sites including the remnants of the Hellenistic-Roman period as well as structures from the Crusader and Ottoman periods.</p>
                                  <p>Much more than a historical and archeological marvel, Akko also has colorful Oriental markets, museums, beaches and water sports facilities, a fishermen’s port, marina, restaurants, hotels, and annual picturesque festivals – all that and more are just a few of the city’s fantastic tourist attractions.</p>
                                  <p>The city's fascinating historical heritage, its rare blend of East and West, authentic glimpses from the past and unique remnants from different cultures, have all made Akko into one of the most vital Ancient World cities.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/1.jpg"} class="img-responsive">
								   </div>
								   <h3>The Knights' Halls</h3>
								   <p>A magnificent tour of the halls of the Hospitallers Order’s Fortress from the Crusader period. Discover the amazing remains of the ancient Order, the renovated and stunningly reconstructed halls, courtyard and surrounding streets, and step into history as a 830-year old story unfolds before you within the halls of the citadel.</p>
								   <p>Be sure to visit the streets, chapels, stores and the Arts and Crafts Market, featuring artisans from the Crusades era, offering their wares: blacksmiths, glass blowers, potters, weavers, embroiderers, leather craftsmen, basket weavers, perfume and oil craftsmen, and more</p>
										<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/2.jpg"} class="img-responsive">
								   </div>	

								    <p>تحفل زيارة عكا، المدينة التي اعترفت بها منظمة اليونسكو كإحدى مواقع التراث العالمي، برحلة مليئة
									الحنين إلى ماض مجيد وتجربة شديدة الفرادة. هذه المدينة القديمة والرائعة، تفتخر بالعديد من المواقع
									السياحية ومن ضمنها آثار من الفترة الهيلينية والرومانية إضافة إلى بنايات منذ الفترتين الصليبية
									والعثمانية.</p>
									<p>تعدّ عكّا أكثر بكثير من مجرد أعجوبة تاريخية وأثرية، إذ يوجد في عكا أيضا أسواق شرقية زاخرة
									بالألوان، ومتاحف وشواطئ ومرافق للرياضات المائية، وميناء للصيادين، ومرسى، ومطاعم، وفنادق،
									ومهرجانات سنوية خلابة، كل هذا وغيره ليس سوى نزر يسير من مناطق الجذب السياحي الكثيرة التي
									تتمتع بها المدينة.</p>
									<p>إن الإرث التاريخي المذهل لهذه المدينة، واحتواؤها على مزيج نادر يجمع ما بين الشرق والغرب،
									واللمحات الأصيلة من الماضي، والشواهد الفريدة على الثقافات المختلفة التي تداخلتها، قد جعلت من عكا
									واحدة من أكثر مدن العالم القديم حيوية.</p>
								    <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/1.jpg"} class="img-responsive">
								    </div>
									<h3>قاعات الفرسان</h3>
									<p>خذوا جولة رائعة في قاعات قلعة فرسان الإسبتارية من العصر الصليبي، اكتشفوا الآثار المذهلة للنظام
									القديم، والقاعات التي تم تجديدها والتي تمت إعادة بناؤها بشكل مذهل، وساحة الفناء والشوارع المحيطة
									بالقلعة. ادخلوا إلى التاريخ الذي تتكشف فيه قصة يبلغ عمرها 4000 عاما أمامكم داخل قاعات القلعة.</p>
									<p>لا تنسوا زيارة الشوارع ودور العبادة والمتاجر وسوق الفنون والحرف اليدوية الذي ظل محلا يضمّ
									الحرفيين منذ حقبة الحروب الصليبية، والذين يعرضون بضائعهم: الحدّادون، نافخو الزجاج، الخزّافون،
									المطرّزون، حرفيّو الدباغة، نسّاجو السلال، العطّارين، وحرفيّو صناعة الزيت وغيرهم.		</p>	
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/2.jpg"} class="img-responsive">
								    </div>	
                                    -->


								    <p>تحفل زيارة عكا، المدينة التي اعترفت بها منظمة اليونسكو كإحدى مواقع التراث العالمي، برحلة مليئة الحنين إلى ماض مجيد وتجربة شديدة الفرادة. هذه المدينة القديمة والرائعة، تفتخر بالعديد من المواقع السياحية ومن ضمنها آثار من الفترة الهيلينية والرومانية إضافة إلى بنايات منذ الفترتين الصليبية والعثمانية.</p>
									<p>تعدّ عكّا أكثر بكثير من مجرد أعجوبة تاريخية وأثرية، إذ يوجد في عكا أيضا أسواق شرقية زاخرة بالألوان، ومتاحف وشواطئ ومرافق للرياضات المائية، وميناء للصيادين، ومرسى، ومطاعم، وفنادق، ومهرجانات سنوية خلابة، كل هذا وغيره ليس سوى نزر يسير من مناطق الجذب السياحي الكثيرة التي تتمتع بها المدينة.</p>
									<p>إن الإرث التاريخي المذهل لهذه المدينة، واحتواؤها على مزيج نادر يجمع ما بين الشرق والغرب، واللمحات الأصيلة من الماضي، والشواهد الفريدة على الثقافات المختلفة التي تداخلتها، قد جعلت من عكا واحدة من أكثر مدن العالم القديم حيوية.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/1.jpg"} class="img-responsive">
								    </div>
									<h3>قاعات الفرسان</h3>
									<p>خذوا جولة رائعة في قاعات قلعة فرسان الإسبتارية من العصر الصليبي، اكتشفوا الآثار المذهلة للنظام القديم، والقاعات التي تم تجديدها والتي تمت إعادة بناؤها بشكل مذهل، وساحة الفناء والشوارع المحيطة بالقلعة. ادخلوا إلى التاريخ الذي تتكشف فيه قصة يبلغ عمرها 830 عاما أمامكم داخل قاعات القلعة.</p>
									<p>لا تنسوا زيارة الشوارع ودور العبادة والمتاجر وسوق الفنون والحرف اليدوية الذي ظل محلا يضمّ الحرفيين منذ حقبة الحروب الصليبية، والذين يعرضون بضائعهم: الحدّادون، نافخو الزجاج، الخزّافون، المطرّزون، حرفيّو الدباغة، نسّاجو السلال، العطّارين، وحرفيّو صناعة الزيت وغيرهم.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/2.jpg"} class="img-responsive">
								    </div>

		                        `,
      };
    },
  },

  {
    id: "Haifa",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "3ahATaKkhBk",
    title: "حيفا",
    smltitle: "",
    html: function() {
      return {
        __html: `  
								    <p>حيفا هي ثالث أكبر المدن في إسرائيل، وتحتوي على ميناء إسرائيل الرئيسي، ويقطنها 400 ألف نسمة. تتسلق بيوت المدينة سفوح جبل الكرمل المذكور في التوراة، وهي مدينة يبلغ عمرها 100 عام وقد ازدهرت أهميتها في عشرينيات وثلاثينيات القرن الماضي عندما التزمت بريطانيا بقرار عصبة الأمر بالانتداب على فلسطين لخلق وطن قومي لليهود. أكثر أحياء الكرمل السفلية صخبا هي منطقة الميناء، حيث تجرى معظم الأعمال اليومية في حيفا. وتشغل، إلى حد كبير، سفوح جبل الكرمل الأحياء السكنية، فيما تعتبر قمة الجبل موطنا للمتاحف والعديد من الفنادق والمتاجر. يتم الانتقال من أعلى الجبل إلى أسفله إما عن طريق مترو الأنفاق المسمى "كرمليت" أو من خلال تلّفريك "بات غاليم" إلى جانب الشوارع</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/haifa/1.jpg"} class="img-responsive">
								    </div>
									<p>أهم رموز حيفا وأيقوناتها هو ضريح الباب البهائي، ذو القبة المذهبة، والذي تم الفروغ من بنائه سنة 1953، متاخما للمقر الدولي للديانة البهائية، وهي شبكة من المباني العملاقة المشيدة على الطريقة اليونانية، والتي يذهل جمالها الزوار. تم تجميل ضريح الباب بشكل أكبر نهاية سنة 2001 لدى الانتهاء من تشييد "الحدائق المعلقة" (وهي واحدة من مواقع التراث العالمي بحسب منظمة اليونسكو)، هذه الحدائق الرائعة التي تقودكم من الضريح إلى أسفل جبل الكرمل ستذهلكم بجمالها ودقة تخطيطها. أسفل الحدائق تجدون الحي الألماني، الذي بناه التمبلريون الذي اتخذ منه المهاجرين الألمان التمبلريون المسيحيون في القرن التاسع عشر بيتا لهم. هذه البنايات التمبلرية قد تحولت الآن إلى شبكة من المتاجر الأنيقة والحانات والمطاعم.</p>
									
									<p>تعد مدينة حيفا موطنا للعشرات من المتاحف، بما فيها متحف الفن الياباني، ومتحف السكك الحديدية في إسرائيل، ومتحف "أف عل بي خن" لذكرى الهجرة اليهودية التي كانت تعد غير شرعية. كما أن حيفا هي موطن التخنيون، معهد الدراسات التطبيقية الإسرائيلية الأشهر، النسخة المحلية من معهد ماساتشوستس الأمريكي. يعدّ حي وادي النسناس في حيفا مركزا للاحتفالات العديدة والتي تعكس هوية المدينة التي تضم اليهود والمسيحيين والمسلمين والبهائيين معا</p>
									<h3>مواقع لا تفوّتوا زيارتها</h3>
									<p><em>معبد الباب البهائي</em></p>
									<p><em>الحدائق البهائية المعلقة</em></p>
									<p><em>نقاط المشاهدة البانورامية لحيفا في منطقة الكرمل الأعلى</em></p>
									<p><em>حي التمبلريين الألمان</em></p>
									<h3>وإن رغبتم بالمزيد:</h3>
									<p><span class="ac-en-font">Af-Al-Pi-Chen Museum of Illegal Immigration</span> متحف "أف عل بي خن" لإحياء إرث الهجرة غير الشرعية</p>
									<p><em>متحف السكك الحديدية الإسرائيلية</em></p>
									<p><em>متحف الفن الياباني</em></p>
									<p><em>التخنيون</em></p>
									<p><em>وادي النسناس</em></p>

		                        `,
      };
    },
  },

  {
    id: "Safed",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "i3_ihL51bHo",
    title: "صفد: حيث تلتقي الروحانية بما هو دنيوي",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						      <!--<p>With endless views that extend into distant horizons and pristine mountain air, Safed will instantly captivate you the moment you arrive. Known as the capital of Jewish mysticism past and present, this breathtaking ancient hilltop city is the highest in the Galilee and all of Israel – geologically and spiritually. One of the four sacred cities in Judaism, Safed offers a palpably mystical journey that will leave you in awe of its profound energy.</p>
                                  <p>A short drive from the revered Sea of Galilee, Safed welcomes you with quaint cobblestone alleys and numinous architecture. Listen as the many souls of history share their secrets through an old fortress erected by the Crusaders, the Mamluk, Ottoman and British influences, the War of Independence Monument, as well as a deep sacred history embodied by extraordinary synagogues and ancient tombs.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/safed/1.jpg"} class="img-responsive">
								   </div>
								    <h3>The Eternal Kabbalah Capital</h3>
								   <p>From Rabbi Shimon Bar-Yohai, the 2nd&nbsp;century author of the foundational work on the Kabbalah known as the Zohar, to Ari HaKadosh, the father of contemporary Kabbalah, Safed has been home to Judaism’s highest mystics and their devout students. It was 16th&nbsp;century when Ari HaKadosh “democratized” Kabbalistic teachings by bringing in a new understanding – one that allowed Kabbalah to reach the laymen.</p>
								   <p>As you walk from one synagogue to the next, you’ll feel just how Safed became the unchanging home for such a long lineage of spiritual aspirants, regardless of all that history threw their way. The Abuhav Synanogue whose architectural elements embody numerical mysticism, the Ari Ashkenazi Synagogue dedicated to Ari HaKadosh, and the Yosef Caro Synagogue will all transport you through time and into mysticism’s upper worlds.</p>
								   <h3>An Inspirational Old City &nbsp;</h3>
								   <p>Add more unforgettable moments to your trip by walking the winding cobblestone alleys in the Old City, viewing unique stone buildings and continuing on to the Artists’ Colony. Home to quality galleries that will introduce you to the exquisite works of local artists, including a wide variety of Judaica, this part of the Old City is for lovers of all things art. The Doll Museum and the Museum of Printing Art are special must-see for the culture-hungry.</p>
								   <p>Safed can be as nourishing for your body as it is for your soul – the Old City’s eclectic food offerings promise to please every taste and budget. From Yemenite pancakes and street food to unexpected delicacies at sit-down restaurants, you’ll find all that you’re looking for and more in this gracious city of deep traditions.</p>
								    -->
								    <h3>صفد: حيث تلتقي الروحانية بما هو دنيوي</h3>
									<p>بمناظرها اللامتناهية التي تمتد إلى أبعد الآفاق، والهواء المنعش البكر من الجبال، ستأسركم صفد فور وصولكم إليها. هذه المدينة القديمة الرابضة على قمة التل، والمعروفة باسم عاصفة التصوف اليهودي في الماضي والحاضر، هي الأعلى بين جميع مدن إسرائيل، جغرافيا وروحيا. تعد صفد واحدة من أربعة مدن مقدسة في الديانة اليهودية، وفيها تتوفر رحلة صوفية ستترك في نفوسكم خشوعا من طاقتها العميقة.</p>
									<p>على بعد مسافة قصيرة من السفر بالسيارة عن بحيرة طبريا، ستجدون صفد مرحبة بكم بأزقتها الجذابة المرصوفة بالحجارة، وبهندستها المعمارية الرائعة. أصيخوا السمع للعديد من الأرواح التي تشارككم أسرارها عبر التاريخ، من خلال حصن قديم شيده الصليبيون، وشاهدوا التأثيرات المملوكية والعثمانية والبريطانية من خلال آثارها، ونصب حرب الاستقلال، إلى جانب تاريخ مقدس عميق تجسده المعابد اليهودية الاستثنائية، والمقابر القديمة.</p>
									 <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/safed/1.jpg"} class="img-responsive">
								    </div>
									<h3>عاصمة القبالة الأبدية</h3>
									<p>بدءا من الحاخام شمعون بار يوحاي، الذي يعود تاريخه إلى القرن الثاني، وهو مؤلف العمل المهم المؤسس على القبلاه (وهي معتقدات وشروحات روحانية فلسفية تفسر الحياة والكون والربانيات) ، والمعروف باسم "زوهار" إلى آري كادوش، والد القبلاه المعاصر، كانت صفد موطنا لأعلى مراتب التصوف في اليهودية، ولمريديها المخلصين. حصل ذلك في القرن السادس عشر عندما قام آري كادوش بـ "دمقرطة" التعاليم القبالية من خلال إدخال فهم جديد، أتاح وصول القبالة إلى الأشخاص العاديين.</p>
									<p>لدى تنقّلكم من كنيس إلى آخر، ستدركون كيف صارت صفد موطنا ثابتا لمثل هذا النسب الطويل من المريدين الروحانيين، بغض النظر عن كل العوائق التي اعترضت طريقهم. بدءا من كنيس أبوهاف الذي تتجسد عناصره المعمارية التصوف التعددي، مرورا بكنيس آري أشكنازي المكرس لآري هكادوش، وصولا إلى كنيس يوسف كارو، ستنتقلون في رحلة عبر الزمن، وخلال عوالم التصوف العليا.</p>
									<h3>مدينة قديمة وملهمة</h3>
									<p>أضيفوا مزيدا من اللحظات التي لا تنسى إلى رحلتكم من خلال السير في الأزقة المتعرجة المرصوفة بالحجارة في البلدة القديمة، وشاهدوا المباني الحجرية الفريدة، وواصلوا طريقكم إلى حي الفنانين، موطن الفن الراقي الذي ستتعرفون فيه على الأعمال الرائعة للفنانين المحليين، بما في ذلك مجموعة متنوعة من فنون اليهودية، هذا القسم من البلدة القديمة مخصص لمحبي القطع الفنية. يعد متحف الدمى ومتحف فن الطباعة واحدا من الأماكن التي يجب أن يراها المتعطشون إلى الثقافة.</p>
									<p>يمكن أن تكون صفد غذاء للجسد تماما كما هي غذاء للروح: إن ما تعرضه المدينة من أطعمة نخبوية تضمن إرضاء جميع الأذواق والميزانيات. بدءا من الفطائر اليمنية وأطعمة الشوارع إلى الأطباق الشهية غير المتوقعة في المطاعم، ستجدون هنالك كل ما تبحثون عنه، بل وأكثر، في هذه المدينة الكريمة التي تمتد جذورها عميقا في التاريخ.</p>
															   
		                        `,
      };
    },
  },

  {
    id: "The_Bahai_Gardens",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "JV_AmfRULOo",
    title: "حدائق البهائيين المذهلة",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						          <!-- <h3>Visit the Baha’i Gardens</h3>
                                  <p>Picture yourself standing on the nineteenth terrace which is the very top of this breath taking monument where you can see the rolling hills of the Galilee, the city of Haifa, Akko and the Mediterranean Sea.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/bahai-gardens/1.jpg"} class="img-responsive">
								   </div>
								   <p>Beauty, grandeur, and inspired design combined with the meticulous gardening by generations of dedicated gardeners and a variety of cultures create the unique atmosphere of the Baha’i shrine and gardens in Haifa. While each garden offers a different experience they all share the same theme of gravelling paths, unique hedges and flourishing flower beds. A picture so perfect you must see it with your own eyes to believe the precision and symmetry.</p>
								   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/bahai-gardens/2.jpg"} class="img-responsive">
								   </div>
								     <p>This mystical iconic is site where members of the Baha’i faith have established their shrine and world centre because of its significance to their faith.</p>
                                   <p>The Baha’i faith had its origins from Iran. Its founder Baha'u'llah, was exiled from his homeland at the end of the 19th century, and came to Akko (Acre) and Haifa after suffering persecution in neighbouring countries.&nbsp; He was impressed with the beauty of Mount Carmel and expressed the desire that the Bab (one of the central figures of the Baha’i faith) would be buried there. About 20 years later the bones of the Bab were laid to rest in Haifa on the site that then developed into the centre of The Baha’i faith which is visited by half a million people every year.</p> -->

                                   <h3>زوروا الحدائق البهائية</h3>
									<p>تخيلوا أنفسكم وأنتم تقفون على الشرفة التي تعود للقرن التاسع عشر، في قمة هذا المعلم الخلّاب، حيث يمكنكم من هنالك رؤية تلال الجليل ومدينتي حيفا وعكا، وبينهما البحر المتوسط.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/bahai-gardens/1.jpg"} class="img-responsive">
								   </div>
									<p>يتجمع الجمال والفخامة، والتصميم الملهم، جنبا إلى جنب مع أعمال البستنة الدقيقة التي تقوم بها أجيال من البستانيين المخلصين، وإلى جانب هذا كلّه المجموعة المتنوعة من الثقافات، الجو الفريد للمعبد والحدائق البهائية في حيفا. وفي حين أن كل حديقة من هذه الحدائق توفر تجربة مختلفة، إلا أنها، جميعا، تشترك في وجود مسارات الحصى، والإحاطة النباتية الدقيقة بها، غَلائِلُ الزهور المزدهرة. إنها صورة مثالية يجب عليكم أن تروها بأم أعينكم لكي تصدقوا وجود مثل هذه الدقة والتناسق في العالم.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/bahai-gardens/2.jpg"} class="img-responsive">
								   </div>
									<p>هذا الموقع الديني الرمزي، هو الموقع الذي قام به أتباع الديانة البهائية بإقامة معبدهم ومركزهم العالمي، بسبب أهميته لعقيدتهم.</p>
									<p>تعود أصول الديانة البهائية إلى إيران، حيث تم نفي مؤسس الديانة، بهاء الله، من وطنه في أواخر القرن التاسع عشر، ولجأ إلى كل من عكا وحيفا بعد تعرضه للاضطهاد في دول الجوار. لقد تأثر بهاء الله بجمال جبل الكرمل، وأعرب عن رغبته في دفن حضرة الباب (وهو واحد من الشخصيات المركزية في الإيمان البهائي) هناك. بعد حوالي 20 عاما، تم نقل رفات حضرة الباب للدفن في حيفا، في الموقع الذي تطور بعد ذلك ليصير مركزا للعقيدة البهائية، والذي يزوره نصف مليون شخص كل عام.</p>


		                        `,
      };
    },
  },

  // Hadar asked to hide this post The_Sea_Of_Galilee on 2021-02-04
  // {
  // 		id:"The_Sea_Of_Galilee",
  //        	ctg : "north",
  //         bgImage : "/posts/bank/theeafgalilee/1.jpg",
  //         mobBgImage : "/posts/bank/theeafgalilee/M.jpg",
  //        	isVid:true,
  //        	vidId:"haG-t3wwuMc",
  //         title : "(بحيرة الجليل) طبريا",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         `
  //     }
  //   }
  // },
  // End Hadar asked to hide this post The_Sea_Of_Galilee on 2021-02-04

  {
    id: "Rosh_Pina",
    ctg: "north",
    bgImage: "/posts/bank/roshpina/1.jpg",
    mobBgImage: "/posts/bank/roshpina/M.jpg",
    isVid: true,
    vidId: "_qKbHL5-qrQ",
    title: "روش بينا",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <!-- <h3>Turn back the clock in the authentically picturesque Galilee village</h3>
                                   <p>Known as the Princess of the Galilee, Rosh Pina is home to the perfect mix of natural, cultural, historic and entertainment hotspots. A beautifully restored, serene northern village where aged olive trees and quaint homes are surrounded by lush golden fields, Rosh Pina is just the place for a leisurely and relaxing vacation, where visitors can relive village life as it was, over a century ago.</p>
                                   <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/rosh-pina/1.jpg"} class="img-responsive">
								   </div>
								   <h3>Where magical silence is broken only by chirping birds</h3>
								   <p>In search of a serene nature-filled location, reminiscent of Italy’s Tuscany or France’s Provence? Head north to Rosh Pina, where breathtaking rural landscapes are unhindered by the village’s attractions and you will feel as if transported to an era long ago. Choose from the many available guest houses, outfitted to provide maximum hospitality and interspersed throughout the village’s romantic alleyways, unadulterated by the bustle of the big city and breathing new life into the bewitchingly quaint and hospitable community.</p>
								   <p>Take advantage of the local natural beauty and traipse through stunning green&nbsp;hiking pathsaround Rosh Pina’s river or about the&nbsp;Baron de Rothschild’s Gardens, reportedly modeled to resemble the grand gardens at Versailles. Breathe in the fresh air and enjoy the sheer natural beauty as you stroll, becoming one with nature and recharging your batteries.</p>
								   <h3>A vacation colony with a unique, artistic charm</h3>
								   <p>Stroll about the village’s cobblestone streets, reminiscent of old European towns, and you will encounter a delightful cultural and artistic atmosphere surrounded by magnificent Galilee mountains. A place of trendy coffee shops, gourmet restaurants, art galleries, museums, festivals, historical sites and a shopping center, the city is teeming with antiquity, culture, nature and culinary delights, together recounting the history of the first “Galilee Moshava” (town) and the establishment of Jewish communities in Israel.</p> -->

								   	<h3>عودوا بالزمن إلى الخلف لتعيشوا تجربة القرية الجليلية الخلّابة الأصيلة</h3>
									<p>تعرف روش بينا باسم "أميرة الجليل"، وهي مستقر لمزيج مثالي من المواقع الطبيعية، الثقافية، والتاريخية، وتلك المرتبطة بقضاء الوقت الممتع. هذه القرية الشمالية التي تمت إعادة إحياؤها بصورة جميلة وهادئة، محفوفة بأشجار الزيتون القديمة والمنازل الجذابة المحاطة بالحقول الذهبية المورقة. إن روش بينا هي المكان الأنسب لقضاء إجازة ممتعة ومريحة، حيث يمكن للزوار أن يعيشوا حياة القرية كما كانت منذ أكثر من قرن من الزمن.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/rosh-pina/1.jpg"} class="img-responsive">
								   	</div>
									<h3>حيث لا سحر الصمت سوى زقزقة الطيور</h3>
									<p>هل تبحثون عن موقع هادئ يفيض بسحر الطبيعة، تذكركم بمنطقة توسكانا في إيطاليا أو بروفانس في فرنسا؟ ارموا عصا ترحالكم شمالا إلى روش بينا، حيث المناظر الطبيعية الريفية الخلابة التي لا تخلو من عوامل الجذب في القرية، هنالك ستعشرون وكأنكم عدتم بالزمن وقتا طويلا إلى الوراء. اختاروا أحد بيوت الضيافة والمجهزة لتوفير أقصى قدر من الضيافة والمتناثرة في جميع أرجاء الأزقة الرومانسية في القرية، التي لم يفسدها صخب المدن الكبيرة، وتنفسوا حياة جديدة في المجتمع الساحر والمضياف.</p>
									<p>استفيدوا من الجمال المحلي الطبيعي وتنزهوا عبر مسارات المشي الخضراء المذهلة المحيطة بنهر روش بينا أو حول حدائق البارون دي روتشيلد، التي يقال بأنها مصممة على غرار الحدائق الكبرى في فرساي. استنشقوا الهواء النقي واستمتعوا بالجمال الطبيعي التام أثناء التنزه، توحدوا مع البطارية واشحنوا طاقاتكم.</p>
									<h3>مستعمرة عطلة، ذات سحر فنّي جميل</h3>
									<p>تجولوا في شوارع القرية المرصوفة بالحصى التي تذكرنا بالمدن الأوروبية القديمة، وستلاقون أجواء ثقافية وفنية مبهجة تحيط بها جبال الجليل الرائعة. تنتشر في هذه القرية المقاهي العصرية، والمطاعم المخصصة للذواقة، والمعارض الفنية، والمتاحف، والمهرجانات، والمواقع التاريخية، وموقع التسوق، يجتمع في هذه البلدة ألق العصور القديمة، والثقافة، والطبيعة، والطعام ذو المذاقات الرائعة، مع سرد تاريخي للموشافاة (البلدات) الجليلية وإقامة المجتمعات اليهودية في إسرائيل.</p>

																   
		                        `,
      };
    },
  },

  {
    id: "Nazareth",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    title: "مدينة الناصرة",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						        <p>خليط من الأديان والثقافات: شاهدوا "مهد الديانة المسيحية" وهو ينبض أمامكم بالحياة.</p>
								<p>تشتهر مدينة الناصرة عبر العالم بكونها مهد السيد المسيح، وهي أكبر مدينة عربية في إسرائيل، كما أنها موقع مهم للحجاج والسياح القادمين لزيارة كنيسة البشارة. مدينة الناصرة هي مدينة صغيرة ومزدحمة، وهي تعج بالطرق التي تصطف على جانبيها المتاجر، والأزقة المرصوفة بالحجارة المحفوفة بالقصور التي تعود للعهد العثماني. لقد أعادت الناصرة اكتشاف نفسها خلال السنوات الأخيرة بوصفها جهة ثقافية وطهوية متطورة. كل شيء في الناصرة مفتوح في "الشابات" (ليلة الجمعة والسبت التي تعد عطلة أسبوعية في باقي المدن)، كما أن أجواءها الودية وموقعها المذهل، في قلب الجليل الأدنى (حوالي 24 كيلومترا إلى الغرب من بحيرة طبريا)، يجعلها محطة محببة للكثير من السياح</p>
								  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/nazareth/1.jpg"} class="img-responsive">
								   </div>
								<h3>مهد الديانة المسيحية</h3>
								<p>صارت الناصرة، بعد بضع مئات من السنوات من بدئها كقرية يهودية صغيرة قبل حوالي 2000 سنة معقلا للمسيحية في العصر البيزنطي. خلال تلك الفترة، انتشر اسم الناصرة على نطاق واسع، وقد أدى التوق لرؤية المكان الذي عاشت فيه السيدة العذراء ويسوع المسيح إلى تحويل المدينة إلى موقع حج تتقاطر إليه الشعوب. وقد أدت هذه الزيارات إلى بناء أول كنيسة في المدينة، وهي كنيسة البشارة، في الموقع الذي يقال إنه منزل يوسف النجار ومريم العذراء. لقد تم بناء العديد من الكنائس في جميع أرجاء المدينة، وتم تدميرها وإعادة بنائها مع تقلبات الحكم الإسلامي والمسيحي على مر القرون. في القرن التاسع عشر اجتذبت الناصرة اهتماما متجددا، وعاد المسيحيون للعيش في هذه المدينة، وقاموا بإعادة بناء الكنائس والأديرة. تعد الناصرة اليوم أكبر مدينة عربية في إسرائيل وهي تضم حوالي 30 كنيسة وديرا، بالإضافة إلى المساجد والمعابد اليهودية القديمة.</p>
								<h3>مذاق البلدة القديمة</h3>
								<p>التجوال في الناصرة يشبه استرجاعا لعصورها المختلفة. لقد خلّفت كل عقبة زمنية رمزا قويا خلفها ليصير موقعا سياحيا مبهجا وشعبيا في العصر الحديث. تتركز معظم هذه المواقع في المدينة القديمة التي بنيت في منتصف القرن التاسع عشر بأسلوب معماري شرق أوسطي ساحر. إن تجربة التمشي في الشوارع الضيقة، بين المنازل الخلابة، تعد تربة رائعة، وتستحق التأني للتمتع بالجمال المحيط.</p>
								<p>هنالك العديد من الكنائس الأثرية في البلدة القديمة، وعلى رأسها كنيسة البشارة. لقد احتفظت الكنيسة التي أعيد بناؤها بواسطة أجزاء من الكنائس السابقة، من العصرين الصليبي والبيزنطي، وهي تضم مجموعة رائعة من اللوحات.</p>
								<p>إلى جانب هذه الكنيسة توجد كنيسة القديس يوسف، المبنية على أنقاض المباني الزراعية التي، وفقا للروايات، احتوت على منجرة يوسف، زوج مريم العذراء. وبينما تم بناء كنيسة البشارة على أنقاض منزل مريم، تم بناء كنيسة البشارة للروم الأرثوذوكس فوق بئر مريم، والتي قيل بأن والدة المسيح قد شربت منها. يعود هذا المبنى إلى الفترة الصليبية، وفيه بعض اللوحات الجدارية المثيرة للاهتمام. وإلى جوار بئر مريم مباشرة توجد كنيسة البشارة للروم الأرثوذوكس داخل قاعة صليبية. وتقول الروايات بأن هذا هو مكان المجمع الذي صلى يسوع فيه.</p>
								<p>من ضمن العديد من الكنائس، توجد في الناصرة كنيسة البلاطة <span class="ac-en-font">(Mensa Christi)</span>، الكنيسة المارونية، كنيسة القديس جبرائيل، وكنيسة السالزيان. كما توجد في المدينة بنايات مهمة تعود للحقبة العثمانية، بما فيها السرايا، المبنى الحكومي، الذي بناه ظاهر العمر، متصرّف لواء الجليل في القرن الثامن عشر، إلى جانب المسجد الأبيض، الذي يستخدم اليوم كدار للعبادة وكمركز تعليمي وثقافي. ويضم المسجد الأبيض أيضا متحفا يحتوي على معروضات توثق تاريخ الناصرة.</p>
								<p>لن تكتمل أية جولة في مدينة الناصرة القديمة من دون زيارة السوق المحلي، الذي صار نقطة جذب شهيرة ومعروفة بفضل الأكشاك الملونة وتنوع البضائع فيه. هناك، يمكنكم الاستمتاع بما يمكن أن نصفه مهرجانا بصريا من المنسوجات الجميلة، وتذوق التوابل والأطعمة المحلية، والأعمال الفنية والهدايا التذكارية. إن جميع الأصوات والمشاهد والروائح هناك مجبولة بالروح الشرق متوسطية الأصيلة.</p>
								<h3>لمحة من السحر البلاد</h3>
								<p>تمتلئ الناصرة بالزوايا الرائعة والجميلة والتي ستفتح قلبك على جمالها. هنالك مكان آخر يستحق زيارتكم أثناء تجولكم سيرا على الأقدام، وهو المنزه المحيط بمقام النبي سعين للاستمتاع بالمنظر الرائع للجليل. يمكنكم زيارة الحمام التركي القديم الذي تم اكتشافه أثناء تجديد أحد متاجر المدينة، وإلقاء نظرة خاطفة على قصر فاخر تعرض فيه ثروات وعادات الطبقة العثمانية العليا في القرن التاسع عشر، ومن ضمنها بعض اللوحات الجدارية الرائعة. يجدر بكم أيضا زيارة منزل أسقف الروم الأرثوذوكس، حيث يمكنكم التجول عبر سلسلة من الممرات التحت أرضية المكتشفة في الفناء. هنالك موقع آخر مثير للاهتمام هو مجمع المسكوبية الذي بناه الروس كنزل للحجاج في المدينة.</p>
								<p>إن مدينة الناصرة التي استقبلت الحجاج والوافدين إليها منذ عدة قرون، تحتوي على نزل مسيحية وفنادق فاخرة تضمن راحة السياح المتوافدين إلى هذا الموقع المهم، وخاصة في فترة عيد الميلاد، تحتوي على العشرات من المطاعم التي تقدم أشهى المأكولات ذات النكهات الرائعة التي تجتذب الزوار طيلة العام. تمتلئ الناصرة بالبهجة في عيد الميلاد، حيث تتزين المدينة بأجمل حللها وتستعد لاستقبال الأجواء المقدسة والترانيم المنبعثة من كنائس المدينة</p>
							   
		                        `,
      };
    },
  },

  // {
  // 		id:"Cheers_To_Israel",
  //        	ctg : "culinarynorth",
  //         bgImage : "/posts/bank/north3/1.jpg",
  //         mobBgImage : "/posts/bank/north3/M.jpg",
  //        	isVid:false,
  //        	// vidId:"Cxii1yKqKwI",
  //         title : "GREAT WITH WHITE OR RED",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Over the past decade, Israeli wine-making has become a vital and thriving industry.</p>
  //                            <p>The fertile land of the area has been recognized worldwide as an excellent setting for burgeoning vineyards, and the local scene is trendy and opulent.</p>
  //                            <p>In the north, the general atmosphere reminiscent of French or Italian wine regions while the south&nbsp;has become renowned for its burgeoning&nbsp;wine scene, thanks to pioneering farmers and their use of computerized drip irrigation.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/cheers-to-israel/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						    <p><span style="font-family: arial,sans-serif;">The Israeli wine scene allows visitors a fantastic experience combining delectable wine tastings with the stunning vistas and energy this has to offer.</span></p>
  // 						   <p>So come get a taste of Israel’s wine country through its many fantastic tours of the vineyards and boutique wineries, the fantastic wine and music festivals and year-round wine-themed events.</p>
  // 						   <p>FYI, a visit to Israel goes great with white or red.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "A_Galilean_Treat",
    ctg: "culinary",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "kF808ENuuTQ",
    title: "CULINARY JOYS TO SUIT EVERY PALATE",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						          <p>A visit to the Galilee brings tastes and flavors unlike any you’ve ever experienced before. From regional cheeses handmade in artisanal dairies to world-class wines from boutique vineyards, from gourmet family-run restaurants to freshly-picked fruits and vegetables bursting with flavor, the Galilee is a foodie’s paradise.</p>
								   <h3>A Region Flowing with Milk and Wine</h3>
								   <p>Visit an artisanal dairy to discover the richness of Galilee cheeses and take part in the rhythm of cheese-making. Let an expert cheese-maker guide you as you taste some of the area’s many unique soft, hard and semi-hard cheeses, such as&nbsp;<em>lebane</em>, a creamy yoghurt-like soft cheese made from sheep or goat’s milk that is often served mixed with local herbs like za’atar, or&nbsp;<em>zefatit</em>, a salted sheep’s curd cheese that is molded into a basket and named for the area of&nbsp;<em>Zefat</em>, or Safed, where it was first made.</p>
								   <p>If you’d like some wine to accompany your cheese, you’ll be in for a treat. Each wine is better than the last. A recent revolution in wine-making caused boutique wineries to spring up across the Galilee’s highly varied terroir, every vineyard raising grapes with a flavor that is specific to the soil in which they grow. Gaze out over hills covered in vines while you savor deep, fruity reds and fresh white wines with the guidance of Israel’s top wine-makers. Explore the grape blends that produced wines earning top honors at the world’s wine fairs, many of which are not available for sale outside of Israel.</p>
								   <h3>Taste the Harvest</h3>
								   <p>Visit pick-your-own orchards to revel in berries, apples, cherries, peaches, plums and even sabra-fruit that are plump, juicy and bursting with flavor. Tour spice farms to smell and taste an ever-changing range of herbs and spices, both those that are familiar to you and those that you’ve never encountered before. Discover the Galilee’s native flavors and create your own herbal teas and spice blends.</p>
								   <p>Another of the Galilee’s important harvests, olive oil, also awaits you. If you thought that all olive oil tastes the same, a visit to a family-run olive oil farm in the Galilee will change your mind. Sample olive oils to learn what makes each oil taste different and join the fun of picking olives and pressing them the old-fashioned way to make your own extra-virgin olive oil.</p>
								                                 
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/galilean-treat/1.jpg"} class="img-responsive">
								   </div>
								   <h3>Markets and Restaurants</h3>
								   <p>The Galilee’s ancient towns boast a plethora of markets where you can buy the best local produce and artisanal products, often sold by the experts who made them. Amble the markets tasting and testing to discover delights around every corner, or join a knowledgeable foodie guide who will lead you to the best stalls and finest treats.</p>
								   <p>As you wander the Galilee following your taste buds you’ll encounter gourmet restaurants tucked away in the unlikeliest corners. Some of the country’s best cooking is served in unassuming Galilee eateries perched on the edge of magnificent views. Many are family-run, serving dishes made with love from ingredients that were grown or raised within just a few miles. But to really plumb the depths of the Galilee’s produce, take part in a cooking workshop. They are led by local chefs who know the land inside and out and are eager to share the best way to choose, prepare and enjoy the tastiest local produce. Often you’ll pick your ingredients before you prepare them, making dishes that taste better than anything you’ve ever cooked before.</p>
								   <h3>The Unique Experience of the Galilee</h3>
								   <p>The Galilee is much more than a series of delicious flavors. Visit ruined fortresses and biblical sites where Jesus preached and battles were fought. Climb up mountains, thrill with white-water rafting and hike alongside bubbling streams as part of your dream vacation in the Galilee.</p>
											<p>Photo credit:Itamar Grinberg		</p>			   
		                        `,
      };
    },
  },

  {
    id: "Galilee_Action",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "5Ep3GgxELag",
    title: "الإثارة في الجليل",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

								  <p> الأنهار والبحيرات والسواحل العديدة في الجليل هي مصدر للكثير من المرح للزوار من كافة الأجيال، إذ يمكن للباحثين عن المغامرة أن يستمتعوا بالرذاذ على وجوههم أثناء تسابق أصدقائهم على التجديف بقوارب الـ "كاياك" في المياه المتلاطمة، أو يمكن للعائلات والأزواج الاسترخاء معا على الضفاف الخضراء الرائعة لأحد أنهار الجليل العديدة. يمكنكم أيضا تبريد أجسامكم أثناء ممارستكم لواحدة من المتع المائية كالتزلج على الماء أو ركوب العجلات المنفوخة الطافية، أو ركوب الأمواج مدفوعين بقوة الرياح التي تلتقطها الطائرات القماشية الهوائية الملونة في بحيرة طبريا. أما على امتداد الساحل، فيحب السائحون التسكع على شواطئ الجليل الرملية الساخنة أو التمتع بالجمال الصافي في مغارات رأس الناقورة الصخرية البيضاء.</p>
									<p>إلى جانب الرياضات المغامرة في الماء يمكنكم العثور عليها إما في الهواء أو على الأرض. ويمكن للسائحين النشطين الاستمتاع بالأنشطة التي تسبب فوران الأدرينالين في الجسم مثل القفز بالمظلة في السماء أو القفز فوق المسارات الجبلية الوعرة أو الهبوط بالحبال على المنحدرات الصعبة. أما في فصل الشتاء فيمكن الاستمتاع برياضات التزلج على الجليد والثلج في جبل الشيخ، في مواضع محددة تختلف درجة صعوبتها وفقا لتجربة الزوار واختيارهم.</p>
									 <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/galilee-action/1.jpg"} class="img-responsive">
								   </div>
									<h3>كنز الطبيعة الجليلية الزاخر بالجمال</h3>
									<p>يفيض الجليل بالأماكن ذات الجمال الطبيعي، حيث يمكن للعائلات والأزواج ومجموعات الأصدقاء التنزه أو إلقاء نظرة على الحياة البرية أو مجرد الاستمتاع بالتنزه في أحضان الطبيعة الهادئة. إن التجول على طول هذه المسارات إما على ظهور الخيل، أو السير على المسارات المحددة بصورة ممتازة سيرا على الأقدام أو على الدراجات، سيمنحكم شعورا بالجمال والمتعة والإثارة أينما ذهبتم. شاهدوا الطبيعة واسترخوا من خلال استكشاف الطيور والحياة البرية في محمية وادي الحولة الطبيعية، أو اختبروا سحر امتزاج الغابات بالحقول والأنهار التي تتكشف تحتكم وأنتم ترتفعون في منطاد في الجلبوع. أضيفوا المزيد من الألق إلى تجربتكم من خلال التعمق في روحانيات الأماكن المقدسة للمسيحيين واليهود والبهائيين.</p>
									<p>تعدّ مسارات المشي للمسافات الطويلة في الجليل، وهي مسارات عديدة ومتنوعة، نقطة جذب للمتنزهين من جميع الأعمار، طيلة أيام السنة. سواء أكنتم تفضلون التنزه في الظلال بجانب الجداول الهادئة، أو تحبون الإثارة الكامنة في تسلق الجبال والهبوط منها بواسطة الحبال، أو الاستمتاع بتحقيق الإنجاز المتمثل في الوصول إلى نقطة مشاهدة لمنظر مذهل على قمة تل مليء بالتحديات، فإنكم ستجدون الطريق المثالية بانتظاركم. فجميع الخيارات مفتوحة في الجليل.</p>
									<p>الصورة لإيتامار غرينبرغ</p>

								   
		                        `,
      };
    },
  },

  {
    id: "Bet_Shean",
    ctg: "north",
    bgImage: "/posts/bank/betshean/1.jpg",
    mobBgImage: "/posts/bank/betshean/M.jpg",
    isVid: false,
    title: "بيسان",
    smltitle: "",
    html: function() {
      return {
        __html: `  <!-- <p>South of the Sea of Galilee are the remains of one of the largest cities in the Roman-Byzantine Empire, Bet She’an. One of ten ancient cities (hence “Decapolis”) that included Philadelphia (present day Amman in Jordan) and Jerash, Scythopolis ((Bet She’an) was the only decapolis city west of the Jordan river.  It was very grand, with a giant theater, streets of tall columns, shops, bathhouses a hippodrome and hundreds of homes.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/bet-shean/1.jpg"} class="img-responsive">
								   </div>
								   <p>However, the splendid city was toppled in 749 by a massive earthquake, and never rebuilt. Over the centuries the ruins were overgrown – and it was not until the mid-20th century that Israeli archeologists pulled Bet She’an out of the murk, discovering (and restoring) the theater, the Cardo, the columns and much more.</p> -->
								   	<p>لى الجنوب من بحيرة طبريّا، تقع واحدة من أكبر المدن في الإمبراطورية الرومانية البيزنطية، وهي بيسان [بيت شان]، وقد كانت واحدة من المدن العشرة القديمة (التي أطلق عليها اسم "ديكابوليس") والتي شملت مدينة فيلاديلفيا (التي صارت مدينة عمّان، عاصمة المملكة الأردنية الهاشمية)، وجرش. أما مدينة سيثوبوليس (بيسان) فقد كانت مدينة ديكابوليس الوحيدة التي تشيد غربي نهر الأردن. كانت المدينة كبيرة جدا، فيها مسرح عملاق، شوارع محفوفة بالأعمدة المرتفعة، والمتاجر، والحمامات، وميدان سباق الخيل، ومئات المنازل.</p>
								   	<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/bet-shean/1.jpg"} class="img-responsive">
								   </div>
									<p>ومهما يكن من أمر، فقد طوّح زلزال هائل بهذه المدينة الرائعة سنة 749، ولم يُعد بناؤها أبدا. وعلى مر القرون، ظلّت أنقاضها الضخمة، وقد مر الوقت حتى منتصف القرن العشرين إلى أن قام علماء الآثار الإسرائيليين بانتشال الآثار ليكتشفوا (ويعيدوا ترميم) المسرح، والكاردو (الاسم اللاتيني الذي كان يطلق على الشارع العابر من الشمال إلى الجنوب في المدن الرومانية القديمة)، والأعمدة، وغيرها الكثير.</p>
								   
		                        `,
      };
    },
  },

  {
    id: "Zichron_Yaakov",
    ctg: "north",
    bgImage: "/posts/bank/zichronyaakov/1.jpg",
    mobBgImage: "/posts/bank/zichronyaakov/M.jpg",
    isVid: false,
    title: "زخرون يعقوب",
    smltitle: "",
    html: function() {
      return {
        __html: `<!-- <p>Zichron Ya’akov is a wonderful town for tourists, both local and foreign. This picturesque moshava semi-cooperative farming community built at the tip of the Carmel mountain range is the first moshava ever built in Israel and is a main tourism and vacation site in this region.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/zichron-yaakov/1.jpg"} class="img-responsive">
								   </div>
								    <p>Anyone who visits&nbsp;<strong>Zichron&nbsp;Ya’akov&nbsp;</strong>goes straight to Ha-Nadiv Street, and Ha-Meyasdim Street in the town center, which has become a very popular pedestrian mall, thanks to the special atmosphere in this place. The streets are paved with stones and pass between the moshava’s original houses (some of which have been reconstructed), which are bustling with activity.</p>
								   <p>There are many quaint and charming restaurants and coffee shops, interspersed between beautifully designed stores that sell local art works and lovely souvenirs. There are art galleries, unique artists' studios and workshops. New, modern buildings stand alongside old ones, such as the synagogue and the administration building, an old courtyard with a display of antique agricultural implements.</p>
								   <p>From its early days,&nbsp;<strong>Zichron Ya’akov</strong>&nbsp;had two main characteristics: wine and tranquility. The moshava’s founding farmers cultivated vineyards and the large winery built here in 1889 became the area’s most important industry. During the British Mandate period (1917-1948), the moshava became a holiday resort and rural vacations site, and to this day has hotels, spas and guesthouses.</p>
								-->	

								<p>تعد زخرون يعقوب مدينة رائعة في أنظار السياح المحليين والأجانب. فهذه المدينة التي يقطنها مجتمع زراعي شبه تعاوني يقيم في منطقة خلّابة تقع على طرف سلسلة جبال الكرمل، هي أول "موشافا" تبنى في إسرائيل، وهي تعد موقعا رئيسيا للسياحة والعطلات في هذه المنطقة.</p>
 
								<p>كل من يزور زخرون يعقوب يذهب مباشرة إلى شارع "هنديف" وشارع "هميسديم" وسط المدينة، والذي أصبح جادة سير مشهورة بفضل الجو الخاص الذي يسود هذا المكان. الشوارع هنا مرصوفة بالحجارة وتمر بين منازل الموشافاة الأصلية (التي جرت إعادة بناء بعضها)، وهي شوارع تعج بالنشاط.</p>
								<p>تجدون في هذه المدينة العديد من المطاعم والمقاهي الجذابة والساحرة، المنتشرة بين المتاجر التي صممت بذوق عال، والتي تبيع الأعمال الفنية المحلية والهدايا التذكارية الرائعة. تجدون هنا أيضا معارض فنية واستديوهات وورش عمل فريدة من نوعها بإدارة فنانين. وتصطف المباني الجديدة والمعاصرة إلى جانب المباني القديمة، على غرار الكنيس، ومبنى الإدارة، وفناء قديم يعرض الأدوات الزراعية العتيقة.</p>
								<p>كان لزخرون يعقوب، منذ نشوئها، ميزتان أساسيتان هما : النبيذ والهدوء. إذ قام المزارعون المؤسسون لهذه الموشافاة بزراعة الكروم، وصار مصنع النبيذ الكبير الذي تم بناؤه سنة 1889 أهم معالم الصناعة في المنطقة. وخلال فترة الانتداب البريطاني (ما بين 1917 حتى 1948) صارت الموشافاة منتجعا لقضاء العطلات، ومحلا للإجازات الريفية، ولا تزال الفنادق والمنتجعات الصحية وبيوت الضيافة تملأ المكان حتى يومنا هذا.</p>
													   
		                        `,
      };
    },
  },

  // {
  // 		id:"ULTIMATE_BEACH_FUNe_Routes",
  //        	ctg : "culinarynorth",
  //         bgImage : "/posts/bank/north1/1.jpg",
  //         mobBgImage : "/posts/bank/north1/M.jpg",
  //        	isVid:true,
  //        	vidId:"Cxii1yKqKwI",
  //         title : "DISCOVER THE WINE ROUTES",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Discover a different Israel through it's wineries and vineyards, through the passion of the people who are crafting award winning wines from home grown grapes.</p>
  //                            <p>Enjoy vintage wines, gourmet foods, and gorgeous scenery. Spend time experiencing Israel as you never have before, as a Wine Connoisseur! The beauty of these routes in Israel is of course the authentic wine but also the incredible landscapes that surround the wineries. Many of the wineries are situated near ‘Zimmers’ which are little spa complexes that are dotted around northern Israel. They have little cabins with Jacuzzis that face out to the magnificent views of the rolling green hills. You can relax in your personal cabin with a splendid glass of wine from the local winery.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/discover-the-wine-routes/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <div class="wpb_wrapper"><p>The Middle East &amp; Eastern Mediterranean was the cradle of wine production, and the ancient land of Canaan is in fact one of the earliest countries to cultivate wine over 2,000 years before the vine came to Europe.</p><p>There are currently over 25 commercial wineries and over 150 boutique wineries in Israel where wine making has become a personal obsession with wine makers striving to produce world class wines.</p><p>Israel like other 'long' countries such as Chile or Italy enjoys a variety of microclimates. While the northern region gets much rain and even snow in the winter, just a few hours away Israel's southern region is very arid with desert conditions. This range in microclimates supports many grape varieties, which can grow on several different types of soil, yielding excellent results.</p><p>As always in matters of taste, you must visit Israel’s wineries and vineyards and decide for yourself which is your favourite!</p><p></p></div>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Birdtastic_Hula_Lake",
    ctg: "north",
    bgImage: "/posts/bank/birdtastichulak/1.jpg",
    mobBgImage: "/posts/bank/birdtastichulak/M.jpg",
    isVid: true,
    vidId: "ImobrsxsKl8",
    title: "بحيرة الحولة: مجمع الطيور المهاجرة",
    smltitle: "",
    html: function() {
      return {
        __html: `
						  <!-- <p>Hula Valley The Hula valley is located in a drained swampland by an attractive large lake, and is one of the area’s top places for friendly hiking and biking excursions. The Hula Valley is the country’s primary migration route for birds, making bird watching a very popular and fascinating experience.&nbsp;<strong>In 2009, the BBC Nature Magazine named the Hula Valley as one of the top nature watching places in the world.</strong></p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/birdtastic-hula-lake/1.jpg"} class="img-responsive">
								   </div>
								   <h3>Discover One of the World's Top Birdwatching Sites</h3>
                                   <p>In the heart of the picturesque Hula Valley in Upper Galilee, only two hours drive north from Tel-Aviv, between two majestic mountain ranges, lays a place of extraordinary beauty - the Hula Lake. One of the most important birdwatching sites in the world, this ecological internationally acclaimed wetland reserve, is an oasis for birds and nature lovers everywhere. Offering a rare and unique opportunity to experience nature without barriers or partitions, it's an invitation for an experience of a lifetime.</p>
								    <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/birdtastic-hula-lake/2.jpg"} class="img-responsive">
								   </div>
								   <h3>Follow the Birds and Marvel Nature</h3>
								   <p>During every migration season (spring and fall) over 500 million birds and close to 400 species travel through the Hula Lake. This wetland paradise is the perfect stopover for small waterfalls, cormorants, heron, pelicans, raptors, strokes and cranes.</p>
								   <p>Declared by the BBC Wildlife as one of the world's top ten birdwatching sites, Hula Lake or as it called in Hebrew Agamon Hula, naturally attracts birdwatchers from all around the world. Join the international Hula bird festival every year in the fall and enjoy a truly not-to-be missed-experience.</p>
								   <p>There are several ways to witness this dazzling humbling phenomenon. All you need is simply choose your adventure.</p>
								   <p><strong>Explore the Trails</strong>. Tour the park's magical trails. You can walk, bike or use club carts to drive around. You'll pass through fruit groves waterway and get a glimpse of the wetland wildlife.</p>
								   <p><strong>Drive a Tractor</strong>. Join a guided tour in a Tractor-Drawn "Safari Wagon" that takes you deep into the Agamon's premises. The wagon "hides" you from the birds and therefore enables a rare up close and personal encounter with these beautiful creatures.</p>
								   <p><strong>Sunrise and Night tours</strong>. For the more adventurers, there are 2 special tour experiences. One is the 'Sunrise Tour' that offers unbeatable birdwatching and photography opportunities. Alternatively, the 'Night Owl Tour' offers a completely different look on the reserve. With campfire and star-gazing you'll peek into the lives of wild cats, nocturnal raptors and fruit bats.</p>
								   <p><strong>Uplift the Spirit and Witness Nature Preservation at Work</strong><br> Agamon Hula gained world acclaim for being model for a sustainable ecological system balancing between nature, tourism and agriculture.<br> Visit the ringing center in the park and watch the work done to preserve nature. Go to the "bird Island tour" and maybe you'll even get a chance to help release a bird back to nature. It doesn't get much better than this.<br> With so many different types of animals and tireless work to preserve nature in creative ecological ways, Hula Lake offers more than a fun trip with beautiful scenery but a true feel good experience that opens the heart and mind.</p> -->
									<p>يقع وادي الحولة في منطقة مستنقعات مجففة بجانب بحيرة كبيرة وجذابة، ويعد الوادي واحدا من أفضل الأماكن لممارسة رياضة المشي لمسافات طويلة وركوب الدراجات في المنطقة. إن واجي الحولة هو طريق الهجرة الرئيسي للطيور في البلاد، وهو ما يحيل تجربة مشاهدة الطيور إلى تجربة رائعة وشديدة الشعبية. <strong>في العام <span class="ac-en-font">2009</span>، وصفت مجلّة <span class="ac-en-font">The BBC Nature Magazine</span> وادي الحولة كأحد أفضل مواقع مشاهدة الطبيعة في العالم.</strong></p>

								<h3>اكتشفوا واحدا من أفضل مواقع مراقبة الطيور في العالم</h3>
								<p>في قلب وادي الحولة الخلّاب الواقع في منطقة الجليل الأعلى، وعلى بعد ساعتين فقط سفرا بالسيارة إلى الشمال من تل أبيب، وبين سلسلتين جبليتين مهيبتين، يقع مكان آسر الجمال, إنه بحيرة الحولة. وهو واحد من أهم مواقع مشاهدة الطيور في العالم، فهذه المحمية الطبيعية المعترف بها عالميا محمية للأراضي الرطبة، هي واحة للطيور ومحبي الطبيعة في كل مكان. وهي تقدّم للزائرين فرصة نادرة وفريدة للتواصل مع الطبيعة من دون حواجز أو عوائق. إنها دعوة لخوض تجربة لن تنسوها أبدا.</p>

								 <div class="img-wrapper">
																	   <img src=${getImgUrl() +
                                       "/posts/birdtastic-hula-lake/1.jpg"} class="img-responsive">
																   </div>
																   <h3>اتبعوا الطيور، وتمتعوا بأعجوبة الطبيعة</h3>
								<p>طيلة موسم هجرة الطيور (الربيع والخريف) يسافر أكثر من <span class="ac-en-font">500</span> مليون طائر موزعة على نحو <span class="ac-en-font">400</span> نوع، عبر بحيرة الحولة. هذه الأرض الرطبة- الجنّة، تعد محطة توقف مثالية لطيور الغاق، ومالك الحزين، والبجع، والطيور الجارحة، وغيرها من الطيور. </p>
								<p>هذه البحيرة التي أعلنت عنها <span class="ac-en-font">BBC Wildlife</span> بوصفها واحدة من أفضل عشرة مواقع لمشاهدة الطيور حول العالم، تجذب بحيرة الحولة، أو كما يطلق عليها بالعبرية اسم "أغامون حولة" مراقبي الطيور من أقاصي الأرض. انضموا إلى مهرجان طيور الحولة الدولي في خريف كل عام واستمتعوا بتجربة لا ينبغي تفويتها أبدا</p>
								<p>هنالك عدة طرق لمشاهدة هذه الظاهرة المدهشة. إن كل ما تحتاجونه ببساطة هو اختيار نوع المغامرة الذي ترغبون في خوضه.
								<p>استكشفوا المسارات. تجولوا في مسارات المنتزه السحرية. بإمكانكم السير أو ركوب الدراجة أو استخدام عربات التجوّل الخاصة بالمنتزه. ستمرون عبر مسارات المياه التي تتخلل بساتين الفاكهة، وستحظون بلمحة من الحياة البرية في الأراضي الرطبة.</p>
								<div class="img-wrapper">
																	   <img src=${getImgUrl() +
                                       "/posts/birdtastic-hula-lake/2.jpg"} class="img-responsive">
																   </div>
								<p>تمتعوا بقيادة جرّار نقل. انضموا إلى جولة إرشادية في "عربة سفاري" مجرورة، تأخذكم إلى أعماق البحيرة. هذه العربات تجعلكم "خفيين" عن أعين الطيور، وهي بالتالي تتيح لكم لقاء نادرا وشخصيا مع هذه المخلوقات الجميلة.</p>
								<p>جولات في ساعات الشروق وساعات الليل. لمن يحبون المغامرة أكثر من ذلك، هنالك تجربتان خاصتان من الجولات. الأولى هي ’جولة الشروق‘ التي توفر فرصا لا تضاهى لمشاهدة الطيور وتصويرها فوتوغرافيا. وعلى الضد تماما، توفّر ’الجولة الليلية‘ تجربة مختلفة تماما للمحمية. حيث التحلق حول نيران التخييم والتحديق في النجوم، وحيث ستحظون بلمحة سريعة عن حياة القطط البرية والطيور الجارحة الليلية وخفافيش الفاكهة.</p>
								<h3>شاهدوا المحمية الطبيعية في ذروة نشاطها، واعملوا من أجل الطبيعة.</h3>
								<p>اكتسبت بحيرة الحولة شهرة عالمية لاحتوائها على نموذج لنظام بيئي مستدام يوازن ما بين الطبيعة والسياحة والزراعة. زوروا مركز الرنين في الحديقة وشاهدوا العمل الجاري للحفاظ على الطبيعة. شاركوا في "جولة جزيرة الطيور" ولربما تحظون بفرصة للمساعدة في إعادة طائر إلى الطبيعة، إنكم لن تحظوا بتجربة أفضل من هذه. مع وجود العديد من أنواع الحيوانات المختلفة، والعمل الدؤوب الساعي للحفاظ على الطبيعة بطرق بيئية إبداعية، توفر بحيرة الحولة أكثر مما هو مجرد رحلة ممتعة ومناظر طبيعية خلابة، بل إنها تقدم تجربة حقيقية تجعلكم تشعرون براحة تفتح القلوب والعقول</p>
								 

		                        `,
      };
    },
  },

  {
    id: "The_Kibbutz_Experience",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: false,
    title: "تجربة الكيبوتس التي لا تضاهى",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           <!-- <p>Predominantly based amongst beautiful landscape settings dotted around the country the Kibbutz life is a modern day phenomenon and a totally unique way of living. The movement which started in 1905 is a collective community way of living traditionally based on agriculture. Each kibbutz would sell its own produce.  The people living on them would all collectively work together to preserve it and work the land.</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/kibbutz-experience/1.jpg"} class="img-responsive">
								   </div>
								    <p>The word ‘Kibbutz’ in Hebrew means group.&nbsp;The point being it is a voluntary democratic community where people live and work together to generate economically. It is founded on the principles of communal ownership of property and social equality.</p>
                                   <p>Some would describe the beautiful settings and a life of equality a utopia and why not experience it for yourself?&nbsp; Many of the Kibbutzim are open to visitors whether you would like to stay a few hours or a few months learning what this life is all about.</p> -->

                                   <p>تعتبر حياة الكيبوتس، المتواجدة في الغالب وسط مشهدية المناظر الطبيعية المنتشرة في جميع أرجاء البلاد، ظاهرة حديثة وأسلوب حياة فريد تماما. إن حركة الكيبوتسات التي انطلقت سنة 1905 هي أسلوب حياة مجتمعي جماعي للعيش، ويعتمد بشكل تقليدي على الزراعة. كان كل كيبوتس يقوم ببيع منتجاته الخاصة. ويعمل جميع سكانه معا بشكل جماعي من أجل الحفاظ عليه وفلاحة الأرض.</p>
                                   <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/kibbutz-experience/1.jpg"} class="img-responsive">
								   </div>
									<p>تعني كلمة "كيبوتس" بالعبرية جماعة. إنه مجتمع ديمقراطي وتطوعي، حيث يعيش الناس ويعملون معا لكي يخلقوا انتاجا اقتصاديا. ويرتكز الكيبوتس على مبادئ الملكية الجماعية للممتلكات والمساواة الاجتماعية.</p>
									<p>قد يصف البعض الأماكن الجميلة وحياة المساواة بأنها مدينة طوباوية فاضلة، فلماذا لا تجربها بنفسك؟ العديد من الكيبوتسات متاحة لزيارة الزوار، سواء أكنت ترغب بالبقاء لبضعة ساعات أو المكوث لبضعة أشهر لتعلم ما الذي تدور حوله حياة الكيبوتسات</p>

								   
		                        `,
      };
    },
  },

  {
    id: "National_Parks",
    ctg: "general",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: false,
    title: "المنتزهات والحدائق الوطنية",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						          <p> على الرغم من صغر حجم إسرائيل، إلا أن مناظرها الطبيعية تتنوع بشكل كبير! ستجدون مدنا حديثة ومدنا قديمة، وشواطئ وبحيرات وصحاري وجبال خضراء. إن منتزهات إسرائيل الوطنية ومحمياتها الطبيعية تسخّر كل هذا من أجلكم لكي تتمتعوا بمشاهدة المناظر الطبيعية الرائعة.</p>
 									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/national-parks/1.jpg"} class="img-responsive">
								   </div>
									<p>في جنوبي البلاد ستجدون مساحة من السهول الصحراوية التي تتراوح ألوانها بين الذهبي والبرتقالي. أما النقب والعربة وإيلات ففيها طبيعة نارية حمراء، في الجنوب الذي يضم البحر الميت، منطقة "مستبيه رمون" وواحة "عين جدي" الصحراوية، ناهيك عن توفر المسارات الرائعة للمشي وركوب الدراجات. حينما تغرب الشمس، يتحول الجنوب إلى بحر أحمر مضيء تغلفه غلالة من السحر، وفي الظلام تتحول السماء إلى غطاء متلألئ زاخر بالنجوم التي يمكن مشاهدتها كلّها، في ظل غياب التلوث الضوئي في هذه المنطقة.</p>
									<p>أما شمالي البلاد، فالتلال والجبال الخضراء الفاتنة تنتظركم، إلى جانب جبل الشيخ المغطى بالثلوج. مرتفعات الجولان إلى الشمال الشرقي هي موطن لمناظر جبلية رائعة ولمجموعة من الثقافات. هنالك مسارات لا حصر لها في الغابات، إلى جانب مسارات المشي للمسافات الطويلة التي تمر بشلالات المياه، لكي يستمتع بها جميع أفراد العائلة. المنظر من قمم الجبال يحبس الأنفاس، حيث تأخذك عيناك على طول الطريق إلى البحر الأبيض المتوسط. ستجدون أسفل الجبال، سفوح الجليل الخضراء، حيث طبريا الشهيرة، ومصانع النبيذ، وبعض منتجعات الاسترخاء الرائعة. إنها حقا أرض العجائب.</p>
									  <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/national-parks/2.jpg"} class="img-responsive">
								   </div>
									<p>توفر المنتزهات الوطنية مغامرات ثقافية وطبيعية مثيرة. لديكم الفرصة لزيارة المواقع التاريخية الرائعة واتباع مسارات الطبيعة الرائعة أثناء بحثكم عن بعض الصنوف الحياتية النادرة كالوعل الصحراوي ونسور الجولان. إن التنوع المذهل للعجائب الطبيعية والالتقاء المباشر بالطبيعة العذراء والنباتات هو أجمل ما في هذه الجولات.</p>

		                        `,
      };
    },
  },

  {
    id: "Tiberias",
    ctg: "north",
    bgImage: "/posts/bank/tiberias/1.jpg",
    mobBgImage: "/posts/bank/tiberias/M.jpg",
    isVid: false,
    title: "مدينة طبرية",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						          <!-- <p>Located at the shores of the Sea of Galilee, Tiberias, the capital of the Galilee, was established in the early Roman period and has served as a religious, administrative and culture center of the Jewish people for many years.</p>
                                  <p>In addition to its rich history and significance, modern day Tiberias is synonymous with holiday in Israel. Here one can enjoy a variety of activities the city has to offer, and experience a wonderful mix of relaxation, nature and history, along with contemporary attractions, active water sports, pilgrimage sites and unique tourist attractions</p>
                                  <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/tiberias/1.jpg"} class="img-responsive">
								   </div>
								   <p>A visit to Tiberias is not complete without a visit to its surrounding area, which features many must-see sights, including The city Bet Shean, one of the oldest cities in the world, and one of the country’s largest archaeological sites; Magdala (Migdal) the ancient town on the Sea of Galilee which was home to many of Jesus’s disciples and is said to have been the home of Mary Magdalene; Megiddo, a beautiful and impressive national park and one of the most important archeological sites in Israel from the time of the Bible. Once an ancient city of critical strategic importance, Megiddo is a UNESCO World Heritage Site, and an inspiring location for lovers of history and archeology.</p> -->

								   	<p>تقع مدينة طبرية، عاصمة الجليل، على ضفاف بحيرة طبريا، وقد تمّ تأسيسها في بدايات العصر الروماني، وكانت مركزا دينيا وإداريا وثقافيا للشعب اليهودي لسنوات عديدة.</p>
									<p>بالإضافة إلى تاريخها الغني وأهميتها، فإن اسم طبريا الحديث يعد مرادفا لقضاء العطلة في إسرائيل. هنا يمكن للمرء التمتع بمجموعة متنوعة من الأنشطة التي تقدمها المدينة، وتجربة هذا الخليط الرائع من الاسترخاء والطبيعة والتمتع بالتاريخ، إلى جانب مناطق الجذب المعاصرة والرياضات المائية النشطة ومواقع الحج ومناطق الجذب السياحي الفريدة.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/tiberias/1.jpg"} class="img-responsive">
								  	</div>
									<p>لا تكتمل زيارة طبرية من دون زيارة المنطقة المحيطة بها، والتي تتميز بالعديد من المعالم السياحية التي لا يجب تفويت مشاهدتها، بما في ذلك مدينة بيسان، إحدى أقدم مدن العالم، وهي واحدة من أكبر المواقع الأثرية في البلاد؛ هنالك أيضا بلدة المجدل القديمة على بحر الجليل، والتي كانت موطنا للعديد من تلاميذ يسوع، ويقال بأنها كانت موطن مريم المجدلية؛ وهنالك أيضا مجيدو، وهو منتزه وطني جميل ومثير للإعجاب، وواحد من أهم المواقع الأثرية في إسرائيل من زمن الكتاب المقدس. تعتبر منطقة مجدو، التي احتوت فيما مضى على مدينة قديمة ذات أهمية استراتيجية حاسمة، واحدة من مواقع التراث العالمي لليونسكو، وموقعا ملهما لعشاق التاريخ والآثار.</p>

								   
		                        `,
      };
    },
  },

  {
    id: "Breakfast-In-Israel",
    ctg: "culinary",
    bgImage: "posts/bank/breakfast-in-israel/1.jpg",
    mobBgImage: "posts/bank/breakfast-in-israel/M.jpg",
    isVid: true,
    vidId: "JJ7PhOw1p5E",
    title: "BREAKFAST IN ISRAEL",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						          <h3>A LEGEND IN ITS OWN MEALTIME</h3>
						         
								    <p>Breakfast in an Israeli hotel or restaurant is unparalleled.<br/>
									The Israeli breakfast is a world renowned culinary institution. So much so in fact, that you can find it as its own standalone category on most self-respecting restaurants and café’s’ menus.</p>
									<p>What is so special about the Israeli breakfast you ask? Well, it’s actually a mixture of things.</p>
									<p>The ingredients – fresh, local, bursting with flavors and the perfect way to start a healthy energetic day in this vibrant country.</p>
                                    <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/breakfast-in-israel/1.jpg"} class="img-responsive">
								    </div>

                                    <p>The Variety -&nbsp; While the Israeli breakfast has the same basic types of food – eggs, cheese, bread, salads etc. – everywhere you go you will receive different types, different flavors and different styles of cooking and serving- made to order, just as you like.</p>
									<p>The generosity – the Israeli breakfast is the gift that just keeps giving, from the incredible omelets to the huge selection of soft and hard cheeses, from the amazing variety of salads to the obligatory fresh squeezed juices and coffee to order - the Israeli breakfast can be the only meal you eat in a day.</p>
									<p>Location location location – the best way to enjoy the fantastic feast called the Israeli breakfast is of course - in Israel, while engaging in people watching in the trendy streets of Tel Aviv, chilling out by the waves in the cafes on the beaches or promenades, or taking in the magnificent air and stunning views of any of this country’s stunning attractions.</p>
											   
		                        `,
      };
    },
  },

  {
    id: "Privacy_Policy",
    ctg: "telaviv",
    bgImage: "/HomeSlider/desktop/1.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "PRIVACY POLICY",
    smltitle: "",
    html: function() {
      return {
        __html: `


							<p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>
							
							<h3><span>OUR COMMITMENT TO YOU</span><span>&nbsp;</span></h3>
							<p>We, at&nbsp;The Israeli government, the Ministry of Tourism ("<strong>us</strong>", "<strong>we</strong>" or the<strong>&nbsp;"Ministry</strong>") respect the privacy of our users (each, a "<strong>User</strong>" or "<strong>you</strong>") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>&nbsp;</strong>"<strong>Website</strong>" and "<strong>App</strong>" respectively, and collectively the "<strong>Service(s)</strong>"). &nbsp;</p>
							<p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>
							
							<h3><span>CONTENTS</span></h3>
							<p>
							  <a href="#Grounds" style="color:#000"><span>1. </span>GROUNDS FOR DATA COLLECTION</a><br/>

							  <a href="#WhatType" style="color:#000"><span>2. </span>WHAT TYPE OF DATA WE COLLECT?</a><br/>

							  <a href="#HowDoWeUse" style="color:#000"><span>3. </span>HOW DO WE USE THE DATA WE COLLECT?</a><br/>

							  <a href="#Tracking" style="color:#000"><span>4. </span>TRACKING TECHNOLOGIES</a><br/>

							  <a href="#WitWhom" style="color:#000"><span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</a><br/>

							  <a href="#HowWeProtect" style="color:#000"><span>6. </span>HOW WE PROTECT YOUR INFORMATION</a><br/>

							  <a href="#Retention" style="color:#000"><span>7. </span>RETENTION</a><br/>

							  <a href="#UserRigths" style="color:#000"><span>8. </span>USER RIGHTS</a><br/>

							  <a href="#Transfer" style="color:#000"><span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA</a><br/>

							  <a href="#OurPolicy" style="color:#000"><span>10. </span>OUR POLICY TOWARD CHILDREN</a><br/>

							  <a href="#HowToContactUs" style="color:#000"><span>11. </span>HOW TO CONTACT US?</a><br/>

							  <a href="#Updates" style="color:#000"><span>12. </span>UPDATES TO THIS POLICY</a><br/>
							</p>

							
							<h3 id="Grounds"><span>GROUNDS FOR DATA COLLECTION</span><span>&nbsp;</span></h3>
							<p><span>Processing of your “<strong>Personal Data</strong>” (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>
							<p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>
							
							<h3 id="WhatType"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>
							<h3><span>Personal Data</span></h3>
							<p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>&nbsp;or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>
							<ul style="list-style-type: disc;margin-left:0in;">
							  <li><span>When you send us an email&nbsp;</span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>
							  <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>
							</ul>
							<h3><span>Non-Personal Data</span></h3>
							<p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:&nbsp;</span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>
							<p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.&nbsp;</span></p>
							
							<h3 id="HowDoWeUse"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>
							<ul>
							  <li><strong><span>Provision of the Service</span></strong><em><span>&nbsp;–&nbsp;</span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.&nbsp;</span></li>
							  <li><strong><span>Service announcements</span></strong><span>&nbsp;- we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>
							  <li><strong><span>Analytics, surveys and research</span></strong><span>&nbsp;- from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>
							  <li><strong><span>Protecting our interests</span></strong><em><span>&nbsp;-&nbsp;</span></em><span>we may use your Personal Data when we believe it’s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.&nbsp;</span></li>
							  <li><strong><span>Enforcing of policies</span></strong><span>&nbsp;- we may use your Personal Data in order to enforce our policies, including but not limited to our <a href="https://new.goisrael.com/international/Posts/telaviv/Privacy_Policy" style="text-decoration:underline;color:#000" target="_blank"> Terms </a></span><span style="line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;">
								 
								</span><span style="line-height:;font-family:Calibri;line-height:;color:windowtext;">.&nbsp;</span></li>
							  <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>&nbsp;- we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>
							  <li><strong><span>Newsletter</span></strong><span>&nbsp;- we may use your Personal Data in order to send you our newsletter, if you subscribed to it. &nbsp;</span>
								<ol style="list-style-type: circle;">
								  <li><u><span>Opt-out of receiving our newsletter</span></u><span>&nbsp;- You may choose not to receive our newsletter by clicking on the “unsubscribe” link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.&nbsp;</span></li>
								</ol>
							  </li>
							</ul>
							
							<h3 id="Tracking"><span>TRACKING TECHNOLOGIES</span></h3>
							<p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, "<strong>Tracking Technologies</strong>"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services’ performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>
							<p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>
							<h3>Types of Tracking Technologies We Use</h3>
							<p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>
							<p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are "session cookies" and expires upon closing of your browser. Other cookies are "persistent cookies", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>
							<p>For example, we use a performance tracking technology tool called “<strong>Google Analytics</strong>” to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google’s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at 
							  <a href="//www.google.com/analytics/terms/us.html" target="_blank" style="text-decoration:underline;color:#000">www.google.com/analytics/</a>, and the Google Privacy Policy, available at 
							  <a href="//www.google.com/policies/privacy/" target="_blank" style="text-decoration:underline;color:#000">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at 
							  <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" style="text-decoration:underline;color:#000">tools.google.com/dlpage/gaoptout</a>.
							</p>
							<h3><span>Interest-Based Advertising &amp; User Choice</span></h3>
							<p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>
							<h3><span>How to Manage Your Tracking Technologies Settings</span></h3>
							<p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>
							<p style="margin-bottom:6.0pt;"><strong>Turning off cookies via your web browser
								<br>&nbsp;
							  </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the "Help" section of the web browser. Below are some links to some commonly used web browsers:</p>
							<p>
							  <a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank" style="text-decoration:underline;color:#000"><span>Google Chrome</span></a><br/>

							  <a href="https://support.microsoft.com/en-us/kb/260971" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Explorer</span></a><br/>

							  <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" style="text-decoration:underline;color:#000"><span>Mozilla Firefox</span></a><br/>

							  <a href="https://support.apple.com/kb/PH5042?locale=en_US" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Desktop)</span></a><br/>

							  <a href="https://support.apple.com/en-us/HT201265" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Mobile)</span></a><br/>

							  <a href="//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067" target="_blank" style="text-decoration:underline;color:#000"><span>Android Browser</span></a><br/>

							  <a href="//www.opera.com/help" target="_blank" style="text-decoration:underline;color:#000"><span>Opera</span></a><br/>

							  <a href="//www.opera.com/help/mobile/android#privacy" target="_blank" style="text-decoration:underline;color:#000"><span>Opera Mobile</span></a>
							</p>
							<p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>
							<p style="margin-bottom:6.0pt;"><strong>Turning off third party cookies
								<br>&nbsp;
							  </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;
							  <a href="//www.networkadvertising.org/choices/" target="_blank" style="text-decoration:underline;color:#000">Network Advertising Initiative</a>.
							</p>
							<h3><span>Other helpful resources</span><br/></h3>
							<p>
							<span>To learn more about advertisers’ use of cookies the following links may be helpful:</span><br/>
							  <a href="//www.youronlinechoices.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>

							  <a href="//www.iab.net/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (US)</span></a><br/>

							  <a href="//www.iabeurope.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (EU)</span></a>
							</p>
							<p style="margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;"><strong>Turning off cookies on a mobile device</strong></h3>
							<p>You can-opt out of certain types of interest-based advertising, by accessing the “settings” on your device:</p>
							<ul style="list-style-type: disc;margin-left:undefined;">
							  <li><strong><span>If you're using an Apple device</span></strong><span>&nbsp;you can configure your device to limit ad tracking to by clicking on "settings" &gt; "privacy" &gt; "advertising" and toggling "limit ad tracking" to ‘on.’</span></strong></li>
							  <li><strong><span>If you're using an Android device</span></strong><span>&nbsp;you can opt out of most app-based tracking for advertising by opening the "Google Settings" app on your device, selecting "Ads", and then selecting the option to opt-out of interest-based ads.</span></strong></li>
							</ul>
							<p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>
							
							<h3 id="WitWhom"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>
							<ul>
							  <li><strong><span>Internal concerned parties</span></strong><span>&nbsp;- we may share your information with other</span><span style="color:windowtext;">&nbsp;</span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>
							  <li><strong><span>Business partners</span></strong><span>&nbsp;- we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>
							  <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>&nbsp;- we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.&nbsp;</span></li>
							</ul>
							
							<h3 id="HowWeProtect"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>
							<p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn’t publicly available. We limit access of your information only to those employees or partners on a “need to know” basis, in order to enable the carrying out of the agreement between us.&nbsp;</span></p>
							<p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.&nbsp;</span></p>
							
							<h3 id="Retention"><span>RETENTION</span></h3>
							<p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.&nbsp;</span></p>
							
							<h3  id="UserRigths"><span>USER RIGHTS</span></h3>
							<h4><strong><span style="font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;">EU User Rights</span></strong></h4>
							<p><span>As an EU resident, you may request to:&nbsp;</span></p>
							<ol start="1" style="list-style-type: lower-alpha;margin-left: 0px;">
							  <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.&nbsp;</span></li>
							  <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.&nbsp;</span></li>
							  <li><span>Request rectification of your Personal Data that is in our control.</span></li>
							  <li><span>Request erasure of your Personal Data.&nbsp;</span></li>
							  <li><span>Object to the processing of Personal Data by us.&nbsp;</span></li>
							  <li><span>Request to restrict processing of your Personal Data by us.</span></li>
							  <li><span>Lodge a complaint with a supervisory authority.</span></li>
							</ol>
							<p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.&nbsp;</span></p>
							<p><span>Users Outside the EU -&nbsp;</span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>
							
							<h3 id="Transfer"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>&nbsp;</span></h3>
							<p><span>If you reside in the European Union ("<strong>EU</strong>"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>
							
							<h3 id="OurPolicy"><span>OUR POLICY TOWARD CHILDREN</span></h3>
							<p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; “<strong>Age of Consent</strong>”). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>
							
							<h3 id="HowToContactUs"><span>HOW TO CONTACT US?</span></h3>
							<p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href="mailto:Dpo@tourism.gov.il" style="text-decoration:underline;color:#000"> Dpo@tourism.gov.il</a>
							</p>
							
							<h3 id="Updates"><span>UPDATES TO THIS POLICY</span></h3>
							<p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the "Last Updated" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.&nbsp;</p>

						   
							`,
      };
    },
  },
  {
    id: "Port_Charms",
    ctg: "telaviv",
    bgImage: "/posts/bank/portcharms/1.jpg",
    mobBgImage: "/posts/bank/portcharms/M.jpg",
    isVid: false,
    title: "سحر الميناء",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <h3>مباعث السحر المختلفة في ميناء يافا</h3>
								<p>لميناء يافا عبق التاريخ القديم: إذ تعود الاكتشافات الأثرية في الميناء إلى العصور المصرية القديمة، والعصر الروماني، وعصر نابليون. يمكنكم الوصول إلى ميناء يافا من خلال قلعة يافا القديمة. إن المشي عبرا لمباني الحجرية التي تم ترميمها، والممرات المرصوفة بالحجارة يجعلكم تشعرون حقا وكأنكم قد عدتم بالزمن إلى الوراء. أما في هذه الأيام، صارت قلعة يافا القديمة موئلا للعديد من الفنانين والمعارض.</p>
								<h3>الملذات الصغيرة التي يكمن الفارق فيها</h3>
								<p>كانت بدايات مدينة تل أبيب الحديثة متواضعة في ميناء يافا، حيث اعتاد المهاجرون والجيوش والتجار إرساء سفنهم. يشتهر الميناء بكونه واحدا من أقدم موانئ العالم. وفي الوقت الحاضر، بعد إعادة ترميم الميناء، لا يزال الصيادون المحليون يستخدمونه، فيما أصبحت المنطقة التاريخية المحيطة بالميناء منطقة جذب سياحي شهيرة. يمكنكم الجلوس على البارات أو مطاعم المأكولات البحرية التي تملأ الأرصفة، والتمتع بالنسيم العليل والاسترخاء، أو يمكنكم القيام برحلة بحرية تنطلق كل ساعة قرب الشاطئ.</p>
								<p>تم تحويل الحظائر <span class="ac-en-font">(Hangars)</span> القريبة من الماء إلى صالات عرض ومساحات ثقافية، على غرار مركز "نا لجاعات" الذي تديره مجموعة من ضعاف السمع والبصر، إلى جانب المتاجر المتخصصة والمطاعم الممتازة. هنالك طرق مختلفة للصعود من الميناء إلى المدينة القديمة. أحد هذه الطرق عبارة عن ممر شبه خفي يصل إلى "ساحة كدوميم" حيث يمكنكم رؤية كنيسة القديس بطرس وجسر الأمنيات والآثار القديمة لمدينة يافا، إلى جانب متحف إيلانا غور.</p>

		                        `,
      };
    },
  },
  {
    id: "Al_Jazzar_Mosque_ar",
    ctg: "general",
    bgImage: "/posts/bank/aljazzarmosque/1.jpg",
    mobBgImage: "/posts/bank/aljazzarmosque/M.jpg",
    isVid: false,
    title: "مسجد الجزار الساحر في مدينة عكا",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <p>  مسجد الجزار يقع بين حيطان البلدة القديمة لمدينة عكا التي تتسم بطابعها العربي اليهودي المختلط ويُعدّ أكبر المساجد خارج أورشليم القدس وأكثرها إثارةً. تم بناؤه عام 1781 على يد أحمد باشا الجزار، الذي تولى آنذاك منصب الحاكم العثماني للمنطقة. الجزار كان مسلمًا ينحدر من أصول بوسنية والذي أصبح مشهورًا حول العالم قبل بناء المسجد بسنتين فقط بفضل انتصاره على نابوليون بونبارت، الذي حققه بدعم من الأسطول البريطاني ومن مستشاره اليهودي حاييم فرحي. </p>

								<p>وكان يطلق على مسجد الجزار أصلاً اسم مسجد الأنوار كما أنه بات معروفًا باللغة العربية باسم جامع الباشا. وبالإضافة إلى هذه الأسماء يطلق على مسجد الجزار اسم المسجد الأبيض نظرًا لقبته الفضية البيضاء التي تم دهنها منذ ذلك الحين باللون الأخضر.</p>


								<p>أنشئ المسجد الذي يهيمن على أفق مدينة عكا على الطريقة العثمانية، حيث أنه يدمج العناصر البيزنطية والفارسية كما وصُنعت بعض أعمدته من مستلزمات البناء التي أخِذت من حطام تعود إلى مدينة قيسارية، في حين أن التصاميم الداخلية المزخرفة لديه مستوحاة من مساجد إسطنبول الفاخرة. </p>


								<p>أحمد باشا الجزار وحليفه سليمان باشا مدفونان في ضريح داخل الساحة الفخمة للمسجد.</p>

								<p>المسجد هو موطن أثر ديني استثنائي يسمى شعر النبي، والذي يقال عنه حسب الأسطورة المحلية أنه عبارة عن شعرة تعود للحية النبي محمد صلعم حيث تم شراؤها من قبل عائلة ميسورة في عام 1901 من المسجد الأزرق في إسطنبول. وكانت تقام مسيرة بشعر النبي تجوب شوارع عكا في عيد الفطر للإشارة إلى انتهاء صوم شهر رمضان، لكن حاليًا يتم الاحتفاظ بها بشكل دائم في خزانة زجاجية داخل دهليز النساء في الطابق العلوي. ويجب تحديد موعد مسبقًا لزيارة المسجد.</p>

								<p>عدا عن زيارة مسجد الجزار هنالك الكثير من الفعاليات التي تتيحها مدينة عكا، ومن بينها الزيارات إلى الحدائق البهائية الرائعة، وإلى منزل حاييم فرحي الذي عيّنه أحمد الجزار في منصب وزير المالية وكان يُعتبر ذراعه اليمنى، وميناء عكا، والحمامات التركية المسماة حمام الباشا، والقلعة الهوسپيتلاريّة (قاعات الفرسان)، وأسوار البلدة القديمة وكذلك سوق البلدة القديمة. ولك أن تعرف أيضًا أن مدينة عكا مشهورة بمطاعم الأسماك والمأكولات البحرية الموجودة فيها.</p>

								<p>أثناء تواجدك في البلدة القديمة لمدينة عكا، لا تنسى النزول إلى المرسى حيث يمكنك القيام برحلة بحرية تسير بمحاذاة حيطان المدينة.</p>

								<p>هذا وتشكل المدينة كذلك موطن أكبر متنزه مغامرات في إسرائيل، والذي يشمل أطول مجسم اصطناعي لتسلق الصخور في العالم بمعنى القفز بالحبال من ارتفاع 32 مترًا، وغيره العديد من معالم الجذب السياحي التي تجعل عكا موقعًا لا بد من زيارته إذا كنت تسافر مع أطفال.</p>

		                        `,
      };
    },
  },
];



// WEBPACK FOOTER //
// ./src/Posts/PostsData.js